
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1x6xR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d965ace2720375a6$export$2e2bcd8739ae039);

var $9bX9o = parcelRequire("9bX9o");

var $lldcY = parcelRequire("lldcY");
var $d965ace2720375a6$export$2e2bcd8739ae039 = (0, $lldcY.createReportPageBootstrap)('burnup', (0, $9bX9o.default));

});
parcelRegister("9bX9o", function(module, exports) {

$parcel$export(module.exports, "default", () => $943745ea3b535083$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $yuXsW = parcelRequire("yuXsW");

var $2Wgbz = parcelRequire("2Wgbz");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $94EW1 = parcelRequire("94EW1");

var $5YKhl = parcelRequire("5YKhl");


var $6j0nJ = parcelRequire("6j0nJ");

var $khYfp = parcelRequire("khYfp");
function $943745ea3b535083$export$f8b7c42892b2454({ boardId: boardId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: (0, $6j0nJ.APP_ID),
        teamName: "helios-reports",
        packageName: "@atlassian/jira-software-burnup-report"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $2Wgbz.default)
    }, false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94EW1.default), {
        testId: "software-burnup-report.burnup-spinner"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $khYfp.default), {
        boardId: boardId,
        now: null
    }))));
}
const $943745ea3b535083$var$App = (props)=>{
    const { baseUrl: baseUrl, projectKey: projectKey, boardId: boardId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YKhl.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        boardId: boardId,
        reportType: (0, $07d657390afa880f$export$d47e946c43f3f3cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($943745ea3b535083$export$f8b7c42892b2454, {
        boardId: boardId
    }));
};
var $943745ea3b535083$export$2e2bcd8739ae039 = $943745ea3b535083$var$App;

});
parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("2Wgbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e169a67ca28ac2$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $8Y3VE = parcelRequire("8Y3VE");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $5zSUY = parcelRequire("5zSUY");

var $eeJ3R = parcelRequire("eeJ3R");

var $aXA7t = parcelRequire("aXA7t");

var $277yk = parcelRequire("277yk");



const $a3e169a67ca28ac2$var$retryLink = new (0, $kcwGc.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $eeJ3R.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $a3e169a67ca28ac2$var$errorLink = (0, $aqG9W.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'errorType'
            ], null);
            return (0, $eeJ3R.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $eeJ3R.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
            'statusCode'
        ], null);
        (0, $eeJ3R.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $a3e169a67ca28ac2$var$fragmentMatcher = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($277yk))
});
const $a3e169a67ca28ac2$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $a3e169a67ca28ac2$var$fragmentMatcher
};
const $a3e169a67ca28ac2$var$cache = new (0, $2vRh6.InMemoryCache)($a3e169a67ca28ac2$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a3e169a67ca28ac2$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $a3e169a67ca28ac2$var$xsrfLink = ()=>(0, $8Y3VE.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $5zSUY.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $a3e169a67ca28ac2$var$clientCreator = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: 'SWAG',
        link: (0, $bvQX6.ApolloLink).from([
            $a3e169a67ca28ac2$var$retryLink,
            $a3e169a67ca28ac2$var$xsrfLink(),
            $a3e169a67ca28ac2$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($a3e169a67ca28ac2$var$cache),
            new (0, $35Kb7.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $a3e169a67ca28ac2$var$customFetch
            })
        ]),
        cache: $a3e169a67ca28ac2$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$a3e169a67ca28ac2$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $a3e169a67ca28ac2$var$clientCreator
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});

parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("8Y3VE", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $6876f98359b8915e$export$2f04de43fe27971a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $6876f98359b8915e$export$2f04de43fe27971a(setter) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        var request = (0, $fKE23.__rest)(operation, []);
        return new (0, $bvQX6.Observable)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $bvQX6.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $bvQX6.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bvQX6.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $bvQX6.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $bvQX6.Observable).of({
                data: {}
            });
            return new (0, $bvQX6.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("eeJ3R", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $ff92a92e5b2be045$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $ff92a92e5b2be045$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $ff92a92e5b2be045$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $ff92a92e5b2be045$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $ff92a92e5b2be045$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $ff92a92e5b2be045$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $ff92a92e5b2be045$export$3e50530825dee9d1);

var $gUUjF = parcelRequire("gUUjF");
const $ff92a92e5b2be045$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $gUUjF.default).safeErrorWithoutCustomerData(type, m, params);
};
const $ff92a92e5b2be045$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $ff92a92e5b2be045$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$ff92a92e5b2be045$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $ff92a92e5b2be045$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $ff92a92e5b2be045$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $ff92a92e5b2be045$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $ff92a92e5b2be045$export$25d52be9f4671e9e = (error, queryName)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $ff92a92e5b2be045$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});

parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fYqUr = parcelRequire("fYqUr");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fYqUr.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("277yk", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});


parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("94EW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d0e968743ebc023$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $7d0e968743ebc023$var$Spinner = ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d0e968743ebc023$var$SpinnerContainer, {
        "data-test-id": testId,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
var $7d0e968743ebc023$export$2e2bcd8739ae039 = $7d0e968743ebc023$var$Spinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7d0e968743ebc023$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1tke1mjv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5YKhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9578c7dbc76b3a6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kIY50 = parcelRequire("kIY50");

var $8WuJm = parcelRequire("8WuJm");

var $fijOW = parcelRequire("fijOW");

var $7Uhfl = parcelRequire("7Uhfl");
function $9578c7dbc76b3a6a$export$2e2bcd8739ae039({ baseUrl: baseUrl, boardId: boardId, children: children, reportType: reportType, projectKey: projectKey }) {
    const reportsUrl = `${baseUrl}/jira/software/projects/${projectKey}/boards/${boardId}/reports`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            boardType: 'Agility'
        }
    }, (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fijOW.default), {
        boardId: boardId,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Uhfl.default), {
        reportType: reportType,
        reportsUrl: reportsUrl,
        boardId: boardId
    }, children));
}

});
parcelRegister("fijOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $68bf4db62e7e9525$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts = (0, $7rh0R.lazy)(()=>(parcelRequire("b2w1X")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $68bf4db62e7e9525$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts, props)));
var $68bf4db62e7e9525$export$2e2bcd8739ae039 = $68bf4db62e7e9525$var$ProjectKeyboardShortcuts;

});
parcelRegister("b2w1X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("28hU0")
]).then(()=>parcelRequire('8aQut'));

});


parcelRegister("7Uhfl", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c9d5272f200bc5$export$2e2bcd8739ae039);

var $fHwH9 = parcelRequire("fHwH9");

var $1PNaF = parcelRequire("1PNaF");

var $a1jkl = parcelRequire("a1jkl");
var $01c9d5272f200bc5$export$2e2bcd8739ae039 = (0, $fHwH9.default)({
    Header: $1PNaF.default
})((0, $a1jkl.default));

});
parcelRegister("fHwH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83371236161dde7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $e83371236161dde7$var$isEmpty = (s)=>s === undefined || s === null || s === '';
const $e83371236161dde7$var$getDisplayName = (x)=>{
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    if (!$e83371236161dde7$var$isEmpty(x.displayName)) return x.displayName;
    if (!$e83371236161dde7$var$isEmpty(x.name)) return x.name;
    return 'Component';
};
const $e83371236161dde7$export$19c55c6cefb3b57 = (defaults)=>(Component)=>{
        const displayName = $e83371236161dde7$var$getDisplayName(Component);
        // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
        const WithProps = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...defaults,
                ...props
            });
        WithProps.displayName = `WithProps(${displayName})`;
        // @ts-expect-error - TS2322 - Type '{ (props: Partial<A> & B): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Partial<A> & B, unknown>'.
        return WithProps;
    };
var $e83371236161dde7$export$2e2bcd8739ae039 = $e83371236161dde7$export$19c55c6cefb3b57;

});

parcelRegister("1PNaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1435ed448d0e9ab$export$2e2bcd8739ae039);

var $c76ap = parcelRequire("c76ap");

var $fHwH9 = parcelRequire("fHwH9");

var $eGoYe = parcelRequire("eGoYe");

var $gJRME = parcelRequire("gJRME");

var $6VbGL = parcelRequire("6VbGL");

var $78k8U = parcelRequire("78k8U");
var $c1435ed448d0e9ab$export$2e2bcd8739ae039 = (0, $fHwH9.default)({
    BreadcrumbRenderer: $c76ap.default,
    HowTo: $gJRME.default,
    Chevron: $eGoYe.default,
    HowToReadText: $6VbGL.default
})((0, $78k8U.default));

});
parcelRegister("eGoYe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d36a23fa96896270$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");


var $giAhk = parcelRequire("giAhk");

var $g8JvH = parcelRequire("g8JvH");

var $3Gpwl = parcelRequire("3Gpwl");
const $d36a23fa96896270$var$ChevronIconComponent = ({ onClick: onClick, showHowTo: showHowTo, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d36a23fa96896270$var$ChevronIcon, {
        onClick: onClick
    }, showHowTo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: intl.formatMessage((0, $3Gpwl.default).hideHowToRead),
        size: "medium",
        primaryColor: `var(--ds-text-brand, ${(0, $73a5c9d720aa66e1$exports).B400})`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: intl.formatMessage((0, $3Gpwl.default).howToRead),
        size: "medium",
        primaryColor: `var(--ds-text-brand, ${(0, $73a5c9d720aa66e1$exports).B400})`
    }));
const $d36a23fa96896270$var$ChevronWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('reportPageHeader', {
    onClick: 'howToToggled'
})($d36a23fa96896270$var$ChevronIconComponent);
var $d36a23fa96896270$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($d36a23fa96896270$var$ChevronWithAnalytics);
const $d36a23fa96896270$var$ChevronIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _1skzyfq0",
            __cmplp.className
        ])
    });
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("3Gpwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a18a116ec213f13$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2a18a116ec213f13$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    howToRead: {
        "id": "software-reports-report-page.header.chevron.how-to-read",
        "defaultMessage": "How to read this report"
    },
    hideHowToRead: {
        "id": "software-reports-report-page.header.chevron.hide-how-to-read",
        "defaultMessage": "Hide report help"
    }
});

});


parcelRegister("gJRME", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f725212b9b9021$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5OdZ3 = parcelRequire("5OdZ3");

var $gUUjF = parcelRequire("gUUjF");

var $8uD7Y = parcelRequire("8uD7Y");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");


var $g8w56 = parcelRequire("g8w56");
class $f8f725212b9b9021$export$d2e991ab6448c561 extends (0, $eUqFw.Component) {
    static getHowToDataForReportType(reportType) {
        switch(reportType){
            case 0, $07d657390afa880f$export$d47e946c43f3f3cc:
                return {
                    whatItIs: (0, $g8w56.default).burnupReportWhat,
                    howToReadIt: (0, $g8w56.default).burnupReportHow,
                    learnMoreLink: 'https://confluence.atlassian.com/jirasoftwarecloud/reports-952607296.html'
                };
            case 0, $07d657390afa880f$export$c456b3f56f927707:
                return {
                    whatItIs: (0, $g8w56.default).velocityReportWhat,
                    howToReadIt: (0, $g8w56.default).velocityReportHow,
                    learnMoreLink: 'https://confluence.atlassian.com/jirasoftwarecloud/velocity-report-next-gen-975029957.html'
                };
            case 0, $07d657390afa880f$export$1c3e2d262d98feed:
                return {
                    whatItIs: (0, $g8w56.default).cumulativeFlowWhat,
                    howToReadIt: (0, $g8w56.default).cumulativeFlowHow,
                    learnMoreLink: 'https://confluence.atlassian.com/jirasoftwarecloud/cumulative-flow-diagram-next-gen-975029954.html'
                };
            case 0, $07d657390afa880f$export$f42d2c00cd6e24b6:
                return {
                    whatItIs: (0, $g8w56.default).burndownWhat,
                    howToReadIt: (0, $g8w56.default).burndownHow,
                    learnMoreLink: 'https://confluence.atlassian.com/display/JIRASOFTWARECLOUD/Sprint+burndown+%28next-gen%29'
                };
            default:
                // Should not be reachable
                (0, $gUUjF.default).safeErrorWithoutCustomerData('software-reports.report-page.how-to', 'Unknown report type how-to requested.');
                return {
                    whatItIs: (0, $g8w56.default).whatItIs,
                    howToReadIt: (0, $g8w56.default).howToReadIt,
                    learnMoreLink: '#'
                };
        }
    }
    render() {
        const { intl: { formatMessage: formatMessage }, visible: visible, reportType: reportType } = this.props;
        const howToData = $f8f725212b9b9021$export$d2e991ab6448c561.getHowToDataForReportType(reportType);
        const learnMore = formatMessage((0, $g8w56.default).learnMore);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8f725212b9b9021$var$HowToContainer, {
            visible: visible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8f725212b9b9021$var$Gutter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $g8w56.default).whatItIs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(howToData.whatItIs))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8f725212b9b9021$var$Gutter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $g8w56.default).howToReadIt)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...howToData.howToReadIt,
            values: {
                learnMore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                    onClick: (e, analyticsEvent)=>{
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'report-page-learn-more');
                    },
                    target: "_blank",
                    href: howToData.learnMoreLink
                }, learnMore)
            }
        }))));
    }
}
var $f8f725212b9b9021$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($f8f725212b9b9021$export$d2e991ab6448c561);
const $f8f725212b9b9021$var$HowToContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visible: visible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1reo15vq _18m915vq _v564it2h _otyru2gc",
            __cmplp.visible ? "_c71l68cl" : "_c71lidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8f725212b9b9021$var$Gutter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1ssb _1yt4u2gc",
            __cmplp.className
        ])
    });
});

});
const $07d657390afa880f$export$c456b3f56f927707 = 'velocity';
const $07d657390afa880f$export$d47e946c43f3f3cc = 'burnup';
const $07d657390afa880f$export$f42d2c00cd6e24b6 = 'burndown';
const $07d657390afa880f$export$47b059c21f4ed074 = 'burnupChart';
const $07d657390afa880f$export$1c3e2d262d98feed = 'cumulative';
const $07d657390afa880f$export$d76071d5de2774fc = 'software.reports.report-page';

parcelRegister("g8w56", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b2297b9137441a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $00b2297b9137441a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    whatItIs: {
        "id": "software-reports-report-page.header.how-to.what-it-is",
        "defaultMessage": "What it is"
    },
    howToReadIt: {
        "id": "software-reports-report-page.header.how-to.how-to-read-it",
        "defaultMessage": "How to read it"
    },
    learnMore: {
        "id": "software-reports-report-page.header.how-to.learn-more",
        "defaultMessage": "Learn more"
    },
    burnupReportWhat: {
        "id": "software-reports-report-page.header.how-to.burnup-report-what",
        "defaultMessage": "Maintain your sprint's health by identifying problems such as scope creep or planned path deviation."
    },
    burnupReportHow: {
        "id": "software-reports-report-page.header.how-to.burnup-report-how",
        "defaultMessage": "The distance between lines is the amount of work remaining. Examine the Work scope line to identify scope creep. {learnMore}"
    },
    velocityReportWhat: {
        "id": "software-reports-report-page.header.how-to.velocity-report-what",
        "defaultMessage": "Your team's velocity is calculated by taking the average of the total completed estimates from their last few sprints."
    },
    velocityReportHow: {
        "id": "software-reports-report-page.header.how-to.velocity-report-how",
        "defaultMessage": "Grey: the total estimate of each sprint's issues when the sprint began. Green: the total completed estimates when the sprint ended. {learnMore}"
    },
    cumulativeFlowWhat: {
        "id": "software-reports-report-page.header.how-to.cumulative-flow-what",
        "defaultMessage": "Shows the statuses of issues over time. This helps you identify potential bottlenecks that need to be investigated."
    },
    cumulativeFlowHow: {
        "id": "software-reports-report-page.header.how-to.cumulative-flow-how",
        "defaultMessage": "The distance between each column lines shows you how long issues take to get from one state to another. Look for points where one band is growing at a faster rate than another to find bottlenecks. {learnMore}"
    },
    burndownWhat: {
        "id": "software-reports-report-page.header.how-to.burndown-what",
        "defaultMessage": "Shows the total work remaining for the current sprint, and the likelihood of your team completing the sprint on time. Also shows a summary of scope changes and work done throughout the sprint."
    },
    burndownHow: {
        "id": "software-reports-report-page.header.how-to.burndown-how",
        "defaultMessage": "The red line shows how much work remains in the sprint. The grey line shows the ideal progress rate. {learnMore}"
    }
});

});


parcelRegister("6VbGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f54379f215fdd1d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $g8JvH = parcelRequire("g8JvH");

var $8zGUB = parcelRequire("8zGUB");
const $1f54379f215fdd1d$var$HowToReadComponent = ({ onClick: onClick, intl: intl })=>// @ts-expect-error onClick event type doesn't match DOM event
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f54379f215fdd1d$var$HowToReadText, {
        onClick: onClick
    }, intl.formatMessage((0, $8zGUB.default).howToRead));
const $1f54379f215fdd1d$var$HowToReadComponentWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('reportPageHeader', {
    onClick: 'howToToggled'
})($1f54379f215fdd1d$var$HowToReadComponent);
var $1f54379f215fdd1d$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($1f54379f215fdd1d$var$HowToReadComponentWithAnalytics);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f54379f215fdd1d$var$HowToReadText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1vl3 _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8zGUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b88c428a943039$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c8b88c428a943039$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    howToRead: {
        "id": "software-reports-report-page.header.how-to-read-text.how-to-read",
        "defaultMessage": "How to read this report"
    }
});

});


parcelRegister("78k8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $af73e53afc6d60ed$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");

var $3a8wJ = parcelRequire("3a8wJ");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $jWL8K = parcelRequire("jWL8K");


var $5pzzA = parcelRequire("5pzzA");
class $af73e53afc6d60ed$export$8b251419efc915eb extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onToggleHowToPane = (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'report-page-how-to', {
                isOpening: !this.state.showHowTo
            });
            this.setState({
                showHowTo: !this.state.showHowTo
            });
        };
        this.state = {
            showHowTo: false
        };
    }
    renderTitle() {
        const { intl: { formatMessage: formatMessage }, reportType: reportType } = this.props;
        if (reportType === (0, $07d657390afa880f$export$c456b3f56f927707)) return formatMessage((0, $5pzzA.default).velocityReportTitle);
        if (reportType === (0, $07d657390afa880f$export$d47e946c43f3f3cc)) return formatMessage((0, $5pzzA.default).burnupReportTitle);
        if (reportType === (0, $07d657390afa880f$export$1c3e2d262d98feed)) return formatMessage((0, $5pzzA.default).cumulativeFlowTitle);
        if (reportType === (0, $07d657390afa880f$export$f42d2c00cd6e24b6)) return formatMessage((0, $5pzzA.default).burndownTitle);
        return null;
    }
    render() {
        const { BreadcrumbRenderer: BreadcrumbRenderer, HowTo: HowTo, Chevron: Chevron, HowToReadText: HowToReadText, boardId: boardId } = this.props;
        const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadcrumbRenderer, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
            truncateTitle: true,
            breadcrumbs: breadcrumbs,
            actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$HowToReadContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
                onClick: this.onToggleHowToPane,
                showHowTo: this.state.showHowTo
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HowToReadText, {
                onClick: this.onToggleHowToPane
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                paddingInlineStart: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWL8K.JswShareButton), {
                boardId: boardId
            })))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$HeadingStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$TruncatingTextStyle, null, this.renderTitle()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HowTo, {
            visible: this.state.showHowTo,
            reportType: this.props.reportType
        }));
    }
}
const $af73e53afc6d60ed$var$HeaderWithIntl = (0, $giAhk.injectIntlV2)($af73e53afc6d60ed$export$8b251419efc915eb);
var $af73e53afc6d60ed$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $af73e53afc6d60ed$var$HeaderWithIntl;
const $af73e53afc6d60ed$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af73e53afc6d60ed$var$HowToReadContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af73e53afc6d60ed$var$HeadingStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $af73e53afc6d60ed$var$TruncatingTextStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $af73e53afc6d60ed$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4fkly",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("jWL8K", function(module, exports) {

$parcel$export(module.exports, "JswShareButton", () => $bcd52ee284d5eb3c$export$54c54e47ce207cc8);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $iSNkS = parcelRequire("iSNkS");

var $dWLk9 = parcelRequire("dWLk9");

var $5cwrp = parcelRequire("5cwrp");
const $bcd52ee284d5eb3c$var$REPORT_SHARE_CONTENT_TYPE = 'report';
const $bcd52ee284d5eb3c$export$54c54e47ce207cc8 = ({ boardId: boardId })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        integrationType: (0, $iSNkS.integrationTypes).CLASSIC_BOARD,
        triggerButtonStyle: "icon-only",
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: formatMessage((0, $5cwrp.default).shareTitle),
        shareFormTitle: formatMessage((0, $5cwrp.default).shareFormTitle),
        shareContentType: $bcd52ee284d5eb3c$var$REPORT_SHARE_CONTENT_TYPE,
        objectAri: (0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        }),
        copyTooltipText: formatMessage((0, $5cwrp.default).shareTooltipText),
        shareFormHelperMessage: formatMessage((0, $5cwrp.default).shareHelperMessage)
    });
};

});
parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lUmmJ")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f4cb7ac67043f68$var$_share = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("ec2xp")));
function $9f4cb7ac67043f68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9f4cb7ac67043f68$var$_share.default
    }));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = module.exports.default = $9f4cb7ac67043f68$var$ShareIcon;

});
parcelRegister("ec2xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55427aa389adc57$var$_react = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a55427aa389adc57$var$_UNSAFE_baseNew = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a55427aa389adc57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a55427aa389adc57$var$ShareIcon = (props)=>/*#__PURE__*/ $a55427aa389adc57$var$_react.default.createElement($a55427aa389adc57$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a55427aa389adc57$var$ShareIcon.displayName = 'ShareIcon';
var $a55427aa389adc57$var$_default = module.exports.default = $a55427aa389adc57$var$ShareIcon;

});


parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("lUmmJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2xQrm")
]).then(()=>parcelRequire('iHQJU'));

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("5cwrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38ea6be0c7e8bc7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a38ea6be0c7e8bc7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "software-report-header-common.share-button.share-title",
        "defaultMessage": "Report"
    },
    shareFormTitle: {
        "id": "software-report-header-common.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "software-report-header-common.share-button.share-tooltip-text",
        "defaultMessage": "Embed this link in other Atlassian products such as Confluence"
    },
    shareHelperMessage: {
        "id": "software-report-header-common.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("5pzzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f33dc4ae0bc5d70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3f33dc4ae0bc5d70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    burnupReportTitle: {
        "id": "software-reports-report-page.header.burnup-report-title",
        "defaultMessage": "Burnup report"
    },
    velocityReportTitle: {
        "id": "software-reports-report-page.header.velocity-report-title",
        "defaultMessage": "Velocity report"
    },
    cumulativeFlowTitle: {
        "id": "software-reports-report-page.header.cumulative-flow-title",
        "defaultMessage": "Cumulative flow diagram"
    },
    burndownTitle: {
        "id": "software-reports-report-page.header.burndown-title",
        "defaultMessage": "Sprint burndown chart"
    },
    hideHowToRead: {
        "id": "software-reports-report-page.header.hide-how-to-read",
        "defaultMessage": "Hide report help"
    },
    beta: {
        "id": "software-reports-report-page.header.beta",
        "defaultMessage": "Beta"
    }
});

});



parcelRegister("a1jkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3824cc88f2ebd0$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aTgXo = parcelRequire("aTgXo");

var $aYtGv = parcelRequire("aYtGv");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");

var $dmmMp = parcelRequire("dmmMp");
function $7e3824cc88f2ebd0$export$33aa3110c4070c17({ Header: Header, boardId: boardId, reportType: reportType, reportsUrl: reportsUrl, children: children, intl: intl }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${reportType}ReportPage`,
        containerId: `${boardId}`,
        containerType: "board",
        objectId: reportType,
        objectType: "report",
        attributes: {
            boardId: boardId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: intl.formatMessage((0, $dmmMp.default).reportsBreadcrumbTitle),
            href: reportsUrl,
            type: 'reports'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e3824cc88f2ebd0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
        reportType: reportType,
        boardId: boardId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e3824cc88f2ebd0$var$Content, null, children))));
}
var $7e3824cc88f2ebd0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($7e3824cc88f2ebd0$export$33aa3110c4070c17);
const $7e3824cc88f2ebd0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1l47 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $7e3824cc88f2ebd0$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _18m91wug _1yt4fkly",
            __cmplp.className
        ])
    });
});

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("dmmMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9287900086a8ffab$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9287900086a8ffab$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reportsBreadcrumbTitle: {
        "id": "software-reports-report-page.reports-breadcrumb-title",
        "defaultMessage": "Reports"
    }
});

});




parcelRegister("6j0nJ", function(module, exports) {

$parcel$export(module.exports, "APP_ID", () => $47745909a3490ed2$export$d76071d5de2774fc);
$parcel$export(module.exports, "ISSUE_ADDED", () => $47745909a3490ed2$export$cbc0c8b58a79121d);
$parcel$export(module.exports, "ISSUE_REMOVED", () => $47745909a3490ed2$export$8af14bf2cdc1bfb6);
$parcel$export(module.exports, "ESTIMATION_CHANGE", () => $47745909a3490ed2$export$9d9cfaae8236bc9b);
$parcel$export(module.exports, "TRANSITION_TO_DONE", () => $47745909a3490ed2$export$960e029b4a8abb9);
$parcel$export(module.exports, "TRANSITION_TO_NOT_DONE", () => $47745909a3490ed2$export$27c9c19a3722804a);
$parcel$export(module.exports, "COLUMN_CHANGE", () => $47745909a3490ed2$export$2d4e05cc935c4886);
$parcel$export(module.exports, "UNKNOWN_EVENT", () => $47745909a3490ed2$export$d138dd7d7e8efc82);
$parcel$export(module.exports, "START_EVENT", () => $47745909a3490ed2$export$8bd7ff36223ef5c1);
$parcel$export(module.exports, "END_EVENT", () => $47745909a3490ed2$export$770b45b6acd8c824);
$parcel$export(module.exports, "COMPLETION_SCATTER_SERIES", () => $47745909a3490ed2$export$4cd2ea97b64cb15e);
$parcel$export(module.exports, "SCOPE_SCATTER_SERIES", () => $47745909a3490ed2$export$1c7a611c0a218d57);
$parcel$export(module.exports, "NON_WORKING", () => $47745909a3490ed2$export$748a2ba1e75474a);
const $47745909a3490ed2$export$d76071d5de2774fc = 'software.reports.burnup';
const $47745909a3490ed2$export$91f438b1afe47b53 = 'ACTIVE';
const $47745909a3490ed2$export$1dec7a5987befb9f = 'FUTURE';
const $47745909a3490ed2$export$2c06387706cfbfed = 'CLOSED';
const $47745909a3490ed2$export$cbc0c8b58a79121d = 'ISSUE_ADDED';
const $47745909a3490ed2$export$8af14bf2cdc1bfb6 = 'ISSUE_REMOVED';
const $47745909a3490ed2$export$9d9cfaae8236bc9b = 'ESTIMATION_CHANGE';
const $47745909a3490ed2$export$960e029b4a8abb9 = 'TRANSITION_TO_DONE';
const $47745909a3490ed2$export$27c9c19a3722804a = 'TRANSITION_TO_NOT_DONE';
const $47745909a3490ed2$export$2d4e05cc935c4886 = 'COLUMN_CHANGE';
const $47745909a3490ed2$export$d138dd7d7e8efc82 = 'UNKNOWN_EVENT';
const $47745909a3490ed2$export$8bd7ff36223ef5c1 = 'START_EVENT';
const $47745909a3490ed2$export$770b45b6acd8c824 = 'END_EVENT';
const $47745909a3490ed2$export$4cd2ea97b64cb15e = 'COMPLETION_SCATTER_SERIES';
const $47745909a3490ed2$export$1c7a611c0a218d57 = 'SCOPE_SCATTER_SERIES';
const $47745909a3490ed2$export$67f0f1f8894b1970 = 'WORKING';
const $47745909a3490ed2$export$748a2ba1e75474a = 'NON_WORKING';
const $47745909a3490ed2$export$56d196d2844d1ca1 = {
    PURPLE: 'PURPLE',
    BLUE: 'BLUE',
    GREEN: 'GREEN',
    TEAL: 'TEAL',
    YELLOW: 'YELLOW',
    ORANGE: 'ORANGE'
};
const $47745909a3490ed2$export$b41c0f52c41112e3 = {
    default: 'inprogress',
    inprogress: 'inprogress',
    moved: 'moved',
    new: 'default',
    removed: 'removed',
    success: 'success',
    done: 'success'
};

});

parcelRegister("khYfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba5fff0ccc598e65$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $9EHc8 = parcelRequire("9EHc8");

var $8WuJm = parcelRequire("8WuJm");

var $eIp1n = parcelRequire("eIp1n");

var $6DhaC = parcelRequire("6DhaC");

var $18WwW = parcelRequire("18WwW");

var $j9nvD = parcelRequire("j9nvD");

var $emz59 = parcelRequire("emz59");

var $2SjBx = parcelRequire("2SjBx");

var $gd0Sp = parcelRequire("gd0Sp");

var $4m36T = parcelRequire("4m36T");

var $2Ljpd = parcelRequire("2Ljpd");

var $hyxSC = parcelRequire("hyxSC");

var $fzRmt = parcelRequire("fzRmt");

var $bj12i = parcelRequire("bj12i");

var $7BaJ4 = parcelRequire("7BaJ4");
const $ba5fff0ccc598e65$export$f8b7c42892b2454 = ({ boardId: boardId, now: now })=>{
    const [state] = (0, $2Ljpd.useBurnupFilters)();
    const source = (0, $2SjBx.default)('source');
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: filtersData, loading: filtersLoading, refetch: refetchFilters, error: filtersError } = (0, $bj12i.useBurnupFiltersQuery)({
        boardId: boardId
    });
    const { data: chartData, loading: chartLoading, error: chartError, refetch: refetchChart } = (0, $fzRmt.useBurnupDataQuery)({
        boardId: boardId,
        ...state.dataVariables
    });
    const filters = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filtersData, [
        'boardScope',
        'reports',
        'burnupChart',
        'filters'
    ], null);
    const customFieldId = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(filtersData, [
        'boardScope',
        'estimation',
        'current',
        'customFieldId'
    ], null);
    const currentEstimationType = (0, $6DhaC.getCurrentEstimationStatistic)(customFieldId);
    const experienceId = (0, $j9nvD.useExperienceId)(chartLoading || filtersLoading);
    const chart = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(chartData, [
        'boardScope',
        'reports',
        'burnupChart',
        'chart'
    ], null);
    const { data: timeTrackingOptionsData } = (0, $emz59.default)();
    const timeTrackingOptions = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(timeTrackingOptionsData, [
        'jira',
        'timeTrackingOptions'
    ], (0, $4m36T.defaultTimeTrackingOptions));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "burnupChart",
        attributes: {
            referrer: source || 'direct-link'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        analyticsSource: "burnup",
        application: (0, $eIp1n.JIRA_SOFTWARE),
        edition: tenantContext && tenantContext.appEditions.software,
        experience: "viewBurnup",
        experienceId: experienceId,
        additionalAttributes: {
            synthetic: (0, $hyxSC.isPollinatorTenant)()
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BaJ4.default), {
        now: now,
        filters: filters,
        // @ts-expect-error - TS2322 - Type 'ApolloError | undefined' is not assignable to type 'ApolloError | null'.
        filtersError: filtersError,
        filtersLoading: filtersLoading,
        estimationType: currentEstimationType,
        chart: chart,
        // @ts-expect-error - TS2322 - Type 'ApolloError | undefined' is not assignable to type 'ApolloError | null'.
        chartError: chartError,
        chartLoading: chartLoading,
        onRefetchFilters: ()=>{
            refetchFilters();
        },
        onRefetchChart: ()=>{
            refetchChart();
        },
        timeTrackingOptions: timeTrackingOptions,
        boardId: boardId,
        slaTrackingEnabled: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $18WwW.default), {
        boardId: boardId
    }));
};
var $ba5fff0ccc598e65$export$2e2bcd8739ae039 = $ba5fff0ccc598e65$export$f8b7c42892b2454;

});
parcelRegister("6DhaC", function(module, exports) {

$parcel$export(module.exports, "getSprintFilterRank", () => $bc707c3f30772b28$export$1755a846daf90585);
$parcel$export(module.exports, "getCurrentEstimationStatistic", () => $bc707c3f30772b28$export$9ad7be5a9981cacf);

var $k61d1 = parcelRequire("k61d1");


var $IXOMa = parcelRequire("IXOMa");
const $bc707c3f30772b28$export$1755a846daf90585 = (sprints, sprintId)=>{
    if (sprints && sprintId !== null) return (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(sprints, {
        id: sprintId
    }) + 1;
    return null;
};
const $bc707c3f30772b28$export$9ad7be5a9981cacf = (customFieldId)=>{
    if (customFieldId === (0, $3e06b78b373b0848$export$7357917ec07093f)) return 0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE;
    if (typeof customFieldId === 'string' && customFieldId.startsWith('customfield_')) // story points's customFieldId is customfield_<number>
    return 0, $IXOMa.ESTIMATION_STORY_POINTS;
    // if it's something else, fallback to issue count
    // issue count's customFieldId is null
    return 0, $IXOMa.ESTIMATION_ISSUE_COUNT;
};

});
parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});

const $3e06b78b373b0848$export$7357917ec07093f = 'timeoriginalestimate';

parcelRegister("IXOMa", function(module, exports) {

$parcel$export(module.exports, "ESTIMATION_STORY_POINTS", () => $78c6ec0128d9179b$export$7a8b8513cad04b5b);
$parcel$export(module.exports, "ESTIMATION_ISSUE_COUNT", () => $78c6ec0128d9179b$export$308700cf6ed0483b);
$parcel$export(module.exports, "ESTIMATION_ORIGINAL_ESTIMATE", () => $78c6ec0128d9179b$export$8e4faf3574eea10c);
$parcel$export(module.exports, "formatEstimate", () => $78c6ec0128d9179b$export$36d0190fc64fc5df);
$parcel$export(module.exports, "formatEstimateForTooltip", () => $78c6ec0128d9179b$export$e6df7a1b4bc99436);

var $4m36T = parcelRequire("4m36T");

var $7v0hO = parcelRequire("7v0hO");

var $2E8fA = parcelRequire("2E8fA");
const $78c6ec0128d9179b$export$7a8b8513cad04b5b = 'STORY_POINTS';
const $78c6ec0128d9179b$export$308700cf6ed0483b = 'ISSUE_COUNT';
const $78c6ec0128d9179b$export$8e4faf3574eea10c = 'ORIGINAL_ESTIMATE';
const $78c6ec0128d9179b$export$36d0190fc64fc5df = (estimate, timeTrackingOptions, estimationStatistic, intl)=>{
    if (estimationStatistic === $78c6ec0128d9179b$export$8e4faf3574eea10c) return (0, $7v0hO.timeTrackingFormatter)(estimate, timeTrackingOptions, intl);
    if (estimationStatistic === $78c6ec0128d9179b$export$7a8b8513cad04b5b) return String((0, $2E8fA.roundTo2DecimalPlaces)(estimate));
    return String(estimate);
};
const $78c6ec0128d9179b$export$e6df7a1b4bc99436 = (estimate, timeTrackingOptions, estimationStatistic, intl)=>{
    const estimateToUse = estimationStatistic === $78c6ec0128d9179b$export$8e4faf3574eea10c ? estimate * (0, $4m36T.SECONDS_PER_HOUR) : estimate;
    return $78c6ec0128d9179b$export$36d0190fc64fc5df(estimateToUse, timeTrackingOptions, estimationStatistic, intl);
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $84936c9163886c98$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $eI5EY = parcelRequire("eI5EY");

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");

var $3W1DB = parcelRequire("3W1DB");
const $84936c9163886c98$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatterNew = (time, unit, unitDisplay, { formatNumber: formatNumber })=>{
    if (time > 0) {
        const fixedTime = time.toFixed(2);
        return formatNumber(parseFloat(fixedTime), {
            style: 'unit',
            unit: unit,
            unitDisplay: unitDisplay
        }).replace(/\.?0+$/, '');
    }
    return formatNumber(0, {
        style: 'unit',
        unit: unit,
        unitDisplay: unitDisplay
    });
};
const $84936c9163886c98$var$timeFormatterOld = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatterNew = (timeInSeconds, units, formatNumber)=>{
    const timeForZero = formatNumber(0, {
        style: 'unit',
        unit: (0, $4m36T.TimeUnits).MINUTE,
        unitDisplay: 'narrow'
    });
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? timeObj.time.concat(' ', formatNumber(currentTimeValue, {
            style: 'unit',
            unit: unit.type,
            unitDisplay: 'narrow'
        })) : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterOld = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongFormNew = (timeInSeconds, units, formatNumber)=>{
    const timeForZero = formatNumber(0, {
        style: 'unit',
        unit: (0, $4m36T.TimeUnits).MINUTE,
        unitDisplay: 'long'
    });
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: timeObj.time.concat(' ', formatNumber(currentTimeValue, {
                style: 'unit',
                unit: unit.type,
                unitDisplay: 'long'
            }))
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? timeObj.time.concat(' ', formatNumber(currentTimeValue, {
            style: 'unit',
            unit: unit.type,
            unitDisplay: 'long'
        })) : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongFormOld = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatNumber: formatNumber, formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[1].time, units[1].type, 'narrow', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[1].time, formatMessage(units[1].suffix));
        case (0, $4m36T.TimeFormats).HOURS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[2].time, units[2].type, 'narrow', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[2].time, formatMessage(units[2].suffix));
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timePrettyFormatterNew(timeInSeconds, units, formatNumber);
            return $84936c9163886c98$var$timePrettyFormatterOld(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage, formatNumber: formatNumber })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitLongDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitLongHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitLongMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[1].time, units[1].type, 'long', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $4m36T.TimeFormats).HOURS:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timeFormatterNew(units[2].time, units[2].type, 'long', {
                formatNumber: formatNumber
            });
            return $84936c9163886c98$var$timeFormatterOld(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            if ((0, $eI5EY.fg)('sea-3245-time-tracking-formatter-refactor')) return $84936c9163886c98$var$timePrettyFormatterLongFormNew(timeInSeconds, units, formatNumber);
            return $84936c9163886c98$var$timePrettyFormatterLongFormOld(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("3W1DB", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $1595a85c80e57d00$export$aab44654646f3ccc);
const $1595a85c80e57d00$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});


parcelRegister("2E8fA", function(module, exports) {

$parcel$export(module.exports, "roundTo2DecimalPlaces", () => $f48a60efbf02d10b$export$9c1b92586a99bb20);
/**
 * Round a number to 2 decimal cases.
 *
 * @example
 *
 *   roundTo2DecimalPlaces(2);
 *   // 2
 *   roundTo2DecimalPlaces(1.9);
 *   // 1.9
 *   roundTo2DecimalPlaces(1.99);
 *   // 1.99
 *   roundTo2DecimalPlaces(1.993);
 *   // 1.99
 *   roundTo2DecimalPlaces(1.997);
 *   // 2
 *
 */ const $f48a60efbf02d10b$export$9c1b92586a99bb20 = (input)=>Math.round(input * 100) / 100;

});



parcelRegister("18WwW", function(module, exports) {

$parcel$export(module.exports, "default", () => $30e2efad184824d2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $d6f6c = parcelRequire("d6f6c");

var $gd0Sp = parcelRequire("gd0Sp");

var $3no2s = parcelRequire("3no2s");
const $30e2efad184824d2$var$ViewEvent = ({ boardId: boardId, ProjectConfigQuery: ProjectConfigQuery, FireScreenAnalytics: FireScreenAnalytics })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectConfigQuery, {
        variables: {
            boardId: boardId
        }
    }, ({ data: projectConfigData, loading: projectConfigLoading })=>{
        const features = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(projectConfigData, [
            'boardScope',
            'features'
        ], null);
        const featureMapping = features && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        features.reduce((acc, val)=>{
            acc[val.key] = val.status;
            return acc;
        }, {});
        return !projectConfigLoading && featureMapping && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FireScreenAnalytics, {
            attributes: {
                ...featureMapping,
                isJiraAdmin: tenantContext.isAdmin,
                isSiteAdmin: tenantContext.isSiteAdmin
            }
        });
    });
};
$30e2efad184824d2$var$ViewEvent.defaultProps = {
    ProjectConfigQuery: (0, $3no2s.default),
    FireScreenAnalytics: (0, $d6f6c.FireScreenAnalytics)
};
var $30e2efad184824d2$export$2e2bcd8739ae039 = $30e2efad184824d2$var$ViewEvent;

});
parcelRegister("3no2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88c9969eddbe28a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ipS98 = parcelRequire("ipS98");

var $9ypom = parcelRequire("9ypom");
const $e88c9969eddbe28a$export$193158f35b816f66 = (0, $9ypom.default)`
    query ProjectConfigQuery($boardId: ID!) {
        boardScope(boardId: $boardId) {
            features {
                key
                status
            }
        }
    }
`;
const $e88c9969eddbe28a$var$ProjectConfigQuery = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipS98.Query), {
        query: $e88c9969eddbe28a$export$193158f35b816f66,
        fetchPolicy: "no-cache",
        ...props
    });
var $e88c9969eddbe28a$export$2e2bcd8739ae039 = $e88c9969eddbe28a$var$ProjectConfigQuery;

});
parcelRegister("ipS98", function(module, exports) {

$parcel$export(module.exports, "Query", () => $d684901c79534e6a$export$62297b13309008b2);


var $fKE23 = parcelRequire("fKE23");

var $wLG4P = parcelRequire("wLG4P");

var $1Qivz = parcelRequire("1Qivz");
function $d684901c79534e6a$export$62297b13309008b2(props) {
    var children = props.children, query = props.query, options = (0, $fKE23.__rest)(props, [
        "children",
        "query"
    ]);
    var result = (0, $wLG4P.useQuery)(query, options);
    return children && result ? children(result) : null;
}
(function(Query) {
    Query.propTypes = {
        client: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        notifyOnNetworkStatusChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        pollInterval: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        query: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        partialRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        returnPartialData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
    };
})($d684901c79534e6a$export$62297b13309008b2 || ($d684901c79534e6a$export$62297b13309008b2 = {}));
function $d684901c79534e6a$export$17b8b19c814bcf56(props) {
    var _a = (0, $wLG4P.useMutation)(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
(function(Mutation) {
    Mutation.propTypes = {
        mutation: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        optimisticResponse: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
        ]),
        refetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
        ]),
        awaitRefetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        update: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
    };
})($d684901c79534e6a$export$17b8b19c814bcf56 || ($d684901c79534e6a$export$17b8b19c814bcf56 = {}));
function $d684901c79534e6a$export$f55210826850c514(props) {
    var result = (0, $wLG4P.useSubscription)(props.subscription, props);
    return props.children && result ? props.children(result) : null;
}
(function(Subscription) {
    Subscription.propTypes = {
        subscription: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onSubscriptionData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onSubscriptionComplete: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        shouldResubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
        ])
    };
})($d684901c79534e6a$export$f55210826850c514 || ($d684901c79534e6a$export$f55210826850c514 = {}));

});
parcelRegister("wLG4P", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $0627f9105c9a9319$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useMutation", () => $0627f9105c9a9319$export$609860bf8b0084c);
$parcel$export(module.exports, "useSubscription", () => $0627f9105c9a9319$export$368b4214baeb914c);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $0627f9105c9a9319$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $0627f9105c9a9319$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) this.handleErrorOrCompleted();
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.ssrInitiated = function() {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0, $fKE23.__assign)({
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined,
            stale: false,
            client: this.client
        }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previousData.result = ssrLoading;
            return ssrLoading;
        }
        var result;
        if (this.ssrInitiated()) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.ssrInitiated() && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        var _a, _b;
        if (this.ssrInitiated()) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.ssrInitiated()) (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.renderPromises) === null || _b === void 0 || _b.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.onNewData();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        this.currentObservable.query && this.currentObservable.query.resetQueryStoreErrors();
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery || !this.previousData.result) return;
        var _a = this.previousData.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($0627f9105c9a9319$var$OperationData);
function $0627f9105c9a9319$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $0627f9105c9a9319$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    var queryData = queryDataRef.current || new $0627f9105c9a9319$var$QueryData({
        options: updatedOptions,
        context: context,
        onNewData: function() {
            if (!queryData.ssrInitiated()) Promise.resolve().then(forceUpdate);
            else forceUpdate();
        }
    });
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    if (queryData.ssrInitiated() && !queryDataRef.current) queryDataRef.current = queryData;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $0627f9105c9a9319$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        if (!queryDataRef.current) queryDataRef.current = queryData;
        return function() {
            return queryData.cleanup();
        };
    }, []);
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    return result;
}
function $0627f9105c9a9319$export$dd0a697e1782aedd(query, options) {
    return $0627f9105c9a9319$var$useBaseQuery(query, options, false);
}
function $0627f9105c9a9319$export$fd83eea6ecd2d8fa(query, options) {
    return $0627f9105c9a9319$var$useBaseQuery(query, options, true);
}
var $0627f9105c9a9319$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($0627f9105c9a9319$var$OperationData);
function $0627f9105c9a9319$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $0627f9105c9a9319$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $0627f9105c9a9319$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($0627f9105c9a9319$var$OperationData);
function $0627f9105c9a9319$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $0627f9105c9a9319$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $0627f9105c9a9319$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $0627f9105c9a9319$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $0627f9105c9a9319$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $0627f9105c9a9319$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});




parcelRegister("j9nvD", function(module, exports) {

$parcel$export(module.exports, "useExperienceId", () => $937dca7056a891eb$export$6bd9343ed6f3ac45);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");
const $937dca7056a891eb$export$6bd9343ed6f3ac45 = (isLoading)=>{
    const wasLoading = (0, $eUqFw.useRef)(isLoading);
    const experienceId = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    if (!wasLoading.current && isLoading) experienceId.current = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
    wasLoading.current = isLoading;
    return experienceId.current;
};

});

parcelRegister("emz59", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58858aa78d082d9$export$2e2bcd8739ae039);

var $iZuDo = parcelRequire("iZuDo");

var $9ypom = parcelRequire("9ypom");
const $a58858aa78d082d9$export$bc74855a50e75a27 = (0, $9ypom.default)`
query TimeTrackingOptions {
  jira {
    timeTrackingOptions {
      workingHoursPerDay
      workingDaysPerWeek
      defaultUnit
      timeFormat
    }
  }
}`;
const $a58858aa78d082d9$var$useTimeTrackingOptionsQuery = ()=>(0, $iZuDo.useQuery)($a58858aa78d082d9$export$bc74855a50e75a27, {
        notifyOnNetworkStatusChange: true
    });
var $a58858aa78d082d9$export$2e2bcd8739ae039 = $a58858aa78d082d9$var$useTimeTrackingOptionsQuery;

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});


parcelRegister("2SjBx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c67a39e49d2c975$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8itcz = parcelRequire("8itcz");

var $8blac = parcelRequire("8blac");

var $lB25E = parcelRequire("lB25E");
const $6c67a39e49d2c975$var$defaultOptions = {
    useRouter: (0, $lB25E.useRouter),
    useState: (0, $eUqFw.useState),
    useEffect: (0, $eUqFw.useEffect)
};
/**
 * This is a hook that gets a querystring parameter from the URL and removes it.
 *
 * This parameter is stored in the component's state through `useState`.
 *
 * You shouldn't rely on this clearing after the source is removed from the URL within a single
 * session, since this isn't done.
 */ const $6c67a39e49d2c975$var$useQueryParameter = (parameter, options)=>{
    const { useRouter: useRouter, useState: useState, useEffect: useEffect } = {
        ...$6c67a39e49d2c975$var$defaultOptions,
        ...options || {}
    };
    const [{ location: location, query: query }, { replace: replace }] = useRouter();
    const [stateValue, setValue] = useState(null);
    const { [parameter]: value, ...otherQuery } = query;
    const targetUrl = `${location.pathname}${!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(otherQuery) ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($8itcz))).stringify(otherQuery)}` : ''}`;
    useEffect(()=>{
        if (value) setValue(value);
    }, [
        setValue,
        value
    ]);
    useEffect(()=>{
        replace(targetUrl);
    }, [
        replace,
        targetUrl
    ]);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string | null'.
    return value || stateValue;
};
var $6c67a39e49d2c975$export$2e2bcd8739ae039 = $6c67a39e49d2c975$var$useQueryParameter;

});
parcelRegister("8itcz", function(module, exports) {

$parcel$export(module.exports, "decode", () => $60a6a8029ffaae01$export$2f872c0f2117be69, (v) => $60a6a8029ffaae01$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $60a6a8029ffaae01$export$98e6a39c04603d36, (v) => $60a6a8029ffaae01$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $60a6a8029ffaae01$export$c564cdbbe6da493, (v) => $60a6a8029ffaae01$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $60a6a8029ffaae01$export$fac44ee5b035f737, (v) => $60a6a8029ffaae01$export$fac44ee5b035f737 = v);
var $60a6a8029ffaae01$export$2f872c0f2117be69;
var $60a6a8029ffaae01$export$98e6a39c04603d36;
var $60a6a8029ffaae01$export$c564cdbbe6da493;
var $60a6a8029ffaae01$export$fac44ee5b035f737;
'use strict';

$60a6a8029ffaae01$export$2f872c0f2117be69 = $60a6a8029ffaae01$export$98e6a39c04603d36 = (parcelRequire("4WGGY"));

$60a6a8029ffaae01$export$c564cdbbe6da493 = $60a6a8029ffaae01$export$fac44ee5b035f737 = (parcelRequire("9xtCu"));

});
parcelRegister("4WGGY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $399db1fd33a7e3fa$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$399db1fd33a7e3fa$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($399db1fd33a7e3fa$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $399db1fd33a7e3fa$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("9xtCu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6f1e2c05a5f80c6e$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $6f1e2c05a5f80c6e$var$map($6f1e2c05a5f80c6e$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(k)) + eq;
        if ($6f1e2c05a5f80c6e$var$isArray(obj[k])) return $6f1e2c05a5f80c6e$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(name)) + eq + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj));
};
var $6f1e2c05a5f80c6e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $6f1e2c05a5f80c6e$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $6f1e2c05a5f80c6e$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("2Ljpd", function(module, exports) {

$parcel$export(module.exports, "useBurnupFilters", () => $22e7493333073680$export$a26ba1a997fe4cf2);

var $129XB = parcelRequire("129XB");
const $22e7493333073680$export$a26ba1a997fe4cf2 = (0, $129XB.makeUseFilters)('@burnup-report/filters-controller');

});
parcelRegister("129XB", function(module, exports) {

$parcel$export(module.exports, "makeUseFilters", () => $f94e12cd91fbc428$export$dfbc178ff0011b5a);

var $WBLbN = parcelRequire("WBLbN");

var $bWKIu = parcelRequire("bWKIu");
const $f94e12cd91fbc428$export$d4c72bab9d6cc13a = {
    sprint: null,
    estimation: null,
    dataLoadedOnce: false,
    dataVariables: {
        sprintId: null,
        estimation: null
    }
};
const $f94e12cd91fbc428$export$142d643ec6e0e2b5 = (name)=>(0, $WBLbN.createStore)({
        initialState: $f94e12cd91fbc428$export$d4c72bab9d6cc13a,
        actions: $bWKIu,
        name: name
    });
const $f94e12cd91fbc428$export$dfbc178ff0011b5a = (name)=>(0, $WBLbN.createHook)($f94e12cd91fbc428$export$142d643ec6e0e2b5(name));

});
parcelRegister("bWKIu", function(module, exports) {

$parcel$export(module.exports, "setSprintAndDirty", () => $9e4fbe91836cb6e1$export$ff6c14fb923280b1);
$parcel$export(module.exports, "setEstimationFieldAndDirty", () => $9e4fbe91836cb6e1$export$a7be6e1a5260566);
$parcel$export(module.exports, "setDataLoadedOnce", () => $9e4fbe91836cb6e1$export$2d13057a26e7d4e0);
$parcel$export(module.exports, "selectFiltersOnDataLoaded", () => $9e4fbe91836cb6e1$export$fb8b40c84288a96a);

var $IXOMa = parcelRequire("IXOMa");
const $9e4fbe91836cb6e1$export$ff6c14fb923280b1 = (newValue)=>({ getState: getState, setState: setState })=>{
        const { dataVariables: dataVariables } = getState();
        setState({
            sprint: newValue,
            dataVariables: {
                ...dataVariables,
                sprintId: newValue.id
            }
        });
    };
const $9e4fbe91836cb6e1$export$a7be6e1a5260566 = (newValue)=>({ getState: getState, setState: setState })=>{
        const { dataVariables: dataVariables } = getState();
        setState({
            estimation: newValue,
            dataVariables: {
                ...dataVariables,
                estimation: newValue
            }
        });
    };
const $9e4fbe91836cb6e1$export$2d13057a26e7d4e0 = (newValue)=>({ setState: setState })=>{
        setState({
            dataLoadedOnce: newValue
        });
    };
const $9e4fbe91836cb6e1$export$fb8b40c84288a96a = (filters, estimationType = (0, $IXOMa.ESTIMATION_ISSUE_COUNT), retroPublishedSprintId = null)=>({ getState: getState, setState: setState })=>{
        if (!filters) return;
        const { sprint: sprint, estimation: estimation } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateUpdate = {};
        // Select the sprint of the newly published retro
        if (retroPublishedSprintId) {
            const newSprint = filters.sprints.find((val)=>val.id.toString() === retroPublishedSprintId);
            if (newSprint) stateUpdate.sprint = newSprint;
        }
        if (!stateUpdate.sprint && !sprint && filters.sprints[0]) {
            const newSprint = filters.sprints[0];
            stateUpdate.sprint = newSprint;
        }
        if (!estimation) stateUpdate.estimation = estimationType;
        setState(stateUpdate);
    };

});



parcelRegister("hyxSC", function(module, exports) {

$parcel$export(module.exports, "isErrorTrackingEnabledWithSentry", () => $07d94fe7fa98db56$export$23d600ca6d887b4d);
$parcel$export(module.exports, "isPollinatorTenant", () => $07d94fe7fa98db56$export$f59b7b56b5cada61);

var $1ybV0 = parcelRequire("1ybV0");
const $07d94fe7fa98db56$export$23d600ca6d887b4d = ()=>(0, $1ybV0.ff)('fe.platform.error.tracking.enabled');
const $07d94fe7fa98db56$export$f59b7b56b5cada61 = ()=>(0, $1ybV0.ff)('jsw.pollinator.tenants');

});

parcelRegister("fzRmt", function(module, exports) {

$parcel$export(module.exports, "useBurnupDataQuery", () => $6d1e39a63869609b$export$88ce72e24cf801c9);

var $eUqFw = parcelRequire("eUqFw");

var $ipS98 = parcelRequire("ipS98");

var $iZuDo = parcelRequire("iZuDo");

var $9ypom = parcelRequire("9ypom");
const $6d1e39a63869609b$export$1e1347962ce53cb8 = (0, $9ypom.default)`
    query BurnupDataQuery(
        $boardId: ID!
        $sprintId: ID
        $estimation: SprintReportsEstimationStatistic
    ) {
        boardScope(boardId: $boardId) {
            reports {
                burnupChart {
                    chart(sprintId: $sprintId, estimation: $estimation) {
                        startTime
                        endTime
                        sprintStartEvent {
                            scopeEstimate
                            timestamp
                            issueList {
                                issueKey
                                issueSummary
                                estimate
                            }
                        }
                        scopeChangeEvents {
                            timestamp
                            issueKey
                            issueSummary
                            eventType
                            scope
                            completion
                            estimate
                            prevScope
                            prevCompletion
                            prevEstimate
                        }
                        sprintEndEvent {
                            scope
                            issueList {
                                issueKey
                                issueSummary
                                estimate
                            }
                            timestamp
                            completion
                        }
                        timeZone
                    }
                }
            }
        }
    }
`;
/**
 * Apollo Query for the burnup chart data.
 */ const $6d1e39a63869609b$var$BurnupDataQuery = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipS98.Query), {
        ...props,
        query: $6d1e39a63869609b$export$1e1347962ce53cb8
    });
const $6d1e39a63869609b$export$88ce72e24cf801c9 = (variables)=>(0, $iZuDo.useQuery)($6d1e39a63869609b$export$1e1347962ce53cb8, {
        variables: variables,
        notifyOnNetworkStatusChange: true
    });
var $6d1e39a63869609b$export$2e2bcd8739ae039 = $6d1e39a63869609b$var$BurnupDataQuery;

});

parcelRegister("bj12i", function(module, exports) {

$parcel$export(module.exports, "useBurnupFiltersQuery", () => $b04092ec6db2d031$export$246308262751f275);

var $eUqFw = parcelRequire("eUqFw");

var $ipS98 = parcelRequire("ipS98");

var $iZuDo = parcelRequire("iZuDo");

var $9ypom = parcelRequire("9ypom");
const $b04092ec6db2d031$export$e2bf070e7017771e = (0, $9ypom.default)`
    query BurnupFiltersQuery($boardId: ID!) {
        boardScope(boardId: $boardId) {
            reports {
                burnupChart {
                    filters {
                        sprints {
                            id
                            goal
                            startDate
                            name
                            endDate
                            sprintState
                        }
                        estimationStatistic
                    }
                }
            }
            estimation {
                current {
                    customFieldId
                }
            }
        }
    }
`;
const $b04092ec6db2d031$var$BurnupFiltersQuery = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipS98.Query), {
        ...props,
        query: $b04092ec6db2d031$export$e2bf070e7017771e
    });
const $b04092ec6db2d031$export$246308262751f275 = (variables)=>(0, $iZuDo.useQuery)($b04092ec6db2d031$export$e2bf070e7017771e, {
        variables: variables,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    });
var $b04092ec6db2d031$export$2e2bcd8739ae039 = $b04092ec6db2d031$var$BurnupFiltersQuery;

});

parcelRegister("7BaJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2db3380a4e635132$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var $8yne0 = parcelRequire("8yne0");

var $lgxha = parcelRequire("lgxha");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");

var $7vf5z = parcelRequire("7vf5z");

var $k6k25 = parcelRequire("k6k25");

var $a4ptX = parcelRequire("a4ptX");

var $1f1m0 = parcelRequire("1f1m0");

var $IXOMa = parcelRequire("IXOMa");


var $1kIkT = parcelRequire("1kIkT");

var $94EW1 = parcelRequire("94EW1");

var $3YysV = parcelRequire("3YysV");

var $iJHZm = parcelRequire("iJHZm");

var $2Ljpd = parcelRequire("2Ljpd");

var $hyxSC = parcelRequire("hyxSC");

var $7vGnP = parcelRequire("7vGnP");

var $bIMcX = parcelRequire("bIMcX");

var $kZ5e1 = parcelRequire("kZ5e1");

var $13lzg = parcelRequire("13lzg");
const $2db3380a4e635132$var$BurnupReportView = ({ now: now, filters: filters, filtersError: filtersError, filtersLoading: filtersLoading, estimationType: estimationType, onRefetchFilters: onRefetchFilters, chart: chart, chartError: chartError, chartLoading: chartLoading, timeTrackingOptions: timeTrackingOptions, onRefetchChart: onRefetchChart, boardId: boardId, slaTrackingEnabled: slaTrackingEnabled = false })=>{
    const intl = (0, $5JgJ2.default)();
    const [state, actions] = (0, $2Ljpd.useBurnupFilters)();
    const onEditSprintComplete = (sprint)=>{
        actions.setSprintAndDirty(sprint);
        onRefetchFilters();
    };
    if ((0, $k6k25.isKnownSprintError)(chartError || filtersError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, slaTrackingEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: "BurnupEmptyView"
    }), !state.dataLoadedOnce && chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>actions.setDataLoadedOnce(true)
    }), state.dataLoadedOnce && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        ttrSlo: 8000,
        ttiSlo: 8000,
        appName: "software-reports-sprint-burnup-chart",
        extra: {
            isSentryEnabled: String((0, $hyxSC.isErrorTrackingEnabledWithSentry)()),
            synthetic: (0, $hyxSC.isPollinatorTenant)()
        },
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $7vGnP.burnupChartPageLoad)
    }));
    if (chartError || filtersError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, slaTrackingEnabled && (0, $3YysV.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    chartError || filtersError, chartError ? 'burnupChart' : 'burnupFilters'), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1kIkT.default), {
        reportName: (0, $8d11e5d9fbfdd77a$export$cf0434be31c2d007),
        chartError: chartError,
        filtersError: filtersError,
        onClickRetry: chartError ? onRefetchChart : onRefetchFilters
    }));
    const userTimeZone = chart && chart.timeZone ? chart.timeZone : 'Etc/UTC';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !filtersLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>actions.selectFiltersOnDataLoaded(filters, estimationType)
    }), !state.dataLoadedOnce && chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>actions.setDataLoadedOnce(true)
    }), state.dataLoadedOnce && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        ttrSlo: 8000,
        ttiSlo: 8000,
        appName: "software-reports-sprint-burnup-chart",
        extra: {
            isSentryEnabled: String((0, $hyxSC.isErrorTrackingEnabledWithSentry)()),
            synthetic: (0, $hyxSC.isPollinatorTenant)()
        },
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: (0, $7vGnP.burnupChartPageLoad)
    }), slaTrackingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
        location: "BurnupFilters"
    }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4ptX.default), {
            disabled: false,
            sprintsLoading: filtersLoading,
            estimationFieldsLoading: filtersLoading,
            sprints: filters ? filters.sprints : [],
            sprint: state.sprint,
            onChangeSprint: actions.setSprintAndDirty,
            estimationFields: filters ? filters.estimationStatistic : [],
            onChangeEstimation: actions.setEstimationFieldAndDirty,
            estimation: state.estimation,
            onExperienceSuccess: onExperienceSuccess,
            boardId: boardId,
            onEditSprintComplete: onEditSprintComplete
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a4ptX.default), {
        disabled: false,
        sprintsLoading: filtersLoading,
        estimationFieldsLoading: filtersLoading,
        sprints: filters ? filters.sprints : [],
        sprint: state.sprint,
        onChangeSprint: actions.setSprintAndDirty,
        estimationFields: filters ? filters.estimationStatistic : [],
        onChangeEstimation: actions.setEstimationFieldAndDirty,
        estimation: state.estimation,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onExperienceSuccess: ()=>{},
        boardId: 1,
        onEditSprintComplete: onEditSprintComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1f1m0.SprintDetailsLegacy), {
        sprint: state.sprint,
        intl: intl
    }), slaTrackingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (!chart || chartLoading) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94EW1.default), {
        testId: "software-burnup-report.ui.burnup-spinner"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: (0, $13lzg.getTrackEventContextAttributes)(state, filters)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
        location: "BurnupChart"
    }, ({ onExperienceSuccess: onExperienceSuccess })=>chart && !chartLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bIMcX.default), {
            now: now,
            statisticField: state.estimation,
            burnup: state.estimation === (0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE) ? (0, $13lzg.convertChartsDataSecondsToHours)(chart) : chart,
            userTimeZone: userTimeZone,
            timeTrackingOptions: timeTrackingOptions,
            onExperienceSuccess: onExperienceSuccess
        }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
        location: "BurnupGrid"
    }, ({ onExperienceSuccess: onExperienceSuccess })=>chart && !chartLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZ5e1.default), {
            burnup: chart,
            statisticField: state.estimation,
            timeTrackingOptions: timeTrackingOptions,
            onExperienceSuccess: onExperienceSuccess
        }) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !chart || chartLoading || filtersLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94EW1.default), {
        testId: "software-burnup-report.ui.burnup-spinner"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: (0, $13lzg.getTrackEventContextAttributes)(state, filters)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bIMcX.default), {
        now: now,
        statisticField: state.estimation,
        burnup: state.estimation === (0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE) ? (0, $13lzg.convertChartsDataSecondsToHours)(chart) : chart,
        userTimeZone: userTimeZone,
        timeTrackingOptions: timeTrackingOptions,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onExperienceSuccess: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kZ5e1.default), {
        burnup: chart,
        statisticField: state.estimation,
        timeTrackingOptions: timeTrackingOptions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null))));
};
var $2db3380a4e635132$export$2e2bcd8739ae039 = $2db3380a4e635132$var$BurnupReportView;

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("k6k25", function(module, exports) {

$parcel$export(module.exports, "isKnownSprintError", () => $4a0b5129f66bc901$export$d1d5531bac6e963c);

var $illlw = parcelRequire("illlw");


var $6DhaC = parcelRequire("6DhaC");
const $4a0b5129f66bc901$export$4bc70768d9bf7727 = (state, filters)=>({
        estimationStatistic: state.estimation,
        sprintFilterRank: (0, $6DhaC.getSprintFilterRank)(filters && filters.sprints, state.sprint && state.sprint.id),
        totalSprints: filters && filters.sprints.length
    });
const $4a0b5129f66bc901$export$d1d5531bac6e963c = (error)=>{
    if (!error) return false;
    if (!error.graphQLErrors || !error.graphQLErrors.length) return false;
    const errorKey = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error.graphQLErrors[0], [
        'extensions',
        'errorType'
    ], null);
    return errorKey === (0, $31671c3bcdb1b8f1$export$1fcf329e1604c2ae) || errorKey === (0, $31671c3bcdb1b8f1$export$3f429f4e61b797fe);
};

});
const $31671c3bcdb1b8f1$export$91f438b1afe47b53 = 'ACTIVE';
const $31671c3bcdb1b8f1$export$1dec7a5987befb9f = 'FUTURE';
const $31671c3bcdb1b8f1$export$2c06387706cfbfed = 'CLOSED';
const $31671c3bcdb1b8f1$export$1fcf329e1604c2ae = 'jsw.reports.no-started-sprint-available';
const $31671c3bcdb1b8f1$export$3f429f4e61b797fe = 'jsw.reports.no-such-sprint-found';
const $31671c3bcdb1b8f1$export$f7109619a5e9e0d6 = 'burn-reports-common';
const $31671c3bcdb1b8f1$export$a81c17aababf7d22 = 'sprintActionReopen';


parcelRegister("a4ptX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3d8349366ad457$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $a6Zux = parcelRequire("a6Zux");

var $3eyoM = parcelRequire("3eyoM");

var $2txB9 = parcelRequire("2txB9");

var $d00oA = parcelRequire("d00oA");
const $6e3d8349366ad457$export$7cde9e07a15fb2bc = ({ onChangeSprint: onChangeSprint, sprints: sprints, disabled: disabled, sprintsLoading: sprintsLoading, sprint: sprint, isDefaultOpen: isDefaultOpen })=>{
    const intl = (0, $5JgJ2.default)();
    const onChangeSprintWithAnalytics = (option, _, analyticsEvent)=>{
        onChangeSprint(option.sprint);
        const attributes = (0, $d00oA.getSprintFilterEventAttributes)(sprints, option.sprint);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sprintBurndownChartSprintFilter', attributes);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a6Zux.ControlContainer), {
        "data-test-id": "software-burn-reports-common.ui.controls.sprint-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a6Zux.ControlLabel), {
        htmlFor: "burndownSprint"
    }, intl.formatMessage((0, $3eyoM.default).sprint)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        defaultMenuIsOpen: isDefaultOpen,
        isDisabled: disabled,
        id: "burndownSprint",
        isLoading: sprintsLoading,
        "aria-label": intl.formatMessage((0, $3eyoM.default).sprint),
        label: intl.formatMessage((0, $3eyoM.default).sprint),
        value: sprint ? (0, $d00oA.optionForSprint)(sprint) : null,
        // @ts-expect-error - TS2322 - Type '(option: SprintOption, _: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(value: SprintOption | null, action: ActionMeta<SprintOption>) => void'.
        onChange: onChangeSprintWithAnalytics,
        options: sprints ? sprints.map((0, $d00oA.optionForSprint)) : []
    }));
};
const $6e3d8349366ad457$export$2f80af0f1f112cb9 = ({ onChangeEstimation: onChangeEstimation, estimation: estimation, disabled: disabled, estimationFieldsLoading: estimationFieldsLoading, estimationFields: estimationFields, isDefaultOpen: isDefaultOpen })=>{
    const intl = (0, $5JgJ2.default)();
    const onChangeEstimationWithAnalytics = (option, _, analyticsEvent)=>{
        onChangeEstimation(option.value);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'sprintBurndownChartEstimationFilter', {
            estimationStatistic: option.value
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a6Zux.ControlContainer), {
        "data-test-id": "software-burn-reports-common.ui.controls.estimation-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a6Zux.ControlLabel), {
        htmlFor: "burndownEstimationField"
    }, intl.formatMessage((0, $3eyoM.default).estimationField)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        defaultMenuIsOpen: isDefaultOpen,
        isDisabled: disabled,
        id: "burndownEstimationField",
        "aria-label": intl.formatMessage((0, $3eyoM.default).estimationField),
        label: intl.formatMessage((0, $3eyoM.default).estimationField),
        isLoading: estimationFieldsLoading,
        // @ts-expect-error - TS2322 - Type '(option: EstimationFieldOption, _: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type '(value: EstimationFieldOption | null, action: ActionMeta<EstimationFieldOption>) => void'.
        onChange: onChangeEstimationWithAnalytics,
        value: estimation ? (0, $d00oA.optionForStatistic)(estimation, intl) : null,
        options: estimationFields ? estimationFields.map((estimationField)=>(0, $d00oA.optionForStatistic)(estimationField, intl)) : []
    }));
};
const $6e3d8349366ad457$var$Controls = ({ sprints: sprints, sprint: sprint, estimation: estimation, sprintsLoading: sprintsLoading, estimationFieldsLoading: estimationFieldsLoading, estimationFields: estimationFields, onChangeSprint: onChangeSprint, onChangeEstimation: onChangeEstimation, disabled: disabled, onExperienceSuccess: onExperienceSuccess, boardId: boardId, onEditSprintComplete: onEditSprintComplete })=>{
    (0, $eUqFw.useEffect)(()=>{
        if (!sprintsLoading && !estimationFieldsLoading) onExperienceSuccess();
    }, [
        onExperienceSuccess,
        sprint,
        estimation,
        sprintsLoading,
        estimationFieldsLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a6Zux.ControlsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3d8349366ad457$export$7cde9e07a15fb2bc, {
        onChangeSprint: onChangeSprint,
        sprints: sprints,
        disabled: disabled,
        sprintsLoading: sprintsLoading,
        sprint: sprint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e3d8349366ad457$export$2f80af0f1f112cb9, {
        onChangeEstimation: onChangeEstimation,
        estimation: estimation,
        disabled: disabled,
        estimationFieldsLoading: estimationFieldsLoading,
        estimationFields: estimationFields
    }), !sprintsLoading && sprint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2txB9.default), {
        sprint: sprint,
        boardId: boardId,
        onEditSprintComplete: onEditSprintComplete
    }));
};
var $6e3d8349366ad457$export$2e2bcd8739ae039 = $6e3d8349366ad457$var$Controls;

});
parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});




parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("a6Zux", function(module, exports) {

$parcel$export(module.exports, "ControlsContainer", () => $7edbd9758b96a311$export$9987290566e0de90);
$parcel$export(module.exports, "ControlContainer", () => $7edbd9758b96a311$export$8561285c34903aad);
$parcel$export(module.exports, "ControlLabel", () => $7edbd9758b96a311$export$9b4cb4c863feb00b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $7edbd9758b96a311$export$9987290566e0de90 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { lowerOpacity: lowerOpacity, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564a7xe",
            __cmplp.lowerOpacity ? "_tzy41ou4" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $7edbd9758b96a311$export$8561285c34903aad = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi _p12fp3fh _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $7edbd9758b96a311$export$9b4cb4c863feb00b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1yt4sz9k _syaz1wmz _11c816g6 _19pkpxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3eyoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b1f052ee983708$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b2b1f052ee983708$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sprint: {
        "id": "software-burn-reports-common.controls.sprint",
        "defaultMessage": "Sprint"
    },
    estimationField: {
        "id": "software-burn-reports-common.controls.estimation-field",
        "defaultMessage": "Estimation field"
    },
    optionStatisticIssueCount: {
        "id": "software-burn-reports-common.controls.option-statistic-issue-count",
        "defaultMessage": "Issue count"
    },
    optionStatisticStoryPoints: {
        "id": "software-burn-reports-common.controls.option-statistic-story-points",
        "defaultMessage": "Story points"
    },
    optionStatisticOriginalEstimate: {
        "id": "software-burn-reports-common.controls.option-statistic-original-estimate",
        "defaultMessage": "Time"
    }
});

});

parcelRegister("2txB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $a92a21e00ce8beac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a92a21e00ce8beac$var$LazySprintActions = (0, $7rh0R.lazy)(()=>(parcelRequire("elHeG")), {
    moduleId: "./src/packages/software/reports/burn-reports-common/src/ui/controls/sprint-actions/index.tsx"
});
const $a92a21e00ce8beac$export$146371f4b0ba879d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.burn-reports-common.sprint-actions.defer",
        packageName: "jiraSoftwareBurnReportsCommon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "burn-reports-common-sprint-actions-defer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a92a21e00ce8beac$var$LazySprintActions, props)));
var $a92a21e00ce8beac$export$2e2bcd8739ae039 = $a92a21e00ce8beac$export$146371f4b0ba879d;

});
parcelRegister("elHeG", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hhC3L")
]).then(()=>parcelRequire('269Xd'));

});


parcelRegister("d00oA", function(module, exports) {

$parcel$export(module.exports, "optionForStatistic", () => $23f75a4c20766923$export$ac8575c7d97671c);
$parcel$export(module.exports, "optionForSprint", () => $23f75a4c20766923$export$8ca7784503650dd7);
$parcel$export(module.exports, "getSprintFilterEventAttributes", () => $23f75a4c20766923$export$c4f24900e6ace89);

var $IXOMa = parcelRequire("IXOMa");

var $6DhaC = parcelRequire("6DhaC");

var $3eyoM = parcelRequire("3eyoM");
const $23f75a4c20766923$export$ac8575c7d97671c = (statistic, intl)=>{
    if (statistic === (0, $IXOMa.ESTIMATION_ISSUE_COUNT)) return {
        label: intl.formatMessage((0, $3eyoM.default).optionStatisticIssueCount),
        value: (0, $IXOMa.ESTIMATION_ISSUE_COUNT)
    };
    if (statistic === (0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE)) return {
        label: intl.formatMessage((0, $3eyoM.default).optionStatisticOriginalEstimate),
        value: (0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE)
    };
    return {
        label: intl.formatMessage((0, $3eyoM.default).optionStatisticStoryPoints),
        value: (0, $IXOMa.ESTIMATION_STORY_POINTS)
    };
};
const $23f75a4c20766923$export$8ca7784503650dd7 = (sprint)=>({
        sprint: sprint,
        label: sprint.name,
        value: sprint.id
    });
const $23f75a4c20766923$export$c4f24900e6ace89 = (sprints, sprint)=>({
        sprintFilterRank: (0, $6DhaC.getSprintFilterRank)(sprints, sprint && sprint.id),
        totalSprints: sprints && sprints.length
    });

});


parcelRegister("1f1m0", function(module, exports) {

$parcel$export(module.exports, "SprintDetails", () => $a93c97c73f44de00$export$8ffabcc164d0c0b5);
$parcel$export(module.exports, "SprintDetailsLegacy", () => $a93c97c73f44de00$export$e661e5ac2f0d82e1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3xcI8 = parcelRequire("3xcI8");

var $1Yimi = parcelRequire("1Yimi");

var $kjXsi = parcelRequire("kjXsi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");

var $gd0Sp = parcelRequire("gd0Sp");

var $9Pshr = parcelRequire("9Pshr");
const $a93c97c73f44de00$var$SprintDate = ({ startDate: startDate, endDate: endDate, locale: locale })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!startDate || !endDate) return null;
    const start = (0, $8K9kM.formatWithLocale)((0, $3xcI8.default)(startDate), 'PPP', locale);
    const end = (0, $8K9kM.formatWithLocale)((0, $3xcI8.default)(endDate), 'PPP', locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        weight: "bold"
    }, formatMessage((0, $9Pshr.default).sprintDate)), " - ", `${start} - ${end}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), null, `${formatMessage((0, $9Pshr.default).sprintDate)} - ${formatMessage((0, $9Pshr.default).screenReaderSprintDate, {
        startDate: start,
        endDate: end
    })}`));
};
const $a93c97c73f44de00$var$SprintGoal = ({ goal: goal })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!goal) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        weight: "bold"
    }, formatMessage((0, $9Pshr.default).sprintGoal)), " - ", goal);
};
const $a93c97c73f44de00$export$8ffabcc164d0c0b5 = ({ sprint: sprint })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    if (!sprint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a93c97c73f44de00$var$SprintDetailsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a93c97c73f44de00$var$SprintDate, {
        startDate: sprint.startDate,
        endDate: sprint.endDate,
        locale: tenantContext.locale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a93c97c73f44de00$var$SprintGoal, {
        goal: sprint.goal
    }));
};
const $a93c97c73f44de00$var$SprintDateLegacy = ({ startDate: startDate, endDate: endDate, locale: locale, intl: intl })=>{
    if (!startDate || !endDate) return null;
    const start = (0, $8K9kM.formatWithLocale)((0, $3xcI8.default)(startDate), 'PPP', locale);
    const end = (0, $8K9kM.formatWithLocale)((0, $3xcI8.default)(endDate), 'PPP', locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "strong",
        color: "inherit"
    }, intl.formatMessage((0, $9Pshr.default).sprintDate)), ' ', "- ", `${start} - ${end}`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), null, `${intl.formatMessage((0, $9Pshr.default).sprintDate)} - ${intl.formatMessage((0, $9Pshr.default).screenReaderSprintDate, {
        startDate: start,
        endDate: end
    })}`));
};
/* @deprecated - use SprintGoal instead which removes intl prop and uses useIntl hook */ const $a93c97c73f44de00$var$SprintGoalLegacy = ({ goal: goal, intl: intl })=>{
    if (!goal) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "strong",
        color: "inherit"
    }, intl.formatMessage((0, $9Pshr.default).sprintGoal)), ' ', "- ", goal);
};
const $a93c97c73f44de00$export$e661e5ac2f0d82e1 = ({ sprint: sprint, intl: intl })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    if (!sprint) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a93c97c73f44de00$var$SprintDetailsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a93c97c73f44de00$var$SprintDateLegacy, {
        intl: intl,
        startDate: sprint.startDate,
        endDate: sprint.endDate,
        locale: tenantContext.locale
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a93c97c73f44de00$var$SprintGoalLegacy, {
        intl: intl,
        goal: sprint.goal
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a93c97c73f44de00$var$SprintDetailsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _19pkxy5q _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kjXsi", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $cfcbcec828cf2e62$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $cfcbcec828cf2e62$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $cfcbcec828cf2e62$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /**
 * Visible only to screenreaders. Use when there is a need
 * to provide more context to a non-sighted user.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $cfcbcec828cf2e62$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
const $cfcbcec828cf2e62$export$88fad6aa294f111c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$200c8e5d652aa9af = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9Pshr", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e2069dd9d00a11$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $44e2069dd9d00a11$var$messages = (0, $90IgZ.defineMessages)({
    sprintDate: {
        "id": "software-burn-reports-common.sprint-details.sprint-date",
        "defaultMessage": "Date"
    },
    screenReaderSprintDate: {
        "id": "software-burn-reports-common.sprint-details.screen-reader-sprint-date",
        "defaultMessage": "{startDate} to {endDate}"
    },
    sprintGoal: {
        "id": "software-burn-reports-common.sprint-details.sprint-goal",
        "defaultMessage": "Sprint goal"
    }
});
var $44e2069dd9d00a11$export$2e2bcd8739ae039 = $44e2069dd9d00a11$var$messages;

});


const $8d11e5d9fbfdd77a$export$cf0434be31c2d007 = 'burnup';
const $8d11e5d9fbfdd77a$export$789d8a41ceb37ba3 = 'sprintBurndownChart';
const $8d11e5d9fbfdd77a$export$17501f6f36b13095 = 'cumulativeFlowDiagram';
const $8d11e5d9fbfdd77a$export$873cd93836278312 = 'velocityReport';

parcelRegister("1kIkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7d2897afc40173$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $SFoH6 = parcelRequire("SFoH6");

var $4Es8k = parcelRequire("4Es8k");

var $giAhk = parcelRequire("giAhk");

var $d6f6c = parcelRequire("d6f6c");

var $17dMY = parcelRequire("17dMY");

var $7fmVq = parcelRequire("7fmVq");
const $ed7d2897afc40173$export$802a7d2be59f38c3 = ({ onClickRetry: onClickRetry, intl: intl, filtersError: filtersError, chartError: chartError, reportName: reportName })=>{
    const statusCode = chartError ? (0, $7fmVq.getErrorStatus)(chartError) : (0, $7fmVq.getErrorStatus)(filtersError);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $SFoH6.default)),
        header: intl.formatMessage((0, $17dMY.default).fetchError),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: ()=>onClickRetry()
        }, intl.formatMessage((0, $17dMY.default).retryOnError))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
        eventName: `${reportName} failed`,
        attributes: {
            isChartError: !!chartError,
            isFiltersError: !!filtersError,
            errorType: chartError ? (0, $7fmVq.getErrorType)(chartError) : (0, $7fmVq.getErrorType)(filtersError),
            statusCode: `${statusCode || 'unknown'}` // returning as string so we can pass it on to SignalFX as an enum
        }
    }));
};
const $ed7d2897afc40173$var$ErrorEmptyStateWithIntl = (0, $giAhk.injectIntlV2)($ed7d2897afc40173$export$802a7d2be59f38c3);
var $ed7d2897afc40173$export$2e2bcd8739ae039 = $ed7d2897afc40173$var$ErrorEmptyStateWithIntl;

});
parcelRegister("SFoH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $88dd63a378373614$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $8E7L8 = parcelRequire("8E7L8");
const $88dd63a378373614$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8E7L8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8E7L8)),
    autoDark: false
});
var $88dd63a378373614$export$2e2bcd8739ae039 = $88dd63a378373614$var$Illustration;
// for advanced use only
const $88dd63a378373614$export$a179c88182cb9d56 = [
    0,
    0,
    277,
    263
];

});
parcelRegister("8E7L8", function(module, exports) {
module.exports = new URL("icecream-accident.69b5c609.svg", import.meta.url).toString();

});


parcelRegister("17dMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca8353b2a2cadbad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ca8353b2a2cadbad$var$messages = (0, $90IgZ.defineMessages)({
    fetchError: {
        "id": "software-reports-cumulative-flow-diagram.error-empty-state.fetch-error",
        "defaultMessage": "There was an error while fetching your report."
    },
    retryOnError: {
        "id": "software-reports-cumulative-flow-diagram.error-empty-state.retry-on-error",
        "defaultMessage": "Retry"
    }
});
var $ca8353b2a2cadbad$export$2e2bcd8739ae039 = $ca8353b2a2cadbad$var$messages;

});

parcelRegister("7fmVq", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $db1253326a345556$export$e19f9f08a6d79fd2);
$parcel$export(module.exports, "getErrorStatus", () => $db1253326a345556$export$bff99894b739024c);

var $illlw = parcelRequire("illlw");
const $db1253326a345556$export$e19f9f08a6d79fd2 = (error)=>{
    if (!error) return 'unknown';
    return error.networkError ? 'network_error' : 'graphql_error';
};
const $db1253326a345556$export$bff99894b739024c = (error)=>{
    if (!error) return null;
    if (error.networkError) return null;
    if (!error.graphQLErrors || !error.graphQLErrors.length) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error.graphQLErrors[0], [
        'extensions',
        'statusCode'
    ], null);
};

});


parcelRegister("3YysV", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $a40137074e874fc9$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $a40137074e874fc9$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $a40137074e874fc9$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $a40137074e874fc9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $kwMhr = parcelRequire("kwMhr");

var $gUUjF = parcelRequire("gUUjF");

var $iH6c1 = parcelRequire("iH6c1");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $lB25E = parcelRequire("lB25E");

var $cdFlB = parcelRequire("cdFlB");

var $8QSkp = parcelRequire("8QSkp");

var $6rUGr = parcelRequire("6rUGr");

var $abbBt = parcelRequire("abbBt");

const $a40137074e874fc9$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReasonWithStatusCode)((0, $e052d5702b12477c$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $a40137074e874fc9$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $a40137074e874fc9$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $a40137074e874fc9$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $a40137074e874fc9$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $a40137074e874fc9$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error.message) && !!$a40137074e874fc9$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $a40137074e874fc9$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $a40137074e874fc9$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($a40137074e874fc9$export$34bc86f6bf17f1e0(errorResponse)) return 0, $e052d5702b12477c$export$3c39b2049cd1acb3;
    if ($a40137074e874fc9$export$8a5d666d6e5b82fc(errorResponse)) return 0, $e052d5702b12477c$export$fdfe3175a0c7be80;
    if ((0, $JRB5w.isClientFetchError)(errorResponse)) return 0, $e052d5702b12477c$export$38fe4329f59f7ac5;
    if ((0, $1ybV0.ff)('jsw.cmp.response-null-abort') && $a40137074e874fc9$export$7193151b5738a995(errorResponse)) return 0, $e052d5702b12477c$export$49d11848b43d6dbf;
    if ($a40137074e874fc9$export$ed0f33c09abc69f3(errorResponse)) return 0, $e052d5702b12477c$export$32e56551129a1642;
    return null;
};
const $a40137074e874fc9$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $6rUGr.extractStatusCode)(errorResponse);
    const abortFailureReason = $a40137074e874fc9$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $8QSkp.extractTraceId)(errorResponse) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const hash = (0, $iH6c1.getErrorHash)(errorResponse) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(window, [
        'BUILD_KEY'
    ]) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    if (abortFailureReason) // Fire SLA Abort event to monitor the volume of client-side issues without impacting SLO
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $e052d5702b12477c$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash,
            isBacklogWithRelayEnabled: (0, $cdFlB.isBacklogWithRelayEnabled)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $abbBt.createFailureReason)((0, $e052d5702b12477c$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // 40x missing permission, experience does not exist, not logged in, etc
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReason)((0, $e052d5702b12477c$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira/projects?showFlag=jsw.project-not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $a40137074e874fc9$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $a40137074e874fc9$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $a40137074e874fc9$export$2e2bcd8739ae039 = $a40137074e874fc9$var$responseToSla;

});
parcelRegister("cdFlB", function(module, exports) {

$parcel$export(module.exports, "isBacklogWithRelayEnabled", () => $1432a1708fd01450$export$bc84f8a9593e9b2c);

var $1ybV0 = parcelRequire("1ybV0");
const $1432a1708fd01450$export$bc84f8a9593e9b2c = ()=>(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay');

});

parcelRegister("8QSkp", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $d4638007eaa5c85e$export$431eacb6aecbacdf);
const $d4638007eaa5c85e$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("6rUGr", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $9a98a294942c3212$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $9a98a294942c3212$export$1fdf7c1c0741a7e7);

var $illlw = parcelRequire("illlw");

var $cD8SO = parcelRequire("cD8SO");
const $9a98a294942c3212$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))(statusCodes);
    return statusCode || null;
};
const $9a98a294942c3212$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $9a98a294942c3212$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});
parcelRegister("cD8SO", function(module, exports) {

var $77fbL = parcelRequire("77fbL");

var $bOiiU = parcelRequire("bOiiU");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $932004927d7c326a$var$max(array) {
    return array && array.length ? $77fbL(array, $3QMTK, $bOiiU) : undefined;
}
module.exports = $932004927d7c326a$var$max;

});
parcelRegister("77fbL", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $52e4f805c3622ecd$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8aco7(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $52e4f805c3622ecd$var$baseExtremum;

});

parcelRegister("bOiiU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $899290031a4184bf$var$baseGt(value, other) {
    return value > other;
}
module.exports = $899290031a4184bf$var$baseGt;

});



parcelRegister("abbBt", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $3789a68bf3687ffa$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $3789a68bf3687ffa$export$cc7dce678df87fe9);
const $3789a68bf3687ffa$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $3789a68bf3687ffa$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $e052d5702b12477c$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $e052d5702b12477c$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $e052d5702b12477c$export$7b9f56c34c008ec2 = '429-error';
const $e052d5702b12477c$export$3c39b2049cd1acb3 = 'user-network-error';
const $e052d5702b12477c$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $e052d5702b12477c$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $e052d5702b12477c$export$49d11848b43d6dbf = 'response-null-error';
const $e052d5702b12477c$export$32e56551129a1642 = 'client-third-party-app-error';
const $e052d5702b12477c$export$fa14a20fcf1b1eb4 = 'unknown';


parcelRegister("7vGnP", function(module, exports) {

$parcel$export(module.exports, "burnupChartPageLoad", () => $1da692b3c27d7d59$export$ab8c07f4516583d1);

var $lNfG4 = parcelRequire("lNfG4");
const $1da692b3c27d7d59$export$ab8c07f4516583d1 = (0, $lNfG4.metrics).pageLoad({
    key: 'software-reports.burnup-chart',
    slo: {
        fmp: {
            initial: {
                threshold: 8000
            },
            transition: {
                threshold: 8000
            }
        },
        tti: {
            initial: {
                threshold: 8000
            },
            transition: {
                threshold: 8000
            }
        }
    }
});

});

parcelRegister("bIMcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $34ba692305701a20$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2JyHi = parcelRequire("2JyHi");

var $2W5il = parcelRequire("2W5il");
var $j3E5n = parcelRequire("j3E5n");

var $aw6hh = parcelRequire("aw6hh");
var $kdava = parcelRequire("kdava");
var $5Rjce = parcelRequire("5Rjce");
var $aiDtf = parcelRequire("aiDtf");

var $5vRmQ = parcelRequire("5vRmQ");

var $kPSHX = parcelRequire("kPSHX");

var $8YJjX = parcelRequire("8YJjX");


var $iX87Q = parcelRequire("iX87Q");
var $4q38b = parcelRequire("4q38b");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $IXOMa = parcelRequire("IXOMa");

var $4cuuf = parcelRequire("4cuuf");

var $ewTkV = parcelRequire("ewTkV");

var $16ODO = parcelRequire("16ODO");

var $5FspW = parcelRequire("5FspW");

var $Mv60I = parcelRequire("Mv60I");
$5vRmQ.use([
    (0, $2W5il.install),
    (0, $j3E5n.install),
    (0, $aw6hh.install),
    (0, $kdava.install),
    (0, $5Rjce.install),
    (0, $aiDtf.install),
    (0, $kPSHX.install)
]);
const $34ba692305701a20$export$acaa6426d77a227e = ({ burnup: burnup, statisticField: statisticField, now: now, userTimeZone: userTimeZone, timeTrackingOptions: timeTrackingOptions, onExperienceSuccess: onExperienceSuccess })=>{
    const intl = (0, $5JgJ2.default)();
    (0, $4q38b.default)();
    const [isMouseOver, setIsMouseOver] = (0, $eUqFw.useState)(false);
    const renderTooltip = (0, $eUqFw.useMemo)(()=>(0, $5FspW.makeRenderTooltip)({
            intl: intl,
            statisticField: statisticField,
            userTimeZone: userTimeZone,
            timeTrackingOptions: timeTrackingOptions
        }), [
        intl,
        statisticField,
        userTimeZone,
        timeTrackingOptions
    ]);
    const prefersReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const option = (0, $Mv60I.getOptions)({
        renderTooltip: renderTooltip,
        burnup: burnup,
        isMouseOver: isMouseOver,
        statisticField: statisticField,
        now: now || new Date(),
        intl: intl,
        userTimeZone: userTimeZone,
        prefersReducedMotion: prefersReducedMotion
    });
    const setMouseTrue = (0, $eUqFw.useCallback)(()=>setIsMouseOver(true), []);
    const setMouseFalse = (0, $eUqFw.useCallback)(()=>setIsMouseOver(false), []);
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    const getCompletedWorkMessage = (field)=>{
        if (field === (0, $IXOMa.ESTIMATION_ISSUE_COUNT)) return intl.formatMessage((0, $16ODO.default).remainingIssuesDescription);
        if (field === (0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE)) return intl.formatMessage((0, $16ODO.default).remainingTimeDescription);
        return intl.formatMessage((0, $16ODO.default).remainingStoriesDescription);
    };
    const getScopeMessage = (field)=>{
        if (field === (0, $IXOMa.ESTIMATION_ISSUE_COUNT)) return intl.formatMessage((0, $16ODO.default).scopeIssues);
        if (field === (0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE)) return intl.formatMessage((0, $16ODO.default).scopeTime);
        return intl.formatMessage((0, $16ODO.default).scopeStories);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($34ba692305701a20$var$ChartContainer, {
        "data-test-id": "software-burnup-report.ui.chart.burnup-chart-container",
        onFocus: setMouseTrue,
        onBlur: setMouseFalse,
        onMouseOver: setMouseTrue,
        onMouseEnter: setMouseTrue,
        onMouseOut: setMouseFalse,
        onMouseLeave: setMouseFalse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewTkV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cuuf.default), {
        name: intl.formatMessage((0, $16ODO.default).completedName),
        description: getCompletedWorkMessage(statisticField),
        color: (0, $iX87Q.default)('color.chart.success', (0, $73a5c9d720aa66e1$exports).G400)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cuuf.default), {
        name: intl.formatMessage((0, $16ODO.default).guidelineName),
        description: intl.formatMessage((0, $16ODO.default).guidelineDescription),
        color: (0, $iX87Q.default)('color.chart.neutral', (0, $73a5c9d720aa66e1$exports).N60)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4cuuf.default), {
        name: intl.formatMessage((0, $16ODO.default).scope),
        description: getScopeMessage(statisticField),
        color: (0, $iX87Q.default)('color.chart.danger', (0, $73a5c9d720aa66e1$exports).R400)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2JyHi))), {
        echarts: $5vRmQ,
        option: option,
        style: {
            width: '100%',
            height: 500
        },
        className: "software-burnup-report-ui-chart-burnup-chart"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
        eventName: "sprintBurnupChart loaded"
    }));
};
var $34ba692305701a20$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $34ba692305701a20$export$acaa6426d77a227e;
const $34ba692305701a20$var$ChartContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2JyHi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $1fdab2e1e227f900$var$react_1 = (0, $fKE23.__importStar)((parcelRequire("eUqFw")));

var $eUpRa = parcelRequire("eUpRa");

var $11Oi5 = parcelRequire("11Oi5");

var $ayOoE = parcelRequire("ayOoE");

var $5joMY = parcelRequire("5joMY");

var $6fivB = parcelRequire("6fivB");
/**
 * core component for echarts binding
 */ var $1fdab2e1e227f900$var$EChartsReactCore = /** @class */ function(_super) {
    (0, $fKE23.__extends)(EChartsReactCore, _super);
    function EChartsReactCore(props) {
        var _this = _super.call(this, props) || this;
        _this.echarts = props.echarts;
        _this.ele = null;
        _this.isInitialResize = true;
        return _this;
    }
    EChartsReactCore.prototype.componentDidMount = function() {
        this.renderNewEcharts();
    };
    // update
    EChartsReactCore.prototype.componentDidUpdate = function(prevProps) {
        /**
         * if shouldSetOption return false, then return, not update echarts options
         * default is true
         */ var shouldSetOption = this.props.shouldSetOption;
        if ((0, $ayOoE.isFunction)(shouldSetOption) && !shouldSetOption(prevProps, this.props)) return;
        // 以下属性修改的时候，需要 dispose 之后再新建
        // 1. 切换 theme 的时候
        // 2. 修改 opts 的时候
        // 3. 修改 onEvents 的时候，这样可以取消所有之前绑定的事件 issue #151
        if (!(0, $6fivB.isEqual)(prevProps.theme, this.props.theme) || !(0, $6fivB.isEqual)(prevProps.opts, this.props.opts) || !(0, $6fivB.isEqual)(prevProps.onEvents, this.props.onEvents)) {
            this.dispose();
            this.renderNewEcharts(); // 重建
            return;
        }
        // when these props are not isEqual, update echarts
        var pickKeys = [
            'option',
            'notMerge',
            'lazyUpdate',
            'showLoading',
            'loadingOption'
        ];
        if (!(0, $6fivB.isEqual)((0, $11Oi5.pick)(this.props, pickKeys), (0, $11Oi5.pick)(prevProps, pickKeys))) this.updateEChartsOption();
        /**
         * when style or class name updated, change size.
         */ if (!(0, $6fivB.isEqual)(prevProps.style, this.props.style) || !(0, $6fivB.isEqual)(prevProps.className, this.props.className)) this.resize();
    };
    EChartsReactCore.prototype.componentWillUnmount = function() {
        this.dispose();
    };
    /**
     * return the echart object
     * 1. if exist, return the existed instance
     * 2. or new one instance
     */ EChartsReactCore.prototype.getEchartsInstance = function() {
        return this.echarts.getInstanceByDom(this.ele) || this.echarts.init(this.ele, this.props.theme, this.props.opts);
    };
    /**
     * dispose echarts and clear size-sensor
     */ EChartsReactCore.prototype.dispose = function() {
        if (this.ele) {
            try {
                (0, $eUpRa.clear)(this.ele);
            } catch (e) {
                console.warn(e);
            }
            // dispose echarts instance
            this.echarts.dispose(this.ele);
        }
    };
    /**
     * render a new echarts instance
     */ EChartsReactCore.prototype.renderNewEcharts = function() {
        var _this = this;
        var _a = this.props, onEvents = _a.onEvents, onChartReady = _a.onChartReady;
        // 1. new echarts instance
        var echartsInstance = this.updateEChartsOption();
        // 2. bind events
        this.bindEvents(echartsInstance, onEvents || {});
        // 3. on chart ready
        if ((0, $ayOoE.isFunction)(onChartReady)) onChartReady(echartsInstance);
        // 4. on resize
        if (this.ele) (0, $eUpRa.bind)(this.ele, function() {
            _this.resize();
        });
    };
    // bind the events
    EChartsReactCore.prototype.bindEvents = function(instance, events) {
        function _bindEvent(eventName, func) {
            // ignore the event config which not satisfy
            if ((0, $5joMY.isString)(eventName) && (0, $ayOoE.isFunction)(func)) // binding event
            instance.on(eventName, function(param) {
                func(param, instance);
            });
        }
        // loop and bind
        for(var eventName in events)if (Object.prototype.hasOwnProperty.call(events, eventName)) _bindEvent(eventName, events[eventName]);
    };
    /**
     * render the echarts
     */ EChartsReactCore.prototype.updateEChartsOption = function() {
        var _a = this.props, option = _a.option, _b = _a.notMerge, notMerge = _b === void 0 ? false : _b, _c = _a.lazyUpdate, lazyUpdate = _c === void 0 ? false : _c, showLoading = _a.showLoading, _d = _a.loadingOption, loadingOption = _d === void 0 ? null : _d;
        // 1. get or initial the echarts object
        var echartInstance = this.getEchartsInstance();
        // 2. set the echarts option
        echartInstance.setOption(option, notMerge, lazyUpdate);
        // 3. set loading mask
        if (showLoading) echartInstance.showLoading(loadingOption);
        else echartInstance.hideLoading();
        return echartInstance;
    };
    /**
     * resize wrapper
     */ EChartsReactCore.prototype.resize = function() {
        // 1. get the echarts object
        var echartsInstance = this.getEchartsInstance();
        // 2. call echarts instance resize if not the initial resize
        // resize should not happen on first render as it will cancel initial echarts animations
        if (!this.isInitialResize) try {
            echartsInstance.resize();
        } catch (e) {
            console.warn(e);
        }
        // 3. update variable for future calls
        this.isInitialResize = false;
    };
    EChartsReactCore.prototype.render = function() {
        var _this = this;
        var _a = this.props, style = _a.style, _b = _a.className, className = _b === void 0 ? '' : _b;
        // default height = 300
        var newStyle = (0, $fKE23.__assign)({
            height: 300
        }, style);
        return $1fdab2e1e227f900$var$react_1.default.createElement("div", {
            ref: function(e) {
                _this.ele = e;
            },
            style: newStyle,
            className: "echarts-for-react " + className
        });
    };
    return EChartsReactCore;
}($1fdab2e1e227f900$var$react_1.PureComponent);
module.exports.default = $1fdab2e1e227f900$var$EChartsReactCore;

});
parcelRegister("eUpRa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ver = module.exports.clear = module.exports.bind = void 0;

var $IT7qM = parcelRequire("IT7qM");
/**
 * Created by hustcc on 18/6/9.[高考时间]
 * Contract: i@hust.cc
 */ /**
 * bind an element with resize callback function
 * @param {*} element
 * @param {*} cb
 */ var $adaa5a3ed1b746ee$var$bind = function bind(element, cb) {
    var sensor = (0, $IT7qM.getSensor)(element); // listen with callback
    sensor.bind(cb); // return unbind function
    return function() {
        sensor.unbind(cb);
    };
};
/**
 * clear all the listener and sensor of an element
 * @param element
 */ module.exports.bind = $adaa5a3ed1b746ee$var$bind;
var $adaa5a3ed1b746ee$var$clear = function clear(element) {
    var sensor = (0, $IT7qM.getSensor)(element);
    (0, $IT7qM.removeSensor)(sensor);
};
module.exports.clear = $adaa5a3ed1b746ee$var$clear;
var $adaa5a3ed1b746ee$var$ver = "1.0.1";
module.exports.ver = $adaa5a3ed1b746ee$var$ver;

});
parcelRegister("IT7qM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.removeSensor = module.exports.getSensor = void 0;

var $086edda1bd856c9f$var$_id = $086edda1bd856c9f$var$_interopRequireDefault((parcelRequire("kEStO")));

var $ef2F5 = parcelRequire("ef2F5");

var $4S1UF = parcelRequire("4S1UF");
function $086edda1bd856c9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ /**
 * all the sensor objects.
 * sensor pool
 */ var $086edda1bd856c9f$var$Sensors = {};
/**
 * get one sensor
 * @param element
 * @returns {*}
 */ var $086edda1bd856c9f$var$getSensor = function getSensor(element) {
    var sensorId = element.getAttribute($4S1UF.SizeSensorId); // 1. if the sensor exists, then use it
    if (sensorId && $086edda1bd856c9f$var$Sensors[sensorId]) return $086edda1bd856c9f$var$Sensors[sensorId];
     // 2. not exist, then create one
    var newId = (0, $086edda1bd856c9f$var$_id["default"])();
    element.setAttribute($4S1UF.SizeSensorId, newId);
    var sensor = (0, $ef2F5.createSensor)(element); // add sensor into pool
    $086edda1bd856c9f$var$Sensors[newId] = sensor;
    return sensor;
};
/**
 * 移除 sensor
 * @param sensor
 */ module.exports.getSensor = $086edda1bd856c9f$var$getSensor;
var $086edda1bd856c9f$var$removeSensor = function removeSensor(sensor) {
    var sensorId = sensor.element.getAttribute($4S1UF.SizeSensorId); // remove attribute
    sensor.element.removeAttribute($4S1UF.SizeSensorId); // remove event, dom of the sensor used
    sensor.destroy(); // exist, then remove from pool
    if (sensorId && $086edda1bd856c9f$var$Sensors[sensorId]) delete $086edda1bd856c9f$var$Sensors[sensorId];
};
module.exports.removeSensor = $086edda1bd856c9f$var$removeSensor;

});
parcelRegister("kEStO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $f0a1cda51de6078c$var$id = 1;
/**
 * generate unique id in application
 * @return {string}
 */ var $f0a1cda51de6078c$var$_default = function _default() {
    return "".concat($f0a1cda51de6078c$var$id++);
};
module.exports["default"] = $f0a1cda51de6078c$var$_default;

});

parcelRegister("ef2F5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $ez7Ma = parcelRequire("ez7Ma");

var $9i5xi = parcelRequire("9i5xi");
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ /**
 * sensor strategies
 */ // export const createSensor = createObjectSensor;
var $a5e487f26edb520a$var$createSensor = typeof ResizeObserver !== 'undefined' ? $9i5xi.createSensor : $ez7Ma.createSensor;
module.exports.createSensor = $a5e487f26edb520a$var$createSensor;

});
parcelRegister("ez7Ma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $a9aa5dae3a4fed45$var$_debounce = $a9aa5dae3a4fed45$var$_interopRequireDefault((parcelRequire("41C6E")));

var $4S1UF = parcelRequire("4S1UF");
function $a9aa5dae3a4fed45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $a9aa5dae3a4fed45$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * create object DOM of sensor
   * @returns {HTMLObjectElement}
   */ var newSensor = function newSensor() {
        // adjust style
        if (getComputedStyle(element).position === 'static') element.style.position = 'relative';
        var obj = document.createElement('object');
        obj.onload = function() {
            obj.contentDocument.defaultView.addEventListener('resize', resizeListener); // 直接触发一次 resize
            resizeListener();
        };
        obj.style.display = 'block';
        obj.style.position = 'absolute';
        obj.style.top = '0';
        obj.style.left = '0';
        obj.style.height = '100%';
        obj.style.width = '100%';
        obj.style.overflow = 'hidden';
        obj.style.pointerEvents = 'none';
        obj.style.zIndex = '-1';
        obj.style.opacity = '0';
        obj.setAttribute('class', $4S1UF.SensorClassName);
        obj.setAttribute('tabindex', $4S1UF.SensorTabIndex);
        obj.type = 'text/html'; // append into dom
        element.appendChild(obj); // for ie, should set data attribute delay, or will be white screen
        obj.data = 'about:blank';
        return obj;
    };
    /**
   * trigger listeners
   */ var resizeListener = (0, $a9aa5dae3a4fed45$var$_debounce["default"])(function() {
        // trigger all listener
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * listen with one callback function
   * @param cb
   */ var bind = function bind(cb) {
        // if not exist sensor, then create one
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy all
   */ var destroy = function destroy() {
        if (sensor && sensor.parentNode) {
            if (sensor.contentDocument) // remote event
            sensor.contentDocument.defaultView.removeEventListener('resize', resizeListener);
             // remove dom
            sensor.parentNode.removeChild(sensor); // initial variable
            sensor = undefined;
            listeners = [];
        }
    };
    /**
   * cancel listener bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $a9aa5dae3a4fed45$var$createSensor;

});
parcelRegister("41C6E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $2ee4d0893728450c$var$_default = function _default(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
    var timer = null;
    return function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timer);
        timer = setTimeout(function() {
            fn.apply(_this, args);
        }, delay);
    };
};
module.exports["default"] = $2ee4d0893728450c$var$_default;

});

parcelRegister("4S1UF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SensorTabIndex = module.exports.SensorClassName = module.exports.SizeSensorId = void 0;
/**
 * Created by hustcc on 18/6/9.
 * Contract: i@hust.cc
 */ var $38bdb0710e4d1feb$var$SizeSensorId = 'size-sensor-id';
module.exports.SizeSensorId = $38bdb0710e4d1feb$var$SizeSensorId;
var $38bdb0710e4d1feb$var$SensorClassName = 'size-sensor-object';
module.exports.SensorClassName = $38bdb0710e4d1feb$var$SensorClassName;
var $38bdb0710e4d1feb$var$SensorTabIndex = '-1';
module.exports.SensorTabIndex = $38bdb0710e4d1feb$var$SensorTabIndex;

});


parcelRegister("9i5xi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSensor = void 0;

var $6c3a16dc23f0575f$var$_debounce = $6c3a16dc23f0575f$var$_interopRequireDefault((parcelRequire("41C6E")));
function $6c3a16dc23f0575f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Created by hustcc on 18/7/5.
 * Contract: i@hust.cc
 */ var $6c3a16dc23f0575f$var$createSensor = function createSensor(element) {
    var sensor = undefined; // callback
    var listeners = [];
    /**
   * trigger listeners
   */ var resizeListener = (0, $6c3a16dc23f0575f$var$_debounce["default"])(function() {
        // trigger all
        listeners.forEach(function(listener) {
            listener(element);
        });
    });
    /**
   * create ResizeObserver sensor
   * @returns
   */ var newSensor = function newSensor() {
        var s = new ResizeObserver(resizeListener); // listen element
        s.observe(element); // trigger once
        resizeListener();
        return s;
    };
    /**
   * listen with callback
   * @param cb
   */ var bind = function bind(cb) {
        if (!sensor) sensor = newSensor();
        if (listeners.indexOf(cb) === -1) listeners.push(cb);
    };
    /**
   * destroy
   */ var destroy = function destroy() {
        sensor.disconnect();
        listeners = [];
        sensor = undefined;
    };
    /**
   * cancel bind
   * @param cb
   */ var unbind = function unbind(cb) {
        var idx = listeners.indexOf(cb);
        if (idx !== -1) listeners.splice(idx, 1);
         // no listener, and sensor is exist
        // then destroy the sensor
        if (listeners.length === 0 && sensor) destroy();
    };
    return {
        element: element,
        bind: bind,
        destroy: destroy,
        unbind: unbind
    };
};
module.exports.createSensor = $6c3a16dc23f0575f$var$createSensor;

});




parcelRegister("11Oi5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pick = void 0;
/**
 * 保留 object 中的部分内容
 * @param obj
 * @param keys
 */ function $0bfce51b76d9ff5d$var$pick(obj, keys) {
    var r = {};
    keys.forEach(function(key) {
        r[key] = obj[key];
    });
    return r;
}
module.exports.pick = $0bfce51b76d9ff5d$var$pick;

});

parcelRegister("ayOoE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFunction = void 0;
function $7b042c163e4bbffb$var$isFunction(v) {
    return typeof v === 'function';
}
module.exports.isFunction = $7b042c163e4bbffb$var$isFunction;

});

parcelRegister("5joMY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isString = void 0;
function $3de1f4aa7ad186c9$var$isString(v) {
    return typeof v === 'string';
}
module.exports.isString = $3de1f4aa7ad186c9$var$isString;

});

parcelRegister("6fivB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isEqual = void 0;

var $fKE23 = parcelRequire("fKE23");

var $48c28041ff9688c4$var$fast_deep_equal_1 = (0, $fKE23.__importDefault)((parcelRequire("aG7FO")));
module.exports.isEqual = $48c28041ff9688c4$var$fast_deep_equal_1.default;

});
parcelRegister("aG7FO", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});



parcelRegister("2W5il", function(module, exports) {

$parcel$export(module.exports, "install", () => $22351b0136540228$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2muFi = parcelRequire("2muFi");

var $cwcEN = parcelRequire("cwcEN");

var $icXd2 = parcelRequire("icXd2");

var $d1Jiw = parcelRequire("d1Jiw");
function $22351b0136540228$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $cwcEN.default));
    registers.registerSeriesModel((0, $2muFi.default));
    registers.registerLayout((0, $icXd2.default)('line', true));
    registers.registerVisual({
        seriesType: 'line',
        reset: function(seriesModel) {
            var data = seriesModel.getData(); // Visual coding for legend
            var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual('style').fill;
            data.setVisual('legendLineStyle', lineStyle);
        }
    }); // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $d1Jiw.default)('line'));
}

});
parcelRegister("2muFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b856c4fdbb1e017$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $3OWAv = parcelRequire("3OWAv");

var $5vVec = parcelRequire("5vVec");

var $4TnMt = parcelRequire("4TnMt");

var $hXAsm = parcelRequire("hXAsm");
var $1b856c4fdbb1e017$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $3OWAv.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $hXAsm.default)();
        var line = (0, $4TnMt.createSymbol)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual('symbol');
        var visualRotate = this.getData().getVisual('symbolRotate');
        var symbolType = visualType === 'none' ? 'circle' : visualType; // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $4TnMt.createSymbol)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf('empty') > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = '#fff';
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = 'series.line';
    LineSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    LineSeriesModel.defaultOption = {
        zlevel: 0,
        z: 3,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        clip: true,
        label: {
            position: 'top'
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: 'solid'
        },
        emphasis: {
            scale: true,
            lineStyle: {
                width: 'bolder'
            }
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: 'emptyCircle',
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: 'auto',
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: 'none',
        animationEasing: 'linear',
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: 'clone'
        }
    };
    return LineSeriesModel;
}((0, $5vVec.default));
var $1b856c4fdbb1e017$export$2e2bcd8739ae039 = $1b856c4fdbb1e017$var$LineSeriesModel;

});
parcelRegister("3OWAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c837ce8a6b25399$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $kyX7l = parcelRequire("kyX7l");

var $jrSv6 = parcelRequire("jrSv6");

var $eNXvv = parcelRequire("eNXvv");

var $ckizb = parcelRequire("ckizb");

var $gwjrp = parcelRequire("gwjrp");

var $6LGi5 = parcelRequire("6LGi5");

var $8AzOm = parcelRequire("8AzOm");

var $lljDt = parcelRequire("lljDt");

var $be33G = parcelRequire("be33G");

var $8tpV4 = parcelRequire("8tpV4");
function $2c837ce8a6b25399$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $gwjrp.default).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $hzBt5.map(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $eNXvv.getDimensionTypeByAxis)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $2c837ce8a6b25399$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $hzBt5.each(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $2c837ce8a6b25399$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $8AzOm.createSourceFromSeriesDataOption)(sourceRaw);
    } else {
        source = sourceManager.getSource(); // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL);
    }
    var coordSysInfo = (0, $6LGi5.getCoordSysInfoBySeries)(seriesModel);
    var coordSysDimDefs = $2c837ce8a6b25399$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $hzBt5.isFunction(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $hzBt5.curry((0, $be33G.makeSeriesEncodeForAxisCoordSys), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $jrSv6.default)(source, createDimensionOptions);
    var firstCategoryDimIndex = $2c837ce8a6b25399$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $lljDt.enableDataStack)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $kyX7l.default)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $2c837ce8a6b25399$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $2c837ce8a6b25399$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) {
        var sampleItem = $2c837ce8a6b25399$var$firstDataNotNull(source.data || []);
        return sampleItem != null && !$hzBt5.isArray((0, $ckizb.getDataItemValue)(sampleItem));
    }
}
function $2c837ce8a6b25399$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $2c837ce8a6b25399$export$2e2bcd8739ae039 = $2c837ce8a6b25399$var$createSeriesData;

});
parcelRegister("hzBt5", function(module, exports) {

$parcel$export(module.exports, "$override", () => $ccb2c4ef73c7c1d9$export$d35a04b83ea6803e);
$parcel$export(module.exports, "guid", () => $ccb2c4ef73c7c1d9$export$46e8f25c7328f77e);
$parcel$export(module.exports, "logError", () => $ccb2c4ef73c7c1d9$export$58da9968c3170cb1);
$parcel$export(module.exports, "clone", () => $ccb2c4ef73c7c1d9$export$9cd59f9826255e47);
$parcel$export(module.exports, "isPrimitive", () => $ccb2c4ef73c7c1d9$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isDom", () => $ccb2c4ef73c7c1d9$export$9f57505b7bd8dae);
$parcel$export(module.exports, "merge", () => $ccb2c4ef73c7c1d9$export$4950aa0f605343fb);
$parcel$export(module.exports, "isObject", () => $ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isArray", () => $ccb2c4ef73c7c1d9$export$43bee75e5e14138e);
$parcel$export(module.exports, "isBuiltInObject", () => $ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f);
$parcel$export(module.exports, "mergeAll", () => $ccb2c4ef73c7c1d9$export$18aef43295bbe906);
$parcel$export(module.exports, "extend", () => $ccb2c4ef73c7c1d9$export$8b58be045bf06082);
$parcel$export(module.exports, "defaults", () => $ccb2c4ef73c7c1d9$export$ebe90cb607ad99e);
$parcel$export(module.exports, "keys", () => $ccb2c4ef73c7c1d9$export$ed97f33186d4b816);
$parcel$export(module.exports, "createCanvas", () => $ccb2c4ef73c7c1d9$export$cd3d1f114b139967);
$parcel$export(module.exports, "indexOf", () => $ccb2c4ef73c7c1d9$export$305f7d4e9d4624f2);
$parcel$export(module.exports, "inherits", () => $ccb2c4ef73c7c1d9$export$69f1b2dcda23c5f8);
$parcel$export(module.exports, "mixin", () => $ccb2c4ef73c7c1d9$export$e36fc9d62a853069);
$parcel$export(module.exports, "isArrayLike", () => $ccb2c4ef73c7c1d9$export$1e2f57719e155213);
$parcel$export(module.exports, "each", () => $ccb2c4ef73c7c1d9$export$79b2f7037acddd43);
$parcel$export(module.exports, "map", () => $ccb2c4ef73c7c1d9$export$871de8747c9eaa88);
$parcel$export(module.exports, "slice", () => $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f);
$parcel$export(module.exports, "reduce", () => $ccb2c4ef73c7c1d9$export$533b26079ad0b4b);
$parcel$export(module.exports, "filter", () => $ccb2c4ef73c7c1d9$export$3dea766d36a8935f);
$parcel$export(module.exports, "find", () => $ccb2c4ef73c7c1d9$export$71aa6c912b956294);
$parcel$export(module.exports, "bind", () => $ccb2c4ef73c7c1d9$export$2385a24977818dd0);
$parcel$export(module.exports, "isFunction", () => $ccb2c4ef73c7c1d9$export$f6e2535fb5126e54);
$parcel$export(module.exports, "curry", () => $ccb2c4ef73c7c1d9$export$c3095a23b368d1f2);
$parcel$export(module.exports, "isString", () => $ccb2c4ef73c7c1d9$export$844ec244b1367d54);
$parcel$export(module.exports, "isStringSafe", () => $ccb2c4ef73c7c1d9$export$29d0bb2a4e07b252);
$parcel$export(module.exports, "isNumber", () => $ccb2c4ef73c7c1d9$export$7e4aa119212bc614);
$parcel$export(module.exports, "isTypedArray", () => $ccb2c4ef73c7c1d9$export$b119cc7e1840e59c);
$parcel$export(module.exports, "isGradientObject", () => $ccb2c4ef73c7c1d9$export$fa2c283003ed971c);
$parcel$export(module.exports, "isImagePatternObject", () => $ccb2c4ef73c7c1d9$export$a49bbf3a55dcef7b);
$parcel$export(module.exports, "isRegExp", () => $ccb2c4ef73c7c1d9$export$49841c62b9eff15);
$parcel$export(module.exports, "eqNaN", () => $ccb2c4ef73c7c1d9$export$7d667b9a0c48c975);
$parcel$export(module.exports, "retrieve", () => $ccb2c4ef73c7c1d9$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "retrieve2", () => $ccb2c4ef73c7c1d9$export$995e01f2f5c9d030);
$parcel$export(module.exports, "retrieve3", () => $ccb2c4ef73c7c1d9$export$2e94551289abb95b);
$parcel$export(module.exports, "normalizeCssArray", () => $ccb2c4ef73c7c1d9$export$f3a38102c49f4268);
$parcel$export(module.exports, "assert", () => $ccb2c4ef73c7c1d9$export$a7a9523472993e97);
$parcel$export(module.exports, "trim", () => $ccb2c4ef73c7c1d9$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "setAsPrimitive", () => $ccb2c4ef73c7c1d9$export$112e66431016387b);
$parcel$export(module.exports, "HashMap", () => $ccb2c4ef73c7c1d9$export$60ef0b43d585640a);
$parcel$export(module.exports, "createHashMap", () => $ccb2c4ef73c7c1d9$export$55f8aa7ef875b0a4);
$parcel$export(module.exports, "concatArray", () => $ccb2c4ef73c7c1d9$export$4fd8af2c48c43416);
$parcel$export(module.exports, "createObject", () => $ccb2c4ef73c7c1d9$export$79c7e160a7743efd);
$parcel$export(module.exports, "hasOwn", () => $ccb2c4ef73c7c1d9$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "noop", () => $ccb2c4ef73c7c1d9$export$8793edee2d425525);
var $ccb2c4ef73c7c1d9$var$BUILTIN_OBJECT = {
    '[object Function]': true,
    '[object RegExp]': true,
    '[object Date]': true,
    '[object Error]': true,
    '[object CanvasGradient]': true,
    '[object CanvasPattern]': true,
    '[object Image]': true,
    '[object Canvas]': true
};
var $ccb2c4ef73c7c1d9$var$TYPED_ARRAY = {
    '[object Int8Array]': true,
    '[object Uint8Array]': true,
    '[object Uint8ClampedArray]': true,
    '[object Int16Array]': true,
    '[object Uint16Array]': true,
    '[object Int32Array]': true,
    '[object Uint32Array]': true,
    '[object Float32Array]': true,
    '[object Float64Array]': true
};
var $ccb2c4ef73c7c1d9$var$objToString = Object.prototype.toString;
var $ccb2c4ef73c7c1d9$var$arrayProto = Array.prototype;
var $ccb2c4ef73c7c1d9$var$nativeForEach = $ccb2c4ef73c7c1d9$var$arrayProto.forEach;
var $ccb2c4ef73c7c1d9$var$nativeFilter = $ccb2c4ef73c7c1d9$var$arrayProto.filter;
var $ccb2c4ef73c7c1d9$var$nativeSlice = $ccb2c4ef73c7c1d9$var$arrayProto.slice;
var $ccb2c4ef73c7c1d9$var$nativeMap = $ccb2c4ef73c7c1d9$var$arrayProto.map;
var $ccb2c4ef73c7c1d9$var$ctorFunction = (function() {}).constructor;
var $ccb2c4ef73c7c1d9$var$protoFunction = $ccb2c4ef73c7c1d9$var$ctorFunction ? $ccb2c4ef73c7c1d9$var$ctorFunction.prototype : null;
var $ccb2c4ef73c7c1d9$var$protoKey = '__proto__';
var $ccb2c4ef73c7c1d9$var$methods = {};
function $ccb2c4ef73c7c1d9$export$d35a04b83ea6803e(name, fn) {
    $ccb2c4ef73c7c1d9$var$methods[name] = fn;
}
var $ccb2c4ef73c7c1d9$var$idStart = 0x0907;
function $ccb2c4ef73c7c1d9$export$46e8f25c7328f77e() {
    return $ccb2c4ef73c7c1d9$var$idStart++;
}
function $ccb2c4ef73c7c1d9$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $ccb2c4ef73c7c1d9$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[i]);
        }
    } else if ($ccb2c4ef73c7c1d9$var$TYPED_ARRAY[typeStr]) {
        if (!$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[i]);
            }
        }
    } else if (!$ccb2c4ef73c7c1d9$var$BUILTIN_OBJECT[typeStr] && !$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(source) && !$ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $ccb2c4ef73c7c1d9$var$protoKey) result[key] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $ccb2c4ef73c7c1d9$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(source) || !$ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(target)) return overwrite ? $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $ccb2c4ef73c7c1d9$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(sourceProp) && $ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(targetProp) && !$ccb2c4ef73c7c1d9$export$43bee75e5e14138e(sourceProp) && !$ccb2c4ef73c7c1d9$export$43bee75e5e14138e(targetProp) && !$ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(sourceProp) && !$ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(targetProp) && !$ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f(sourceProp) && !$ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f(targetProp) && !$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(sourceProp) && !$ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(targetProp)) $ccb2c4ef73c7c1d9$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $ccb2c4ef73c7c1d9$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $ccb2c4ef73c7c1d9$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $ccb2c4ef73c7c1d9$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $ccb2c4ef73c7c1d9$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $ccb2c4ef73c7c1d9$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $ccb2c4ef73c7c1d9$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $ccb2c4ef73c7c1d9$export$ed97f33186d4b816(source);
    for(var i = 0; i < keysArr.length; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $ccb2c4ef73c7c1d9$export$cd3d1f114b139967 = function() {
    return $ccb2c4ef73c7c1d9$var$methods.createCanvas();
};
$ccb2c4ef73c7c1d9$var$methods.createCanvas = function() {
    return document.createElement('canvas');
};
function $ccb2c4ef73c7c1d9$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $ccb2c4ef73c7c1d9$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $ccb2c4ef73c7c1d9$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $ccb2c4ef73c7c1d9$export$ebe90cb607ad99e(target, source, override);
}
function $ccb2c4ef73c7c1d9$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $ccb2c4ef73c7c1d9$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $ccb2c4ef73c7c1d9$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $ccb2c4ef73c7c1d9$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $ccb2c4ef73c7c1d9$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $ccb2c4ef73c7c1d9$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $ccb2c4ef73c7c1d9$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $ccb2c4ef73c7c1d9$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $ccb2c4ef73c7c1d9$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $ccb2c4ef73c7c1d9$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $ccb2c4ef73c7c1d9$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($ccb2c4ef73c7c1d9$var$nativeSlice.call(arguments)));
    };
}
var $ccb2c4ef73c7c1d9$export$2385a24977818dd0 = $ccb2c4ef73c7c1d9$var$protoFunction && $ccb2c4ef73c7c1d9$export$f6e2535fb5126e54($ccb2c4ef73c7c1d9$var$protoFunction.bind) ? $ccb2c4ef73c7c1d9$var$protoFunction.call.bind($ccb2c4ef73c7c1d9$var$protoFunction.bind) : $ccb2c4ef73c7c1d9$var$bindPolyfill;
function $ccb2c4ef73c7c1d9$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($ccb2c4ef73c7c1d9$var$nativeSlice.call(arguments)));
    };
}
function $ccb2c4ef73c7c1d9$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $ccb2c4ef73c7c1d9$var$objToString.call(value) === '[object Array]';
}
function $ccb2c4ef73c7c1d9$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $ccb2c4ef73c7c1d9$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $ccb2c4ef73c7c1d9$export$29d0bb2a4e07b252(value) {
    return $ccb2c4ef73c7c1d9$var$objToString.call(value) === '[object String]';
}
function $ccb2c4ef73c7c1d9$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $ccb2c4ef73c7c1d9$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $ccb2c4ef73c7c1d9$export$fa523b2c4941fd4f(value) {
    return !!$ccb2c4ef73c7c1d9$var$BUILTIN_OBJECT[$ccb2c4ef73c7c1d9$var$objToString.call(value)];
}
function $ccb2c4ef73c7c1d9$export$b119cc7e1840e59c(value) {
    return !!$ccb2c4ef73c7c1d9$var$TYPED_ARRAY[$ccb2c4ef73c7c1d9$var$objToString.call(value)];
}
function $ccb2c4ef73c7c1d9$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $ccb2c4ef73c7c1d9$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $ccb2c4ef73c7c1d9$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $ccb2c4ef73c7c1d9$export$49841c62b9eff15(value) {
    return $ccb2c4ef73c7c1d9$var$objToString.call(value) === '[object RegExp]';
}
function $ccb2c4ef73c7c1d9$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $ccb2c4ef73c7c1d9$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $ccb2c4ef73c7c1d9$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $ccb2c4ef73c7c1d9$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $ccb2c4ef73c7c1d9$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $ccb2c4ef73c7c1d9$var$nativeSlice.apply(arr, args);
}
function $ccb2c4ef73c7c1d9$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $ccb2c4ef73c7c1d9$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $ccb2c4ef73c7c1d9$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $ccb2c4ef73c7c1d9$var$primitiveKey = '__ec_primitive__';
function $ccb2c4ef73c7c1d9$export$112e66431016387b(obj) {
    obj[$ccb2c4ef73c7c1d9$var$primitiveKey] = true;
}
function $ccb2c4ef73c7c1d9$export$c3825b437cbdea5c(obj) {
    return obj[$ccb2c4ef73c7c1d9$var$primitiveKey];
}
var $ccb2c4ef73c7c1d9$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        this.data = {};
        var isArr = $ccb2c4ef73c7c1d9$export$43bee75e5e14138e(obj);
        this.data = {};
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $ccb2c4ef73c7c1d9$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.get = function(key) {
        return this.data.hasOwnProperty(key) ? this.data[key] : null;
    };
    HashMap.prototype.set = function(key, value) {
        return this.data[key] = value;
    };
    HashMap.prototype.each = function(cb, context) {
        for(var key in this.data)if (this.data.hasOwnProperty(key)) cb.call(context, this.data[key], key);
    };
    HashMap.prototype.keys = function() {
        return $ccb2c4ef73c7c1d9$export$ed97f33186d4b816(this.data);
    };
    HashMap.prototype.removeKey = function(key) {
        delete this.data[key];
    };
    return HashMap;
}();
function $ccb2c4ef73c7c1d9$export$55f8aa7ef875b0a4(obj) {
    return new $ccb2c4ef73c7c1d9$export$60ef0b43d585640a(obj);
}
function $ccb2c4ef73c7c1d9$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $ccb2c4ef73c7c1d9$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $ccb2c4ef73c7c1d9$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $ccb2c4ef73c7c1d9$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $ccb2c4ef73c7c1d9$export$8793edee2d425525() {}

});

parcelRegister("kyX7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef84d7185c8a372d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 
var $hzBt5 = parcelRequire("hzBt5");

var $fR3z1 = parcelRequire("fR3z1");

var $ddlYG = parcelRequire("ddlYG");

var $kWuWu = parcelRequire("kWuWu");

var $eNXvv = parcelRequire("eNXvv");

var $3JGxt = parcelRequire("3JGxt");

var $8tpV4 = parcelRequire("8tpV4");

var $ckizb = parcelRequire("ckizb");

var $aly4X = parcelRequire("aly4X");

var $8AzOm = parcelRequire("8AzOm");

var $6Bzg6 = parcelRequire("6Bzg6");

var $kJQdt = parcelRequire("kJQdt");
var $ef84d7185c8a372d$var$isObject = $hzBt5.isObject;
var $ef84d7185c8a372d$var$map = $hzBt5.map;
var $ef84d7185c8a372d$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird udpate animation.
var $ef84d7185c8a372d$var$ID_PREFIX = 'e\0\0';
var $ef84d7185c8a372d$var$INDEX_NOT_FOUND = -1; // type SeriesDimensionIndex = DimensionIndex;
var $ef84d7185c8a372d$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $ef84d7185c8a372d$var$CLONE_PROPERTIES = [
    '_approximateExtent'
]; // -----------------------------
// Internal method declarations:
// -----------------------------
var $ef84d7185c8a372d$var$prepareInvertedIndex;
var $ef84d7185c8a372d$var$getId;
var $ef84d7185c8a372d$var$getIdNameFromStore;
var $ef84d7185c8a372d$var$normalizeDimensions;
var $ef84d7185c8a372d$var$transferProperties;
var $ef84d7185c8a372d$var$cloneListForMapAndSample;
var $ef84d7185c8a372d$var$makeIdFromName;
var $ef84d7185c8a372d$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = []; // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {}; // Globel layout properties.
        this._layout = {}; // Item visual properties after visual coding
        this._itemVisuals = []; // Item layout properties after layout
        this._itemLayouts = []; // Graphic elemnents
        this._graphicEls = []; // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {}; // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false; // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'lttbDownSample',
            'map'
        ]; // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $kJQdt.isSeriesDataSchema)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $hzBt5.isString(dimInfoInput) ? new (0, $3JGxt.default)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $3JGxt.default)) ? new (0, $3JGxt.default)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $hzBt5.createHashMap();
            $hzBt5.each(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Becuause of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
         // Retrieve from series dimension definition becuase it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatbility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recogonized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if (typeof dim === 'number' // If being a number-like string but not being defined as a dimension name.
         || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $6Bzg6.default)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $8AzOm.isSourceInstance)(data) || $hzBt5.isArrayLike(data) ? new (0, $kWuWu.DefaultDataProvider)(data, dimensions.length) : data;
            store = new (0, $6Bzg6.default)();
            var dimensionInfos = $ef84d7185c8a372d$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store; // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count()); // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $eNXvv.summarizeDimensions)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exaclty cooresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $ef84d7185c8a372d$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL); // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $ckizb.isDataItemOption)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $ckizb.convertOptionIdName)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $ckizb.convertOptionIdName)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$ef84d7185c8a372d$var$makeIdFromName(this, idx);
        $ef84d7185c8a372d$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculte extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $ef84d7185c8a372d$var$isObject(key) ? $hzBt5.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Becuase:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $ef84d7185c8a372d$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Becuase:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $ef84d7185c8a372d$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $hzBt5.isArray(dimensions) ? store.getValues($ef84d7185c8a372d$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Inlcuding '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retreive the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $ef84d7185c8a372d$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $hzBt5.keys(range);
        var dimIndices = [];
        $hzBt5.each(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if (typeof dims === 'function') {
            ctx = cb;
            cb = dims;
            dims = [];
        } // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict'; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $ef84d7185c8a372d$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this; // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $ef84d7185c8a372d$var$map($ef84d7185c8a372d$var$normalizeDimensions(dims), this._getStoreDimIndex, this); // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, becuase `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each sereis
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $hzBt5.bind(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $ef84d7185c8a372d$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $ef84d7185c8a372d$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $fR3z1.default)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $ddlYG.default)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $ef84d7185c8a372d$var$getId(otherList, idx);
        }, function(idx) {
            return $ef84d7185c8a372d$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($ef84d7185c8a372d$var$isObject(kvObj)) $hzBt5.extend(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key); // TODO Performance?
            if ($hzBt5.isArray(val)) val = val.slice();
            else if ($ef84d7185c8a372d$var$isObject(val)) val = $hzBt5.extend({}, val);
            itemVisual[key] = val;
        }
        return val;
    }; // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($ef84d7185c8a372d$var$isObject(key)) $hzBt5.extend(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        if ($ef84d7185c8a372d$var$isObject(key)) {
            for(var name_1 in key)if (key.hasOwnProperty(name_1)) this.setLayout(name_1, key[name_1]);
            return;
        }
        this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $hzBt5.extend(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $aly4X.setCommonECData)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $hzBt5.each(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $ef84d7185c8a372d$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $ef84d7185c8a372d$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (typeof originalMethod !== 'function') return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($hzBt5.slice(arguments)));
        };
    }; // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $ef84d7185c8a372d$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $hzBt5.each(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $ef84d7185c8a372d$var$CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $ef84d7185c8a372d$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $ef84d7185c8a372d$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $ckizb.convertOptionIdName)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $ef84d7185c8a372d$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $ef84d7185c8a372d$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $ef84d7185c8a372d$var$ID_PREFIX + rawIndex;
            return id;
        };
        $ef84d7185c8a372d$var$normalizeDimensions = function(dimensions) {
            if (!$hzBt5.isArray(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transfered.
     */ $ef84d7185c8a372d$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $ef84d7185c8a372d$var$map(original.dimensions, original._getDimInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
            $ef84d7185c8a372d$var$transferProperties(list, original);
            return list;
        };
        $ef84d7185c8a372d$var$transferProperties = function(target, source) {
            $hzBt5.each($ef84d7185c8a372d$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $hzBt5.each($ef84d7185c8a372d$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $hzBt5.clone(source[propName]);
            });
            target._calculationInfo = $hzBt5.extend({}, source._calculationInfo);
        };
        $ef84d7185c8a372d$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $ef84d7185c8a372d$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $ef84d7185c8a372d$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $ef84d7185c8a372d$export$2e2bcd8739ae039 = $ef84d7185c8a372d$var$SeriesData;

});
parcelRegister("fR3z1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8ae91f82b16bb49$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gZXYp = parcelRequire("gZXYp");

var $jKrBG = parcelRequire("jKrBG");

var $jdsea = parcelRequire("jdsea");

var $2A2Wy = parcelRequire("2A2Wy");

var $5jmEk = parcelRequire("5jmEk");

var $9N9yS = parcelRequire("9N9yS");

var $hzBt5 = parcelRequire("hzBt5");
var $b8ae91f82b16bb49$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option; // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $hzBt5.merge)(this.option, option, true);
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    }; // `path` can be 'xxx.yyy.zzz', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'xxx.yyy.zzz' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * Squash option stack into one.
   * parentModel will be removed after squashed.
   *
   * NOTE: resolveParentPath will not be applied here for simplicity. DON'T use this function
   * if resolveParentPath is modified.
   *
   * @param deepMerge If do deep merge. Default to be false.
   */ // squash(
    //     deepMerge?: boolean,
    //     handleCallback?: (func: () => object) => object
    // ) {
    //     const optionStack = [];
    //     let model: Model = this;
    //     while (model) {
    //         if (model.option) {
    //             optionStack.push(model.option);
    //         }
    //         model = model.parentModel;
    //     }
    //     const newOption = {} as Opt;
    //     let option;
    //     while (option = optionStack.pop()) {    // Top down merge
    //         if (isFunction(option) && handleCallback) {
    //             option = handleCallback(option);
    //         }
    //         if (deepMerge) {
    //             merge(newOption, option);
    //         }
    //         else {
    //             extend(newOption, option);
    //         }
    //     }
    //     // Remove parentModel
    //     this.option = newOption;
    //     this.parentModel = null;
    // }
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {}; // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $hzBt5.clone)(this.option));
    }; // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    }; // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    }; // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $gZXYp.default).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
             // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
(0, $jKrBG.enableClassExtend)($b8ae91f82b16bb49$var$Model);
(0, $jKrBG.enableClassCheck)($b8ae91f82b16bb49$var$Model);
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $5jmEk.LineStyleMixin));
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $9N9yS.ItemStyleMixin));
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $jdsea.AreaStyleMixin));
(0, $hzBt5.mixin)($b8ae91f82b16bb49$var$Model, (0, $2A2Wy.default));
var $b8ae91f82b16bb49$export$2e2bcd8739ae039 = $b8ae91f82b16bb49$var$Model;

});
parcelRegister("gZXYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c600dd4dc583a2a4$export$2e2bcd8739ae039);
var $c600dd4dc583a2a4$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $c600dd4dc583a2a4$var$Env = function() {
    function Env() {
        this.browser = new $c600dd4dc583a2a4$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.canvasSupported = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
    }
    return Env;
}();
var $c600dd4dc583a2a4$var$env = new $c600dd4dc583a2a4$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $c600dd4dc583a2a4$var$env.wxa = true;
    $c600dd4dc583a2a4$var$env.canvasSupported = true;
    $c600dd4dc583a2a4$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
    $c600dd4dc583a2a4$var$env.worker = true;
    $c600dd4dc583a2a4$var$env.canvasSupported = true;
} else if (typeof navigator === 'undefined') {
    $c600dd4dc583a2a4$var$env.node = true;
    $c600dd4dc583a2a4$var$env.canvasSupported = true;
    $c600dd4dc583a2a4$var$env.svgSupported = true;
} else $c600dd4dc583a2a4$var$detect(navigator.userAgent, $c600dd4dc583a2a4$var$env);
function $c600dd4dc583a2a4$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.canvasSupported = !!document.createElement('canvas').getContext;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $c600dd4dc583a2a4$export$2e2bcd8739ae039 = $c600dd4dc583a2a4$var$env;

});

parcelRegister("jKrBG", function(module, exports) {

$parcel$export(module.exports, "parseClassType", () => $e607ba58dd731678$export$fbe18865d303bf01);
$parcel$export(module.exports, "isExtendedClass", () => $e607ba58dd731678$export$4f3b818f3dd2d182);
$parcel$export(module.exports, "enableClassExtend", () => $e607ba58dd731678$export$cd4c3a4dca301c70);
$parcel$export(module.exports, "mountExtend", () => $e607ba58dd731678$export$c9c2d87774f1275d);
$parcel$export(module.exports, "enableClassCheck", () => $e607ba58dd731678$export$e1aac4552ae82081);
$parcel$export(module.exports, "enableClassManagement", () => $e607ba58dd731678$export$241315e45585454d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");
var $e607ba58dd731678$var$TYPE_DELIMITER = '.';
var $e607ba58dd731678$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $e607ba58dd731678$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $e607ba58dd731678$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($e607ba58dd731678$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $e607ba58dd731678$var$checkClassType(componentType) {
    $hzBt5.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $e607ba58dd731678$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$e607ba58dd731678$var$IS_EXTENDED_CLASS]);
}
function $e607ba58dd731678$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this; // For backward compat, we both support ts class inheritance and this
        // "extend" approach.
        // The constructor should keep the same behavior as ts class inheritance:
        // If this constructor/$constructor is not declared, auto invoke the super
        // constructor.
        // If this constructor/$constructor is declared, it is responsible for
        // calling the super constructor.
        function ExtendedClass() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (!proto.$constructor) {
                if (!$e607ba58dd731678$var$isESClass(superClass)) // Will throw error if superClass is an es6 native class.
                superClass.apply(this, arguments);
                else {
                    var ins = $hzBt5.createObject(ExtendedClass.prototype, new (superClass.bind.apply(superClass, (0, $fKE23.__spreadArray)([
                        void 0
                    ], args)))());
                    return ins;
                }
            } else proto.$constructor.apply(this, arguments);
        }
        ExtendedClass[$e607ba58dd731678$var$IS_EXTENDED_CLASS] = true;
        $hzBt5.extend(ExtendedClass.prototype, proto);
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $e607ba58dd731678$var$superCall;
        ExtendedClass.superApply = $e607ba58dd731678$var$superApply;
        $hzBt5.inherits(ExtendedClass, this);
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $e607ba58dd731678$var$isESClass(fn) {
    return typeof fn === 'function' && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $e607ba58dd731678$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
} // A random offset.
var $e607ba58dd731678$var$classBase = Math.round(Math.random() * 10);
function $e607ba58dd731678$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $e607ba58dd731678$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
} // superCall should have class info, which can not be fetch from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, do not overrides method f,
// then when method of class C is called, dead loop occured.
function $e607ba58dd731678$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $e607ba58dd731678$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $e607ba58dd731678$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'xxx'
   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance memeber".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we stil support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $e607ba58dd731678$var$checkClassType(componentFullType); // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $e607ba58dd731678$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$e607ba58dd731678$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$e607ba58dd731678$var$IS_CONTAINER]) $hzBt5.each(obj, function(o, type) {
            type !== $e607ba58dd731678$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $hzBt5.each(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $e607ba58dd731678$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$e607ba58dd731678$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$e607ba58dd731678$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$e607ba58dd731678$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }

});

parcelRegister("jdsea", function(module, exports) {

$parcel$export(module.exports, "AreaStyleMixin", () => $dfd52098e56aabb6$export$a3a0ed7e2dd84c9e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6CLz8 = parcelRequire("6CLz8");
var $dfd52098e56aabb6$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $dfd52098e56aabb6$var$getAreaStyle = (0, $6CLz8.default)($dfd52098e56aabb6$export$52de6e304d934d85);
var $dfd52098e56aabb6$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $dfd52098e56aabb6$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();

});
parcelRegister("6CLz8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d2b30416931ea4c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

var $hzBt5 = parcelRequire("hzBt5");
function $4d2b30416931ea4c$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $hzBt5.indexOf(excludes, propName) >= 0 || includes && $hzBt5.indexOf(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        } // TODO Text or image?
        return style;
    };
}

});


parcelRegister("2A2Wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e113a126e4524bf$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hcRXD = parcelRequire("hcRXD");

var $kiooD = parcelRequire("kiooD");
var $1e113a126e4524bf$var$PATH_COLOR = [
    'textStyle',
    'color'
]; // TODO Performance improvement?
var $1e113a126e4524bf$var$tmpRichText = new (0, $kiooD.default)();
var $1e113a126e4524bf$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($1e113a126e4524bf$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $hcRXD.getFont)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        $1e113a126e4524bf$var$tmpRichText.useStyle({
            text: text,
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily'),
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline'),
            padding: this.getShallow('padding'),
            lineHeight: this.getShallow('lineHeight'),
            rich: this.getShallow('rich')
        });
        $1e113a126e4524bf$var$tmpRichText.update();
        return $1e113a126e4524bf$var$tmpRichText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $1e113a126e4524bf$export$2e2bcd8739ae039 = $1e113a126e4524bf$var$TextStyleMixin;

});
parcelRegister("hcRXD", function(module, exports) {

$parcel$export(module.exports, "setLabelStyle", () => $c86d6a2391ab42dd$export$9a13992917966657);
$parcel$export(module.exports, "createTextStyle", () => $c86d6a2391ab42dd$export$f8998c3d0a13de59);
$parcel$export(module.exports, "createTextConfig", () => $c86d6a2391ab42dd$export$e149afab8df6e053);
$parcel$export(module.exports, "labelInner", () => $c86d6a2391ab42dd$export$f62786d3261ab0f4);
$parcel$export(module.exports, "getLabelStatesModels", () => $c86d6a2391ab42dd$export$9739a32674be5893);
$parcel$export(module.exports, "getFont", () => $c86d6a2391ab42dd$export$155316a870a9d61e);
$parcel$export(module.exports, "setLabelValueAnimation", () => $c86d6a2391ab42dd$export$7bdbceaf9ab378f2);
$parcel$export(module.exports, "animateLabelValue", () => $c86d6a2391ab42dd$export$dd6101605f5c186);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kiooD = parcelRequire("kiooD");

var $hzBt5 = parcelRequire("hzBt5");

var $51xyq = parcelRequire("51xyq");


var $ckizb = parcelRequire("ckizb");

var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");
var $c86d6a2391ab42dd$var$EMPTY_OBJ = {};
function $c86d6a2391ab42dd$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $c86d6a2391ab42dd$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $hzBt5.isFunction)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $hzBt5.retrieve2)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $c86d6a2391ab42dd$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified // TODO specified position?
) {
    opt = opt || $c86d6a2391ab42dd$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $kiooD.default);
    var needsCreateText = false;
    for(var i = 0; i < (0, $51xyq.DISPLAY_STATES).length; i++){
        var stateModel = labelStatesModels[(0, $51xyq.DISPLAY_STATES)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $kiooD.default)();
                targetEl.setTextContent(textContent);
            } // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $c86d6a2391ab42dd$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $c86d6a2391ab42dd$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($c86d6a2391ab42dd$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
            var stateName = (0, $51xyq.SPECIAL_STATES)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $hzBt5.retrieve2)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $c86d6a2391ab42dd$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $c86d6a2391ab42dd$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        } // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto slient is those cases.
        textContent.silent = !!normalModel.getShallow('silent'); // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal; // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $c86d6a2391ab42dd$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $c86d6a2391ab42dd$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $c86d6a2391ab42dd$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $c86d6a2391ab42dd$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $c86d6a2391ab42dd$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $c86d6a2391ab42dd$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $hzBt5.extend)(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $c86d6a2391ab42dd$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
     // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $c86d6a2391ab42dd$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $c86d6a2391ab42dd$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $c86d6a2391ab42dd$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]); // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $c86d6a2391ab42dd$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get('minMargin');
    if (margin != null) textStyle.margin = margin;
    $c86d6a2391ab42dd$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $c86d6a2391ab42dd$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $c86d6a2391ab42dd$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $hzBt5.keys)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $c86d6a2391ab42dd$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $c86d6a2391ab42dd$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign'
];
var $c86d6a2391ab42dd$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $c86d6a2391ab42dd$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $c86d6a2391ab42dd$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $hzBt5.retrieve2)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
     // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    } // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $c86d6a2391ab42dd$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $c86d6a2391ab42dd$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $hzBt5.retrieve2)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $c86d6a2391ab42dd$var$TEXT_PROPS_SELF.length; i++){
        var key = $c86d6a2391ab42dd$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $c86d6a2391ab42dd$var$TEXT_PROPS_BOX.length; i++){
            var key = $c86d6a2391ab42dd$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $c86d6a2391ab42dd$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $hzBt5.trim)([
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $c86d6a2391ab42dd$export$f62786d3261ab0f4 = (0, $ckizb.makeInner)();
function $c86d6a2391ab42dd$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $c86d6a2391ab42dd$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $c86d6a2391ab42dd$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $c86d6a2391ab42dd$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation) return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText; // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $hzBt5.retrieve2)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $ckizb.interpolateRawValues)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $c86d6a2391ab42dd$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $c86d6a2391ab42dd$export$b533918394a58529(textEl, labelText);
    }
    (labelInnerStore.prevValue == null ? (0, $9ubot.initProps) : (0, $9ubot.updateProps))(textEl, {}, animatableModel, dataIndex, null, during);
}

});
parcelRegister("kiooD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec6869b798380d79$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $h0yya = parcelRequire("h0yya");

var $lm58d = parcelRequire("lm58d");

var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");

var $agXnr = parcelRequire("agXnr");

var $aeCKo = parcelRequire("aeCKo");

var $lGSv6 = parcelRequire("lGSv6");

var $g1Uer = parcelRequire("g1Uer");
var $ec6869b798380d79$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $ec6869b798380d79$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $ec6869b798380d79$export$21aaaa0607ee0e2b = {
    style: (0, $hzBt5.defaults)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $g1Uer.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $ec6869b798380d79$var$ZRText = function(_super) {
    (0, $fKE23.__extends)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $ec6869b798380d79$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $ec6869b798380d79$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $lGSv6.default)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $ec6869b798380d79$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {
        throw new Error('Can\'t attach text on another text');
    };
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $hzBt5.extend)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $hzBt5.keys)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $hzBt5.extend)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $ec6869b798380d79$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $02NbV.DEFAULT_FONT);
        var textPadding = style.padding;
        var text = $ec6869b798380d79$var$getStyleText(style);
        var contentBlock = (0, $h0yya.parsePlainText)(text, style);
        var needDrawBg = $ec6869b798380d79$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = (0, $02NbV.adjustTextY)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var outerWidth_1 = contentBlock.width;
            textPadding && (outerWidth_1 += textPadding[1] + textPadding[3]);
            var boxX = (0, $02NbV.adjustTextX)(baseX, outerWidth_1, textAlign);
            var boxY = (0, $02NbV.adjustTextY)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth_1, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $ec6869b798380d79$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $ec6869b798380d79$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $ec6869b798380d79$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $ec6869b798380d79$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $lm58d.default));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            if (textStroke) {
                subElStyle.stroke = textStroke;
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            if (textFill) subElStyle.fill = textFill;
            subElStyle.font = textFont;
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $lGSv6.default)((0, $02NbV.adjustTextX)(subElStyle.x, style.width, subElStyle.textAlign), (0, $02NbV.adjustTextY)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), style.width, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $ec6869b798380d79$var$getStyleText(style);
        var contentBlock = (0, $h0yya.parseRichText)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = (0, $02NbV.adjustTextX)(baseX, outerWidth, textAlign);
        var boxY = (0, $02NbV.adjustTextY)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($ec6869b798380d79$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $ec6869b798380d79$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $ec6869b798380d79$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $lm58d.default));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $ec6869b798380d79$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $ec6869b798380d79$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $ec6869b798380d79$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $02NbV.DEFAULT_FONT);
        subElStyle.opacity = (0, $hzBt5.retrieve3)(tokenStyle.opacity, style.opacity, 1);
        if (textStroke) {
            subElStyle.lineWidth = (0, $hzBt5.retrieve3)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $hzBt5.retrieve2)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $lGSv6.default)((0, $02NbV.adjustTextX)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $02NbV.adjustTextY)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $aeCKo.default));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $hzBt5.retrieve2)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $agXnr.default));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $hzBt5.retrieve2)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $hzBt5.retrieve3)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if (style.fontSize || style.fontFamily || style.fontWeight) {
            var fontSize = '';
            if (typeof style.fontSize === 'string' && (style.fontSize.indexOf('px') !== -1 || style.fontSize.indexOf('rem') !== -1 || style.fontSize.indexOf('em') !== -1)) fontSize = style.fontSize;
            else if (!isNaN(+style.fontSize)) fontSize = style.fontSize + 'px';
            else fontSize = '12px';
            font = [
                style.fontStyle,
                style.fontWeight,
                fontSize,
                style.fontFamily || 'sans-serif'
            ].join(' ');
        }
        return font && (0, $hzBt5.trim)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $g1Uer.default));
var $ec6869b798380d79$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $ec6869b798380d79$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
function $ec6869b798380d79$export$176336068cc5371f(style) {
    $ec6869b798380d79$var$normalizeStyle(style);
    (0, $hzBt5.each)(style.rich, $ec6869b798380d79$var$normalizeStyle);
    return style;
}
function $ec6869b798380d79$var$normalizeStyle(style) {
    if (style) {
        style.font = $ec6869b798380d79$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $ec6869b798380d79$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $ec6869b798380d79$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $hzBt5.normalizeCssArray)(style.padding);
    }
}
function $ec6869b798380d79$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $ec6869b798380d79$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $ec6869b798380d79$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $ec6869b798380d79$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $ec6869b798380d79$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $ec6869b798380d79$export$2e2bcd8739ae039 = $ec6869b798380d79$var$ZRText;

});
parcelRegister("h0yya", function(module, exports) {

$parcel$export(module.exports, "truncateText", () => $c61d3caa01110056$export$59a943b34a82e690);
$parcel$export(module.exports, "parsePlainText", () => $c61d3caa01110056$export$5772575e34ef80f9);
$parcel$export(module.exports, "parseRichText", () => $c61d3caa01110056$export$15ec9472ff2d721);

var $3RCXB = parcelRequire("3RCXB");

var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");
var $c61d3caa01110056$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $c61d3caa01110056$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) return '';
    var textLines = (text + '').split('\n');
    options = $c61d3caa01110056$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $c61d3caa01110056$var$truncateSingleLine(textLines[i], options);
    return textLines.join('\n');
}
function $c61d3caa01110056$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $hzBt5.extend)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $hzBt5.retrieve2)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $hzBt5.retrieve2)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $hzBt5.retrieve2)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $02NbV.getWidth)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $02NbV.getWidth)('a', font);
    preparedOpts.placeholder = (0, $hzBt5.retrieve2)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $02NbV.getWidth)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $c61d3caa01110056$var$truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) return '';
    var lineWidth = (0, $02NbV.getWidth)(textLine, font);
    if (lineWidth <= containerWidth) return textLine;
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $c61d3caa01110056$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $02NbV.getWidth)(textLine, font);
    }
    if (textLine === '') textLine = options.placeholder;
    return textLine;
}
function $c61d3caa01110056$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $c61d3caa01110056$export$5772575e34ef80f9(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $02NbV.getLineHeight)(font);
    var lineHeight = (0, $hzBt5.retrieve2)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var width = style.width;
    var lines;
    if (width != null && overflow === 'break' || overflow === 'breakAll') lines = text ? $c61d3caa01110056$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $hzBt5.retrieve2)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    var outerHeight = height;
    var outerWidth = width;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        if (outerWidth != null) outerWidth += padding[1] + padding[3];
    }
    if (text && truncate && outerWidth != null) {
        var options = $c61d3caa01110056$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for(var i = 0; i < lines.length; i++)lines[i] = $c61d3caa01110056$var$truncateSingleLine(lines[i], options);
    }
    if (width == null) {
        var maxWidth = 0;
        for(var i = 0; i < lines.length; i++)maxWidth = Math.max((0, $02NbV.getWidth)(lines[i], font), maxWidth);
        width = maxWidth;
    }
    return {
        lines: lines,
        height: height,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentHeight: contentHeight,
        width: width
    };
}
var $c61d3caa01110056$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $c61d3caa01110056$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $c61d3caa01110056$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}();
function $c61d3caa01110056$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $c61d3caa01110056$export$ca607d3c98caaf7e();
    text != null && (text += '');
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $c61d3caa01110056$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $c61d3caa01110056$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $c61d3caa01110056$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $c61d3caa01110056$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $c61d3caa01110056$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $c61d3caa01110056$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $02NbV.getLineHeight)(font);
            var tokenHeight = (0, $hzBt5.retrieve2)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $hzBt5.retrieve3)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $02NbV.getWidth)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $3RCXB.findExistImage(bgImg);
                        if ($3RCXB.isImageReady(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        token.text = $c61d3caa01110056$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.width = token.contentWidth = (0, $02NbV.getWidth)(token.text, font);
                    }
                } else token.contentWidth = (0, $02NbV.getWidth)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $hzBt5.retrieve2)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $hzBt5.retrieve2)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $c61d3caa01110056$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $02NbV.parsePercent)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $c61d3caa01110056$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split('\n');
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $c61d3caa01110056$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $02NbV.getWidth)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $c61d3caa01110056$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $c61d3caa01110056$var$RichTextLine([
            token
        ]));
    }
}
function $c61d3caa01110056$var$isLatin(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x21 && code <= 0xFF;
}
var $c61d3caa01110056$var$breakCharMap = (0, $hzBt5.reduce)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $c61d3caa01110056$var$isWordBreakChar(ch) {
    if ($c61d3caa01110056$var$isLatin(ch)) {
        if ($c61d3caa01110056$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $c61d3caa01110056$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $02NbV.getWidth)(ch, font);
        var inWord = isBreakAll ? false : !$c61d3caa01110056$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        accumWidth += currentWordWidth;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}

});
parcelRegister("3RCXB", function(module, exports) {

$parcel$export(module.exports, "findExistImage", () => $2d048b0f2d40f336$export$1b614f30ac2c8867);
$parcel$export(module.exports, "createOrUpdateImage", () => $2d048b0f2d40f336$export$46c791b69ff9a0f);
$parcel$export(module.exports, "isImageReady", () => $2d048b0f2d40f336$export$37ca7dd901d0236d);

var $lXNaK = parcelRequire("lXNaK");
var $2d048b0f2d40f336$var$globalImageCache = new (0, $lXNaK.default)(50);
function $2d048b0f2d40f336$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $2d048b0f2d40f336$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $2d048b0f2d40f336$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $2d048b0f2d40f336$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$2d048b0f2d40f336$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = new Image();
            image.onload = image.onerror = $2d048b0f2d40f336$var$imageOnLoad;
            $2d048b0f2d40f336$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
            image.src = image.__zrImageSrc = newImageOrSrc;
        }
        return image;
    } else return newImageOrSrc;
}
function $2d048b0f2d40f336$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $2d048b0f2d40f336$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}

});
parcelRegister("lXNaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd540418ef47102$export$2e2bcd8739ae039);
var $ffd540418ef47102$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $ffd540418ef47102$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $ffd540418ef47102$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $ffd540418ef47102$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $ffd540418ef47102$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $ffd540418ef47102$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $ffd540418ef47102$export$2e2bcd8739ae039 = $ffd540418ef47102$var$LRU;

});


parcelRegister("02NbV", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FONT", () => $00865865f57df308$export$7d7a232b6d2cc80c);
$parcel$export(module.exports, "getWidth", () => $00865865f57df308$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getLineHeight", () => $00865865f57df308$export$56204a27a2958a55);
$parcel$export(module.exports, "adjustTextX", () => $00865865f57df308$export$eb5a525ef00ef9a4);
$parcel$export(module.exports, "adjustTextY", () => $00865865f57df308$export$bf7d6802d2badd9);
$parcel$export(module.exports, "getBoundingRect", () => $00865865f57df308$export$c381147bfed79d9f);
$parcel$export(module.exports, "parsePercent", () => $00865865f57df308$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "calculateTextPosition", () => $00865865f57df308$export$eee3603b512feab7);

var $lGSv6 = parcelRequire("lGSv6");

var $hzBt5 = parcelRequire("hzBt5");

var $lXNaK = parcelRequire("lXNaK");
var $00865865f57df308$var$textWidthCache = {};
var $00865865f57df308$export$7d7a232b6d2cc80c = '12px sans-serif';
var $00865865f57df308$var$_ctx;
var $00865865f57df308$var$_cachedFont;
function $00865865f57df308$var$defaultMeasureText(text, font) {
    if (!$00865865f57df308$var$_ctx) $00865865f57df308$var$_ctx = (0, $hzBt5.createCanvas)().getContext('2d');
    if ($00865865f57df308$var$_cachedFont !== font) $00865865f57df308$var$_cachedFont = $00865865f57df308$var$_ctx.font = font || $00865865f57df308$export$7d7a232b6d2cc80c;
    return $00865865f57df308$var$_ctx.measureText(text);
}
var $00865865f57df308$var$methods = {
    measureText: $00865865f57df308$var$defaultMeasureText
};
function $00865865f57df308$export$d35a04b83ea6803e(name, fn) {
    $00865865f57df308$var$methods[name] = fn;
}
function $00865865f57df308$export$3c49c185de0c2bfc(text, font) {
    font = font || $00865865f57df308$export$7d7a232b6d2cc80c;
    var cacheOfFont = $00865865f57df308$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $00865865f57df308$var$textWidthCache[font] = new (0, $lXNaK.default)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = $00865865f57df308$var$methods.measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $00865865f57df308$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $00865865f57df308$export$3c49c185de0c2bfc(text, font);
    var height = $00865865f57df308$export$56204a27a2958a55(font);
    var x = $00865865f57df308$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $00865865f57df308$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $lGSv6.default)(x, y, width, height);
    return rect;
}
function $00865865f57df308$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $00865865f57df308$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $lGSv6.default)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $00865865f57df308$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $00865865f57df308$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === 'right') x -= width;
    else if (textAlign === 'center') x -= width / 2;
    return x;
}
function $00865865f57df308$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === 'middle') y -= height / 2;
    else if (verticalAlign === 'bottom') y -= height;
    return y;
}
function $00865865f57df308$export$56204a27a2958a55(font) {
    return $00865865f57df308$export$3c49c185de0c2bfc("\u56FD", font);
}
function $00865865f57df308$export$866cc30a33805630(text, font) {
    return $00865865f57df308$var$methods.measureText(text, font);
}
function $00865865f57df308$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $00865865f57df308$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $00865865f57df308$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $00865865f57df308$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}

});
parcelRegister("lGSv6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca7cbed3c1846ab$export$2e2bcd8739ae039);

var $crEgd = parcelRequire("crEgd");

var $4vVC3 = parcelRequire("4vVC3");
var $fca7cbed3c1846ab$var$mathMin = Math.min;
var $fca7cbed3c1846ab$var$mathMax = Math.max;
var $fca7cbed3c1846ab$var$lt = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$rb = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$lb = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$rt = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$minTv = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$maxTv = new (0, $4vVC3.default)();
var $fca7cbed3c1846ab$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $fca7cbed3c1846ab$var$mathMin(other.x, this.x);
        var y = $fca7cbed3c1846ab$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $fca7cbed3c1846ab$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $fca7cbed3c1846ab$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $crEgd.create();
        $crEgd.translate(m, m, [
            -a.x,
            -a.y
        ]);
        $crEgd.scale(m, m, [
            sx,
            sy
        ]);
        $crEgd.translate(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, -d0, 0);
                    else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, d0, 0);
                else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, 0, -d2);
                    else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, 0, d2);
                else (0, $4vVC3.default).set($fca7cbed3c1846ab$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $4vVC3.default).copy(mtv, overlap ? $fca7cbed3c1846ab$var$minTv : $fca7cbed3c1846ab$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $fca7cbed3c1846ab$var$lt.x = $fca7cbed3c1846ab$var$lb.x = source.x;
        $fca7cbed3c1846ab$var$lt.y = $fca7cbed3c1846ab$var$rt.y = source.y;
        $fca7cbed3c1846ab$var$rb.x = $fca7cbed3c1846ab$var$rt.x = source.x + source.width;
        $fca7cbed3c1846ab$var$rb.y = $fca7cbed3c1846ab$var$lb.y = source.y + source.height;
        $fca7cbed3c1846ab$var$lt.transform(m);
        $fca7cbed3c1846ab$var$rt.transform(m);
        $fca7cbed3c1846ab$var$rb.transform(m);
        $fca7cbed3c1846ab$var$lb.transform(m);
        target.x = $fca7cbed3c1846ab$var$mathMin($fca7cbed3c1846ab$var$lt.x, $fca7cbed3c1846ab$var$rb.x, $fca7cbed3c1846ab$var$lb.x, $fca7cbed3c1846ab$var$rt.x);
        target.y = $fca7cbed3c1846ab$var$mathMin($fca7cbed3c1846ab$var$lt.y, $fca7cbed3c1846ab$var$rb.y, $fca7cbed3c1846ab$var$lb.y, $fca7cbed3c1846ab$var$rt.y);
        var maxX = $fca7cbed3c1846ab$var$mathMax($fca7cbed3c1846ab$var$lt.x, $fca7cbed3c1846ab$var$rb.x, $fca7cbed3c1846ab$var$lb.x, $fca7cbed3c1846ab$var$rt.x);
        var maxY = $fca7cbed3c1846ab$var$mathMax($fca7cbed3c1846ab$var$lt.y, $fca7cbed3c1846ab$var$rb.y, $fca7cbed3c1846ab$var$lb.y, $fca7cbed3c1846ab$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $fca7cbed3c1846ab$export$2e2bcd8739ae039 = $fca7cbed3c1846ab$var$BoundingRect;

});
parcelRegister("crEgd", function(module, exports) {

$parcel$export(module.exports, "create", () => $90f73c92e4c09026$export$185802fd694ee1f5);
$parcel$export(module.exports, "identity", () => $90f73c92e4c09026$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $90f73c92e4c09026$export$784d13d8ee351f07);
$parcel$export(module.exports, "mul", () => $90f73c92e4c09026$export$6e3a27864ab166fe);
$parcel$export(module.exports, "translate", () => $90f73c92e4c09026$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "rotate", () => $90f73c92e4c09026$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $90f73c92e4c09026$export$dcdf75081b88279d);
$parcel$export(module.exports, "invert", () => $90f73c92e4c09026$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "clone", () => $90f73c92e4c09026$export$9cd59f9826255e47);
function $90f73c92e4c09026$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $90f73c92e4c09026$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $90f73c92e4c09026$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $90f73c92e4c09026$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $90f73c92e4c09026$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $90f73c92e4c09026$export$bb628a54ab399bc9(out, a, rad) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * atx + st * aty;
    out[5] = ct * aty - st * atx;
    return out;
}
function $90f73c92e4c09026$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $90f73c92e4c09026$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $90f73c92e4c09026$export$9cd59f9826255e47(a) {
    var b = $90f73c92e4c09026$export$185802fd694ee1f5();
    $90f73c92e4c09026$export$784d13d8ee351f07(b, a);
    return b;
}

});

parcelRegister("4vVC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3496bf65801d919c$export$2e2bcd8739ae039);
var $3496bf65801d919c$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $3496bf65801d919c$export$2e2bcd8739ae039 = $3496bf65801d919c$var$Point;

});




parcelRegister("lm58d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8bfa2133f4d35a8$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $02NbV = parcelRequire("02NbV");

var $hMiip = parcelRequire("hMiip");

var $hzBt5 = parcelRequire("hzBt5");
var $f8bfa2133f4d35a8$export$5fbb6d98091bcb56 = (0, $hzBt5.defaults)({
    strokeFirst: true,
    font: (0, $02NbV.DEFAULT_FONT),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $hMiip.DEFAULT_PATH_STYLE));
var $f8bfa2133f4d35a8$var$TSpan = function(_super) {
    (0, $fKE23.__extends)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($f8bfa2133f4d35a8$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += '' : text = '';
            var rect = (0, $02NbV.getBoundingRect)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $g1Uer.default));
$f8bfa2133f4d35a8$var$TSpan.prototype.type = 'tspan';
var $f8bfa2133f4d35a8$export$2e2bcd8739ae039 = $f8bfa2133f4d35a8$var$TSpan;

});
parcelRegister("g1Uer", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COMMON_STYLE", () => $bab85bd1aedea063$export$737672163db00fe3);
$parcel$export(module.exports, "DEFAULT_COMMON_ANIMATION_PROPS", () => $bab85bd1aedea063$export$9908943fb57fbe51);
$parcel$export(module.exports, "default", () => $bab85bd1aedea063$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $3MGIU = parcelRequire("3MGIU");

var $lGSv6 = parcelRequire("lGSv6");

var $hzBt5 = parcelRequire("hzBt5");

var $4rgPt = parcelRequire("4rgPt");
var $bab85bd1aedea063$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $bab85bd1aedea063$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $bab85bd1aedea063$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$bab85bd1aedea063$export$737672163db00fe3[$bab85bd1aedea063$var$STYLE_MAGIC_KEY] = true;
var $bab85bd1aedea063$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $bab85bd1aedea063$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $bab85bd1aedea063$var$Displayable = function(_super) {
    (0, $fKE23.__extends)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $hzBt5.keys)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $bab85bd1aedea063$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $lGSv6.default)(0, 0, 0, 0));
            if (transform) (0, $lGSv6.default).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $lGSv6.default)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $hzBt5.extend)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $4rgPt.STYLE_CHANGED_BIT);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $4rgPt.STYLE_CHANGED_BIT));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $4rgPt.STYLE_CHANGED_BIT);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($bab85bd1aedea063$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$bab85bd1aedea063$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$bab85bd1aedea063$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $bab85bd1aedea063$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $hzBt5.keys)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $hzBt5.keys)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $bab85bd1aedea063$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $bab85bd1aedea063$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $hzBt5.extend)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $bab85bd1aedea063$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $4rgPt.REDRAW_BIT) | (0, $4rgPt.STYLE_CHANGED_BIT);
    }();
    return Displayable;
}((0, $3MGIU.default));
var $bab85bd1aedea063$var$tmpRect = new (0, $lGSv6.default)(0, 0, 0, 0);
var $bab85bd1aedea063$var$viewRect = new (0, $lGSv6.default)(0, 0, 0, 0);
function $bab85bd1aedea063$var$isDisplayableCulled(el, width, height) {
    $bab85bd1aedea063$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $bab85bd1aedea063$var$tmpRect.applyTransform(el.transform);
    $bab85bd1aedea063$var$viewRect.width = width;
    $bab85bd1aedea063$var$viewRect.height = height;
    return !$bab85bd1aedea063$var$tmpRect.intersect($bab85bd1aedea063$var$viewRect);
}
var $bab85bd1aedea063$export$2e2bcd8739ae039 = $bab85bd1aedea063$var$Displayable;

});
parcelRegister("3MGIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c16fec6ca39fd98$export$2e2bcd8739ae039);

var $kVlB5 = parcelRequire("kVlB5");

var $fyp5g = parcelRequire("fyp5g");

var $lGSv6 = parcelRequire("lGSv6");

var $1J7Ke = parcelRequire("1J7Ke");

var $02NbV = parcelRequire("02NbV");

var $hzBt5 = parcelRequire("hzBt5");

var $2MY1H = parcelRequire("2MY1H");

var $f7lrR = parcelRequire("f7lrR");

var $gZXYp = parcelRequire("gZXYp");

var $4rgPt = parcelRequire("4rgPt");
var $2c16fec6ca39fd98$export$97b5e845c7286801 = '__zr_normal__';
var $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS = [
    'x',
    'y',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'rotation',
    'ignore'
];
var $2c16fec6ca39fd98$var$DEFAULT_ANIMATABLE_MAP = {
    x: true,
    y: true,
    scaleX: true,
    scaleY: true,
    originX: true,
    originY: true,
    rotation: true,
    ignore: false
};
var $2c16fec6ca39fd98$var$tmpTextPosCalcRes = {};
var $2c16fec6ca39fd98$var$tmpBoundingRect = new (0, $lGSv6.default)(0, 0, 0, 0);
var $2c16fec6ca39fd98$var$Element = function() {
    function Element(props) {
        this.id = (0, $hzBt5.guid)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $2c16fec6ca39fd98$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($2c16fec6ca39fd98$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $02NbV.calculateTextPosition)($2c16fec6ca39fd98$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.y;
                textAlign = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $2c16fec6ca39fd98$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $02NbV.parsePercent)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $02NbV.parsePercent)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $4rgPt.REDRAW_BIT);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $2MY1H.LIGHT_LABEL_COLOR) : (0, $2MY1H.DARK_LABEL_COLOR);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $f7lrR.parse)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $f7lrR.stringify)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $hzBt5.extend)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $hzBt5.isObject)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $hzBt5.keys)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (fromStateTransition && fromStateTransition !== $2c16fec6ca39fd98$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveFinalToTarget(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($2c16fec6ca39fd98$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $2c16fec6ca39fd98$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $hzBt5.indexOf)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $hzBt5.logError)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $4rgPt.REDRAW_BIT);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $4rgPt.REDRAW_BIT);
            }
        }
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $hzBt5.indexOf)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $hzBt5.indexOf)(currentStates, oldState);
        var newStateExists = (0, $hzBt5.indexOf)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $hzBt5.extend)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $hzBt5.extend)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $hzBt5.extend)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $hzBt5.extend)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $2c16fec6ca39fd98$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $2c16fec6ca39fd98$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        if (componentEl === this) throw new Error('Recursive component attachment.');
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        if (textEl.__zr && !textEl.__hostTarget) throw new Error('Text element has been added to zrender.');
        textEl.innerTransformable = new (0, $kVlB5.default)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $hzBt5.extend)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $4rgPt.REDRAW_BIT);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop) {
        var target = key ? this[key] : this;
        if (!target) {
            (0, $hzBt5.logError)('Property "' + key + '" is not existed in element ' + this.id);
            return;
        }
        var animator = new (0, $fyp5g.default)(target, loop);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $hzBt5.indexOf)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $2c16fec6ca39fd98$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $2c16fec6ca39fd98$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $2c16fec6ca39fd98$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = false;
        elProto.silent = false;
        elProto.isGroup = false;
        elProto.draggable = false;
        elProto.dragging = false;
        elProto.ignoreClip = false;
        elProto.__inHover = false;
        elProto.__dirty = (0, $4rgPt.REDRAW_BIT);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    logDeprecatedError(key, xKey, yKey);
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    logDeprecatedError(key, xKey, yKey);
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty && (!(0, $gZXYp.default).browser.ie || (0, $gZXYp.default).browser.version > 8)) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $hzBt5.mixin)($2c16fec6ca39fd98$var$Element, (0, $1J7Ke.default));
(0, $hzBt5.mixin)($2c16fec6ca39fd98$var$Element, (0, $kVlB5.default));
function $2c16fec6ca39fd98$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $2c16fec6ca39fd98$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        animator.start(cfg.easing, cfg.force);
    }
    return animators;
}
function $2c16fec6ca39fd98$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $2c16fec6ca39fd98$var$is2DArray(value) {
    return (0, $hzBt5.isArrayLike)(value[0]);
}
function $2c16fec6ca39fd98$var$copyValue(target, source, key) {
    if ((0, $hzBt5.isArrayLike)(source[key])) {
        if (!(0, $hzBt5.isArrayLike)(target[key])) target[key] = [];
        if ((0, $hzBt5.isTypedArray)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $2c16fec6ca39fd98$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($2c16fec6ca39fd98$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $2c16fec6ca39fd98$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $2c16fec6ca39fd98$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $2c16fec6ca39fd98$var$animateToShallow(animatable, topKey, source, target, cfg, animationProps, animators, reverse) {
    var animatableKeys = [];
    var changedKeys = [];
    var targetKeys = (0, $hzBt5.keys)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $hzBt5.isObject)(animationProps);
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        if (source[innerKey] != null && target[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $hzBt5.isObject)(target[innerKey]) && !(0, $hzBt5.isArrayLike)(target[innerKey])) {
                if (topKey) {
                    if (!reverse) {
                        source[innerKey] = target[innerKey];
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $2c16fec6ca39fd98$var$animateToShallow(animatable, innerKey, source[innerKey], target[innerKey], cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else {
                animatableKeys.push(innerKey);
                changedKeys.push(innerKey);
            }
        } else if (!reverse) {
            source[innerKey] = target[innerKey];
            animatable.updateDuringAnimation(topKey);
            changedKeys.push(innerKey);
        }
    }
    var keyLen = animatableKeys.length;
    if (keyLen > 0 || cfg.force && !animators.length) {
        var existsAnimators = animatable.animators;
        var existsAnimatorsOnSameTarget = [];
        for(var i = 0; i < existsAnimators.length; i++)if (existsAnimators[i].targetName === topKey) existsAnimatorsOnSameTarget.push(existsAnimators[i]);
        if (!additive && existsAnimatorsOnSameTarget.length) for(var i = 0; i < existsAnimatorsOnSameTarget.length; i++){
            var allAborted = existsAnimatorsOnSameTarget[i].stopTracks(changedKeys);
            if (allAborted) {
                var idx = (0, $hzBt5.indexOf)(existsAnimators, existsAnimatorsOnSameTarget[i]);
                existsAnimators.splice(idx, 1);
            }
        }
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                reversedTarget[innerKey] = source[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else source[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animatableKeys[i];
                sourceClone[innerKey] = (0, $fyp5g.cloneValue)(source[innerKey]);
                $2c16fec6ca39fd98$var$copyValue(source, target, innerKey);
            }
        }
        var animator = new (0, $fyp5g.default)(source, false, additive ? existsAnimatorsOnSameTarget : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animatableKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animatableKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animatableKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $2c16fec6ca39fd98$export$2e2bcd8739ae039 = $2c16fec6ca39fd98$var$Element;

});
parcelRegister("kVlB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b9e247faabbfb1$export$2e2bcd8739ae039);

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");
var $f3b9e247faabbfb1$var$mIdentity = $crEgd.identity;
var $f3b9e247faabbfb1$var$EPSILON = 5e-5;
function $f3b9e247faabbfb1$var$isNotAroundZero(val) {
    return val > $f3b9e247faabbfb1$var$EPSILON || val < -$f3b9e247faabbfb1$var$EPSILON;
}
var $f3b9e247faabbfb1$var$scaleTmp = [];
var $f3b9e247faabbfb1$var$tmpTransform = [];
var $f3b9e247faabbfb1$var$originTransform = $crEgd.create();
var $f3b9e247faabbfb1$var$abs = Math.abs;
var $f3b9e247faabbfb1$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $f3b9e247faabbfb1$var$isNotAroundZero(this.rotation) || $f3b9e247faabbfb1$var$isNotAroundZero(this.x) || $f3b9e247faabbfb1$var$isNotAroundZero(this.y) || $f3b9e247faabbfb1$var$isNotAroundZero(this.scaleX - 1) || $f3b9e247faabbfb1$var$isNotAroundZero(this.scaleY - 1);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            m && $f3b9e247faabbfb1$var$mIdentity(m);
            return;
        }
        m = m || $crEgd.create();
        if (needLocalTransform) this.getLocalTransform(m);
        else $f3b9e247faabbfb1$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $crEgd.mul(m, parentTransform, m);
            else $crEgd.copy(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($f3b9e247faabbfb1$var$scaleTmp);
            var relX = $f3b9e247faabbfb1$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $f3b9e247faabbfb1$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($f3b9e247faabbfb1$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $f3b9e247faabbfb1$var$scaleTmp[0] || 0;
            var sy = (($f3b9e247faabbfb1$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $f3b9e247faabbfb1$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $crEgd.create();
        $crEgd.invert(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            $crEgd.mul($f3b9e247faabbfb1$var$tmpTransform, parent.invTransform, m);
            m = $f3b9e247faabbfb1$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $f3b9e247faabbfb1$var$originTransform[4] = ox;
            $f3b9e247faabbfb1$var$originTransform[5] = oy;
            $crEgd.mul($f3b9e247faabbfb1$var$tmpTransform, m, $f3b9e247faabbfb1$var$originTransform);
            $f3b9e247faabbfb1$var$tmpTransform[4] -= ox;
            $f3b9e247faabbfb1$var$tmpTransform[5] -= oy;
            m = $f3b9e247faabbfb1$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $ef5pP.applyTransform(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $ef5pP.applyTransform(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $f3b9e247faabbfb1$var$abs(m[0] - 1) > 1e-10 && $f3b9e247faabbfb1$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($f3b9e247faabbfb1$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        var target = this;
        for(var i = 0; i < $f3b9e247faabbfb1$export$98ab6203ec3396e2.length; i++){
            var propName = $f3b9e247faabbfb1$export$98ab6203ec3396e2[i];
            target[propName] = source[propName];
        }
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy) {
            m[4] = -ox * sx - skewX * oy * sy;
            m[5] = -oy * sy - skewY * ox * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $crEgd.rotate(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.x = 0;
        proto.y = 0;
        proto.scaleX = 1;
        proto.scaleY = 1;
        proto.originX = 0;
        proto.originY = 0;
        proto.skewX = 0;
        proto.skewY = 0;
        proto.rotation = 0;
        proto.globalScaleRatio = 1;
    }();
    return Transformable;
}();
var $f3b9e247faabbfb1$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
var $f3b9e247faabbfb1$export$2e2bcd8739ae039 = $f3b9e247faabbfb1$var$Transformable;

});
parcelRegister("ef5pP", function(module, exports) {

$parcel$export(module.exports, "create", () => $a5e6aad6152849a4$export$185802fd694ee1f5);
$parcel$export(module.exports, "copy", () => $a5e6aad6152849a4$export$784d13d8ee351f07);
$parcel$export(module.exports, "clone", () => $a5e6aad6152849a4$export$9cd59f9826255e47);
$parcel$export(module.exports, "set", () => $a5e6aad6152849a4$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $a5e6aad6152849a4$export$e16d8520af44a096);
$parcel$export(module.exports, "scaleAndAdd", () => $a5e6aad6152849a4$export$19cedf1da84ba854);
$parcel$export(module.exports, "sub", () => $a5e6aad6152849a4$export$f93b5905241a7cca);
$parcel$export(module.exports, "len", () => $a5e6aad6152849a4$export$fc1400facf92c78);
$parcel$export(module.exports, "lenSquare", () => $a5e6aad6152849a4$export$48e33bc611e4c25a);
$parcel$export(module.exports, "length", () => $a5e6aad6152849a4$export$f24224f1c91d8156);
$parcel$export(module.exports, "lengthSquare", () => $a5e6aad6152849a4$export$2f106540dd9a5136);
$parcel$export(module.exports, "mul", () => $a5e6aad6152849a4$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $a5e6aad6152849a4$export$159d9494db57879b);
$parcel$export(module.exports, "dot", () => $a5e6aad6152849a4$export$94132a0e348806d4);
$parcel$export(module.exports, "scale", () => $a5e6aad6152849a4$export$dcdf75081b88279d);
$parcel$export(module.exports, "normalize", () => $a5e6aad6152849a4$export$a3295358bff77e);
$parcel$export(module.exports, "distance", () => $a5e6aad6152849a4$export$9f17032d917177de);
$parcel$export(module.exports, "dist", () => $a5e6aad6152849a4$export$6c4a311cc157c764);
$parcel$export(module.exports, "distanceSquare", () => $a5e6aad6152849a4$export$137c0a69d1ff4a79);
$parcel$export(module.exports, "distSquare", () => $a5e6aad6152849a4$export$c68db45a034c13b0);
$parcel$export(module.exports, "negate", () => $a5e6aad6152849a4$export$aef51622e549b8b0);
$parcel$export(module.exports, "lerp", () => $a5e6aad6152849a4$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "applyTransform", () => $a5e6aad6152849a4$export$9f9dcb98c894b623);
$parcel$export(module.exports, "min", () => $a5e6aad6152849a4$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $a5e6aad6152849a4$export$8960430cfd85939f);
function $a5e6aad6152849a4$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $a5e6aad6152849a4$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $a5e6aad6152849a4$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $a5e6aad6152849a4$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $a5e6aad6152849a4$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $a5e6aad6152849a4$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $a5e6aad6152849a4$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $a5e6aad6152849a4$export$fc1400facf92c78(v) {
    return Math.sqrt($a5e6aad6152849a4$export$48e33bc611e4c25a(v));
}
var $a5e6aad6152849a4$export$f24224f1c91d8156 = $a5e6aad6152849a4$export$fc1400facf92c78;
function $a5e6aad6152849a4$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $a5e6aad6152849a4$export$2f106540dd9a5136 = $a5e6aad6152849a4$export$48e33bc611e4c25a;
function $a5e6aad6152849a4$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $a5e6aad6152849a4$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $a5e6aad6152849a4$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $a5e6aad6152849a4$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $a5e6aad6152849a4$export$a3295358bff77e(out, v) {
    var d = $a5e6aad6152849a4$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $a5e6aad6152849a4$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $a5e6aad6152849a4$export$6c4a311cc157c764 = $a5e6aad6152849a4$export$9f17032d917177de;
function $a5e6aad6152849a4$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $a5e6aad6152849a4$export$c68db45a034c13b0 = $a5e6aad6152849a4$export$137c0a69d1ff4a79;
function $a5e6aad6152849a4$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $a5e6aad6152849a4$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $a5e6aad6152849a4$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $a5e6aad6152849a4$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $a5e6aad6152849a4$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}

});


parcelRegister("fyp5g", function(module, exports) {

$parcel$export(module.exports, "interpolateNumber", () => $b52d7d2323499a1c$export$d871d53bd7eeb390);
$parcel$export(module.exports, "cloneValue", () => $b52d7d2323499a1c$export$c5e92b7f105af84e);
$parcel$export(module.exports, "default", () => $b52d7d2323499a1c$export$2e2bcd8739ae039);

var $aU7WT = parcelRequire("aU7WT");

var $f7lrR = parcelRequire("f7lrR");

var $hzBt5 = parcelRequire("hzBt5");
var $b52d7d2323499a1c$var$arraySlice = Array.prototype.slice;
function $b52d7d2323499a1c$export$d871d53bd7eeb390(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $b52d7d2323499a1c$export$35d34bc0ed591a92(p0, p1, percent) {
    return percent > 0.5 ? p1 : p0;
}
function $b52d7d2323499a1c$export$f8938d924b05a6eb(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $b52d7d2323499a1c$export$d871d53bd7eeb390(p0[i], p1[i], percent);
}
function $b52d7d2323499a1c$export$3297a85eaaa37024(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $b52d7d2323499a1c$export$d871d53bd7eeb390(p0[i][j], p1[i][j], percent);
    }
}
function $b52d7d2323499a1c$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $b52d7d2323499a1c$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $b52d7d2323499a1c$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $b52d7d2323499a1c$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $b52d7d2323499a1c$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $b52d7d2323499a1c$var$catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $b52d7d2323499a1c$var$catmullRomInterpolate1DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $b52d7d2323499a1c$var$catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
}
function $b52d7d2323499a1c$var$catmullRomInterpolate2DArray(out, p0, p1, p2, p3, t, t2, t3) {
    var len = p0.length;
    var len2 = p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[1] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $b52d7d2323499a1c$var$catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
    }
}
function $b52d7d2323499a1c$export$c5e92b7f105af84e(value) {
    if ((0, $hzBt5.isArrayLike)(value)) {
        var len = value.length;
        if ((0, $hzBt5.isArrayLike)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($b52d7d2323499a1c$var$arraySlice.call(value[i]));
            return ret;
        }
        return $b52d7d2323499a1c$var$arraySlice.call(value);
    }
    return value;
}
function $b52d7d2323499a1c$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]);
    rgba[1] = Math.floor(rgba[1]);
    rgba[2] = Math.floor(rgba[2]);
    return 'rgba(' + rgba.join(',') + ')';
}
function $b52d7d2323499a1c$var$guessArrayDim(value) {
    return (0, $hzBt5.isArrayLike)(value && value[0]) ? 2 : 1;
}
var $b52d7d2323499a1c$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $b52d7d2323499a1c$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.maxTime = 0;
        this.arrDim = 0;
        this.interpolable = true;
        this._needsSort = false;
        this._isAllValueEqual = true;
        this._lastFrame = 0;
        this._lastFramePercent = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return !this._isAllValueEqual && this.keyframes.length >= 2 && this.interpolable && this.maxTime > 0;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, value) {
        if (time >= this.maxTime) this.maxTime = time;
        else this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        if (this.interpolable) {
            if ((0, $hzBt5.isArrayLike)(value)) {
                var arrayDim = $b52d7d2323499a1c$var$guessArrayDim(value);
                if (len > 0 && this.arrDim !== arrayDim) {
                    this.interpolable = false;
                    return;
                }
                if (arrayDim === 1 && typeof value[0] !== 'number' || arrayDim === 2 && typeof value[0][0] !== 'number') {
                    this.interpolable = false;
                    return;
                }
                if (len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this._isAllValueEqual) {
                        if (arrayDim === 1) {
                            if (!$b52d7d2323499a1c$var$is1DArraySame(value, lastFrame.value)) this._isAllValueEqual = false;
                        } else this._isAllValueEqual = false;
                    }
                }
                this.arrDim = arrayDim;
            } else {
                if (this.arrDim > 0) {
                    this.interpolable = false;
                    return;
                }
                if (typeof value === 'string') {
                    var colorArray = $f7lrR.parse(value);
                    if (colorArray) {
                        value = colorArray;
                        this.isValueColor = true;
                    } else this.interpolable = false;
                } else if (typeof value !== 'number' || isNaN(value)) {
                    this.interpolable = false;
                    return;
                }
                if (this._isAllValueEqual && len > 0) {
                    var lastFrame = keyframes[len - 1];
                    if (this.isValueColor && !$b52d7d2323499a1c$var$is1DArraySame(lastFrame.value, value)) this._isAllValueEqual = false;
                    else if (lastFrame.value !== value) this._isAllValueEqual = false;
                }
            }
        }
        var kf = {
            time: time,
            value: value,
            percent: 0
        };
        this.keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var arrDim = this.arrDim;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        for(var i = 0; i < kfsLen; i++){
            kfs[i].percent = kfs[i].time / this.maxTime;
            if (arrDim > 0 && i !== kfsLen - 1) $b52d7d2323499a1c$var$fillArray(kfs[i].value, lastKf.value, arrDim);
        }
        if (additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && arrDim === additiveTrack.arrDim && this.isValueColor === additiveTrack.isValueColor && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (arrDim === 0) {
                    if (this.isValueColor) kfs[i].additiveValue = $b52d7d2323499a1c$var$add1DArray([], kfs[i].value, startValue, -1);
                    else kfs[i].additiveValue = kfs[i].value - startValue;
                } else if (arrDim === 1) kfs[i].additiveValue = $b52d7d2323499a1c$var$add1DArray([], kfs[i].value, startValue, -1);
                else if (arrDim === 2) kfs[i].additiveValue = $b52d7d2323499a1c$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var keyframes = this.keyframes;
        var kfsNum = this.keyframes.length;
        var propName = this.propName;
        var arrDim = this.arrDim;
        var isValueColor = this.isValueColor;
        var frameIdx;
        if (percent < 0) frameIdx = 0;
        else if (percent < this._lastFramePercent) {
            var start = Math.min(this._lastFrame + 1, kfsNum - 1);
            for(frameIdx = start; frameIdx >= 0; frameIdx--){
                if (keyframes[frameIdx].percent <= percent) break;
            }
            frameIdx = Math.min(frameIdx, kfsNum - 2);
        } else {
            for(frameIdx = this._lastFrame; frameIdx < kfsNum; frameIdx++){
                if (keyframes[frameIdx].percent > percent) break;
            }
            frameIdx = Math.min(frameIdx - 1, kfsNum - 2);
        }
        var nextFrame = keyframes[frameIdx + 1];
        var frame = keyframes[frameIdx];
        if (!(frame && nextFrame)) return;
        this._lastFrame = frameIdx;
        this._lastFramePercent = percent;
        var range = nextFrame.percent - frame.percent;
        if (range === 0) return;
        var w = (percent - frame.percent) / range;
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $b52d7d2323499a1c$var$tmpRgba : target[propName];
        if ((arrDim > 0 || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.useSpline) {
            var p1 = keyframes[frameIdx][valueKey];
            var p0 = keyframes[frameIdx === 0 ? frameIdx : frameIdx - 1][valueKey];
            var p2 = keyframes[frameIdx > kfsNum - 2 ? kfsNum - 1 : frameIdx + 1][valueKey];
            var p3 = keyframes[frameIdx > kfsNum - 3 ? kfsNum - 1 : frameIdx + 2][valueKey];
            if (arrDim > 0) arrDim === 1 ? $b52d7d2323499a1c$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w) : $b52d7d2323499a1c$var$catmullRomInterpolate2DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
            else if (isValueColor) {
                $b52d7d2323499a1c$var$catmullRomInterpolate1DArray(targetArr, p0, p1, p2, p3, w, w * w, w * w * w);
                if (!isAdditive) target[propName] = $b52d7d2323499a1c$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = p2;
                else value = $b52d7d2323499a1c$var$catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        } else {
            if (arrDim > 0) arrDim === 1 ? $b52d7d2323499a1c$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w) : $b52d7d2323499a1c$export$3297a85eaaa37024(targetArr, frame[valueKey], nextFrame[valueKey], w);
            else if (isValueColor) {
                $b52d7d2323499a1c$export$f8938d924b05a6eb(targetArr, frame[valueKey], nextFrame[valueKey], w);
                if (!isAdditive) target[propName] = $b52d7d2323499a1c$var$rgba2String(targetArr);
            } else {
                var value = void 0;
                if (!this.interpolable) value = $b52d7d2323499a1c$export$35d34bc0ed591a92(frame[valueKey], nextFrame[valueKey], w);
                else value = $b52d7d2323499a1c$export$d871d53bd7eeb390(frame[valueKey], nextFrame[valueKey], w);
                if (isAdditive) this._additiveValue = value;
                else target[propName] = value;
            }
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var arrDim = this.arrDim;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (arrDim === 0) {
            if (this.isValueColor) {
                $f7lrR.parse(target[propName], $b52d7d2323499a1c$var$tmpRgba);
                $b52d7d2323499a1c$var$add1DArray($b52d7d2323499a1c$var$tmpRgba, $b52d7d2323499a1c$var$tmpRgba, additiveValue, 1);
                target[propName] = $b52d7d2323499a1c$var$rgba2String($b52d7d2323499a1c$var$tmpRgba);
            } else target[propName] = target[propName] + additiveValue;
        } else if (arrDim === 1) $b52d7d2323499a1c$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (arrDim === 2) $b52d7d2323499a1c$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $b52d7d2323499a1c$var$Animator = function() {
    function Animator(target, loop, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._delay = 0;
        this._maxTime = 0;
        this._paused = false;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $hzBt5.logError)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
    }
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props) {
        return this.whenWithKeys(time, props, (0, $hzBt5.keys)(props));
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $b52d7d2323499a1c$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var lastFinalKf = additiveTrack.keyframes[additiveTrack.keyframes.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.isValueColor && initialValue) initialValue = $b52d7d2323499a1c$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time !== 0) track.addKeyframe(0, $b52d7d2323499a1c$export$c5e92b7f105af84e(initialValue));
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $b52d7d2323499a1c$export$c5e92b7f105af84e(props[propName]));
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing, forceAnimate) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            track.prepare(additiveTrack);
            if (track.needsAnimate()) tracks.push(track);
            else if (!track.interpolable) {
                var lastKf = kfs[kfs.length - 1];
                if (lastKf) self._target[track.propName] = lastKf.value;
            }
        }
        if (tracks.length || forceAnimate) {
            var clip = new (0, $aU7WT.default)({
                life: this._maxTime,
                loop: this._loop,
                delay: this._delay,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing && easing !== 'spline') clip.easing = easing;
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveFinalToTarget = function(target, trackKeys) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var lastKf = kfs[kfs.length - 1];
            if (lastKf) {
                var val = $b52d7d2323499a1c$export$c5e92b7f105af84e(lastKf.value);
                if (track.isValueColor) val = $b52d7d2323499a1c$var$rgba2String(val);
                target[propName] = val;
            }
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $hzBt5.keys)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $b52d7d2323499a1c$export$2e2bcd8739ae039 = $b52d7d2323499a1c$var$Animator;

});
parcelRegister("aU7WT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f054cd398e1cf20$export$2e2bcd8739ae039);

var $ir4Gx = parcelRequire("ir4Gx");
var $7f054cd398e1cf20$var$Clip = function() {
    function Clip(opts) {
        this._initialized = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop == null ? false : opts.loop;
        this.gap = opts.gap || 0;
        this.easing = opts.easing || 'linear';
        this.onframe = opts.onframe;
        this.ondestroy = opts.ondestroy;
        this.onrestart = opts.onrestart;
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._initialized) {
            this._startTime = globalTime + this._delay;
            this._initialized = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var percent = (globalTime - this._startTime - this._pausedTime) / this._life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easing = this.easing;
        var easingFunc = typeof easing === 'string' ? (0, $ir4Gx.default)[easing] : easing;
        var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
        this.onframe && this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                this._restart(globalTime);
                this.onrestart && this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype._restart = function(globalTime) {
        var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
        this._startTime = globalTime - remainder + this.gap;
        this._pausedTime = 0;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    return Clip;
}();
var $7f054cd398e1cf20$export$2e2bcd8739ae039 = $7f054cd398e1cf20$var$Clip;

});
parcelRegister("ir4Gx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6be61faf3db9f54$export$2e2bcd8739ae039);
var $d6be61faf3db9f54$var$easing = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $d6be61faf3db9f54$var$easing.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $d6be61faf3db9f54$var$easing.bounceIn(k * 2) * 0.5;
        return $d6be61faf3db9f54$var$easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $d6be61faf3db9f54$export$2e2bcd8739ae039 = $d6be61faf3db9f54$var$easing;

});


parcelRegister("f7lrR", function(module, exports) {

$parcel$export(module.exports, "parse", () => $b01825ad73760605$export$98e6a39c04603d36);
$parcel$export(module.exports, "lift", () => $b01825ad73760605$export$590e8b2c435046d9);
$parcel$export(module.exports, "stringify", () => $b01825ad73760605$export$fac44ee5b035f737);
$parcel$export(module.exports, "toHex", () => $b01825ad73760605$export$7ea66e3774a60b67);
$parcel$export(module.exports, "fastLerp", () => $b01825ad73760605$export$66cb3c0e9efc61c8);
$parcel$export(module.exports, "fastMapToColor", () => $b01825ad73760605$export$daa5a65daad5df58);
$parcel$export(module.exports, "lerp", () => $b01825ad73760605$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "mapToColor", () => $b01825ad73760605$export$296e08242b78a3ec);
$parcel$export(module.exports, "modifyHSL", () => $b01825ad73760605$export$d898ae866e27bf18);
$parcel$export(module.exports, "modifyAlpha", () => $b01825ad73760605$export$ab4754bf42583a26);
$parcel$export(module.exports, "lum", () => $b01825ad73760605$export$16c0ec21a6f9ef95);
$parcel$export(module.exports, "random", () => $b01825ad73760605$export$4385e60b38654f68);

var $lXNaK = parcelRequire("lXNaK");
var $b01825ad73760605$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $b01825ad73760605$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $b01825ad73760605$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $b01825ad73760605$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $b01825ad73760605$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $b01825ad73760605$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $b01825ad73760605$var$clampCssByte(parseInt(str, 10));
}
function $b01825ad73760605$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $b01825ad73760605$var$clampCssFloat(parseFloat(str) / 100);
    return $b01825ad73760605$var$clampCssFloat(parseFloat(str));
}
function $b01825ad73760605$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $b01825ad73760605$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $b01825ad73760605$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $b01825ad73760605$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $b01825ad73760605$var$colorCache = new (0, $lXNaK.default)(20);
var $b01825ad73760605$var$lastRemovedArr = null;
function $b01825ad73760605$var$putToCache(colorStr, rgbaArr) {
    if ($b01825ad73760605$var$lastRemovedArr) $b01825ad73760605$var$copyRgba($b01825ad73760605$var$lastRemovedArr, rgbaArr);
    $b01825ad73760605$var$lastRemovedArr = $b01825ad73760605$var$colorCache.put(colorStr, $b01825ad73760605$var$lastRemovedArr || rgbaArr.slice());
}
function $b01825ad73760605$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $b01825ad73760605$var$colorCache.get(colorStr);
    if (cached) return $b01825ad73760605$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $b01825ad73760605$var$kCSSColorTable) {
        $b01825ad73760605$var$copyRgba(rgbaArr, $b01825ad73760605$var$kCSSColorTable[str]);
        $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $b01825ad73760605$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $b01825ad73760605$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $b01825ad73760605$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $b01825ad73760605$var$parseCssFloat(params.pop());
            case 'rgb':
                if (params.length !== 3) {
                    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $b01825ad73760605$var$setRgba(rgbaArr, $b01825ad73760605$var$parseCssInt(params[0]), $b01825ad73760605$var$parseCssInt(params[1]), $b01825ad73760605$var$parseCssInt(params[2]), alpha);
                $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsla':
                if (params.length !== 4) {
                    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $b01825ad73760605$var$parseCssFloat(params[3]);
                $b01825ad73760605$var$hsla2rgba(params, rgbaArr);
                $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $b01825ad73760605$var$hsla2rgba(params, rgbaArr);
                $b01825ad73760605$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $b01825ad73760605$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $b01825ad73760605$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $b01825ad73760605$var$parseCssFloat(hsla[1]);
    var l = $b01825ad73760605$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $b01825ad73760605$var$setRgba(rgba, $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$cssHueToRgb(m1, m2, h) * 255), $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $b01825ad73760605$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $b01825ad73760605$export$590e8b2c435046d9(color, level) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $b01825ad73760605$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $b01825ad73760605$export$7ea66e3774a60b67(color) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $b01825ad73760605$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $b01825ad73760605$var$clampCssFloat($b01825ad73760605$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $b01825ad73760605$export$daa5a65daad5df58 = $b01825ad73760605$export$66cb3c0e9efc61c8;
function $b01825ad73760605$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $b01825ad73760605$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $b01825ad73760605$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $b01825ad73760605$export$fac44ee5b035f737([
        $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $b01825ad73760605$var$clampCssByte($b01825ad73760605$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $b01825ad73760605$var$clampCssFloat($b01825ad73760605$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $b01825ad73760605$export$296e08242b78a3ec = $b01825ad73760605$export$3a89f8d6f6bf6c9f;
function $b01825ad73760605$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $b01825ad73760605$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $b01825ad73760605$var$clampCssAngle(h));
        s != null && (colorArr[1] = $b01825ad73760605$var$parseCssFloat(s));
        l != null && (colorArr[2] = $b01825ad73760605$var$parseCssFloat(l));
        return $b01825ad73760605$export$fac44ee5b035f737($b01825ad73760605$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $b01825ad73760605$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $b01825ad73760605$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $b01825ad73760605$var$clampCssFloat(alpha);
        return $b01825ad73760605$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $b01825ad73760605$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $b01825ad73760605$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $b01825ad73760605$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $b01825ad73760605$export$4385e60b38654f68() {
    var r = Math.round(Math.random() * 255);
    var g = Math.round(Math.random() * 255);
    var b = Math.round(Math.random() * 255);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
}

});


parcelRegister("1J7Ke", function(module, exports) {

$parcel$export(module.exports, "default", () => $1420005adaadc5c8$export$2e2bcd8739ae039);
var $1420005adaadc5c8$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $1420005adaadc5c8$export$2e2bcd8739ae039 = $1420005adaadc5c8$var$Eventful;

});

parcelRegister("2MY1H", function(module, exports) {

$parcel$export(module.exports, "devicePixelRatio", () => $207ea070da30923d$export$508f096bfcdaac40);
$parcel$export(module.exports, "DARK_MODE_THRESHOLD", () => $207ea070da30923d$export$fd81e7ebc7dae256);
$parcel$export(module.exports, "DARK_LABEL_COLOR", () => $207ea070da30923d$export$f8ce94761f39398d);
$parcel$export(module.exports, "LIGHT_LABEL_COLOR", () => $207ea070da30923d$export$3c6e95f318c8369b);
$parcel$export(module.exports, "LIGHTER_LABEL_COLOR", () => $207ea070da30923d$export$27682248795c3c6b);
var $207ea070da30923d$var$dpr = 1;
if (typeof window !== 'undefined') $207ea070da30923d$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $207ea070da30923d$export$7cdcde344c85339c = 0;
var $207ea070da30923d$export$508f096bfcdaac40 = $207ea070da30923d$var$dpr;
var $207ea070da30923d$export$fd81e7ebc7dae256 = 0.4;
var $207ea070da30923d$export$f8ce94761f39398d = '#333';
var $207ea070da30923d$export$3c6e95f318c8369b = '#ccc';
var $207ea070da30923d$export$27682248795c3c6b = '#eee';

});

parcelRegister("4rgPt", function(module, exports) {

$parcel$export(module.exports, "REDRAW_BIT", () => $33b6bcf503d104f6$export$a7b6db622c6c7dbd);
$parcel$export(module.exports, "STYLE_CHANGED_BIT", () => $33b6bcf503d104f6$export$ada8b2beb3d76671);
$parcel$export(module.exports, "SHAPE_CHANGED_BIT", () => $33b6bcf503d104f6$export$f75fe89a33ebe115);
var $33b6bcf503d104f6$export$a7b6db622c6c7dbd = 1;
var $33b6bcf503d104f6$export$ada8b2beb3d76671 = 2;
var $33b6bcf503d104f6$export$f75fe89a33ebe115 = 4;

});



parcelRegister("hMiip", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PATH_STYLE", () => $cf151c8ba16a6ddf$export$deade517576e293a);
$parcel$export(module.exports, "default", () => $cf151c8ba16a6ddf$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $fvvgx = parcelRequire("fvvgx");

var $ldshw = parcelRequire("ldshw");

var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");

var $2MY1H = parcelRequire("2MY1H");

var $4rgPt = parcelRequire("4rgPt");
var $cf151c8ba16a6ddf$export$deade517576e293a = (0, $hzBt5.defaults)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $g1Uer.DEFAULT_COMMON_STYLE));
var $cf151c8ba16a6ddf$export$71bb6c3c6862c6a5 = {
    style: (0, $hzBt5.defaults)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $g1Uer.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
var $cf151c8ba16a6ddf$var$pathCopyParams = [
    'x',
    'y',
    'rotation',
    'scaleX',
    'scaleY',
    'originX',
    'originY',
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
];
var $cf151c8ba16a6ddf$var$Path = function(_super) {
    (0, $fKE23.__extends)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $cf151c8ba16a6ddf$var$pathCopyParams.length; ++i)decalEl[$cf151c8ba16a6ddf$var$pathCopyParams[i]] = this[$cf151c8ba16a6ddf$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $4rgPt.REDRAW_BIT);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $hzBt5.keys)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $hzBt5.extend)(this.style, value);
            } else if (key === 'shape') (0, $hzBt5.extend)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $hzBt5.isString)(pathFill)) {
                var fillLum = (0, $f7lrR.lum)(pathFill, 0);
                if (fillLum > 0.5) return 0, $2MY1H.DARK_LABEL_COLOR;
                else if (fillLum > 0.2) return 0, $2MY1H.LIGHTER_LABEL_COLOR;
                return 0, $2MY1H.LIGHT_LABEL_COLOR;
            } else if (pathFill) return 0, $2MY1H.LIGHT_LABEL_COLOR;
        }
        return 0, $2MY1H.DARK_LABEL_COLOR;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $hzBt5.isString)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $f7lrR.lum)(textFill, 0) < (0, $2MY1H.DARK_MODE_THRESHOLD);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $4rgPt.SHAPE_CHANGED_BIT);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $fvvgx.default)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $4rgPt.SHAPE_CHANGED_BIT)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectWithStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectWithStroke.width += w / lineScale;
                    rectWithStroke.height += w / lineScale;
                    rectWithStroke.x -= w / lineScale / 2;
                    rectWithStroke.y -= w / lineScale / 2;
                }
            }
            return rectWithStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($ldshw.containStroke(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $ldshw.contain(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $4rgPt.SHAPE_CHANGED_BIT);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $hzBt5.extend)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $4rgPt.SHAPE_CHANGED_BIT));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($cf151c8ba16a6ddf$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $hzBt5.extend)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $hzBt5.extend)({}, normalState.shape);
                    (0, $hzBt5.extend)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $hzBt5.extend)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $hzBt5.extend)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $hzBt5.extend)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $hzBt5.keys)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $cf151c8ba16a6ddf$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $fKE23.__extends)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $hzBt5.clone)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $hzBt5.clone)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $4rgPt.REDRAW_BIT) | (0, $4rgPt.STYLE_CHANGED_BIT) | (0, $4rgPt.SHAPE_CHANGED_BIT);
    }();
    return Path;
}((0, $g1Uer.default));
var $cf151c8ba16a6ddf$export$2e2bcd8739ae039 = $cf151c8ba16a6ddf$var$Path;

});
parcelRegister("fvvgx", function(module, exports) {

$parcel$export(module.exports, "normalizeArcAngles", () => $b4a200f8bdc7ccae$export$bc668021e937022a);
$parcel$export(module.exports, "default", () => $b4a200f8bdc7ccae$export$2e2bcd8739ae039);

var $ef5pP = parcelRequire("ef5pP");

var $lGSv6 = parcelRequire("lGSv6");

var $2MY1H = parcelRequire("2MY1H");

var $eVhyd = parcelRequire("eVhyd");

var $jEMPh = parcelRequire("jEMPh");
var $b4a200f8bdc7ccae$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $b4a200f8bdc7ccae$var$tmpOutX = [];
var $b4a200f8bdc7ccae$var$tmpOutY = [];
var $b4a200f8bdc7ccae$var$min = [];
var $b4a200f8bdc7ccae$var$max = [];
var $b4a200f8bdc7ccae$var$min2 = [];
var $b4a200f8bdc7ccae$var$max2 = [];
var $b4a200f8bdc7ccae$var$mathMin = Math.min;
var $b4a200f8bdc7ccae$var$mathMax = Math.max;
var $b4a200f8bdc7ccae$var$mathCos = Math.cos;
var $b4a200f8bdc7ccae$var$mathSin = Math.sin;
var $b4a200f8bdc7ccae$var$mathSqrt = Math.sqrt;
var $b4a200f8bdc7ccae$var$mathAbs = Math.abs;
var $b4a200f8bdc7ccae$var$PI = Math.PI;
var $b4a200f8bdc7ccae$var$PI2 = $b4a200f8bdc7ccae$var$PI * 2;
var $b4a200f8bdc7ccae$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $b4a200f8bdc7ccae$var$tmpAngles = [];
function $b4a200f8bdc7ccae$var$modPI2(radian) {
    var n = Math.round(radian / $b4a200f8bdc7ccae$var$PI * 1e8) / 1e8;
    return n % 2 * $b4a200f8bdc7ccae$var$PI;
}
function $b4a200f8bdc7ccae$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $b4a200f8bdc7ccae$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $b4a200f8bdc7ccae$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $b4a200f8bdc7ccae$var$PI2) newEndAngle = newStartAngle + $b4a200f8bdc7ccae$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $b4a200f8bdc7ccae$var$PI2) newEndAngle = newStartAngle - $b4a200f8bdc7ccae$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($b4a200f8bdc7ccae$var$PI2 - $b4a200f8bdc7ccae$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($b4a200f8bdc7ccae$var$PI2 - $b4a200f8bdc7ccae$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $b4a200f8bdc7ccae$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $b4a200f8bdc7ccae$var$mathAbs(segmentIgnoreThreshold / (0, $2MY1H.devicePixelRatio) / sx) || 0;
            this._uy = $b4a200f8bdc7ccae$var$mathAbs(segmentIgnoreThreshold / (0, $2MY1H.devicePixelRatio) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._lineDash) {
            this._lineDash = null;
            this._dashOffset = 0;
        }
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $b4a200f8bdc7ccae$var$mathAbs(x - this._xi);
        var dy = $b4a200f8bdc7ccae$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($b4a200f8bdc7ccae$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._needsDash ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._needsDash ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._needsDash ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $b4a200f8bdc7ccae$var$tmpAngles[0] = startAngle;
        $b4a200f8bdc7ccae$var$tmpAngles[1] = endAngle;
        $b4a200f8bdc7ccae$export$bc668021e937022a($b4a200f8bdc7ccae$var$tmpAngles, anticlockwise);
        startAngle = $b4a200f8bdc7ccae$var$tmpAngles[0];
        endAngle = $b4a200f8bdc7ccae$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($b4a200f8bdc7ccae$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * r + cx;
        this._yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($b4a200f8bdc7ccae$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($b4a200f8bdc7ccae$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) {
            this._needsDash && this._dashedLineTo(x0, y0);
            ctx.closePath();
        }
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.setLineDash = function(lineDash) {
        if (lineDash instanceof Array) {
            this._lineDash = lineDash;
            this._dashIdx = 0;
            var lineDashSum = 0;
            for(var i = 0; i < lineDash.length; i++)lineDashSum += lineDash[i];
            this._dashSum = lineDashSum;
            this._needsDash = true;
        } else {
            this._lineDash = null;
            this._needsDash = false;
        }
        return this;
    };
    PathProxy.prototype.setLineDashOffset = function(offset) {
        this._dashOffset = offset;
        return this;
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $b4a200f8bdc7ccae$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($b4a200f8bdc7ccae$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype._dashedLineTo = function(x1, y1) {
        var dashSum = this._dashSum;
        var lineDash = this._lineDash;
        var ctx = this._ctx;
        var offset = this._dashOffset;
        var x0 = this._xi;
        var y0 = this._yi;
        var dx = x1 - x0;
        var dy = y1 - y0;
        var dist = $b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
        var x = x0;
        var y = y0;
        var nDash = lineDash.length;
        var dash;
        var idx;
        dx /= dist;
        dy /= dist;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        x -= offset * dx;
        y -= offset * dy;
        while(dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)){
            idx = this._dashIdx;
            dash = lineDash[idx];
            x += dx * dash;
            y += dy * dash;
            this._dashIdx = (idx + 1) % nDash;
            if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) continue;
            ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? $b4a200f8bdc7ccae$var$mathMin(x, x1) : $b4a200f8bdc7ccae$var$mathMax(x, x1), dy >= 0 ? $b4a200f8bdc7ccae$var$mathMin(y, y1) : $b4a200f8bdc7ccae$var$mathMax(y, y1));
        }
        dx = x - x1;
        dy = y - y1;
        this._dashOffset = -$b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedBezierTo = function(x1, y1, x2, y2, x3, y3) {
        var ctx = this._ctx;
        var dashSum = this._dashSum;
        var offset = this._dashOffset;
        var lineDash = this._lineDash;
        var x0 = this._xi;
        var y0 = this._yi;
        var bezierLen = 0;
        var idx = this._dashIdx;
        var nDash = lineDash.length;
        var t;
        var dx;
        var dy;
        var x;
        var y;
        var tmpLen = 0;
        if (offset < 0) offset = dashSum + offset;
        offset %= dashSum;
        for(t = 0; t < 1; t += 0.1){
            dx = (0, $jEMPh.cubicAt)(x0, x1, x2, x3, t + 0.1) - (0, $jEMPh.cubicAt)(x0, x1, x2, x3, t);
            dy = (0, $jEMPh.cubicAt)(y0, y1, y2, y3, t + 0.1) - (0, $jEMPh.cubicAt)(y0, y1, y2, y3, t);
            bezierLen += $b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
        }
        for(; idx < nDash; idx++){
            tmpLen += lineDash[idx];
            if (tmpLen > offset) break;
        }
        t = (tmpLen - offset) / bezierLen;
        while(t <= 1){
            x = (0, $jEMPh.cubicAt)(x0, x1, x2, x3, t);
            y = (0, $jEMPh.cubicAt)(y0, y1, y2, y3, t);
            idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
            t += lineDash[idx] / bezierLen;
            idx = (idx + 1) % nDash;
        }
        idx % 2 !== 0 && ctx.lineTo(x3, y3);
        dx = x3 - x;
        dy = y3 - y;
        this._dashOffset = -$b4a200f8bdc7ccae$var$mathSqrt(dx * dx + dy * dy);
    };
    PathProxy.prototype._dashedQuadraticTo = function(x1, y1, x2, y2) {
        var x3 = x2;
        var y3 = y2;
        x2 = (x2 + 2 * x1) / 3;
        y2 = (y2 + 2 * y1) / 3;
        x1 = (this._xi + 2 * x1) / 3;
        y1 = (this._yi + 2 * y1) / 3;
        this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($b4a200f8bdc7ccae$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $b4a200f8bdc7ccae$var$min[0] = $b4a200f8bdc7ccae$var$min[1] = $b4a200f8bdc7ccae$var$min2[0] = $b4a200f8bdc7ccae$var$min2[1] = Number.MAX_VALUE;
        $b4a200f8bdc7ccae$var$max[0] = $b4a200f8bdc7ccae$var$max[1] = $b4a200f8bdc7ccae$var$max2[0] = $b4a200f8bdc7ccae$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $b4a200f8bdc7ccae$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $b4a200f8bdc7ccae$var$min2[0] = x0;
                    $b4a200f8bdc7ccae$var$min2[1] = y0;
                    $b4a200f8bdc7ccae$var$max2[0] = x0;
                    $b4a200f8bdc7ccae$var$max2[1] = y0;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.L:
                    (0, $eVhyd.fromLine)(xi, yi, data[i], data[i + 1], $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.C:
                    (0, $eVhyd.fromCubic)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Q:
                    (0, $eVhyd.fromQuadratic)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $b4a200f8bdc7ccae$var$mathCos(startAngle) * rx + cx;
                        y0 = $b4a200f8bdc7ccae$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $eVhyd.fromArc)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * rx + cx;
                    yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $eVhyd.fromLine)(x0, y0, x0 + width, y0 + height, $b4a200f8bdc7ccae$var$min2, $b4a200f8bdc7ccae$var$max2);
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $ef5pP.min($b4a200f8bdc7ccae$var$min, $b4a200f8bdc7ccae$var$min, $b4a200f8bdc7ccae$var$min2);
            $ef5pP.max($b4a200f8bdc7ccae$var$max, $b4a200f8bdc7ccae$var$max, $b4a200f8bdc7ccae$var$max2);
        }
        if (i === 0) $b4a200f8bdc7ccae$var$min[0] = $b4a200f8bdc7ccae$var$min[1] = $b4a200f8bdc7ccae$var$max[0] = $b4a200f8bdc7ccae$var$max[1] = 0;
        return new (0, $lGSv6.default)($b4a200f8bdc7ccae$var$min[0], $b4a200f8bdc7ccae$var$min[1], $b4a200f8bdc7ccae$var$max[0] - $b4a200f8bdc7ccae$var$min[0], $b4a200f8bdc7ccae$var$max[1] - $b4a200f8bdc7ccae$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $b4a200f8bdc7ccae$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $b4a200f8bdc7ccae$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($b4a200f8bdc7ccae$var$mathAbs(dx) > ux || $b4a200f8bdc7ccae$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $b4a200f8bdc7ccae$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $jEMPh.cubicLength)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $jEMPh.quadraticLength)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $b4a200f8bdc7ccae$var$mathCos(startAngle) * rx + cx;
                        y0 = $b4a200f8bdc7ccae$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $b4a200f8bdc7ccae$var$mathMax(rx, ry) * $b4a200f8bdc7ccae$var$mathMin($b4a200f8bdc7ccae$var$PI2, Math.abs(delta));
                    xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * rx + cx;
                    yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $b4a200f8bdc7ccae$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $b4a200f8bdc7ccae$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $b4a200f8bdc7ccae$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $b4a200f8bdc7ccae$var$mathAbs(x - xi);
                    var dy = $b4a200f8bdc7ccae$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $b4a200f8bdc7ccae$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $jEMPh.cubicSubdivide)(xi, x1, x2, x3, t, $b4a200f8bdc7ccae$var$tmpOutX);
                            (0, $jEMPh.cubicSubdivide)(yi, y1, y2, y3, t, $b4a200f8bdc7ccae$var$tmpOutY);
                            ctx.bezierCurveTo($b4a200f8bdc7ccae$var$tmpOutX[1], $b4a200f8bdc7ccae$var$tmpOutY[1], $b4a200f8bdc7ccae$var$tmpOutX[2], $b4a200f8bdc7ccae$var$tmpOutY[2], $b4a200f8bdc7ccae$var$tmpOutX[3], $b4a200f8bdc7ccae$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $jEMPh.quadraticSubdivide)(xi, x1, x2, t, $b4a200f8bdc7ccae$var$tmpOutX);
                            (0, $jEMPh.quadraticSubdivide)(yi, y1, y2, t, $b4a200f8bdc7ccae$var$tmpOutY);
                            ctx.quadraticCurveTo($b4a200f8bdc7ccae$var$tmpOutX[1], $b4a200f8bdc7ccae$var$tmpOutY[1], $b4a200f8bdc7ccae$var$tmpOutX[2], $b4a200f8bdc7ccae$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $b4a200f8bdc7ccae$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $b4a200f8bdc7ccae$var$mathCos(startAngle) * rx + cx;
                        y0 = $b4a200f8bdc7ccae$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $b4a200f8bdc7ccae$var$mathCos(endAngle) * rx + cx;
                    yi = $b4a200f8bdc7ccae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $b4a200f8bdc7ccae$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $b4a200f8bdc7ccae$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $b4a200f8bdc7ccae$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $b4a200f8bdc7ccae$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $b4a200f8bdc7ccae$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $b4a200f8bdc7ccae$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $b4a200f8bdc7ccae$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._needsDash = false;
        proto._dashOffset = 0;
        proto._dashIdx = 0;
        proto._dashSum = 0;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $b4a200f8bdc7ccae$export$2e2bcd8739ae039 = $b4a200f8bdc7ccae$var$PathProxy;

});
parcelRegister("eVhyd", function(module, exports) {

$parcel$export(module.exports, "fromPoints", () => $add400cfec361073$export$188c3cd07b4129dd);
$parcel$export(module.exports, "fromLine", () => $add400cfec361073$export$d2b1491e4450bf2c);
$parcel$export(module.exports, "fromCubic", () => $add400cfec361073$export$c1bc6be456bb6609);
$parcel$export(module.exports, "fromQuadratic", () => $add400cfec361073$export$16fbe795323a1f4c);
$parcel$export(module.exports, "fromArc", () => $add400cfec361073$export$161c8bb0e1d9ef49);

var $ef5pP = parcelRequire("ef5pP");

var $jEMPh = parcelRequire("jEMPh");
var $add400cfec361073$var$mathMin = Math.min;
var $add400cfec361073$var$mathMax = Math.max;
var $add400cfec361073$var$mathSin = Math.sin;
var $add400cfec361073$var$mathCos = Math.cos;
var $add400cfec361073$var$PI2 = Math.PI * 2;
var $add400cfec361073$var$start = $ef5pP.create();
var $add400cfec361073$var$end = $ef5pP.create();
var $add400cfec361073$var$extremity = $ef5pP.create();
function $add400cfec361073$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $add400cfec361073$var$mathMin(left, p[0]);
        right = $add400cfec361073$var$mathMax(right, p[0]);
        top = $add400cfec361073$var$mathMin(top, p[1]);
        bottom = $add400cfec361073$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $add400cfec361073$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $add400cfec361073$var$mathMin(x0, x1);
    min[1] = $add400cfec361073$var$mathMin(y0, y1);
    max[0] = $add400cfec361073$var$mathMax(x0, x1);
    max[1] = $add400cfec361073$var$mathMax(y0, y1);
}
var $add400cfec361073$var$xDim = [];
var $add400cfec361073$var$yDim = [];
function $add400cfec361073$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $jEMPh.cubicExtrema;
    var cubicAt = $jEMPh.cubicAt;
    var n = cubicExtrema(x0, x1, x2, x3, $add400cfec361073$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $add400cfec361073$var$xDim[i]);
        min[0] = $add400cfec361073$var$mathMin(x, min[0]);
        max[0] = $add400cfec361073$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $add400cfec361073$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $add400cfec361073$var$yDim[i]);
        min[1] = $add400cfec361073$var$mathMin(y, min[1]);
        max[1] = $add400cfec361073$var$mathMax(y, max[1]);
    }
    min[0] = $add400cfec361073$var$mathMin(x0, min[0]);
    max[0] = $add400cfec361073$var$mathMax(x0, max[0]);
    min[0] = $add400cfec361073$var$mathMin(x3, min[0]);
    max[0] = $add400cfec361073$var$mathMax(x3, max[0]);
    min[1] = $add400cfec361073$var$mathMin(y0, min[1]);
    max[1] = $add400cfec361073$var$mathMax(y0, max[1]);
    min[1] = $add400cfec361073$var$mathMin(y3, min[1]);
    max[1] = $add400cfec361073$var$mathMax(y3, max[1]);
}
function $add400cfec361073$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $jEMPh.quadraticExtremum;
    var quadraticAt = $jEMPh.quadraticAt;
    var tx = $add400cfec361073$var$mathMax($add400cfec361073$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $add400cfec361073$var$mathMax($add400cfec361073$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $add400cfec361073$var$mathMin(x0, x2, x);
    min[1] = $add400cfec361073$var$mathMin(y0, y2, y);
    max[0] = $add400cfec361073$var$mathMax(x0, x2, x);
    max[1] = $add400cfec361073$var$mathMax(y0, y2, y);
}
function $add400cfec361073$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $ef5pP.min;
    var vec2Max = $ef5pP.max;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $add400cfec361073$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $add400cfec361073$var$start[0] = $add400cfec361073$var$mathCos(startAngle) * rx + x;
    $add400cfec361073$var$start[1] = $add400cfec361073$var$mathSin(startAngle) * ry + y;
    $add400cfec361073$var$end[0] = $add400cfec361073$var$mathCos(endAngle) * rx + x;
    $add400cfec361073$var$end[1] = $add400cfec361073$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $add400cfec361073$var$start, $add400cfec361073$var$end);
    vec2Max(max, $add400cfec361073$var$start, $add400cfec361073$var$end);
    startAngle = startAngle % $add400cfec361073$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $add400cfec361073$var$PI2;
    endAngle = endAngle % $add400cfec361073$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $add400cfec361073$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $add400cfec361073$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $add400cfec361073$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $add400cfec361073$var$extremity[0] = $add400cfec361073$var$mathCos(angle) * rx + x;
        $add400cfec361073$var$extremity[1] = $add400cfec361073$var$mathSin(angle) * ry + y;
        vec2Min(min, $add400cfec361073$var$extremity, min);
        vec2Max(max, $add400cfec361073$var$extremity, max);
    }
}

});
parcelRegister("jEMPh", function(module, exports) {

$parcel$export(module.exports, "cubicAt", () => $e4f7a0998f396fe9$export$547c21de482bbcb2);
$parcel$export(module.exports, "cubicDerivativeAt", () => $e4f7a0998f396fe9$export$55fce925c60b6271);
$parcel$export(module.exports, "cubicRootAt", () => $e4f7a0998f396fe9$export$ca5d13faa10b167e);
$parcel$export(module.exports, "cubicExtrema", () => $e4f7a0998f396fe9$export$df1a172f100d0457);
$parcel$export(module.exports, "cubicSubdivide", () => $e4f7a0998f396fe9$export$a2ee23a0567039da);
$parcel$export(module.exports, "cubicProjectPoint", () => $e4f7a0998f396fe9$export$dbaa3801d1284367);
$parcel$export(module.exports, "cubicLength", () => $e4f7a0998f396fe9$export$af1875d576f60d7c);
$parcel$export(module.exports, "quadraticAt", () => $e4f7a0998f396fe9$export$af17094a950f5073);
$parcel$export(module.exports, "quadraticDerivativeAt", () => $e4f7a0998f396fe9$export$7e161e77e6fff8cb);
$parcel$export(module.exports, "quadraticRootAt", () => $e4f7a0998f396fe9$export$fd895ac7ee764967);
$parcel$export(module.exports, "quadraticExtremum", () => $e4f7a0998f396fe9$export$752e1f8c6e7f7e11);
$parcel$export(module.exports, "quadraticSubdivide", () => $e4f7a0998f396fe9$export$117c659e21a7a060);
$parcel$export(module.exports, "quadraticProjectPoint", () => $e4f7a0998f396fe9$export$81915a594fe10dee);
$parcel$export(module.exports, "quadraticLength", () => $e4f7a0998f396fe9$export$8a68adee46f3cf55);

var $ef5pP = parcelRequire("ef5pP");
var $e4f7a0998f396fe9$var$mathPow = Math.pow;
var $e4f7a0998f396fe9$var$mathSqrt = Math.sqrt;
var $e4f7a0998f396fe9$var$EPSILON = 1e-8;
var $e4f7a0998f396fe9$var$EPSILON_NUMERIC = 1e-4;
var $e4f7a0998f396fe9$var$THREE_SQRT = $e4f7a0998f396fe9$var$mathSqrt(3);
var $e4f7a0998f396fe9$var$ONE_THIRD = 1 / 3;
var $e4f7a0998f396fe9$var$_v0 = (0, $ef5pP.create)();
var $e4f7a0998f396fe9$var$_v1 = (0, $ef5pP.create)();
var $e4f7a0998f396fe9$var$_v2 = (0, $ef5pP.create)();
function $e4f7a0998f396fe9$var$isAroundZero(val) {
    return val > -$e4f7a0998f396fe9$var$EPSILON && val < $e4f7a0998f396fe9$var$EPSILON;
}
function $e4f7a0998f396fe9$var$isNotAroundZero(val) {
    return val > $e4f7a0998f396fe9$var$EPSILON || val < -$e4f7a0998f396fe9$var$EPSILON;
}
function $e4f7a0998f396fe9$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $e4f7a0998f396fe9$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $e4f7a0998f396fe9$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($e4f7a0998f396fe9$var$isAroundZero(A) && $e4f7a0998f396fe9$var$isAroundZero(B)) {
        if ($e4f7a0998f396fe9$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($e4f7a0998f396fe9$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $e4f7a0998f396fe9$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$e4f7a0998f396fe9$var$mathPow(-Y1, $e4f7a0998f396fe9$var$ONE_THIRD);
            else Y1 = $e4f7a0998f396fe9$var$mathPow(Y1, $e4f7a0998f396fe9$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$e4f7a0998f396fe9$var$mathPow(-Y2, $e4f7a0998f396fe9$var$ONE_THIRD);
            else Y2 = $e4f7a0998f396fe9$var$mathPow(Y2, $e4f7a0998f396fe9$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $e4f7a0998f396fe9$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $e4f7a0998f396fe9$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $e4f7a0998f396fe9$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $e4f7a0998f396fe9$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $e4f7a0998f396fe9$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($e4f7a0998f396fe9$var$isAroundZero(a)) {
        if ($e4f7a0998f396fe9$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($e4f7a0998f396fe9$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $e4f7a0998f396fe9$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $e4f7a0998f396fe9$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $e4f7a0998f396fe9$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $e4f7a0998f396fe9$var$_v0[0] = x;
    $e4f7a0998f396fe9$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v0, $e4f7a0998f396fe9$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $e4f7a0998f396fe9$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v1, $e4f7a0998f396fe9$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $e4f7a0998f396fe9$var$_v2[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $e4f7a0998f396fe9$var$_v2[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v2, $e4f7a0998f396fe9$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $e4f7a0998f396fe9$var$mathSqrt(d);
}
function $e4f7a0998f396fe9$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $e4f7a0998f396fe9$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $e4f7a0998f396fe9$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $e4f7a0998f396fe9$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $e4f7a0998f396fe9$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $e4f7a0998f396fe9$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($e4f7a0998f396fe9$var$isAroundZero(a)) {
        if ($e4f7a0998f396fe9$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($e4f7a0998f396fe9$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $e4f7a0998f396fe9$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $e4f7a0998f396fe9$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $e4f7a0998f396fe9$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $e4f7a0998f396fe9$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $e4f7a0998f396fe9$var$_v0[0] = x;
    $e4f7a0998f396fe9$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, _t);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v0, $e4f7a0998f396fe9$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $e4f7a0998f396fe9$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $e4f7a0998f396fe9$var$_v1[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, prev);
        $e4f7a0998f396fe9$var$_v1[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v1, $e4f7a0998f396fe9$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $e4f7a0998f396fe9$var$_v2[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, next);
            $e4f7a0998f396fe9$var$_v2[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $ef5pP.distSquare)($e4f7a0998f396fe9$var$_v2, $e4f7a0998f396fe9$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $e4f7a0998f396fe9$var$mathSqrt(d);
}
function $e4f7a0998f396fe9$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $e4f7a0998f396fe9$export$af17094a950f5073(x0, x1, x2, t);
        var y = $e4f7a0998f396fe9$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}

});



parcelRegister("ldshw", function(module, exports) {

$parcel$export(module.exports, "contain", () => $f720bffe7cfa30e1$export$8893e2b90ba10d92);
$parcel$export(module.exports, "containStroke", () => $f720bffe7cfa30e1$export$8d36b1b5d19157c5);

var $fvvgx = parcelRequire("fvvgx");

var $k0aU5 = parcelRequire("k0aU5");

var $dvSDV = parcelRequire("dvSDV");

var $hTnmd = parcelRequire("hTnmd");

var $30IXf = parcelRequire("30IXf");

var $jEMPh = parcelRequire("jEMPh");

var $j53mu = parcelRequire("j53mu");
var $f720bffe7cfa30e1$var$CMD = (0, $fvvgx.default).CMD;
var $f720bffe7cfa30e1$var$PI2 = Math.PI * 2;
var $f720bffe7cfa30e1$var$EPSILON = 1e-4;
function $f720bffe7cfa30e1$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $f720bffe7cfa30e1$var$EPSILON;
}
var $f720bffe7cfa30e1$var$roots = [
    -1,
    -1,
    -1
];
var $f720bffe7cfa30e1$var$extrema = [
    -1,
    -1
];
function $f720bffe7cfa30e1$var$swapExtrema() {
    var tmp = $f720bffe7cfa30e1$var$extrema[0];
    $f720bffe7cfa30e1$var$extrema[0] = $f720bffe7cfa30e1$var$extrema[1];
    $f720bffe7cfa30e1$var$extrema[1] = tmp;
}
function $f720bffe7cfa30e1$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $jEMPh.cubicRootAt(y0, y1, y2, y3, y, $f720bffe7cfa30e1$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $f720bffe7cfa30e1$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $jEMPh.cubicAt(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $jEMPh.cubicExtrema(y0, y1, y2, y3, $f720bffe7cfa30e1$var$extrema);
                if ($f720bffe7cfa30e1$var$extrema[1] < $f720bffe7cfa30e1$var$extrema[0] && nExtrema > 1) $f720bffe7cfa30e1$var$swapExtrema();
                y0_ = $jEMPh.cubicAt(y0, y1, y2, y3, $f720bffe7cfa30e1$var$extrema[0]);
                if (nExtrema > 1) y1_ = $jEMPh.cubicAt(y0, y1, y2, y3, $f720bffe7cfa30e1$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $f720bffe7cfa30e1$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $f720bffe7cfa30e1$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $f720bffe7cfa30e1$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $f720bffe7cfa30e1$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $jEMPh.quadraticRootAt(y0, y1, y2, y, $f720bffe7cfa30e1$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $jEMPh.quadraticExtremum(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $jEMPh.quadraticAt(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $f720bffe7cfa30e1$var$roots[i] === 0 || $f720bffe7cfa30e1$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $jEMPh.quadraticAt(x0, x1, x2, $f720bffe7cfa30e1$var$roots[i]);
                if (x_ < x) continue;
                if ($f720bffe7cfa30e1$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $f720bffe7cfa30e1$var$roots[0] === 0 || $f720bffe7cfa30e1$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $jEMPh.quadraticAt(x0, x1, x2, $f720bffe7cfa30e1$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $f720bffe7cfa30e1$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $f720bffe7cfa30e1$var$roots[0] = -tmp;
    $f720bffe7cfa30e1$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $f720bffe7cfa30e1$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $f720bffe7cfa30e1$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $f720bffe7cfa30e1$var$roots[0] + cx && x <= $f720bffe7cfa30e1$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $f720bffe7cfa30e1$var$PI2;
        endAngle += $f720bffe7cfa30e1$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $f720bffe7cfa30e1$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $f720bffe7cfa30e1$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $f720bffe7cfa30e1$var$PI2 >= startAngle && angle + $f720bffe7cfa30e1$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $f720bffe7cfa30e1$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $f720bffe7cfa30e1$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $j53mu.default)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $f720bffe7cfa30e1$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $f720bffe7cfa30e1$var$CMD.L:
                if (isStroke) {
                    if ($k0aU5.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $j53mu.default)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $f720bffe7cfa30e1$var$CMD.C:
                if (isStroke) {
                    if ($dvSDV.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $f720bffe7cfa30e1$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $f720bffe7cfa30e1$var$CMD.Q:
                if (isStroke) {
                    if ($hTnmd.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $f720bffe7cfa30e1$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $f720bffe7cfa30e1$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $j53mu.default)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($30IXf.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $f720bffe7cfa30e1$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $f720bffe7cfa30e1$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($k0aU5.containStroke(x0, y0, x1, y0, lineWidth, x, y) || $k0aU5.containStroke(x1, y0, x1, y1, lineWidth, x, y) || $k0aU5.containStroke(x1, y1, x0, y1, lineWidth, x, y) || $k0aU5.containStroke(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $j53mu.default)(x1, y0, x1, y1, x, y);
                    w += (0, $j53mu.default)(x0, y1, x0, y0, x, y);
                }
                break;
            case $f720bffe7cfa30e1$var$CMD.Z:
                if (isStroke) {
                    if ($k0aU5.containStroke(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $j53mu.default)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$f720bffe7cfa30e1$var$isAroundEqual(yi, y0)) w += (0, $j53mu.default)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $f720bffe7cfa30e1$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $f720bffe7cfa30e1$var$containPath(pathProxy, 0, false, x, y);
}
function $f720bffe7cfa30e1$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $f720bffe7cfa30e1$var$containPath(pathProxy, lineWidth, true, x, y);
}

});
parcelRegister("k0aU5", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $e8fc43f3b1e989f4$export$8d36b1b5d19157c5);
function $e8fc43f3b1e989f4$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}

});

parcelRegister("dvSDV", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $9d688e91b9345274$export$8d36b1b5d19157c5);

var $jEMPh = parcelRequire("jEMPh");
function $9d688e91b9345274$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $jEMPh.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("hTnmd", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $d069b1000d43791a$export$8d36b1b5d19157c5);

var $jEMPh = parcelRequire("jEMPh");
function $d069b1000d43791a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $jEMPh.quadraticProjectPoint)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}

});

parcelRegister("30IXf", function(module, exports) {

$parcel$export(module.exports, "containStroke", () => $23143e3badbfbe00$export$8d36b1b5d19157c5);

var $kqaXh = parcelRequire("kqaXh");
var $23143e3badbfbe00$var$PI2 = Math.PI * 2;
function $23143e3badbfbe00$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $23143e3badbfbe00$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kqaXh.normalizeRadian)(endAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kqaXh.normalizeRadian)(startAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $23143e3badbfbe00$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $23143e3badbfbe00$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $23143e3badbfbe00$var$PI2 >= startAngle && angle + $23143e3badbfbe00$var$PI2 <= endAngle;
}

});
parcelRegister("kqaXh", function(module, exports) {

$parcel$export(module.exports, "normalizeRadian", () => $eddebbd6c444578f$export$d44861331f213635);
var $eddebbd6c444578f$var$PI2 = Math.PI * 2;
function $eddebbd6c444578f$export$d44861331f213635(angle) {
    angle %= $eddebbd6c444578f$var$PI2;
    if (angle < 0) angle += $eddebbd6c444578f$var$PI2;
    return angle;
}

});


parcelRegister("j53mu", function(module, exports) {

$parcel$export(module.exports, "default", () => $de4117845188b405$export$2e2bcd8739ae039);
function $de4117845188b405$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}

});




parcelRegister("agXnr", function(module, exports) {

$parcel$export(module.exports, "default", () => $77a9750da057fbd9$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $lGSv6 = parcelRequire("lGSv6");

var $hzBt5 = parcelRequire("hzBt5");
var $77a9750da057fbd9$export$8993f922aeeac642 = (0, $hzBt5.defaults)({
    x: 0,
    y: 0
}, (0, $g1Uer.DEFAULT_COMMON_STYLE));
var $77a9750da057fbd9$export$4aba8ad70847a488 = {
    style: (0, $hzBt5.defaults)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $g1Uer.DEFAULT_COMMON_ANIMATION_PROPS).style)
};
function $77a9750da057fbd9$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $77a9750da057fbd9$var$ZRImage = function(_super) {
    (0, $fKE23.__extends)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $hzBt5.createObject)($77a9750da057fbd9$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $77a9750da057fbd9$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $77a9750da057fbd9$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $lGSv6.default)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $g1Uer.default));
$77a9750da057fbd9$var$ZRImage.prototype.type = 'image';
var $77a9750da057fbd9$export$2e2bcd8739ae039 = $77a9750da057fbd9$var$ZRImage;

});

parcelRegister("aeCKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7739449dac61132f$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $b7hGQ = parcelRequire("b7hGQ");

var $kXoFx = parcelRequire("kXoFx");
var $7739449dac61132f$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $7739449dac61132f$var$subPixelOptimizeOutputShape = {};
var $7739449dac61132f$var$Rect = function(_super) {
    (0, $fKE23.__extends)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $7739449dac61132f$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $kXoFx.subPixelOptimizeRect)($7739449dac61132f$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $b7hGQ.buildPath(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $hMiip.default));
$7739449dac61132f$var$Rect.prototype.type = 'rect';
var $7739449dac61132f$export$2e2bcd8739ae039 = $7739449dac61132f$var$Rect;

});
parcelRegister("b7hGQ", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $817e120940349974$export$5cc7f731b5937e99);
function $817e120940349974$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

});

parcelRegister("kXoFx", function(module, exports) {

$parcel$export(module.exports, "subPixelOptimizeLine", () => $f41c740f33c8dcd8$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimize", () => $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $f41c740f33c8dcd8$export$60e2aa74957d0b9d);
var $f41c740f33c8dcd8$var$round = Math.round;
function $f41c740f33c8dcd8$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($f41c740f33c8dcd8$var$round(x1 * 2) === $f41c740f33c8dcd8$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($f41c740f33c8dcd8$var$round(y1 * 2) === $f41c740f33c8dcd8$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $f41c740f33c8dcd8$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $f41c740f33c8dcd8$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $f41c740f33c8dcd8$var$round(position * 2);
    return (doubledPosition + $f41c740f33c8dcd8$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

});



parcelRegister("51xyq", function(module, exports) {

$parcel$export(module.exports, "HOVER_STATE_BLUR", () => $3a8712efe6873d0c$export$1307d6a87d56baa);
$parcel$export(module.exports, "HOVER_STATE_EMPHASIS", () => $3a8712efe6873d0c$export$f0f2bee145debb31);
$parcel$export(module.exports, "SPECIAL_STATES", () => $3a8712efe6873d0c$export$151308dceb52d5b);
$parcel$export(module.exports, "DISPLAY_STATES", () => $3a8712efe6873d0c$export$57ee5306b85ad7d5);
$parcel$export(module.exports, "Z2_EMPHASIS_LIFT", () => $3a8712efe6873d0c$export$1cb9fc6ed5b9836c);
$parcel$export(module.exports, "HIGHLIGHT_ACTION_TYPE", () => $3a8712efe6873d0c$export$df035d873a9de64f);
$parcel$export(module.exports, "DOWNPLAY_ACTION_TYPE", () => $3a8712efe6873d0c$export$f8a2f7807cc185ea);
$parcel$export(module.exports, "SELECT_ACTION_TYPE", () => $3a8712efe6873d0c$export$89616263e7d38fe9);
$parcel$export(module.exports, "UNSELECT_ACTION_TYPE", () => $3a8712efe6873d0c$export$7636ad95c0f68a79);
$parcel$export(module.exports, "TOGGLE_SELECT_ACTION_TYPE", () => $3a8712efe6873d0c$export$1e90ed8a25542516);
$parcel$export(module.exports, "setStatesFlag", () => $3a8712efe6873d0c$export$868ba38adffa9e39);
$parcel$export(module.exports, "setDefaultStateProxy", () => $3a8712efe6873d0c$export$20f39bbe322fb9ab);
$parcel$export(module.exports, "enterEmphasis", () => $3a8712efe6873d0c$export$b2d02638cc34c042);
$parcel$export(module.exports, "leaveEmphasis", () => $3a8712efe6873d0c$export$11be6f716239ac55);
$parcel$export(module.exports, "enterBlur", () => $3a8712efe6873d0c$export$207f9cb3e1099375);
$parcel$export(module.exports, "leaveBlur", () => $3a8712efe6873d0c$export$fd4a9ec75456d3c1);
$parcel$export(module.exports, "enterSelect", () => $3a8712efe6873d0c$export$252d028dda8ef765);
$parcel$export(module.exports, "leaveSelect", () => $3a8712efe6873d0c$export$ea9a904bd6e32bd3);
$parcel$export(module.exports, "allLeaveBlur", () => $3a8712efe6873d0c$export$b2a593c7b5243584);
$parcel$export(module.exports, "blurComponent", () => $3a8712efe6873d0c$export$569da03256c8a55f);
$parcel$export(module.exports, "blurSeriesFromHighlightPayload", () => $3a8712efe6873d0c$export$64f1fd4daefef21b);
$parcel$export(module.exports, "findComponentHighDownDispatchers", () => $3a8712efe6873d0c$export$f31a644ccca0ef23);
$parcel$export(module.exports, "handleGlobalMouseOverForHighDown", () => $3a8712efe6873d0c$export$416765b6198234ff);
$parcel$export(module.exports, "handleGlboalMouseOutForHighDown", () => $3a8712efe6873d0c$export$2cbc9e6f4b583c84);
$parcel$export(module.exports, "toggleSelectionFromPayload", () => $3a8712efe6873d0c$export$1c7d489f62372d73);
$parcel$export(module.exports, "isSelectChangePayload", () => $3a8712efe6873d0c$export$72aea10e60e45351);
$parcel$export(module.exports, "updateSeriesElementSelection", () => $3a8712efe6873d0c$export$e4ea08ef52e0a73);
$parcel$export(module.exports, "getAllSelectedIndices", () => $3a8712efe6873d0c$export$c529643b619af6b3);
$parcel$export(module.exports, "enableHoverEmphasis", () => $3a8712efe6873d0c$export$5f393df0b5aee2e7);
$parcel$export(module.exports, "setAsHighDownDispatcher", () => $3a8712efe6873d0c$export$9ba15aea1e048d48);
$parcel$export(module.exports, "enableHoverFocus", () => $3a8712efe6873d0c$export$24972466b2b62ac2);
$parcel$export(module.exports, "setStatesStylesFromModel", () => $3a8712efe6873d0c$export$48b68047d330bbc9);
$parcel$export(module.exports, "isHighDownDispatcher", () => $3a8712efe6873d0c$export$77d1445f699c58b5);
$parcel$export(module.exports, "enableComponentHighDownFeatures", () => $3a8712efe6873d0c$export$4da05a9639f01954);
$parcel$export(module.exports, "getHighlightDigit", () => $3a8712efe6873d0c$export$824af40eb714530d);
$parcel$export(module.exports, "isHighDownPayload", () => $3a8712efe6873d0c$export$aebe71265c1b77bf);
$parcel$export(module.exports, "savePathStates", () => $3a8712efe6873d0c$export$9fe78019e6f395b6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lXNaK = parcelRequire("lXNaK");

var $hzBt5 = parcelRequire("hzBt5");

var $aly4X = parcelRequire("aly4X");

var $f7lrR = parcelRequire("f7lrR");

var $ckizb = parcelRequire("ckizb");

var $hMiip = parcelRequire("hMiip");

var $3a8712efe6873d0c$var$_highlightNextDigit = 1;
var $3a8712efe6873d0c$var$_highlightKeyMap = {};
var $3a8712efe6873d0c$var$getSavedStates = (0, $ckizb.makeInner)();
var $3a8712efe6873d0c$export$5542daa30722333e = 0;
var $3a8712efe6873d0c$export$1307d6a87d56baa = 1;
var $3a8712efe6873d0c$export$f0f2bee145debb31 = 2;
var $3a8712efe6873d0c$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $3a8712efe6873d0c$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $3a8712efe6873d0c$export$1cb9fc6ed5b9836c = 10;
var $3a8712efe6873d0c$export$3a2f97d39514bbc = 9;
var $3a8712efe6873d0c$export$df035d873a9de64f = 'highlight';
var $3a8712efe6873d0c$export$f8a2f7807cc185ea = 'downplay';
var $3a8712efe6873d0c$export$89616263e7d38fe9 = 'select';
var $3a8712efe6873d0c$export$7636ad95c0f68a79 = 'unselect';
var $3a8712efe6873d0c$export$1e90ed8a25542516 = 'toggleSelect';
function $3a8712efe6873d0c$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.
var $3a8712efe6873d0c$var$liftedColorCache = new (0, $lXNaK.default)(100);
function $3a8712efe6873d0c$var$liftColor(color) {
    if (typeof color !== 'string') return color;
    var liftedColor = $3a8712efe6873d0c$var$liftedColorCache.get(color);
    if (!liftedColor) {
        liftedColor = $f7lrR.lift(color, -0.1);
        $3a8712efe6873d0c$var$liftedColorCache.put(color, liftedColor);
    }
    return liftedColor;
}
function $3a8712efe6873d0c$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $3a8712efe6873d0c$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $3a8712efe6873d0c$var$doChangeHoverState(el, 'emphasis', $3a8712efe6873d0c$export$f0f2bee145debb31);
}
function $3a8712efe6873d0c$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $3a8712efe6873d0c$export$f0f2bee145debb31) $3a8712efe6873d0c$var$doChangeHoverState(el, 'normal', $3a8712efe6873d0c$export$5542daa30722333e);
}
function $3a8712efe6873d0c$var$singleEnterBlur(el) {
    $3a8712efe6873d0c$var$doChangeHoverState(el, 'blur', $3a8712efe6873d0c$export$1307d6a87d56baa);
}
function $3a8712efe6873d0c$var$singleLeaveBlur(el) {
    if (el.hoverState === $3a8712efe6873d0c$export$1307d6a87d56baa) $3a8712efe6873d0c$var$doChangeHoverState(el, 'normal', $3a8712efe6873d0c$export$5542daa30722333e);
}
function $3a8712efe6873d0c$var$singleEnterSelect(el) {
    el.selected = true;
}
function $3a8712efe6873d0c$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $3a8712efe6873d0c$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $3a8712efe6873d0c$var$traverseUpdateState(el, updater, commonParam) {
    $3a8712efe6873d0c$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $3a8712efe6873d0c$var$updateElementState(child, updater, commonParam);
    });
}
function $3a8712efe6873d0c$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $3a8712efe6873d0c$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $3a8712efe6873d0c$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $3a8712efe6873d0c$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $3a8712efe6873d0c$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $3a8712efe6873d0c$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition // Dont consider the animation to emphasis state.
         && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveFinalToTarget(fromState, props);
    }
    return fromState;
}
function $3a8712efe6873d0c$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $hzBt5.indexOf)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $hMiip.default)) {
        var store = $3a8712efe6873d0c$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($3a8712efe6873d0c$var$hasFillOrStroke(fromFill) || $3a8712efe6873d0c$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {}; // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $hzBt5.extend)({}, state);
                emphasisStyle = (0, $hzBt5.extend)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$3a8712efe6873d0c$var$hasFillOrStroke(emphasisStyle.fill) && $3a8712efe6873d0c$var$hasFillOrStroke(fromFill)) {
                cloned = true; // Not modify the original value.
                state = (0, $hzBt5.extend)({}, state);
                emphasisStyle = (0, $hzBt5.extend)({}, emphasisStyle); // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = $3a8712efe6873d0c$var$liftColor(fromFill);
            } else if (!$3a8712efe6873d0c$var$hasFillOrStroke(emphasisStyle.stroke) && $3a8712efe6873d0c$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $hzBt5.extend)({}, state);
                    emphasisStyle = (0, $hzBt5.extend)({}, emphasisStyle);
                }
                emphasisStyle.stroke = $3a8712efe6873d0c$var$liftColor(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $hzBt5.extend)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $3a8712efe6873d0c$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $3a8712efe6873d0c$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $hzBt5.extend)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $3a8712efe6873d0c$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $3a8712efe6873d0c$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $hzBt5.indexOf)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $3a8712efe6873d0c$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $hzBt5.extend)({}, state);
        blurStyle = (0, $hzBt5.extend)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $3a8712efe6873d0c$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $3a8712efe6873d0c$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $3a8712efe6873d0c$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $3a8712efe6873d0c$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $3a8712efe6873d0c$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $3a8712efe6873d0c$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $3a8712efe6873d0c$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $3a8712efe6873d0c$var$elementStateProxy;
}
function $3a8712efe6873d0c$export$d899507e2598e4ae(el, e) {
    !$3a8712efe6873d0c$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterEmphasis);
}
function $3a8712efe6873d0c$export$784cba1f7fe58cca(el, e) {
    !$3a8712efe6873d0c$var$shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
     && !el.__highByOuter && $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveEmphasis);
}
function $3a8712efe6873d0c$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterEmphasis);
}
function $3a8712efe6873d0c$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveEmphasis);
}
function $3a8712efe6873d0c$export$207f9cb3e1099375(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterBlur);
}
function $3a8712efe6873d0c$export$fd4a9ec75456d3c1(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveBlur);
}
function $3a8712efe6873d0c$export$252d028dda8ef765(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleEnterSelect);
}
function $3a8712efe6873d0c$export$ea9a904bd6e32bd3(el) {
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$var$singleLeaveSelect);
}
function $3a8712efe6873d0c$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $3a8712efe6873d0c$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    model.eachComponent(function(componentType, componentModel) {
        var view = componentType === 'series' ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel); // Leave blur anyway
        view.group.traverse(function(child) {
            $3a8712efe6873d0c$var$singleLeaveBlur(child);
        });
    });
}
function $3a8712efe6873d0c$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $3a8712efe6873d0c$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!(blurScope === 'series' && !sameSeries // Not blur other coordinate system if blurScope is coordinateSystem
         || blurScope === 'coordinateSystem' && !sameCoordSys // Not blur self series if focus is series.
         || focus === 'series' && sameSeries // TODO blurScope: coordinate system
        )) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                $3a8712efe6873d0c$var$singleEnterBlur(child);
            });
            if ((0, $hzBt5.isArrayLike)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $hzBt5.isObject)(focus)) {
                var dataTypes = (0, $hzBt5.keys)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.blurSeries) view.blurSeries(blurredSeries, ecModel);
    });
}
function $3a8712efe6873d0c$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $3a8712efe6873d0c$var$singleEnterBlur(child);
    });
}
function $3a8712efe6873d0c$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    var dataIndex = (0, $ckizb.queryDataIndex)(data, payload); // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $hzBt5.isArray)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0; // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $aly4X.getECData)(el);
        $3a8712efe6873d0c$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $3a8712efe6873d0c$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $3a8712efe6873d0c$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name); // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $aly4X.getECData)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $3a8712efe6873d0c$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $aly4X.getECData)(dispatcher);
    var _a = $3a8712efe6873d0c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf; // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $3a8712efe6873d0c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $hzBt5.each)(dispatchers, function(dispatcher) {
            return $3a8712efe6873d0c$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $3a8712efe6873d0c$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $3a8712efe6873d0c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
         // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $3a8712efe6873d0c$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $3a8712efe6873d0c$export$2cbc9e6f4b583c84(dispatcher, e, api) {
    $3a8712efe6873d0c$export$b2a593c7b5243584(api);
    var ecData = (0, $aly4X.getECData)(dispatcher);
    var dispatchers = $3a8712efe6873d0c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $hzBt5.each)(dispatchers, function(dispatcher) {
        return $3a8712efe6873d0c$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $3a8712efe6873d0c$export$784cba1f7fe58cca(dispatcher, e);
}
function $3a8712efe6873d0c$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$3a8712efe6873d0c$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $ckizb.queryDataIndex)(data, payload);
    if (!(0, $hzBt5.isArray)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $3a8712efe6873d0c$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $3a8712efe6873d0c$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $3a8712efe6873d0c$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $hzBt5.each)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $3a8712efe6873d0c$export$252d028dda8ef765(el) : $3a8712efe6873d0c$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $3a8712efe6873d0c$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $hzBt5.each)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $3a8712efe6873d0c$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $3a8712efe6873d0c$export$9ba15aea1e048d48(el, true);
    $3a8712efe6873d0c$var$traverseUpdateState(el, $3a8712efe6873d0c$export$20f39bbe322fb9ab);
    $3a8712efe6873d0c$export$24972466b2b62ac2(el, focus, blurScope);
}
function $3a8712efe6873d0c$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $aly4X.getECData)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope; // }
    } else if (ecData.focus) ecData.focus = null;
}
var $3a8712efe6873d0c$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $3a8712efe6873d0c$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $3a8712efe6873d0c$export$48b68047d330bbc9(el, itemModel, styleType, getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $3a8712efe6873d0c$var$OTHER_STATES.length; i++){
        var stateName = $3a8712efe6873d0c$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName); // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$3a8712efe6873d0c$var$defaultStyleGetterMap[styleType]]();
    }
}
function $3a8712efe6873d0c$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el; // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
     // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $3a8712efe6873d0c$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $3a8712efe6873d0c$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $aly4X.getECData)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $3a8712efe6873d0c$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $3a8712efe6873d0c$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $3a8712efe6873d0c$var$_highlightNextDigit <= 32) highlightDigit = $3a8712efe6873d0c$var$_highlightKeyMap[highlightKey] = $3a8712efe6873d0c$var$_highlightNextDigit++;
    return highlightDigit;
}
function $3a8712efe6873d0c$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $3a8712efe6873d0c$export$89616263e7d38fe9 || payloadType === $3a8712efe6873d0c$export$7636ad95c0f68a79 || payloadType === $3a8712efe6873d0c$export$1e90ed8a25542516;
}
function $3a8712efe6873d0c$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $3a8712efe6873d0c$export$df035d873a9de64f || payloadType === $3a8712efe6873d0c$export$f8a2f7807cc185ea;
}
function $3a8712efe6873d0c$export$9fe78019e6f395b6(el) {
    var store = $3a8712efe6873d0c$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}

});
parcelRegister("aly4X", function(module, exports) {

$parcel$export(module.exports, "getECData", () => $78864ce604e5f33a$export$b1c39b2bacd1ddc2);
$parcel$export(module.exports, "setCommonECData", () => $78864ce604e5f33a$export$30d6736ebb8e18d5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");
var $78864ce604e5f33a$export$b1c39b2bacd1ddc2 = (0, $ckizb.makeInner)();
var $78864ce604e5f33a$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $78864ce604e5f33a$export$b1c39b2bacd1ddc2(el); // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex; // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $78864ce604e5f33a$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
        });
    }
};

});
parcelRegister("ckizb", function(module, exports) {

$parcel$export(module.exports, "normalizeToArray", () => $8f95c1371be5a40a$export$4f07b212a02c8051);
$parcel$export(module.exports, "defaultEmphasis", () => $8f95c1371be5a40a$export$abdcc6a26372f94b);
$parcel$export(module.exports, "TEXT_STYLE_OPTIONS", () => $8f95c1371be5a40a$export$df45610347a602ad);
$parcel$export(module.exports, "getDataItemValue", () => $8f95c1371be5a40a$export$2c944e12edb48d4b);
$parcel$export(module.exports, "isDataItemOption", () => $8f95c1371be5a40a$export$3e1a543f33ef6883);
$parcel$export(module.exports, "mappingToExists", () => $8f95c1371be5a40a$export$574f818966e4da87);
$parcel$export(module.exports, "isComponentIdInternal", () => $8f95c1371be5a40a$export$feece3e7d52a102b);
$parcel$export(module.exports, "convertOptionIdName", () => $8f95c1371be5a40a$export$fb1a222ba5dd6e51);
$parcel$export(module.exports, "isNameSpecified", () => $8f95c1371be5a40a$export$beae19a2652b3368);
$parcel$export(module.exports, "makeInternalComponentId", () => $8f95c1371be5a40a$export$1753133c42e665e8);
$parcel$export(module.exports, "setComponentTypeToKeyInfo", () => $8f95c1371be5a40a$export$5ac61aca2ba0282d);
$parcel$export(module.exports, "compressBatches", () => $8f95c1371be5a40a$export$6d12cabb0c9bf8e3);
$parcel$export(module.exports, "queryDataIndex", () => $8f95c1371be5a40a$export$42b26cae8b8d10);
$parcel$export(module.exports, "makeInner", () => $8f95c1371be5a40a$export$64df9f8d92ae083f);
$parcel$export(module.exports, "parseFinder", () => $8f95c1371be5a40a$export$95de80076abac814);
$parcel$export(module.exports, "preParseFinder", () => $8f95c1371be5a40a$export$fe600815775d9400);
$parcel$export(module.exports, "queryReferringComponents", () => $8f95c1371be5a40a$export$dc741340f7e5f186);
$parcel$export(module.exports, "SINGLE_REFERRING", () => $8f95c1371be5a40a$export$f076738ec84e693c);
$parcel$export(module.exports, "MULTIPLE_REFERRING", () => $8f95c1371be5a40a$export$48d598924ce4892c);
$parcel$export(module.exports, "setAttribute", () => $8f95c1371be5a40a$export$9fec4d97f1922e0b);
$parcel$export(module.exports, "getAttribute", () => $8f95c1371be5a40a$export$735ee1799fd02602);
$parcel$export(module.exports, "getTooltipRenderMode", () => $8f95c1371be5a40a$export$cc0a17a5d27b4e17);
$parcel$export(module.exports, "groupData", () => $8f95c1371be5a40a$export$7ab5bda43e13168f);
$parcel$export(module.exports, "interpolateRawValues", () => $8f95c1371be5a40a$export$bd0439821a1869f3);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $5BQXp = parcelRequire("5BQXp");

var $fyp5g = parcelRequire("fyp5g");

/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $8f95c1371be5a40a$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $8f95c1371be5a40a$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $8f95c1371be5a40a$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $8f95c1371be5a40a$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $8f95c1371be5a40a$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
]; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
function $8f95c1371be5a40a$export$2c944e12edb48d4b(dataItem) {
    return (0, $hzBt5.isObject)(dataItem) && !(0, $hzBt5.isArray)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $8f95c1371be5a40a$export$3e1a543f33ef6883(dataItem) {
    return (0, $hzBt5.isObject)(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $8f95c1371be5a40a$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $hzBt5.createHashMap)(); // Validate id and name on user input option.
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $hzBt5.isObject)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $8f95c1371be5a40a$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $8f95c1371be5a40a$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $8f95c1371be5a40a$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $8f95c1371be5a40a$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $8f95c1371be5a40a$var$mappingInReplaceAllMode(result, newCmptOptions);
    $8f95c1371be5a40a$var$makeIdAndName(result); // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will ommit those items and result in incorrect result.
    return result;
}
function $8f95c1371be5a40a$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
     // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be ommited.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index]; // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
         // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $8f95c1371be5a40a$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $8f95c1371be5a40a$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $8f95c1371be5a40a$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $hzBt5.assert)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption; // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $8f95c1371be5a40a$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$8f95c1371be5a40a$export$feece3e7d52a102b(cmptOption) && !$8f95c1371be5a40a$export$feece3e7d52a102b(existing) && $8f95c1371be5a40a$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $8f95c1371be5a40a$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
         // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while((resultItem = result[nextIdx]) && // after mapping performed, model will always be assigned with an id if user not given.
        // After that all models have id.
        // (2) If new option has id, it can only set to a hole or append to the last. It should
        // not be merged to the existings with different id. Because id should not be overwritten.
        // (3) Name can be overwritten, because axis use name as 'show label text'.
        (resultItem.newOption || $8f95c1371be5a40a$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$8f95c1371be5a40a$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $8f95c1371be5a40a$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $hzBt5.each)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that compoennt index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $8f95c1371be5a40a$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $hzBt5.createHashMap)();
    (0, $hzBt5.each)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $hzBt5.each)(mapResult, function(item) {
        var opt = item.newOption; // Force ensure id not duplicated.
        (0, $hzBt5.assert)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    }); // Make name and id.
    (0, $hzBt5.each)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $hzBt5.isObject)(opt)) return;
         // name can be overwitten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $8f95c1371be5a40a$var$makeComparableKey(opt.name) : existing ? existing.name // Avoid diffferent series has the same name,
         : $8f95c1371be5a40a$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $8f95c1371be5a40a$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $8f95c1371be5a40a$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $8f95c1371be5a40a$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $8f95c1371be5a40a$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $8f95c1371be5a40a$export$fb1a222ba5dd6e51(obj2[attr], null); // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $8f95c1371be5a40a$var$makeComparableKey(val) {
    return $8f95c1371be5a40a$export$fb1a222ba5dd6e51(val, '');
}
function $8f95c1371be5a40a$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    var type = typeof idOrName;
    return type === 'string' ? idOrName : type === 'number' || (0, $hzBt5.isStringSafe)(idOrName) ? idOrName + '' : defaultValue;
}
function $8f95c1371be5a40a$var$warnInvalidateIdOrName(idOrName) {}
function $8f95c1371be5a40a$var$isValidIdOrName(idOrName) {
    return (0, $hzBt5.isStringSafe)(idOrName) || (0, $5BQXp.isNumeric)(idOrName);
}
function $8f95c1371be5a40a$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($8f95c1371be5a40a$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $8f95c1371be5a40a$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $8f95c1371be5a40a$var$makeComparableKey(cmptOption.id).indexOf($8f95c1371be5a40a$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $8f95c1371be5a40a$export$1753133c42e665e8(idSuffix) {
    return $8f95c1371be5a40a$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $8f95c1371be5a40a$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $hzBt5.each)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $hzBt5.isObject)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $8f95c1371be5a40a$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $8f95c1371be5a40a$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
     : componentModelCtor.determineSubType(mainType, newCmptOption); // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $8f95c1371be5a40a$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $8f95c1371be5a40a$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $8f95c1371be5a40a$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $8f95c1371be5a40a$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $hzBt5.isArray)(payload.dataIndex) ? (0, $hzBt5.map)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $hzBt5.isArray)(payload.name) ? (0, $hzBt5.map)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $8f95c1371be5a40a$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $8f95c1371be5a40a$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $8f95c1371be5a40a$var$innerUniqueIndex = (0, $5BQXp.getRandomIdBase)();
function $8f95c1371be5a40a$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $8f95c1371be5a40a$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $8f95c1371be5a40a$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $8f95c1371be5a40a$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $hzBt5.isString)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $hzBt5.createHashMap)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $hzBt5.each)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $hzBt5.indexOf)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $8f95c1371be5a40a$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $8f95c1371be5a40a$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $8f95c1371be5a40a$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $8f95c1371be5a40a$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        (0, $hzBt5.assert)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    } // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        (0, $hzBt5.assert)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $8f95c1371be5a40a$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $8f95c1371be5a40a$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $8f95c1371be5a40a$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $gZXYp.default).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $8f95c1371be5a40a$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $hzBt5.createHashMap)();
    var keys = [];
    (0, $hzBt5.each)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $8f95c1371be5a40a$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if (typeof targetValue === 'number') {
        var value = (0, $fyp5g.interpolateNumber)(sourceValue || 0, targetValue, percent);
        return (0, $5BQXp.round)(value, isAutoPrecision ? Math.max((0, $5BQXp.getPrecision)(sourceValue || 0), (0, $5BQXp.getPrecision)(targetValue)) : precision);
    } else if (typeof targetValue === 'string') return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i); // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = (0, $fyp5g.interpolateNumber)(leftVal, rightVal, percent);
                interpolated[i] = (0, $5BQXp.round)(value, isAutoPrecision ? Math.max((0, $5BQXp.getPrecision)(leftVal), (0, $5BQXp.getPrecision)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}

});
parcelRegister("5BQXp", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => $41597ca18f9f4bbd$export$d3f68fbaa670562);
$parcel$export(module.exports, "parsePercent", () => $41597ca18f9f4bbd$export$e8514cb5a5e2b40f);
$parcel$export(module.exports, "round", () => $41597ca18f9f4bbd$export$2077e0241d6afd3c);
$parcel$export(module.exports, "asc", () => $41597ca18f9f4bbd$export$debe6e778e0a6d32);
$parcel$export(module.exports, "getPrecision", () => $41597ca18f9f4bbd$export$e0c74b50bbd10f68);
$parcel$export(module.exports, "getPrecisionSafe", () => $41597ca18f9f4bbd$export$6d86ba4ca4984d31);
$parcel$export(module.exports, "getPixelPrecision", () => $41597ca18f9f4bbd$export$666260d9a2dda8a7);
$parcel$export(module.exports, "getPercentWithPrecision", () => $41597ca18f9f4bbd$export$70cc11b075afeb90);
$parcel$export(module.exports, "addSafe", () => $41597ca18f9f4bbd$export$d3389a301c3a5706);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => $41597ca18f9f4bbd$export$18510406f204a1b9);
$parcel$export(module.exports, "remRadian", () => $41597ca18f9f4bbd$export$2ca6dd70a288b1c3);
$parcel$export(module.exports, "isRadianAroundZero", () => $41597ca18f9f4bbd$export$d1df570aea2868f);
$parcel$export(module.exports, "parseDate", () => $41597ca18f9f4bbd$export$6b862160d295c8e);
$parcel$export(module.exports, "quantity", () => $41597ca18f9f4bbd$export$82dd68b83a44b253);
$parcel$export(module.exports, "quantityExponent", () => $41597ca18f9f4bbd$export$97256a17b20a0c24);
$parcel$export(module.exports, "nice", () => $41597ca18f9f4bbd$export$7a695fe44258210b);
$parcel$export(module.exports, "quantile", () => $41597ca18f9f4bbd$export$651fb4afdb6caa4b);
$parcel$export(module.exports, "reformIntervals", () => $41597ca18f9f4bbd$export$12f7386070bc380a);
$parcel$export(module.exports, "numericToNumber", () => $41597ca18f9f4bbd$export$8b4007b942b45a96);
$parcel$export(module.exports, "isNumeric", () => $41597ca18f9f4bbd$export$e90fb89750dba83f);
$parcel$export(module.exports, "getRandomIdBase", () => $41597ca18f9f4bbd$export$474d2ec9aa44a22);
$parcel$export(module.exports, "getLeastCommonMultiple", () => $41597ca18f9f4bbd$export$680a45b749323f49);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embeded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $41597ca18f9f4bbd$var$RADIAN_EPSILON = 1e-4; // Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $41597ca18f9f4bbd$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $41597ca18f9f4bbd$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
function $41597ca18f9f4bbd$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
     // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $41597ca18f9f4bbd$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case 'center':
        case 'middle':
            percent = '50%';
            break;
        case 'left':
        case 'top':
            percent = '0%';
            break;
        case 'right':
        case 'bottom':
            percent = '100%';
            break;
    }
    if (typeof percent === 'string') {
        if ($41597ca18f9f4bbd$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $41597ca18f9f4bbd$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
     // Avoid range error
    precision = Math.min(Math.max(0, precision), $41597ca18f9f4bbd$var$ROUND_SUPPORTED_PRECISION_MAX); // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $41597ca18f9f4bbd$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $41597ca18f9f4bbd$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
     // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $41597ca18f9f4bbd$export$6d86ba4ca4984d31(val);
}
function $41597ca18f9f4bbd$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase(); // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $41597ca18f9f4bbd$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $41597ca18f9f4bbd$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var sum = $hzBt5.reduce(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return 0;
    var digits = Math.pow(10, precision);
    var votesPerQuota = $hzBt5.map(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $hzBt5.map(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $hzBt5.reduce(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $hzBt5.map(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    }); // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
         // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return seats[idx] / digits;
}
function $41597ca18f9f4bbd$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($41597ca18f9f4bbd$export$e0c74b50bbd10f68(val0), $41597ca18f9f4bbd$export$e0c74b50bbd10f68(val1)); // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1; // // PENDING: support more?
    return maxPrecision > $41597ca18f9f4bbd$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $41597ca18f9f4bbd$export$2077e0241d6afd3c(sum, maxPrecision);
} // Number.MAX_SAFE_INTEGER, ie do not support.
var $41597ca18f9f4bbd$export$18510406f204a1b9 = 9007199254740991;
function $41597ca18f9f4bbd$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $41597ca18f9f4bbd$export$d1df570aea2868f(val) {
    return val > -$41597ca18f9f4bbd$var$RADIAN_EPSILON && val < $41597ca18f9f4bbd$var$RADIAN_EPSILON;
} // eslint-disable-next-line
var $41597ca18f9f4bbd$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $41597ca18f9f4bbd$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if (typeof value === 'string') {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $41597ca18f9f4bbd$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
         // Use local time when no timezone offset specifed.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $41597ca18f9f4bbd$export$82dd68b83a44b253(val) {
    return Math.pow(10, $41597ca18f9f4bbd$export$97256a17b20a0c24(val));
}
function $41597ca18f9f4bbd$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $41597ca18f9f4bbd$export$7a695fe44258210b(val, round) {
    var exponent = $41597ca18f9f4bbd$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $41597ca18f9f4bbd$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $41597ca18f9f4bbd$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $41597ca18f9f4bbd$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || typeof val !== 'string' || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $41597ca18f9f4bbd$export$e90fb89750dba83f(val) {
    return !isNaN($41597ca18f9f4bbd$export$8b4007b942b45a96(val));
}
function $41597ca18f9f4bbd$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $41597ca18f9f4bbd$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $41597ca18f9f4bbd$export$a368fd580c0d0fe4(b, a % b);
}
function $41597ca18f9f4bbd$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $41597ca18f9f4bbd$export$a368fd580c0d0fe4(a, b);
}

});




parcelRegister("9ubot", function(module, exports) {

$parcel$export(module.exports, "getAnimationConfig", () => $6e7fc0f961bc64aa$export$5cc7add7ab591d0a);
$parcel$export(module.exports, "updateProps", () => $6e7fc0f961bc64aa$export$c8dce3c08436e91e);
$parcel$export(module.exports, "initProps", () => $6e7fc0f961bc64aa$export$a121566aadcfe021);
$parcel$export(module.exports, "isElementRemoved", () => $6e7fc0f961bc64aa$export$5b89d4b643713034);
$parcel$export(module.exports, "removeElement", () => $6e7fc0f961bc64aa$export$f883456a56996078);
$parcel$export(module.exports, "removeElementWithFadeOut", () => $6e7fc0f961bc64aa$export$6d0fd725cb4aee8a);
$parcel$export(module.exports, "saveOldStyle", () => $6e7fc0f961bc64aa$export$bca7290a9faf0ec9);
$parcel$export(module.exports, "getOldStyle", () => $6e7fc0f961bc64aa$export$ccb1f1e4d2fa86ac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
var $6e7fc0f961bc64aa$export$ae7433df314f6ec3 = (0, $ckizb.makeInner)();
function $6e7fc0f961bc64aa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, extraOpts, extraDelayParams) {
    var animationPayload; // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $hzBt5.retrieve2)(extraOpts.duration, 200);
            easing = (0, $hzBt5.retrieve2)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        } // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if (typeof delay === 'function') delay = delay(dataIndex, extraDelayParams);
        if (typeof duration === 'function') duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $6e7fc0f961bc64aa$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if (typeof dataIndex === 'function') {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $hzBt5.isObject)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'remove';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('remove');
    var animationConfig = $6e7fc0f961bc64aa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation(); // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props); // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $6e7fc0f961bc64aa$export$c8dce3c08436e91e(el, props, animatableModel, dataIndex, cb, during) {
    $6e7fc0f961bc64aa$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $6e7fc0f961bc64aa$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $6e7fc0f961bc64aa$var$animateOrSetProps('init', el, props, animatableModel, dataIndex, cb, during);
}
function $6e7fc0f961bc64aa$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'remove') return true;
    }
    return false;
}
function $6e7fc0f961bc64aa$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($6e7fc0f961bc64aa$export$5b89d4b643713034(el)) return;
    $6e7fc0f961bc64aa$var$animateOrSetProps('remove', el, props, animatableModel, dataIndex, cb, during);
}
function $6e7fc0f961bc64aa$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $6e7fc0f961bc64aa$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $6e7fc0f961bc64aa$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    } // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $6e7fc0f961bc64aa$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $6e7fc0f961bc64aa$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $6e7fc0f961bc64aa$export$bca7290a9faf0ec9(el) {
    $6e7fc0f961bc64aa$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $6e7fc0f961bc64aa$export$ccb1f1e4d2fa86ac(el) {
    return $6e7fc0f961bc64aa$export$ae7433df314f6ec3(el).oldStyle;
}

});

parcelRegister("8q0E1", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => $621140689cf5f5fc$export$d0d5398c9d612037);
$parcel$export(module.exports, "extendPath", () => $621140689cf5f5fc$export$53b54a3137026af0);
$parcel$export(module.exports, "registerShape", () => $621140689cf5f5fc$export$2b95b62e3aaf6fdd);
$parcel$export(module.exports, "getShapeClass", () => $621140689cf5f5fc$export$51df4b5565a58189);
$parcel$export(module.exports, "makePath", () => $621140689cf5f5fc$export$aa9bab72412f5613);
$parcel$export(module.exports, "resizePath", () => $621140689cf5f5fc$export$566dbf1c62b04fc7);
$parcel$export(module.exports, "makeImage", () => $621140689cf5f5fc$export$7a2bdede98851ac5);
$parcel$export(module.exports, "mergePath", () => $621140689cf5f5fc$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "subPixelOptimizeLine", () => $621140689cf5f5fc$export$8b4b620d7f4aad1b);
$parcel$export(module.exports, "subPixelOptimizeRect", () => $621140689cf5f5fc$export$60e2aa74957d0b9d);
$parcel$export(module.exports, "subPixelOptimize", () => $621140689cf5f5fc$export$72c4fd4c1b8fcb10);
$parcel$export(module.exports, "getTransform", () => $621140689cf5f5fc$export$fce0c6cfca85ed96);
$parcel$export(module.exports, "applyTransform", () => $621140689cf5f5fc$export$9f9dcb98c894b623);
$parcel$export(module.exports, "transformDirection", () => $621140689cf5f5fc$export$fff94e9792354cfa);
$parcel$export(module.exports, "groupTransition", () => $621140689cf5f5fc$export$64fcab7860c216ae);
$parcel$export(module.exports, "clipPointsByRect", () => $621140689cf5f5fc$export$e2f409471bbbc1dc);
$parcel$export(module.exports, "clipRectByRect", () => $621140689cf5f5fc$export$d0d3709202b8b2a);
$parcel$export(module.exports, "createIcon", () => $621140689cf5f5fc$export$274edc73af1ae9c8);
$parcel$export(module.exports, "linePolygonIntersect", () => $621140689cf5f5fc$export$4f47c855a5e9ae9);
$parcel$export(module.exports, "lineLineIntersect", () => $621140689cf5f5fc$export$6c0a70ea1d8d158b);
$parcel$export(module.exports, "setTooltipConfig", () => $621140689cf5f5fc$export$fc6410d97fab306c);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("9ubot")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("9ubot")).initProps);
$parcel$export(module.exports, "removeElement", () => (parcelRequire("9ubot")).removeElement);
$parcel$export(module.exports, "removeElementWithFadeOut", () => (parcelRequire("9ubot")).removeElementWithFadeOut);
$parcel$export(module.exports, "isElementRemoved", () => (parcelRequire("9ubot")).isElementRemoved);
$parcel$export(module.exports, "Group", () => (parcelRequire("hXAsm")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("agXnr")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("kiooD")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("aYBv9")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("gwELx")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("rnA7j")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("IXyXP")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("cjY1b")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("9dsiU")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("aeCKo")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("15UDR")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("6RZy2")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("iMbRE")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("4Nii9")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("juJV6")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("4kdki")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("hkgm4")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("lGSv6")).default);
$parcel$export(module.exports, "OrientedBoundingRect", () => (parcelRequire("fi3eW")).default);
$parcel$export(module.exports, "Point", () => (parcelRequire("4vVC3")).default);
$parcel$export(module.exports, "Path", () => (parcelRequire("hMiip")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lJlYD = parcelRequire("lJlYD");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $hMiip = parcelRequire("hMiip");

var $kVlB5 = parcelRequire("kVlB5");

var $agXnr = parcelRequire("agXnr");

var $hXAsm = parcelRequire("hXAsm");

var $kiooD = parcelRequire("kiooD");

var $aYBv9 = parcelRequire("aYBv9");

var $gwELx = parcelRequire("gwELx");

var $rnA7j = parcelRequire("rnA7j");

var $IXyXP = parcelRequire("IXyXP");

var $cjY1b = parcelRequire("cjY1b");

var $9dsiU = parcelRequire("9dsiU");

var $aeCKo = parcelRequire("aeCKo");

var $15UDR = parcelRequire("15UDR");

var $6RZy2 = parcelRequire("6RZy2");

var $iMbRE = parcelRequire("iMbRE");

var $juJV6 = parcelRequire("juJV6");

var $4kdki = parcelRequire("4kdki");

var $hkgm4 = parcelRequire("hkgm4");

var $lGSv6 = parcelRequire("lGSv6");

var $fi3eW = parcelRequire("fi3eW");

var $4vVC3 = parcelRequire("4vVC3");

var $4Nii9 = parcelRequire("4Nii9");

var $kXoFx = parcelRequire("kXoFx");

var $hzBt5 = parcelRequire("hzBt5");

var $aly4X = parcelRequire("aly4X");

var $9ubot = parcelRequire("9ubot");
var $621140689cf5f5fc$var$mathMax = Math.max;
var $621140689cf5f5fc$var$mathMin = Math.min;
var $621140689cf5f5fc$var$_customShapeMap = {};
function $621140689cf5f5fc$export$d0d5398c9d612037(opts) {
    return (0, $hMiip.default).extend(opts);
}
var $621140689cf5f5fc$var$extendPathFromString = $lJlYD.extendFromString;
function $621140689cf5f5fc$export$53b54a3137026af0(pathData, opts) {
    return $621140689cf5f5fc$var$extendPathFromString(pathData, opts);
}
function $621140689cf5f5fc$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $621140689cf5f5fc$var$_customShapeMap[name] = ShapeClass;
}
function $621140689cf5f5fc$export$51df4b5565a58189(name) {
    if ($621140689cf5f5fc$var$_customShapeMap.hasOwnProperty(name)) return $621140689cf5f5fc$var$_customShapeMap[name];
}
function $621140689cf5f5fc$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $lJlYD.createFromString(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $621140689cf5f5fc$var$centerGraphic(rect, path.getBoundingRect());
        $621140689cf5f5fc$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $621140689cf5f5fc$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $agXnr.default)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($621140689cf5f5fc$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $621140689cf5f5fc$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $621140689cf5f5fc$export$7b1dd269fbc4e903 = $lJlYD.mergePath;
function $621140689cf5f5fc$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $621140689cf5f5fc$export$8b4b620d7f4aad1b(param) {
    $kXoFx.subPixelOptimizeLine(param.shape, param.shape, param.style);
    return param;
}
function $621140689cf5f5fc$export$60e2aa74957d0b9d(param) {
    $kXoFx.subPixelOptimizeRect(param.shape, param.shape, param.style);
    return param;
}
var $621140689cf5f5fc$export$72c4fd4c1b8fcb10 = $kXoFx.subPixelOptimize;
function $621140689cf5f5fc$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $crEgd.identity([]);
    while(target && target !== ancestor){
        $crEgd.mul(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $621140689cf5f5fc$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $hzBt5.isArrayLike)(transform)) transform = (0, $kVlB5.default).getLocalTransform(transform);
    if (invert) transform = $crEgd.invert([], transform);
    return $ef5pP.applyTransform([], target, transform);
}
function $621140689cf5f5fc$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $621140689cf5f5fc$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $621140689cf5f5fc$var$isNotGroup(el) {
    return !el.isGroup;
}
function $621140689cf5f5fc$var$isPath(el) {
    return el.shape != null;
}
function $621140689cf5f5fc$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($621140689cf5f5fc$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($621140689cf5f5fc$var$isPath(el)) obj.shape = (0, $hzBt5.extend)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($621140689cf5f5fc$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $9ubot.updateProps)(el, newProp, animatableModel, (0, $aly4X.getECData)(el).dataIndex);
            }
        }
    });
}
function $621140689cf5f5fc$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: this way migth be incorrect when grpahic clipped by a corner.
    // and when element have border.
    return (0, $hzBt5.map)(points, function(point) {
        var x = point[0];
        x = $621140689cf5f5fc$var$mathMax(x, rect.x);
        x = $621140689cf5f5fc$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $621140689cf5f5fc$var$mathMax(y, rect.y);
        y = $621140689cf5f5fc$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $621140689cf5f5fc$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $621140689cf5f5fc$var$mathMax(targetRect.x, rect.x);
    var x2 = $621140689cf5f5fc$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $621140689cf5f5fc$var$mathMax(targetRect.y, rect.y);
    var y2 = $621140689cf5f5fc$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $621140689cf5f5fc$export$274edc73af1ae9c8(iconStr, opt, rect) {
    var innerOpts = (0, $hzBt5.extend)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $hzBt5.defaults)(style, rect), new (0, $agXnr.default)(innerOpts)) : $621140689cf5f5fc$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $621140689cf5f5fc$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($621140689cf5f5fc$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $621140689cf5f5fc$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
    //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $621140689cf5f5fc$var$crossProduct2d(nx, ny, mx, my);
    if ($621140689cf5f5fc$var$nearZero(nmCrossProduct)) return false;
     // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $621140689cf5f5fc$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $621140689cf5f5fc$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $621140689cf5f5fc$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $621140689cf5f5fc$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $621140689cf5f5fc$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $hzBt5.isString)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $hzBt5.each)((0, $hzBt5.keys)(formatterParamsExtra), function(key) {
        if (!(0, $hzBt5.hasOwn)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $aly4X.getECData)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $hzBt5.defaults)({
            content: itemName,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
} // Register built-in shapes. These shapes might be overwirtten
// by users, although we do not recommend that.
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('circle', (0, $aYBv9.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('ellipse', (0, $gwELx.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('sector', (0, $rnA7j.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('ring', (0, $IXyXP.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('polygon', (0, $cjY1b.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('polyline', (0, $9dsiU.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('rect', (0, $aeCKo.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('line', (0, $15UDR.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('bezierCurve', (0, $6RZy2.default));
$621140689cf5f5fc$export$2b95b62e3aaf6fdd('arc', (0, $iMbRE.default));

});
parcelRegister("lJlYD", function(module, exports) {

$parcel$export(module.exports, "createFromString", () => $fd1ed9183e095324$export$ae5b259626f00aeb);
$parcel$export(module.exports, "extendFromString", () => $fd1ed9183e095324$export$68e3a51ba2ed417c);
$parcel$export(module.exports, "mergePath", () => $fd1ed9183e095324$export$7b1dd269fbc4e903);
$parcel$export(module.exports, "clonePath", () => $fd1ed9183e095324$export$18711d956bf1c3eb);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $fvvgx = parcelRequire("fvvgx");

var $hjFOF = parcelRequire("hjFOF");

var $hzBt5 = parcelRequire("hzBt5");
var $fd1ed9183e095324$var$mathSqrt = Math.sqrt;
var $fd1ed9183e095324$var$mathSin = Math.sin;
var $fd1ed9183e095324$var$mathCos = Math.cos;
var $fd1ed9183e095324$var$PI = Math.PI;
function $fd1ed9183e095324$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $fd1ed9183e095324$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($fd1ed9183e095324$var$vMag(u) * $fd1ed9183e095324$var$vMag(v));
}
function $fd1ed9183e095324$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($fd1ed9183e095324$var$vRatio(u, v));
}
function $fd1ed9183e095324$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($fd1ed9183e095324$var$PI / 180.0);
    var xp = $fd1ed9183e095324$var$mathCos(psi) * (x1 - x2) / 2.0 + $fd1ed9183e095324$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $fd1ed9183e095324$var$mathSin(psi) * (x1 - x2) / 2.0 + $fd1ed9183e095324$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $fd1ed9183e095324$var$mathSqrt(lambda);
        ry *= $fd1ed9183e095324$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $fd1ed9183e095324$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $fd1ed9183e095324$var$mathCos(psi) * cxp - $fd1ed9183e095324$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $fd1ed9183e095324$var$mathSin(psi) * cxp + $fd1ed9183e095324$var$mathCos(psi) * cyp;
    var theta = $fd1ed9183e095324$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $fd1ed9183e095324$var$vAngle(u, v);
    if ($fd1ed9183e095324$var$vRatio(u, v) <= -1) dTheta = $fd1ed9183e095324$var$PI;
    if ($fd1ed9183e095324$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $fd1ed9183e095324$var$PI * 1e6) / 1e6;
        dTheta = $fd1ed9183e095324$var$PI * 2 + n % 2 * $fd1ed9183e095324$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $fd1ed9183e095324$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $fd1ed9183e095324$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $fd1ed9183e095324$var$createPathProxyFromString(data) {
    var path = new (0, $fvvgx.default)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $fvvgx.default).CMD;
    var cmdList = data.match($fd1ed9183e095324$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($fd1ed9183e095324$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $fd1ed9183e095324$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $fd1ed9183e095324$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $fd1ed9183e095324$var$SVGPath = function(_super) {
    (0, $fKE23.__extends)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $hMiip.default));
function $fd1ed9183e095324$var$isPathProxy(path) {
    return path.setData != null;
}
function $fd1ed9183e095324$var$createPathOptions(str, opts) {
    var pathProxy = $fd1ed9183e095324$var$createPathProxyFromString(str);
    var innerOpts = (0, $hzBt5.extend)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($fd1ed9183e095324$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $hjFOF.default)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $fd1ed9183e095324$export$ae5b259626f00aeb(str, opts) {
    return new $fd1ed9183e095324$var$SVGPath($fd1ed9183e095324$var$createPathOptions(str, opts));
}
function $fd1ed9183e095324$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $fd1ed9183e095324$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $fKE23.__extends)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($fd1ed9183e095324$var$SVGPath);
    return Sub;
}
function $fd1ed9183e095324$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $hMiip.default)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($fd1ed9183e095324$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $fd1ed9183e095324$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $hMiip.default)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $hjFOF.default)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}

});
parcelRegister("hjFOF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b4a5d419004a39$export$2e2bcd8739ae039);

var $fvvgx = parcelRequire("fvvgx");

var $ef5pP = parcelRequire("ef5pP");
var $c9b4a5d419004a39$var$CMD = (0, $fvvgx.default).CMD;
var $c9b4a5d419004a39$var$points = [
    [],
    [],
    []
];
var $c9b4a5d419004a39$var$mathSqrt = Math.sqrt;
var $c9b4a5d419004a39$var$mathAtan2 = Math.atan2;
function $c9b4a5d419004a39$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $c9b4a5d419004a39$var$CMD.M;
    var C = $c9b4a5d419004a39$var$CMD.C;
    var L = $c9b4a5d419004a39$var$CMD.L;
    var R = $c9b4a5d419004a39$var$CMD.R;
    var A = $c9b4a5d419004a39$var$CMD.A;
    var Q = $c9b4a5d419004a39$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $c9b4a5d419004a39$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $c9b4a5d419004a39$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $c9b4a5d419004a39$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $ef5pP.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $ef5pP.applyTransform)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $c9b4a5d419004a39$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $ef5pP.applyTransform)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}

});


parcelRegister("hXAsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13439d8c81e093b$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $3MGIU = parcelRequire("3MGIU");

var $lGSv6 = parcelRequire("lGSv6");
var $d13439d8c81e093b$var$Group = function(_super) {
    (0, $fKE23.__extends)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
            if (child.__hostTarget) throw 'This elemenet has been used as an attachment';
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $hzBt5.indexOf(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $hzBt5.indexOf(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $lGSv6.default)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $lGSv6.default).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $3MGIU.default));
$d13439d8c81e093b$var$Group.prototype.type = 'group';
var $d13439d8c81e093b$export$2e2bcd8739ae039 = $d13439d8c81e093b$var$Group;

});

parcelRegister("aYBv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fdc99017af94d1f$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $7fdc99017af94d1f$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $7fdc99017af94d1f$var$Circle = function(_super) {
    (0, $fKE23.__extends)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $7fdc99017af94d1f$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape, inBundle) {
        if (inBundle) ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $hMiip.default));
$7fdc99017af94d1f$var$Circle.prototype.type = 'circle';
var $7fdc99017af94d1f$export$2e2bcd8739ae039 = $7fdc99017af94d1f$var$Circle;

});

parcelRegister("gwELx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c07f41b602501a44$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $c07f41b602501a44$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $c07f41b602501a44$var$Ellipse = function(_super) {
    (0, $fKE23.__extends)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $c07f41b602501a44$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $hMiip.default));
$c07f41b602501a44$var$Ellipse.prototype.type = 'ellipse';
var $c07f41b602501a44$export$2e2bcd8739ae039 = $c07f41b602501a44$var$Ellipse;

});

parcelRegister("rnA7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $0524d088410d535e$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $lX4Sm = parcelRequire("lX4Sm");
var $0524d088410d535e$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
        this.innerCornerRadius = 0;
    }
    return SectorShape;
}();
var $0524d088410d535e$var$Sector = function(_super) {
    (0, $fKE23.__extends)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $0524d088410d535e$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $lX4Sm.buildPath(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $hMiip.default));
$0524d088410d535e$var$Sector.prototype.type = 'sector';
var $0524d088410d535e$export$2e2bcd8739ae039 = $0524d088410d535e$var$Sector;

});
parcelRegister("lX4Sm", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $ffb2e3e576a3f168$export$5cc7f731b5937e99);

var $fvvgx = parcelRequire("fvvgx");
var $ffb2e3e576a3f168$var$PI = Math.PI;
var $ffb2e3e576a3f168$var$PI2 = $ffb2e3e576a3f168$var$PI * 2;
var $ffb2e3e576a3f168$var$mathSin = Math.sin;
var $ffb2e3e576a3f168$var$mathCos = Math.cos;
var $ffb2e3e576a3f168$var$mathACos = Math.acos;
var $ffb2e3e576a3f168$var$mathATan2 = Math.atan2;
var $ffb2e3e576a3f168$var$mathAbs = Math.abs;
var $ffb2e3e576a3f168$var$mathSqrt = Math.sqrt;
var $ffb2e3e576a3f168$var$mathMax = Math.max;
var $ffb2e3e576a3f168$var$mathMin = Math.min;
var $ffb2e3e576a3f168$var$e = 1e-4;
function $ffb2e3e576a3f168$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0;
    var y10 = y1 - y0;
    var x32 = x3 - x2;
    var y32 = y3 - y2;
    var t = y32 * x10 - x32 * y10;
    if (t * t < $ffb2e3e576a3f168$var$e) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
function $ffb2e3e576a3f168$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $ffb2e3e576a3f168$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $ffb2e3e576a3f168$var$mathSqrt($ffb2e3e576a3f168$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (radius / r - 1),
        y11: cy0 * (radius / r - 1)
    };
}
function $ffb2e3e576a3f168$export$5cc7f731b5937e99(ctx, shape) {
    var radius = $ffb2e3e576a3f168$var$mathMax(shape.r, 0);
    var innerRadius = $ffb2e3e576a3f168$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var clockwise = !!shape.clockwise;
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var arc;
    if (startAngle === endAngle) arc = 0;
    else {
        var tmpAngles = [
            startAngle,
            endAngle
        ];
        (0, $fvvgx.normalizeArcAngles)(tmpAngles, !clockwise);
        arc = $ffb2e3e576a3f168$var$mathAbs(tmpAngles[0] - tmpAngles[1]);
    }
    var x = shape.cx;
    var y = shape.cy;
    var cornerRadius = shape.cornerRadius || 0;
    var innerCornerRadius = shape.innerCornerRadius || 0;
    if (!(radius > $ffb2e3e576a3f168$var$e)) ctx.moveTo(x, y);
    else if (arc > $ffb2e3e576a3f168$var$PI2 - $ffb2e3e576a3f168$var$e) {
        ctx.moveTo(x + radius * $ffb2e3e576a3f168$var$mathCos(startAngle), y + radius * $ffb2e3e576a3f168$var$mathSin(startAngle));
        ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $ffb2e3e576a3f168$var$e) {
            ctx.moveTo(x + innerRadius * $ffb2e3e576a3f168$var$mathCos(endAngle), y + innerRadius * $ffb2e3e576a3f168$var$mathSin(endAngle));
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var halfRd = $ffb2e3e576a3f168$var$mathAbs(radius - innerRadius) / 2;
        var cr = $ffb2e3e576a3f168$var$mathMin(halfRd, cornerRadius);
        var icr = $ffb2e3e576a3f168$var$mathMin(halfRd, innerCornerRadius);
        var cr0 = icr;
        var cr1 = cr;
        var xrs = radius * $ffb2e3e576a3f168$var$mathCos(startAngle);
        var yrs = radius * $ffb2e3e576a3f168$var$mathSin(startAngle);
        var xire = innerRadius * $ffb2e3e576a3f168$var$mathCos(endAngle);
        var yire = innerRadius * $ffb2e3e576a3f168$var$mathSin(endAngle);
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        if (cr > $ffb2e3e576a3f168$var$e || icr > $ffb2e3e576a3f168$var$e) {
            xre = radius * $ffb2e3e576a3f168$var$mathCos(endAngle);
            yre = radius * $ffb2e3e576a3f168$var$mathSin(endAngle);
            xirs = innerRadius * $ffb2e3e576a3f168$var$mathCos(startAngle);
            yirs = innerRadius * $ffb2e3e576a3f168$var$mathSin(startAngle);
            if (arc < $ffb2e3e576a3f168$var$PI) {
                var it_1 = $ffb2e3e576a3f168$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                if (it_1) {
                    var x0 = xrs - it_1[0];
                    var y0 = yrs - it_1[1];
                    var x1 = xre - it_1[0];
                    var y1 = yre - it_1[1];
                    var a = 1 / $ffb2e3e576a3f168$var$mathSin($ffb2e3e576a3f168$var$mathACos((x0 * x1 + y0 * y1) / ($ffb2e3e576a3f168$var$mathSqrt(x0 * x0 + y0 * y0) * $ffb2e3e576a3f168$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                    var b = $ffb2e3e576a3f168$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                    cr0 = $ffb2e3e576a3f168$var$mathMin(icr, (innerRadius - b) / (a - 1));
                    cr1 = $ffb2e3e576a3f168$var$mathMin(cr, (radius - b) / (a + 1));
                }
            }
        }
        if (!(arc > $ffb2e3e576a3f168$var$e)) ctx.moveTo(x + xrs, y + yrs);
        else if (cr1 > $ffb2e3e576a3f168$var$e) {
            var ct0 = $ffb2e3e576a3f168$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, cr1, clockwise);
            var ct1 = $ffb2e3e576a3f168$var$computeCornerTangents(xre, yre, xire, yire, radius, cr1, clockwise);
            ctx.moveTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr1 < cr) ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr1, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, radius, $ffb2e3e576a3f168$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), !clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr1, $ffb2e3e576a3f168$var$mathATan2(ct1.y11, ct1.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.moveTo(x + xrs, y + yrs);
            ctx.arc(x, y, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $ffb2e3e576a3f168$var$e) || !(arc > $ffb2e3e576a3f168$var$e)) ctx.lineTo(x + xire, y + yire);
        else if (cr0 > $ffb2e3e576a3f168$var$e) {
            var ct0 = $ffb2e3e576a3f168$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -cr0, clockwise);
            var ct1 = $ffb2e3e576a3f168$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -cr0, clockwise);
            ctx.lineTo(x + ct0.cx + ct0.x01, y + ct0.cy + ct0.y01);
            if (cr0 < icr) ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            else {
                ctx.arc(x + ct0.cx, y + ct0.cy, cr0, $ffb2e3e576a3f168$var$mathATan2(ct0.y01, ct0.x01), $ffb2e3e576a3f168$var$mathATan2(ct0.y11, ct0.x11), !clockwise);
                ctx.arc(x, y, innerRadius, $ffb2e3e576a3f168$var$mathATan2(ct0.cy + ct0.y11, ct0.cx + ct0.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.cy + ct1.y11, ct1.cx + ct1.x11), clockwise);
                ctx.arc(x + ct1.cx, y + ct1.cy, cr0, $ffb2e3e576a3f168$var$mathATan2(ct1.y11, ct1.x11), $ffb2e3e576a3f168$var$mathATan2(ct1.y01, ct1.x01), !clockwise);
            }
        } else {
            ctx.lineTo(x + xire, y + yire);
            ctx.arc(x, y, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}

});


parcelRegister("IXyXP", function(module, exports) {

$parcel$export(module.exports, "default", () => $08725022250d2ecb$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $08725022250d2ecb$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $08725022250d2ecb$var$Ring = function(_super) {
    (0, $fKE23.__extends)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $08725022250d2ecb$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $hMiip.default));
$08725022250d2ecb$var$Ring.prototype.type = 'ring';
var $08725022250d2ecb$export$2e2bcd8739ae039 = $08725022250d2ecb$var$Ring;

});

parcelRegister("cjY1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f85d0bf48aed645$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $gF8aT = parcelRequire("gF8aT");
var $8f85d0bf48aed645$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $8f85d0bf48aed645$var$Polygon = function(_super) {
    (0, $fKE23.__extends)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $8f85d0bf48aed645$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $gF8aT.buildPath(ctx, shape, true);
    };
    return Polygon;
}((0, $hMiip.default));
$8f85d0bf48aed645$var$Polygon.prototype.type = 'polygon';
var $8f85d0bf48aed645$export$2e2bcd8739ae039 = $8f85d0bf48aed645$var$Polygon;

});
parcelRegister("gF8aT", function(module, exports) {

$parcel$export(module.exports, "buildPath", () => $c216d0fd1dc1bba6$export$5cc7f731b5937e99);

var $6hEuz = parcelRequire("6hEuz");

var $hvEAg = parcelRequire("hvEAg");
function $c216d0fd1dc1bba6$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth && smooth !== 'spline') {
            var controlPoints = (0, $hvEAg.default)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            if (smooth === 'spline') points = (0, $6hEuz.default)(points, closePath);
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}

});
parcelRegister("6hEuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4933bd7906b6b27a$export$2e2bcd8739ae039);

var $ef5pP = parcelRequire("ef5pP");
function $4933bd7906b6b27a$var$interpolate(p0, p1, p2, p3, t, t2, t3) {
    var v0 = (p2 - p0) * 0.5;
    var v1 = (p3 - p1) * 0.5;
    return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
}
function $4933bd7906b6b27a$export$2e2bcd8739ae039(points, isLoop) {
    var len = points.length;
    var ret = [];
    var distance = 0;
    for(var i = 1; i < len; i++)distance += (0, $ef5pP.distance)(points[i - 1], points[i]);
    var segs = distance / 2;
    segs = segs < len ? len : segs;
    for(var i = 0; i < segs; i++){
        var pos = i / (segs - 1) * (isLoop ? len : len - 1);
        var idx = Math.floor(pos);
        var w = pos - idx;
        var p0 = void 0;
        var p1 = points[idx % len];
        var p2 = void 0;
        var p3 = void 0;
        if (!isLoop) {
            p0 = points[idx === 0 ? idx : idx - 1];
            p2 = points[idx > len - 2 ? len - 1 : idx + 1];
            p3 = points[idx > len - 3 ? len - 1 : idx + 2];
        } else {
            p0 = points[(idx - 1 + len) % len];
            p2 = points[(idx + 1) % len];
            p3 = points[(idx + 2) % len];
        }
        var w2 = w * w;
        var w3 = w * w2;
        ret.push([
            $4933bd7906b6b27a$var$interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3),
            $4933bd7906b6b27a$var$interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)
        ]);
    }
    return ret;
}

});

parcelRegister("hvEAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf4d0096e4ba68b$export$2e2bcd8739ae039);

var $ef5pP = parcelRequire("ef5pP");
function $cbf4d0096e4ba68b$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $ef5pP.min)(min, min, points[i]);
            (0, $ef5pP.max)(max, max, points[i]);
        }
        (0, $ef5pP.min)(min, min, constraint[0]);
        (0, $ef5pP.max)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $ef5pP.clone)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $ef5pP.sub)(v, nextPoint, prevPoint);
        (0, $ef5pP.scale)(v, v, smooth);
        var d0 = (0, $ef5pP.distance)(point, prevPoint);
        var d1 = (0, $ef5pP.distance)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $ef5pP.scale)(v1, v, -d0);
        (0, $ef5pP.scale)(v2, v, d1);
        var cp0 = (0, $ef5pP.add)([], point, v1);
        var cp1 = (0, $ef5pP.add)([], point, v2);
        if (constraint) {
            (0, $ef5pP.max)(cp0, cp0, min);
            (0, $ef5pP.min)(cp0, cp0, max);
            (0, $ef5pP.max)(cp1, cp1, min);
            (0, $ef5pP.min)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}

});



parcelRegister("9dsiU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5b488d42c0217d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $gF8aT = parcelRequire("gF8aT");
var $6b5b488d42c0217d$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $6b5b488d42c0217d$var$Polyline = function(_super) {
    (0, $fKE23.__extends)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $6b5b488d42c0217d$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $gF8aT.buildPath(ctx, shape, false);
    };
    return Polyline;
}((0, $hMiip.default));
$6b5b488d42c0217d$var$Polyline.prototype.type = 'polyline';
var $6b5b488d42c0217d$export$2e2bcd8739ae039 = $6b5b488d42c0217d$var$Polyline;

});

parcelRegister("15UDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc231f8d897ee0c$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $kXoFx = parcelRequire("kXoFx");
var $0cc231f8d897ee0c$var$subPixelOptimizeOutputShape = {};
var $0cc231f8d897ee0c$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $0cc231f8d897ee0c$var$Line = function(_super) {
    (0, $fKE23.__extends)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $0cc231f8d897ee0c$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $kXoFx.subPixelOptimizeLine)($0cc231f8d897ee0c$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $hMiip.default));
$0cc231f8d897ee0c$var$Line.prototype.type = 'line';
var $0cc231f8d897ee0c$export$2e2bcd8739ae039 = $0cc231f8d897ee0c$var$Line;

});

parcelRegister("6RZy2", function(module, exports) {

$parcel$export(module.exports, "default", () => $50076f79052695ed$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $ef5pP = parcelRequire("ef5pP");

var $jEMPh = parcelRequire("jEMPh");
var $50076f79052695ed$var$out = [];
var $50076f79052695ed$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $50076f79052695ed$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 === null || cpy2 === null) return [
        (isTangent ? (0, $jEMPh.cubicDerivativeAt) : (0, $jEMPh.cubicAt))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $jEMPh.cubicDerivativeAt) : (0, $jEMPh.cubicAt))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $jEMPh.quadraticDerivativeAt) : (0, $jEMPh.quadraticAt))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $jEMPh.quadraticDerivativeAt) : (0, $jEMPh.quadraticAt))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $50076f79052695ed$var$BezierCurve = function(_super) {
    (0, $fKE23.__extends)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $50076f79052695ed$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $jEMPh.quadraticSubdivide)(x1, cpx1, x2, percent, $50076f79052695ed$var$out);
                cpx1 = $50076f79052695ed$var$out[1];
                x2 = $50076f79052695ed$var$out[2];
                (0, $jEMPh.quadraticSubdivide)(y1, cpy1, y2, percent, $50076f79052695ed$var$out);
                cpy1 = $50076f79052695ed$var$out[1];
                y2 = $50076f79052695ed$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $jEMPh.cubicSubdivide)(x1, cpx1, cpx2, x2, percent, $50076f79052695ed$var$out);
                cpx1 = $50076f79052695ed$var$out[1];
                cpx2 = $50076f79052695ed$var$out[2];
                x2 = $50076f79052695ed$var$out[3];
                (0, $jEMPh.cubicSubdivide)(y1, cpy1, cpy2, y2, percent, $50076f79052695ed$var$out);
                cpy1 = $50076f79052695ed$var$out[1];
                cpy2 = $50076f79052695ed$var$out[2];
                y2 = $50076f79052695ed$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $50076f79052695ed$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $50076f79052695ed$var$someVectorAt(this.shape, t, true);
        return $ef5pP.normalize(p, p);
    };
    return BezierCurve;
}((0, $hMiip.default));
$50076f79052695ed$var$BezierCurve.prototype.type = 'bezier-curve';
var $50076f79052695ed$export$2e2bcd8739ae039 = $50076f79052695ed$var$BezierCurve;

});

parcelRegister("iMbRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab5e9b2fa9b51ae$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $dab5e9b2fa9b51ae$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $dab5e9b2fa9b51ae$var$Arc = function(_super) {
    (0, $fKE23.__extends)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $dab5e9b2fa9b51ae$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $hMiip.default));
$dab5e9b2fa9b51ae$var$Arc.prototype.type = 'arc';
var $dab5e9b2fa9b51ae$export$2e2bcd8739ae039 = $dab5e9b2fa9b51ae$var$Arc;

});

parcelRegister("juJV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e314706e508ffa50$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");
var $e314706e508ffa50$var$CompoundPath = function(_super) {
    (0, $fKE23.__extends)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $hMiip.default).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $hMiip.default));
var $e314706e508ffa50$export$2e2bcd8739ae039 = $e314706e508ffa50$var$CompoundPath;

});

parcelRegister("4kdki", function(module, exports) {

$parcel$export(module.exports, "default", () => $32635dfe908dc66c$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $7hVfq = parcelRequire("7hVfq");
var $32635dfe908dc66c$var$LinearGradient = function(_super) {
    (0, $fKE23.__extends)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $7hVfq.default));
var $32635dfe908dc66c$export$2e2bcd8739ae039 = $32635dfe908dc66c$var$LinearGradient;

});
parcelRegister("7hVfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e6872524c8c1af$export$2e2bcd8739ae039);
var $54e6872524c8c1af$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $54e6872524c8c1af$export$2e2bcd8739ae039 = $54e6872524c8c1af$var$Gradient;

});


parcelRegister("hkgm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9d0fda966ea171f$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $7hVfq = parcelRequire("7hVfq");
var $c9d0fda966ea171f$var$RadialGradient = function(_super) {
    (0, $fKE23.__extends)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $7hVfq.default));
var $c9d0fda966ea171f$export$2e2bcd8739ae039 = $c9d0fda966ea171f$var$RadialGradient;

});

parcelRegister("fi3eW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b21b0cd71807fe19$export$2e2bcd8739ae039);

var $4vVC3 = parcelRequire("4vVC3");
var $b21b0cd71807fe19$var$extent = [
    0,
    0
];
var $b21b0cd71807fe19$var$extent2 = [
    0,
    0
];
var $b21b0cd71807fe19$var$minTv = new (0, $4vVC3.default)();
var $b21b0cd71807fe19$var$maxTv = new (0, $4vVC3.default)();
var $b21b0cd71807fe19$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $4vVC3.default)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $4vVC3.default)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $4vVC3.default).sub(axes[0], corners[1], corners[0]);
        (0, $4vVC3.default).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $b21b0cd71807fe19$var$minTv.set(Infinity, Infinity);
        $b21b0cd71807fe19$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $b21b0cd71807fe19$var$minTv, $b21b0cd71807fe19$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $b21b0cd71807fe19$var$minTv, $b21b0cd71807fe19$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $4vVC3.default).copy(mtv, overlapped ? $b21b0cd71807fe19$var$minTv : $b21b0cd71807fe19$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $b21b0cd71807fe19$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $b21b0cd71807fe19$var$extent2);
            if ($b21b0cd71807fe19$var$extent[1] < $b21b0cd71807fe19$var$extent2[0] || $b21b0cd71807fe19$var$extent[0] > $b21b0cd71807fe19$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($b21b0cd71807fe19$var$extent2[0] - $b21b0cd71807fe19$var$extent[1]);
                var dist1 = Math.abs($b21b0cd71807fe19$var$extent[0] - $b21b0cd71807fe19$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $4vVC3.default).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $4vVC3.default).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($b21b0cd71807fe19$var$extent2[0] - $b21b0cd71807fe19$var$extent[1]);
                var dist1 = Math.abs($b21b0cd71807fe19$var$extent[0] - $b21b0cd71807fe19$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $4vVC3.default).scale(minTv, axis, dist0 * inverse);
                    else (0, $4vVC3.default).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $b21b0cd71807fe19$export$2e2bcd8739ae039 = $b21b0cd71807fe19$var$OrientedBoundingRect;

});

parcelRegister("4Nii9", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d9ed60c64c2e63$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $g1Uer = parcelRequire("g1Uer");

var $lGSv6 = parcelRequire("lGSv6");
var $37d9ed60c64c2e63$var$m = [];
var $37d9ed60c64c2e63$var$IncrementalDisplayable = function(_super) {
    (0, $fKE23.__extends)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $lGSv6.default)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($37d9ed60c64c2e63$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $g1Uer.default));
var $37d9ed60c64c2e63$export$2e2bcd8739ae039 = $37d9ed60c64c2e63$var$IncrementalDisplayable;

});




parcelRegister("5jmEk", function(module, exports) {

$parcel$export(module.exports, "LINE_STYLE_KEY_MAP", () => $3de04bca35753861$export$9f34de5b59222949);
$parcel$export(module.exports, "LineStyleMixin", () => $3de04bca35753861$export$91eeeeed4a69a7e7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6CLz8 = parcelRequire("6CLz8");
var $3de04bca35753861$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $3de04bca35753861$var$getLineStyle = (0, $6CLz8.default)($3de04bca35753861$export$9f34de5b59222949);
var $3de04bca35753861$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $3de04bca35753861$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();

});

parcelRegister("9N9yS", function(module, exports) {

$parcel$export(module.exports, "ITEM_STYLE_KEY_MAP", () => $72101b64c983bec9$export$ffb0bba5dde0130b);
$parcel$export(module.exports, "ItemStyleMixin", () => $72101b64c983bec9$export$e4f01e48d6fda412);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6CLz8 = parcelRequire("6CLz8");
var $72101b64c983bec9$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
];
var $72101b64c983bec9$var$getItemStyle = (0, $6CLz8.default)($72101b64c983bec9$export$ffb0bba5dde0130b);
var $72101b64c983bec9$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $72101b64c983bec9$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();

});


parcelRegister("ddlYG", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ed899115b3ba9b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $99ed899115b3ba9b$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $99ed899115b3ba9b$var$defaultKeyGetter(item) {
    return item;
}
var $99ed899115b3ba9b$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $99ed899115b3ba9b$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $99ed899115b3ba9b$var$defaultKeyGetter; // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(newIdxMapVal); // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
             // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, map, // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $99ed899115b3ba9b$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $99ed899115b3ba9b$export$2e2bcd8739ae039 = $99ed899115b3ba9b$var$DataDiffer;

});

parcelRegister("kWuWu", function(module, exports) {

$parcel$export(module.exports, "DefaultDataProvider", () => $f3f139f138e24c84$export$b900d7c4c3952a40);
$parcel$export(module.exports, "getRawSourceItemGetter", () => $f3f139f138e24c84$export$92c8ea8642b3957d);
$parcel$export(module.exports, "getRawSourceDataCounter", () => $f3f139f138e24c84$export$803742e832f4b52c);
$parcel$export(module.exports, "getRawSourceValueGetter", () => $f3f139f138e24c84$export$1752de8084789a14);
$parcel$export(module.exports, "retrieveRawValue", () => $f3f139f138e24c84$export$cde9373da9aad801);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $8AzOm = parcelRequire("8AzOm");

var $8tpV4 = parcelRequire("8tpV4");
var $f3f139f138e24c84$var$_a, $f3f139f138e24c84$var$_b, $f3f139f138e24c84$var$_c; // TODO
var $f3f139f138e24c84$var$providerMethods;
var $f3f139f138e24c84$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $f3f139f138e24c84$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $8AzOm.isSourceInstance)(sourceParam) ? (0, $8AzOm.createSourceFromSeriesDataOption)(sourceParam) : sourceParam; // declare source is Source;
        this._source = source;
        var data = this._data = source.data; // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $f3f139f138e24c84$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $f3f139f138e24c84$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $f3f139f138e24c84$var$providerMethods[$f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $hzBt5.extend)(provider, methods);
            if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $f3f139f138e24c84$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $hzBt5.bind)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $f3f139f138e24c84$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $hzBt5.bind)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $f3f139f138e24c84$var$providerMethods = (_a = {}, _a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_ROW)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $hzBt5.each)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = {
            appendData: appendDataSimply
        }, _a[0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $f3f139f138e24c84$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $f3f139f138e24c84$var$rawSourceItemGetterMap = ($f3f139f138e24c84$var$_a = {}, $f3f139f138e24c84$var$_a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $f3f139f138e24c84$var$_a[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $f3f139f138e24c84$var$_a[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = $f3f139f138e24c84$var$getItemSimply, $f3f139f138e24c84$var$_a[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $f3f139f138e24c84$var$_a[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = $f3f139f138e24c84$var$getItemSimply, $f3f139f138e24c84$var$_a);
function $f3f139f138e24c84$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $f3f139f138e24c84$var$rawSourceItemGetterMap[$f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $f3f139f138e24c84$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $f3f139f138e24c84$var$rawSourceDataCounterMap = ($f3f139f138e24c84$var$_b = {}, $f3f139f138e24c84$var$_b[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $f3f139f138e24c84$var$_b[(0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) + '_' + (0, $8tpV4.SERIES_LAYOUT_BY_ROW)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $f3f139f138e24c84$var$_b[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = $f3f139f138e24c84$var$countSimply, $f3f139f138e24c84$var$_b[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $f3f139f138e24c84$var$_b[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = $f3f139f138e24c84$var$countSimply, $f3f139f138e24c84$var$_b);
function $f3f139f138e24c84$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $f3f139f138e24c84$var$rawSourceDataCounterMap[$f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $f3f139f138e24c84$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $f3f139f138e24c84$var$rawSourceValueGetterMap = ($f3f139f138e24c84$var$_c = {}, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS] = $f3f139f138e24c84$var$getRawValueSimply, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS] = $f3f139f138e24c84$var$getRawValueSimply, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_ORIGINAL] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $ckizb.getDataItemValue)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $f3f139f138e24c84$var$_c[0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY] = $f3f139f138e24c84$var$getRawValueSimply, $f3f139f138e24c84$var$_c);
function $f3f139f138e24c84$export$1752de8084789a14(sourceFormat) {
    var method = $f3f139f138e24c84$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $f3f139f138e24c84$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
function $f3f139f138e24c84$export$cde9373da9aad801(data, dataIndex, // Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
     // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $f3f139f138e24c84$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) result = (0, $ckizb.getDataItemValue)(dataItem);
        return result;
    }
}
function $f3f139f138e24c84$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $8tpV4.SOURCE_FORMAT_ORIGINAL) && sourceFormat !== (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL) && !(0, $hzBt5.isObject)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}

});
parcelRegister("8AzOm", function(module, exports) {

$parcel$export(module.exports, "isSourceInstance", () => $640d76e96b117dfa$export$22b808bc02a60488);
$parcel$export(module.exports, "createSource", () => $640d76e96b117dfa$export$1921362e86c73c88);
$parcel$export(module.exports, "detectSourceFormat", () => $640d76e96b117dfa$export$52a469afa4653e57);
$parcel$export(module.exports, "createSourceFromSeriesDataOption", () => $640d76e96b117dfa$export$75aef3f97c0a5edf);
$parcel$export(module.exports, "cloneSourceShallow", () => $640d76e96b117dfa$export$e0365e7e3555ddd4);
$parcel$export(module.exports, "shouldRetrieveDataByName", () => $640d76e96b117dfa$export$8911336b527f8517);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8tpV4 = parcelRequire("8tpV4");

var $ckizb = parcelRequire("ckizb");

var $be33G = parcelRequire("be33G");
var $640d76e96b117dfa$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $8tpV4.SOURCE_FORMAT_UNKNOWN); // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $be33G.guessOrdinal)(this, i) === (0, $be33G.BE_ORDINAL).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $640d76e96b117dfa$export$22b808bc02a60488(val) {
    return val instanceof $640d76e96b117dfa$var$SourceImpl;
}
function $640d76e96b117dfa$export$1921362e86c73c88(sourceData, thisMetaRawOption, sourceFormat) {
    sourceFormat = sourceFormat || $640d76e96b117dfa$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $640d76e96b117dfa$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $640d76e96b117dfa$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $hzBt5.clone)(thisMetaRawOption)
    });
    return source;
}
function $640d76e96b117dfa$export$75aef3f97c0a5edf(data) {
    return new $640d76e96b117dfa$var$SourceImpl({
        data: data,
        sourceFormat: (0, $hzBt5.isTypedArray)(data) ? (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY) : (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)
    });
}
function $640d76e96b117dfa$export$e0365e7e3555ddd4(source) {
    return new $640d76e96b117dfa$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $hzBt5.clone)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $640d76e96b117dfa$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $8tpV4.SOURCE_FORMAT_UNKNOWN);
    if ((0, $hzBt5.isTypedArray)(data)) sourceFormat = (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY);
    else if ((0, $hzBt5.isArray)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $hzBt5.isArray)(item)) {
                sourceFormat = (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS);
                break;
            } else if ((0, $hzBt5.isObject)(item)) {
                sourceFormat = (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS);
                break;
            }
        }
    } else if ((0, $hzBt5.isObject)(data)) {
        for(var key in data)if ((0, $hzBt5.hasOwn)(data, key) && (0, $hzBt5.isArrayLike)(data[key])) {
            sourceFormat = (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $640d76e96b117dfa$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex; // PEDING: could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $640d76e96b117dfa$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data; // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $640d76e96b117dfa$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $hzBt5.isString)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            } // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $hzBt5.isNumber)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $640d76e96b117dfa$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $8tpV4.SERIES_LAYOUT_BY_ROW) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) {
        if (!dimensionsDefine) dimensionsDefine = $640d76e96b117dfa$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $hzBt5.each)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) {
        var value0 = (0, $ckizb.getDataItemValue)(data[0]);
        dimensionsDetectedCount = (0, $hzBt5.isArray)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $640d76e96b117dfa$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $640d76e96b117dfa$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) {
        var dimensions_1 = [];
        (0, $hzBt5.each)(obj, function(value, key) {
            dimensions_1.push(key);
        });
        return dimensions_1;
    }
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefiend or string.
function $640d76e96b117dfa$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $hzBt5.createHashMap)();
    return (0, $hzBt5.map)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $hzBt5.isObject)(rawItem) ? rawItem : {
            name: rawItem
        }; // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        }; // User can set null in dimensions.
        // We dont auto specify name, othewise a given name may
        // cause it be refered unexpectedly.
        if (item.name == null) return item;
         // Also consider number form like 2012.
        item.name += ''; // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $640d76e96b117dfa$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $8tpV4.SERIES_LAYOUT_BY_ROW)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $640d76e96b117dfa$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS);
}

});
parcelRegister("8tpV4", function(module, exports) {

$parcel$export(module.exports, "VISUAL_DIMENSIONS", () => $62b52338a5a1f9d7$export$cd51b5ca77f6f0e4);
$parcel$export(module.exports, "SOURCE_FORMAT_ORIGINAL", () => $62b52338a5a1f9d7$export$2823037fb9d8f0c6);
$parcel$export(module.exports, "SOURCE_FORMAT_ARRAY_ROWS", () => $62b52338a5a1f9d7$export$fcd62ebf51387903);
$parcel$export(module.exports, "SOURCE_FORMAT_OBJECT_ROWS", () => $62b52338a5a1f9d7$export$703ae8a2d83f441);
$parcel$export(module.exports, "SOURCE_FORMAT_KEYED_COLUMNS", () => $62b52338a5a1f9d7$export$6a32b42c754a3cb8);
$parcel$export(module.exports, "SOURCE_FORMAT_TYPED_ARRAY", () => $62b52338a5a1f9d7$export$a918cb016a382d45);
$parcel$export(module.exports, "SOURCE_FORMAT_UNKNOWN", () => $62b52338a5a1f9d7$export$c78f1330778d30d);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_COLUMN", () => $62b52338a5a1f9d7$export$7b3f3c6551b4949b);
$parcel$export(module.exports, "SERIES_LAYOUT_BY_ROW", () => $62b52338a5a1f9d7$export$d55da1467cdf7804);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $62b52338a5a1f9d7$export$cd51b5ca77f6f0e4 = (0, $hzBt5.createHashMap)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'seriesName'
]);
var $62b52338a5a1f9d7$export$2823037fb9d8f0c6 = 'original';
var $62b52338a5a1f9d7$export$fcd62ebf51387903 = 'arrayRows';
var $62b52338a5a1f9d7$export$703ae8a2d83f441 = 'objectRows';
var $62b52338a5a1f9d7$export$6a32b42c754a3cb8 = 'keyedColumns';
var $62b52338a5a1f9d7$export$a918cb016a382d45 = 'typedArray';
var $62b52338a5a1f9d7$export$c78f1330778d30d = 'unknown';
var $62b52338a5a1f9d7$export$7b3f3c6551b4949b = 'column';
var $62b52338a5a1f9d7$export$d55da1467cdf7804 = 'row';

});

parcelRegister("be33G", function(module, exports) {

$parcel$export(module.exports, "BE_ORDINAL", () => $82c35fde694ebd4c$export$328749e9c5b40760);
$parcel$export(module.exports, "resetSourceDefaulter", () => $82c35fde694ebd4c$export$b30cdea50aa00e6);
$parcel$export(module.exports, "makeSeriesEncodeForAxisCoordSys", () => $82c35fde694ebd4c$export$37682b8fdd2e83d);
$parcel$export(module.exports, "querySeriesUpstreamDatasetModel", () => $82c35fde694ebd4c$export$8da66f73a1eda454);
$parcel$export(module.exports, "makeSeriesEncodeForNameBased", () => $82c35fde694ebd4c$export$60b8a57d1f2fed26);
$parcel$export(module.exports, "queryDatasetUpstreamDatasetModels", () => $82c35fde694ebd4c$export$397ba553479711e7);
$parcel$export(module.exports, "guessOrdinal", () => $82c35fde694ebd4c$export$c51adf1a2be01b9c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $8tpV4 = parcelRequire("8tpV4");
var $82c35fde694ebd4c$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $82c35fde694ebd4c$var$innerGlobalModel = (0, $ckizb.makeInner)();
function $82c35fde694ebd4c$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $82c35fde694ebd4c$var$innerGlobalModel(ecModel).datasetMap = (0, $hzBt5.createHashMap)();
}
function $82c35fde694ebd4c$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $82c35fde694ebd4c$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $82c35fde694ebd4c$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $hzBt5.each)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $hzBt5.isObject)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    }); // TODO
    // Auto detect first time axis and do arrangement.
    (0, $hzBt5.each)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when mutiple series share one dimension
        // category axis, series name should better use
        // the other dimsion name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $82c35fde694ebd4c$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $82c35fde694ebd4c$export$8da66f73a1eda454(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS) || sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS)) (0, $hzBt5.each)(dimensionsDefine, function(dim, idx) {
        if (((0, $hzBt5.isObject)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = []; // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $82c35fde694ebd4c$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $82c35fde694ebd4c$export$328749e9c5b40760.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $82c35fde694ebd4c$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $82c35fde694ebd4c$export$328749e9c5b40760.Not) return idxRes0;
             // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $82c35fde694ebd4c$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ]; // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
        // So we dont set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $82c35fde694ebd4c$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $ckizb.queryReferringComponents)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $ckizb.SINGLE_REFERRING)).models[0];
}
function $82c35fde694ebd4c$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by defualt reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $ckizb.queryReferringComponents)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $ckizb.SINGLE_REFERRING)).models;
}
function $82c35fde694ebd4c$export$c51adf1a2be01b9c(source, dimIndex) {
    return $82c35fde694ebd4c$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $82c35fde694ebd4c$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result; // Experience value.
    var maxLoop = 5;
    if ((0, $hzBt5.isTypedArray)(data)) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
     // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $hzBt5.isObject)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $hzBt5.isString)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $82c35fde694ebd4c$export$328749e9c5b40760.Must : $82c35fde694ebd4c$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $8tpV4.SERIES_LAYOUT_BY_ROW)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) {
        var dataObjectRows = data;
        if (!dimName) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_KEYED_COLUMNS)) {
        var dataKeyedColumns = data;
        if (!dimName) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $hzBt5.isTypedArray)(sample)) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ORIGINAL)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $ckizb.getDataItemValue)(item);
            if (!(0, $hzBt5.isArray)(val)) return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $hzBt5.isString)(val); // Consider usage convenience, '1', '2' will be treated as "number".
        // `isFinit('')` get `true`.
        if (val != null && isFinite(val) && val !== '') return beStr ? $82c35fde694ebd4c$export$328749e9c5b40760.Might : $82c35fde694ebd4c$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $82c35fde694ebd4c$export$328749e9c5b40760.Must;
    }
    return $82c35fde694ebd4c$export$328749e9c5b40760.Not;
}

});



parcelRegister("eNXvv", function(module, exports) {

$parcel$export(module.exports, "summarizeDimensions", () => $ac73cd3093eea71d$export$505a22c3734846f1);
$parcel$export(module.exports, "getDimensionTypeByAxis", () => $ac73cd3093eea71d$export$af1622903e71278e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8tpV4 = parcelRequire("8tpV4");
var $ac73cd3093eea71d$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $ac73cd3093eea71d$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $hzBt5.createHashMap)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $hzBt5.each)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $ac73cd3093eea71d$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($ac73cd3093eea71d$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                 // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $ac73cd3093eea71d$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $8tpV4.VISUAL_DIMENSIONS).each(function(v, otherDim) {
            var encodeArr = $ac73cd3093eea71d$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $hzBt5.map)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
    // in this way. Use label.formatter instead. May be remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $ac73cd3093eea71d$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $ac73cd3093eea71d$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
} // FIXME:TS should be type `AxisType`
function $ac73cd3093eea71d$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $ac73cd3093eea71d$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }

});

parcelRegister("3JGxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b869261fc396a82$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $2b869261fc396a82$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $hzBt5.extend(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $2b869261fc396a82$export$2e2bcd8739ae039 = $2b869261fc396a82$var$SeriesDimensionDefine;

});

parcelRegister("6Bzg6", function(module, exports) {

$parcel$export(module.exports, "CtorInt32Array", () => $4cf18c6cfc4197e3$export$b60d945128546f53);
$parcel$export(module.exports, "default", () => $4cf18c6cfc4197e3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $fJfRY = parcelRequire("fJfRY");

var $8AzOm = parcelRequire("8AzOm");
var $4cf18c6cfc4197e3$var$UNDEFINED = 'undefined';
var $4cf18c6cfc4197e3$export$859a1fa4f1106aa0 = typeof Uint32Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Uint32Array;
var $4cf18c6cfc4197e3$export$78cf73566f32c185 = typeof Uint16Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Uint16Array;
var $4cf18c6cfc4197e3$export$b60d945128546f53 = typeof Int32Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Int32Array;
var $4cf18c6cfc4197e3$export$365b104db51a490a = typeof Float64Array === $4cf18c6cfc4197e3$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $4cf18c6cfc4197e3$var$dataCtors = {
    'float': $4cf18c6cfc4197e3$export$365b104db51a490a,
    'int': $4cf18c6cfc4197e3$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $4cf18c6cfc4197e3$export$365b104db51a490a
};
var $4cf18c6cfc4197e3$var$defaultDimValueGetters;
function $4cf18c6cfc4197e3$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $4cf18c6cfc4197e3$export$859a1fa4f1106aa0 : $4cf18c6cfc4197e3$export$78cf73566f32c185;
}
function $4cf18c6cfc4197e3$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $4cf18c6cfc4197e3$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $4cf18c6cfc4197e3$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $4cf18c6cfc4197e3$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end); // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $4cf18c6cfc4197e3$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = []; // It will not be calculated util needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $hzBt5.createHashMap)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider; // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $4cf18c6cfc4197e3$var$defaultDimValueGetters[source.sourceFormat]; // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter; // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $8AzOm.shouldRetrieveDataByName)(source);
        this._dimensions = (0, $hzBt5.map)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $4cf18c6cfc4197e3$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $4cf18c6cfc4197e3$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $4cf18c6cfc4197e3$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx]; // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
            dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $4cf18c6cfc4197e3$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start; // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $4cf18c6cfc4197e3$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $hzBt5.map)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $4cf18c6cfc4197e3$var$getInitialExtent();
            $4cf18c6cfc4197e3$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem); // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx]; // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end; // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions; // TODO get all from store?
            dimensions = []; // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = []; // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        }); // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count(); // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retreive the index with given raw data index
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
         // Indices are ascending
        var indices = this._indices; // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retreive the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we chose the one that `diff >= 0` in this csae.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $4cf18c6cfc4197e3$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $4cf18c6cfc4197e3$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i); // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        } // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $hzBt5.keys)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $4cf18c6cfc4197e3$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i]; // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex]; // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex]; // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        } // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset; // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    }; // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $4cf18c6cfc4197e3$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($4cf18c6cfc4197e3$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) + 2); // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart; // Find a point from current frame that construct a triangel with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                 // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        } // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $4cf18c6cfc4197e3$var$getInitialExtent();
        var newIndices = new ($4cf18c6cfc4197e3$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1)); // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i); // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                     // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $4cf18c6cfc4197e3$var$getInitialExtent();
        if (!dimData) return initialExtent;
         // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count(); // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $hzBt5.reduce)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $4cf18c6cfc4197e3$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $hzBt5.clone)(this._extent);
        target._rawExtent = (0, $hzBt5.clone)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $fJfRY.parseDataValue)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $4cf18c6cfc4197e3$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $fJfRY.parseDataValue)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $fJfRY.parseDataValue)(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
                 : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $4cf18c6cfc4197e3$export$2e2bcd8739ae039 = $4cf18c6cfc4197e3$var$DataStore;

});
parcelRegister("fJfRY", function(module, exports) {

$parcel$export(module.exports, "parseDataValue", () => $b7375e5792a781ae$export$cc7175145baad076);
$parcel$export(module.exports, "getRawValueParser", () => $b7375e5792a781ae$export$c88237b7c265b36b);
$parcel$export(module.exports, "SortOrderComparator", () => $b7375e5792a781ae$export$ed75a5d7b0144167);
$parcel$export(module.exports, "createFilterComparator", () => $b7375e5792a781ae$export$f2644c3485f94c4e);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

var $hzBt5 = parcelRequire("hzBt5");

var $6ds7H = parcelRequire("6ds7H");
function $b7375e5792a781ae$export$cc7175145baad076(value, opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' // spead up when using timestamp
     && typeof value !== 'number' && value != null && value !== '-') value = +(0, $5BQXp.parseDate)(value);
     // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
     : +value;
}
var $b7375e5792a781ae$var$valueParserMap = (0, $hzBt5.createHashMap)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have by defualt `numericToNumber`.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $5BQXp.parseDate)(val);
    },
    'trim': function(val) {
        return typeof val === 'string' ? (0, $hzBt5.trim)(val) : val;
    }
});
function $b7375e5792a781ae$export$c88237b7c265b36b(type) {
    return $b7375e5792a781ae$var$valueParserMap.get(type);
}
var $b7375e5792a781ae$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $b7375e5792a781ae$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (typeof rval !== 'number') {
            var errMsg = '';
            (0, $6ds7H.throwError)(errMsg);
        }
        this._opFn = $b7375e5792a781ae$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $5BQXp.numericToNumber)(rval);
    } // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return typeof lval === 'number' ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $5BQXp.numericToNumber)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $b7375e5792a781ae$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by defualt: 'asc'
   * @param incomparable by defualt: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE]
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    } // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalTypeof = typeof lval;
        var rvalTypeof = typeof rval;
        var lvalFloat = lvalTypeof === 'number' ? lval : (0, $5BQXp.numericToNumber)(lval);
        var rvalFloat = rvalTypeof === 'number' ? rval : (0, $5BQXp.numericToNumber)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = lvalTypeof === 'string';
            var rvalIsStr = rvalTypeof === 'string';
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $b7375e5792a781ae$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $5BQXp.numericToNumber)(rval);
    } // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $5BQXp.numericToNumber)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $b7375e5792a781ae$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $b7375e5792a781ae$var$FilterEqualityComparator(op === 'eq', rval) : (0, $hzBt5.hasOwn)($b7375e5792a781ae$var$ORDER_COMPARISON_OP_MAP, op) ? new $b7375e5792a781ae$var$FilterOrderComparator(op, rval) : null;
}

});
parcelRegister("6ds7H", function(module, exports) {

$parcel$export(module.exports, "warn", () => $4869c5acb29c5c18$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "error", () => $4869c5acb29c5c18$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "deprecateLog", () => $4869c5acb29c5c18$export$4a9c0b74eb885aa1);
$parcel$export(module.exports, "throwError", () => $4869c5acb29c5c18$export$8bf7aba4a9e09055);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4869c5acb29c5c18$var$ECHARTS_PREFIX = '[ECharts] ';
var $4869c5acb29c5c18$var$storedLogs = {};
var $4869c5acb29c5c18$var$hasConsole = typeof console !== 'undefined' // eslint-disable-next-line
 && console.warn && console.log;
function $4869c5acb29c5c18$export$bef1f36f5486a6a3(str) {
    if ($4869c5acb29c5c18$var$hasConsole) // eslint-disable-next-line
    console.log($4869c5acb29c5c18$var$ECHARTS_PREFIX + str);
}
function $4869c5acb29c5c18$export$c106dd0671a0fc2d(str) {
    if ($4869c5acb29c5c18$var$hasConsole) console.warn($4869c5acb29c5c18$var$ECHARTS_PREFIX + str);
}
function $4869c5acb29c5c18$export$a3bc9b8ed74fc(str) {
    if ($4869c5acb29c5c18$var$hasConsole) console.error($4869c5acb29c5c18$var$ECHARTS_PREFIX + str);
}
function $4869c5acb29c5c18$export$4a9c0b74eb885aa1(str) {}
function $4869c5acb29c5c18$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $4869c5acb29c5c18$export$c3747c611a35af25() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
}
function $4869c5acb29c5c18$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $4869c5acb29c5c18$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}

});



parcelRegister("kJQdt", function(module, exports) {

$parcel$export(module.exports, "SeriesDataSchema", () => $f19083ac152d0db4$export$a1ef064685775f3e);
$parcel$export(module.exports, "ensureSourceDimNameMap", () => $f19083ac152d0db4$export$be39ae17310c33f7);
$parcel$export(module.exports, "shouldOmitUnusedDimensions", () => $f19083ac152d0db4$export$238b87930d825d87);
$parcel$export(module.exports, "isSeriesDataSchema", () => $f19083ac152d0db4$export$fafbc856132a3a0e);
$parcel$export(module.exports, "createDimNameMap", () => $f19083ac152d0db4$export$a477f5bebfd07944);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $8AzOm = parcelRequire("8AzOm");
var $f19083ac152d0db4$var$inner = (0, $ckizb.makeInner)();
var $f19083ac152d0db4$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $f19083ac152d0db4$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $f19083ac152d0db4$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $hzBt5.retrieve2)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $8AzOm.shouldRetrieveDataByName)(this.source);
        var makeHashStrict = !$f19083ac152d0db4$export$238b87930d825d87(dimCount); // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            }); // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Becuase in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null // For data stack, we have make sure each series has its own dim on this store.
             && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict // Use escape character '`' in case that property name contains '$'.
             ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') // For better performance, when there are large dimensions, tolerant this defects that hardly meet.
             : property;
            dimHash += '$';
            dimHash += $f19083ac152d0db4$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        } // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++; // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $f19083ac152d0db4$export$fafbc856132a3a0e(schema) {
    return schema instanceof $f19083ac152d0db4$export$a1ef064685775f3e;
}
function $f19083ac152d0db4$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $hzBt5.createHashMap)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $hzBt5.isObject)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $f19083ac152d0db4$export$be39ae17310c33f7(source) {
    var innerSource = $f19083ac152d0db4$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $f19083ac152d0db4$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $f19083ac152d0db4$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}

});


parcelRegister("jrSv6", function(module, exports) {

$parcel$export(module.exports, "createDimensions", () => $e28ad0a468fa8898$export$8066c1b52b2e9504);
$parcel$export(module.exports, "default", () => $e28ad0a468fa8898$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8tpV4 = parcelRequire("8tpV4");

var $3JGxt = parcelRequire("3JGxt");

var $hzBt5 = parcelRequire("hzBt5");

var $8AzOm = parcelRequire("8AzOm");

var $6Bzg6 = parcelRequire("6Bzg6");

var $ckizb = parcelRequire("ckizb");

var $be33G = parcelRequire("be33G");

var $kJQdt = parcelRequire("kJQdt");
function $e28ad0a468fa8898$export$8066c1b52b2e9504(source, opt) {
    return $e28ad0a468fa8898$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $e28ad0a468fa8898$export$2e2bcd8739ae039(source, opt) {
    if (!(0, $8AzOm.isSourceInstance)(source)) source = (0, $8AzOm.createSourceFromSeriesDataOption)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $hzBt5.createHashMap)();
    var resultList = [];
    var dimCount = $e28ad0a468fa8898$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount); // Try to ignore unsed dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $kJQdt.shouldOmitUnusedDimensions)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $kJQdt.ensureSourceDimNameMap)(source) : (0, $kJQdt.createDimNameMap)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $hzBt5.createHashMap)(encodeDef);
    var indicesMap = new (0, $6Bzg6.CtorInt32Array)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $hzBt5.isObject)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $3JGxt.default)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be diplayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
     // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $ckizb.normalizeToArray)(dataDimsRaw).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $hzBt5.isString)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $hzBt5.each)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $hzBt5.isString)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    }); // Apply templetes and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $hzBt5.each)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $hzBt5.isString)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $hzBt5.extend)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim); // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $ckizb.normalizeToArray)(dataDims); // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
         // Apply templates.
        (0, $hzBt5.each)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx); // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $hzBt5.defaults)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $hzBt5.isObject)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $hzBt5.defaults)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $8tpV4.VISUAL_DIMENSIONS).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    } // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    } // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $e28ad0a468fa8898$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0; // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $be33G.guessOrdinal)(source, resultDimIdx) === (0, $be33G.BE_ORDINAL).Must // Consider the case:
         || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $hzBt5.each)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        }); // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $e28ad0a468fa8898$var$removeDuplication(resultList);
    return new (0, $kJQdt.SeriesDataSchema)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $e28ad0a468fa8898$var$removeDuplication(result) {
    var duplicationMap = (0, $hzBt5.createHashMap)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calcualte bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $e28ad0a468fa8898$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $hzBt5.each)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $hzBt5.isObject)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $e28ad0a468fa8898$var$genCoordDimName(name, map, fromZero) {
    var mapData = map.data;
    if (fromZero || mapData.hasOwnProperty(name)) {
        var i = 0;
        while(mapData.hasOwnProperty(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}

});

parcelRegister("gwjrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06eb7162ee6d39e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $c06eb7162ee6d39e$var$coordinateSystemCreators = {};
var $c06eb7162ee6d39e$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $hzBt5.each($c06eb7162ee6d39e$var$coordinateSystemCreators, function(creater, type) {
            var list = creater.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $hzBt5.each(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $c06eb7162ee6d39e$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $c06eb7162ee6d39e$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $c06eb7162ee6d39e$export$2e2bcd8739ae039 = $c06eb7162ee6d39e$var$CoordinateSystemManager;

});

parcelRegister("6LGi5", function(module, exports) {

$parcel$export(module.exports, "getCoordSysInfoBySeries", () => $4ed7efe73ca3066c$export$f2befeb2f4933656);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".

var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $4ed7efe73ca3066c$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $hzBt5.createHashMap)();
        this.categoryAxisMap = (0, $hzBt5.createHashMap)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $4ed7efe73ca3066c$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $4ed7efe73ca3066c$var$CoordSysInfo(coordSysName);
    var fetch = $4ed7efe73ca3066c$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $4ed7efe73ca3066c$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($4ed7efe73ca3066c$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($4ed7efe73ca3066c$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($4ed7efe73ca3066c$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($4ed7efe73ca3066c$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($4ed7efe73ca3066c$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $hzBt5.each)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($4ed7efe73ca3066c$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $4ed7efe73ca3066c$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}

});

parcelRegister("lljDt", function(module, exports) {

$parcel$export(module.exports, "enableDataStack", () => $f89aca61ae1a2e7b$export$f2165f9e8499b278);
$parcel$export(module.exports, "isDimensionStacked", () => $f89aca61ae1a2e7b$export$1dedc39359ae35c);
$parcel$export(module.exports, "getStackedDimension", () => $f89aca61ae1a2e7b$export$909db2be4938fbdf);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $kJQdt = parcelRequire("kJQdt");
function $f89aca61ae1a2e7b$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($f89aca61ae1a2e7b$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    } // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $hzBt5.each)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $hzBt5.isString)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
             // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
     // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id; // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $hzBt5.each)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $f89aca61ae1a2e7b$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $kJQdt.isSeriesDataSchema)(dimensionsInput.schema);
}
function $f89aca61ae1a2e7b$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $f89aca61ae1a2e7b$export$909db2be4938fbdf(data, targetDim) {
    return $f89aca61ae1a2e7b$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

});


parcelRegister("5vVec", function(module, exports) {

$parcel$export(module.exports, "SERIES_UNIVERSAL_TRANSITION_PROP", () => $403c3d48f4c3b330$export$e960441116ae2799);
$parcel$export(module.exports, "default", () => $403c3d48f4c3b330$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $ckizb = parcelRequire("ckizb");

var $6IEE1 = parcelRequire("6IEE1");

var $b7fr8 = parcelRequire("b7fr8");

var $93uXC = parcelRequire("93uXC");

var $e4mIu = parcelRequire("e4mIu");

var $bw304 = parcelRequire("bw304");

var $jKrBG = parcelRequire("jKrBG");

var $kNy1J = parcelRequire("kNy1J");

var $4OBOS = parcelRequire("4OBOS");
var $403c3d48f4c3b330$var$inner = $ckizb.makeInner();
function $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $403c3d48f4c3b330$export$e960441116ae2799 = '__universalTransitionEnabled';
var $403c3d48f4c3b330$var$SeriesModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Becuase this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this; // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $bw304.createTask)({
            count: $403c3d48f4c3b330$var$dataTaskCount,
            reset: $403c3d48f4c3b330$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $403c3d48f4c3b330$var$inner(this).sourceManager = new (0, $kNy1J.SourceManager)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $403c3d48f4c3b330$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $403c3d48f4c3b330$var$inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $403c3d48f4c3b330$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $e4mIu.fetchLayoutMode)(this);
        var inputPositionParams = layoutMode ? (0, $e4mIu.getLayoutParams)(option) : {}; // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $6IEE1.default).hasClass(themeSubType)) themeSubType += 'Series';
        $hzBt5.merge(option, ecModel.getTheme().get(this.subType));
        $hzBt5.merge(option, this.getDefaultOption()); // Default label emphasis `show`
        $ckizb.defaultEmphasis(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $e4mIu.mergeLayoutParam)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $hzBt5.merge(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $e4mIu.fetchLayoutMode)(this);
        if (layoutMode) (0, $e4mIu.mergeLayoutParam)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $403c3d48f4c3b330$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $403c3d48f4c3b330$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $403c3d48f4c3b330$var$inner(this).dataBeforeProcessed = data;
        $403c3d48f4c3b330$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$hzBt5.isTypedArray(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $ckizb.defaultEmphasis(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overriden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $403c3d48f4c3b330$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $403c3d48f4c3b330$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $403c3d48f4c3b330$var$getCurrentTask(this);
        if (task) {
            var context = task.context; // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data; // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $403c3d48f4c3b330$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $hzBt5.createHashMap(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $403c3d48f4c3b330$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $403c3d48f4c3b330$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overrided for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem; // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $4OBOS.defaultSeriesFormatTooltip)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        if ((0, $gZXYp.default).node) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel; // PENDING
        var color = (0, $b7fr8.PaletteMixin).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    }; // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var data = this.getData(dataType);
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $hzBt5.keys(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex);
        return selectedMap[nameOrId] || false;
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$403c3d48f4c3b330$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition; // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
         // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var selectedMode = this.option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'multiple') {
            var selectedMap = this.option.selectedMap || (this.option.selectedMap = {});
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i]; // TODO diffrent types of data share same object.
                var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $403c3d48f4c3b330$var$getSelectionKey(data, lastDataIndex);
            this.option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    }; // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $6IEE1.default).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle'; // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $6IEE1.default));
$hzBt5.mixin($403c3d48f4c3b330$var$SeriesModel, (0, $93uXC.DataFormatMixin));
$hzBt5.mixin($403c3d48f4c3b330$var$SeriesModel, (0, $b7fr8.PaletteMixin));
(0, $jKrBG.mountExtend)($403c3d48f4c3b330$var$SeriesModel, (0, $6IEE1.default));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $403c3d48f4c3b330$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$ckizb.isNameSpecified(seriesModel)) seriesModel.name = $403c3d48f4c3b330$var$getSeriesAutoName(seriesModel) || name;
}
function $403c3d48f4c3b330$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $hzBt5.each(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $403c3d48f4c3b330$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $403c3d48f4c3b330$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $403c3d48f4c3b330$var$dataTaskProgress;
}
function $403c3d48f4c3b330$var$dataTaskProgress(param, context) {
    // Avoid repead cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
} // TODO refactor
function $403c3d48f4c3b330$var$wrapData(data, seriesModel) {
    $hzBt5.each($hzBt5.concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $hzBt5.curry($403c3d48f4c3b330$var$onDataChange, seriesModel));
    });
}
function $403c3d48f4c3b330$var$onDataChange(seriesModel, newList) {
    var task = $403c3d48f4c3b330$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $403c3d48f4c3b330$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $403c3d48f4c3b330$export$2e2bcd8739ae039 = $403c3d48f4c3b330$var$SeriesModel;

});
parcelRegister("6IEE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e46614b9b2e23c5$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $fR3z1 = parcelRequire("fR3z1");

var $9aOrz = parcelRequire("9aOrz");

var $jKrBG = parcelRequire("jKrBG");

var $ckizb = parcelRequire("ckizb");

var $e4mIu = parcelRequire("e4mIu");
var $4e46614b9b2e23c5$var$inner = (0, $ckizb.makeInner)();
var $4e46614b9b2e23c5$var$ComponentModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $9aOrz.getUID('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $e4mIu.fetchLayoutMode(this);
        var inputPositionParams = layoutMode ? $e4mIu.getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        $hzBt5.merge(option, themeModel.get(this.mainType));
        $hzBt5.merge(option, this.getDefaultOption());
        if (layoutMode) $e4mIu.mergeLayoutParam(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $hzBt5.merge(this.option, option, true);
        var layoutMode = $e4mIu.fetchLayoutMode(this);
        if (layoutMode) $e4mIu.mergeLayoutParam(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component';
   * import {XxxModel, XxxOption} from './XxxModel';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor; // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $jKrBG.isExtendedClass)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
         // FIXME: remove this approach?
        var fields = $4e46614b9b2e23c5$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $hzBt5.merge(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $ckizb.queryReferringComponents)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get('left'),
            top: boxLayoutModel.get('top'),
            right: boxLayoutModel.get('right'),
            bottom: boxLayoutModel.get('bottom'),
            width: boxLayoutModel.get('width'),
            height: boxLayoutModel.get('height')
        };
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $fR3z1.default));
(0, $jKrBG.mountExtend)($4e46614b9b2e23c5$var$ComponentModel, (0, $fR3z1.default));
(0, $jKrBG.enableClassManagement)($4e46614b9b2e23c5$var$ComponentModel);
$9aOrz.enableSubTypeDefaulter($4e46614b9b2e23c5$var$ComponentModel);
$9aOrz.enableTopologicalTravel($4e46614b9b2e23c5$var$ComponentModel, $4e46614b9b2e23c5$var$getDependencies);
function $4e46614b9b2e23c5$var$getDependencies(componentType) {
    var deps = [];
    $hzBt5.each($4e46614b9b2e23c5$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    }); // Ensure main type.
    deps = $hzBt5.map(deps, function(type) {
        return (0, $jKrBG.parseClassType)(type).main;
    }); // Hack dataset for convenience.
    if (componentType !== 'dataset' && $hzBt5.indexOf(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $4e46614b9b2e23c5$export$2e2bcd8739ae039 = $4e46614b9b2e23c5$var$ComponentModel;

});
parcelRegister("9aOrz", function(module, exports) {

$parcel$export(module.exports, "getUID", () => $6adc2d455c74fe49$export$6d2b3473b0986646);
$parcel$export(module.exports, "enableSubTypeDefaulter", () => $6adc2d455c74fe49$export$b9faf30b7d655a6f);
$parcel$export(module.exports, "enableTopologicalTravel", () => $6adc2d455c74fe49$export$ce592d345a3ec040);
$parcel$export(module.exports, "inheritDefaultOption", () => $6adc2d455c74fe49$export$68acc510e46fef2);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $jKrBG = parcelRequire("jKrBG");

var $6adc2d455c74fe49$var$base = Math.round(Math.random() * 10);
function $6adc2d455c74fe49$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $6adc2d455c74fe49$var$base++
    ].join('_');
}
function $6adc2d455c74fe49$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $jKrBG.parseClassType)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $jKrBG.parseClassType)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $6adc2d455c74fe49$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $hzBt5.each(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $hzBt5.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $hzBt5.each(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        } // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $hzBt5.each(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $hzBt5.each(availableDeps, function(dependentName) {
                if ($hzBt5.indexOf(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($hzBt5.indexOf(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $hzBt5.each(originalDeps, function(dep) {
            $hzBt5.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $6adc2d455c74fe49$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $hzBt5.merge($hzBt5.merge({}, superOption, true), subOption, true);
}

});

parcelRegister("e4mIu", function(module, exports) {

$parcel$export(module.exports, "LOCATION_PARAMS", () => $a3e30f76c81a3bfd$export$a9aa2cc018afbed);
$parcel$export(module.exports, "box", () => $a3e30f76c81a3bfd$export$827f4ee28efc37);
$parcel$export(module.exports, "getAvailableSize", () => $a3e30f76c81a3bfd$export$145a8938a85a22b1);
$parcel$export(module.exports, "getLayoutRect", () => $a3e30f76c81a3bfd$export$4517a5ca639a7293);
$parcel$export(module.exports, "positionElement", () => $a3e30f76c81a3bfd$export$74054bd96b5eeef1);
$parcel$export(module.exports, "sizeCalculable", () => $a3e30f76c81a3bfd$export$7ede609e8ebc9650);
$parcel$export(module.exports, "fetchLayoutMode", () => $a3e30f76c81a3bfd$export$3968a28a7cbd6063);
$parcel$export(module.exports, "mergeLayoutParam", () => $a3e30f76c81a3bfd$export$1754cb91f16ca028);
$parcel$export(module.exports, "getLayoutParams", () => $a3e30f76c81a3bfd$export$4b0d20af19c9875e);
$parcel$export(module.exports, "copyLayoutParams", () => $a3e30f76c81a3bfd$export$7438999faea9b6cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning

var $hzBt5 = parcelRequire("hzBt5");

var $lGSv6 = parcelRequire("lGSv6");

var $5BQXp = parcelRequire("5BQXp");

var $gyplX = parcelRequire("gyplX");
var $a3e30f76c81a3bfd$var$each = $hzBt5.each;
var $a3e30f76c81a3bfd$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $a3e30f76c81a3bfd$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $a3e30f76c81a3bfd$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $a3e30f76c81a3bfd$export$827f4ee28efc37 = $a3e30f76c81a3bfd$var$boxLayout;
var $a3e30f76c81a3bfd$export$be20d9158c17374c = $hzBt5.curry($a3e30f76c81a3bfd$var$boxLayout, 'vertical');
var $a3e30f76c81a3bfd$export$ae65a483d943e7a7 = $hzBt5.curry($a3e30f76c81a3bfd$var$boxLayout, 'horizontal');
function $a3e30f76c81a3bfd$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $5BQXp.parsePercent)(positionInfo.left, containerWidth);
    var y = (0, $5BQXp.parsePercent)(positionInfo.top, containerHeight);
    var x2 = (0, $5BQXp.parsePercent)(positionInfo.right, containerWidth);
    var y2 = (0, $5BQXp.parsePercent)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $gyplX.normalizeCssArray(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $a3e30f76c81a3bfd$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $gyplX.normalizeCssArray(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $5BQXp.parsePercent)(positionInfo.left, containerWidth);
    var top = (0, $5BQXp.parsePercent)(positionInfo.top, containerHeight);
    var right = (0, $5BQXp.parsePercent)(positionInfo.right, containerWidth);
    var bottom = (0, $5BQXp.parsePercent)(positionInfo.bottom, containerHeight);
    var width = (0, $5BQXp.parsePercent)(positionInfo.width, containerWidth);
    var height = (0, $5BQXp.parsePercent)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        } // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    } // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
     // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    } // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $lGSv6.default)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $a3e30f76c81a3bfd$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    if (!h && !v) return;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $lGSv6.default)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    } // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $a3e30f76c81a3bfd$export$4517a5ca639a7293($hzBt5.defaults({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        el.x = dx;
        el.y = dy;
    } else {
        el.x += dx;
        el.y += dy;
    }
    el.markRedraw();
}
function $a3e30f76c81a3bfd$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$a3e30f76c81a3bfd$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$a3e30f76c81a3bfd$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$a3e30f76c81a3bfd$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $a3e30f76c81a3bfd$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $hzBt5.isObject(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $a3e30f76c81a3bfd$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$hzBt5.isArray(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($a3e30f76c81a3bfd$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($a3e30f76c81a3bfd$export$d7fd4338c7b20804[1], 1);
    copy($a3e30f76c81a3bfd$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($a3e30f76c81a3bfd$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $a3e30f76c81a3bfd$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $a3e30f76c81a3bfd$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        } // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $a3e30f76c81a3bfd$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $a3e30f76c81a3bfd$export$4b0d20af19c9875e(source) {
    return $a3e30f76c81a3bfd$export$7438999faea9b6cc({}, source);
}
function $a3e30f76c81a3bfd$export$7438999faea9b6cc(target, source) {
    source && target && $a3e30f76c81a3bfd$var$each($a3e30f76c81a3bfd$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}

});
parcelRegister("gyplX", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => $c0d37cf36ea6f267$export$b6fe44657ce35c42);
$parcel$export(module.exports, "toCamelCase", () => $c0d37cf36ea6f267$export$86f54f62aa7a7514);
$parcel$export(module.exports, "normalizeCssArray", () => $c0d37cf36ea6f267$export$f3a38102c49f4268);
$parcel$export(module.exports, "encodeHTML", () => $c0d37cf36ea6f267$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "makeValueReadable", () => $c0d37cf36ea6f267$export$3cd8db88714decfc);
$parcel$export(module.exports, "formatTpl", () => $c0d37cf36ea6f267$export$2028496a35766e41);
$parcel$export(module.exports, "formatTplSimple", () => $c0d37cf36ea6f267$export$2fa08233ee42f8e1);
$parcel$export(module.exports, "getTooltipMarker", () => $c0d37cf36ea6f267$export$1987a3dbdf3c45ca);
$parcel$export(module.exports, "formatTime", () => $c0d37cf36ea6f267$export$3203edd9e5edd663);
$parcel$export(module.exports, "capitalFirst", () => $c0d37cf36ea6f267$export$38a1e7552f497c0e);
$parcel$export(module.exports, "convertToColorString", () => $c0d37cf36ea6f267$export$cda04d03233e5555);
$parcel$export(module.exports, "windowOpen", () => $c0d37cf36ea6f267$export$13e13f9b96dbe8fa);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $24InP = parcelRequire("24InP");


var $h0yya = parcelRequire("h0yya");

var $iluMW = parcelRequire("iluMW");
function $c0d37cf36ea6f267$export$b6fe44657ce35c42(x) {
    if (!(0, $5BQXp.isNumeric)(x)) return $hzBt5.isString(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $c0d37cf36ea6f267$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $c0d37cf36ea6f267$export$f3a38102c49f4268 = $hzBt5.normalizeCssArray;
var $c0d37cf36ea6f267$var$replaceReg = /([&<>"'])/g;
var $c0d37cf36ea6f267$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $c0d37cf36ea6f267$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($c0d37cf36ea6f267$var$replaceReg, function(str, c) {
        return $c0d37cf36ea6f267$var$replaceMap[c];
    });
}
function $c0d37cf36ea6f267$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {hh}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $hzBt5.trim(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $5BQXp.parseDate)(value) : value;
        if (!isNaN(+date)) return (0, $24InP.format)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
         // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $hzBt5.isStringSafe(value) ? stringToUserReadable(value) : $hzBt5.isNumber(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
     // By default.
    var numericResult = (0, $5BQXp.numericToNumber)(value);
    return isNumberUserReadable(numericResult) ? $c0d37cf36ea6f267$export$b6fe44657ce35c42(numericResult) : $hzBt5.isStringSafe(value) ? stringToUserReadable(value) : '-';
}
var $c0d37cf36ea6f267$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $c0d37cf36ea6f267$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $c0d37cf36ea6f267$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$hzBt5.isArray(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $c0d37cf36ea6f267$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($c0d37cf36ea6f267$var$wrapVar(alias), $c0d37cf36ea6f267$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($c0d37cf36ea6f267$var$wrapVar($c0d37cf36ea6f267$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? $c0d37cf36ea6f267$export$f9d6449b9af28dc1(val) : val);
    }
    return tpl;
}
function $c0d37cf36ea6f267$export$2fa08233ee42f8e1(tpl, param, encode) {
    $hzBt5.each(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? $c0d37cf36ea6f267$export$f9d6449b9af28dc1(value) : value);
    });
    return tpl;
}
function $c0d37cf36ea6f267$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $hzBt5.isString(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' // Only support string
     + $c0d37cf36ea6f267$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + $c0d37cf36ea6f267$export$f9d6449b9af28dc1(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $c0d37cf36ea6f267$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $5BQXp.parseDate)(value);
    var utc = isUTC ? 'UTC' : '';
    var y = date['get' + utc + 'FullYear']();
    var M = date['get' + utc + 'Month']() + 1;
    var d = date['get' + utc + 'Date']();
    var h = date['get' + utc + 'Hours']();
    var m = date['get' + utc + 'Minutes']();
    var s = date['get' + utc + 'Seconds']();
    var S = date['get' + utc + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $24InP.pad)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100 + '').replace('dd', (0, $24InP.pad)(d, 2)).replace('d', d).replace('hh', (0, $24InP.pad)(h, 2)).replace('h', h).replace('mm', (0, $24InP.pad)(m, 2)).replace('m', m).replace('ss', (0, $24InP.pad)(s, 2)).replace('s', s).replace('SSS', (0, $24InP.pad)(S, 3));
    return tpl;
}
function $c0d37cf36ea6f267$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $c0d37cf36ea6f267$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $hzBt5.isString(color) ? color : $hzBt5.isObject(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $c0d37cf36ea6f267$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}

});
parcelRegister("24InP", function(module, exports) {

$parcel$export(module.exports, "ONE_SECOND", () => $182e621785d53987$export$32c0454ceff7f92d);
$parcel$export(module.exports, "ONE_MINUTE", () => $182e621785d53987$export$35acaebf644db34e);
$parcel$export(module.exports, "ONE_HOUR", () => $182e621785d53987$export$82541edf19e5e3b0);
$parcel$export(module.exports, "ONE_DAY", () => $182e621785d53987$export$a97a1358cbb650ab);
$parcel$export(module.exports, "ONE_YEAR", () => $182e621785d53987$export$99cafda57477293d);
$parcel$export(module.exports, "fullLeveledFormatter", () => $182e621785d53987$export$445bdbd8d2334e40);
$parcel$export(module.exports, "timeUnits", () => $182e621785d53987$export$833c398a55654bb7);
$parcel$export(module.exports, "pad", () => $182e621785d53987$export$5d04458e2a6c373e);
$parcel$export(module.exports, "getPrimaryTimeUnit", () => $182e621785d53987$export$1da4b91a25d7e1c8);
$parcel$export(module.exports, "isPrimaryTimeUnit", () => $182e621785d53987$export$beb5920b69c13da);
$parcel$export(module.exports, "getDefaultFormatPrecisionOfInterval", () => $182e621785d53987$export$124c820721c4f66b);
$parcel$export(module.exports, "format", () => $182e621785d53987$export$d9468344d3651243);
$parcel$export(module.exports, "fullYearGetterName", () => $182e621785d53987$export$8d046fefed9a548e);
$parcel$export(module.exports, "monthGetterName", () => $182e621785d53987$export$5c242a801a23eec7);
$parcel$export(module.exports, "dateGetterName", () => $182e621785d53987$export$4189e6cbc9753260);
$parcel$export(module.exports, "hoursGetterName", () => $182e621785d53987$export$8b40b55b3c06cbe2);
$parcel$export(module.exports, "minutesGetterName", () => $182e621785d53987$export$8807847c5c71eded);
$parcel$export(module.exports, "secondsGetterName", () => $182e621785d53987$export$8f49e73e2eebd168);
$parcel$export(module.exports, "millisecondsGetterName", () => $182e621785d53987$export$312207a92d041116);
$parcel$export(module.exports, "leveledFormat", () => $182e621785d53987$export$fe777b6293828b5d);
$parcel$export(module.exports, "getUnitValue", () => $182e621785d53987$export$e04e41a1e24ffd3f);
$parcel$export(module.exports, "fullYearSetterName", () => $182e621785d53987$export$43fbeac90913b151);
$parcel$export(module.exports, "monthSetterName", () => $182e621785d53987$export$233f59998ed71c09);
$parcel$export(module.exports, "dateSetterName", () => $182e621785d53987$export$82fd379a67f37fa0);
$parcel$export(module.exports, "hoursSetterName", () => $182e621785d53987$export$b6f943e8d23c15bb);
$parcel$export(module.exports, "minutesSetterName", () => $182e621785d53987$export$50303078793fc7d);
$parcel$export(module.exports, "secondsSetterName", () => $182e621785d53987$export$a4a908acda9c3118);
$parcel$export(module.exports, "millisecondsSetterName", () => $182e621785d53987$export$c047afab75f6d84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $6FMoP = parcelRequire("6FMoP");

var $fR3z1 = parcelRequire("fR3z1");
var $182e621785d53987$export$32c0454ceff7f92d = 1000;
var $182e621785d53987$export$35acaebf644db34e = $182e621785d53987$export$32c0454ceff7f92d * 60;
var $182e621785d53987$export$82541edf19e5e3b0 = $182e621785d53987$export$35acaebf644db34e * 60;
var $182e621785d53987$export$a97a1358cbb650ab = $182e621785d53987$export$82541edf19e5e3b0 * 24;
var $182e621785d53987$export$99cafda57477293d = $182e621785d53987$export$a97a1358cbb650ab * 365;
var $182e621785d53987$export$f7854271ddbda64e = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}',
    none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var $182e621785d53987$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $182e621785d53987$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $182e621785d53987$var$fullDayFormatter,
    hour: $182e621785d53987$var$fullDayFormatter + ' ' + $182e621785d53987$export$f7854271ddbda64e.hour,
    minute: $182e621785d53987$var$fullDayFormatter + ' ' + $182e621785d53987$export$f7854271ddbda64e.minute,
    second: $182e621785d53987$var$fullDayFormatter + ' ' + $182e621785d53987$export$f7854271ddbda64e.second,
    millisecond: $182e621785d53987$export$f7854271ddbda64e.none
};
var $182e621785d53987$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $182e621785d53987$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $182e621785d53987$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $182e621785d53987$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $182e621785d53987$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $182e621785d53987$export$1da4b91a25d7e1c8(timeUnit);
}
function $182e621785d53987$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $182e621785d53987$export$d9468344d3651243(// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $5BQXp.parseDate(time);
    var y = date[$182e621785d53987$export$8d046fefed9a548e(isUTC)]();
    var M = date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 4) + 1;
    var d = date[$182e621785d53987$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$182e621785d53987$export$8807847c5c71eded(isUTC)]();
    var s = date[$182e621785d53987$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$182e621785d53987$export$312207a92d041116(isUTC)]();
    var localeModel = lang instanceof (0, $fR3z1.default) ? lang : (0, $6FMoP.getLocaleModel)(lang || (0, $6FMoP.SYSTEM_LANG)) || (0, $6FMoP.getDefaultLocaleModel)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $182e621785d53987$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $182e621785d53987$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $182e621785d53987$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $182e621785d53987$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $182e621785d53987$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $182e621785d53987$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $182e621785d53987$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $182e621785d53987$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if (typeof formatter === 'string') // Single formatter for all units at all levels
    template = formatter;
    else if (typeof formatter === 'function') // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $hzBt5.extend({}, $182e621785d53987$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $182e621785d53987$export$87100da04d711986.length; ++i)defaults[$182e621785d53987$export$87100da04d711986[i]] = "{primary|" + defaults[$182e621785d53987$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $hzBt5.defaults(formatter, defaults) : defaults;
        var unit = $182e621785d53987$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $182e621785d53987$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($hzBt5.isArray(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $182e621785d53987$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $182e621785d53987$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $5BQXp.parseDate(value);
    var M = date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$182e621785d53987$export$4189e6cbc9753260(isUTC)]();
    var h = date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$182e621785d53987$export$8807847c5c71eded(isUTC)]();
    var s = date[$182e621785d53987$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$182e621785d53987$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $182e621785d53987$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = typeof value === 'number' ? $5BQXp.parseDate(value) : value;
    unit = unit || $182e621785d53987$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case 'year':
            return date[$182e621785d53987$export$8d046fefed9a548e(isUTC)]();
        case 'half-year':
            return date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case 'quarter':
            return Math.floor((date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case 'month':
            return date[$182e621785d53987$export$5c242a801a23eec7(isUTC)]();
        case 'day':
            return date[$182e621785d53987$export$4189e6cbc9753260(isUTC)]();
        case 'half-day':
            return date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case 'hour':
            return date[$182e621785d53987$export$8b40b55b3c06cbe2(isUTC)]();
        case 'minute':
            return date[$182e621785d53987$export$8807847c5c71eded(isUTC)]();
        case 'second':
            return date[$182e621785d53987$export$8f49e73e2eebd168(isUTC)]();
        case 'millisecond':
            return date[$182e621785d53987$export$312207a92d041116(isUTC)]();
    }
}
function $182e621785d53987$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $182e621785d53987$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $182e621785d53987$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $182e621785d53987$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $182e621785d53987$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $182e621785d53987$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $182e621785d53987$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $182e621785d53987$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $182e621785d53987$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $182e621785d53987$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $182e621785d53987$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $182e621785d53987$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $182e621785d53987$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $182e621785d53987$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}

});
parcelRegister("6FMoP", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_LANG", () => $4dbc1d8df02dcff2$export$9a2147b3808d4c6b);
$parcel$export(module.exports, "registerLocale", () => $4dbc1d8df02dcff2$export$bab6a7822cc1e2cd);
$parcel$export(module.exports, "createLocaleObject", () => $4dbc1d8df02dcff2$export$ddc371781a6af754);
$parcel$export(module.exports, "getLocaleModel", () => $4dbc1d8df02dcff2$export$37cc638e0e11865f);
$parcel$export(module.exports, "getDefaultLocaleModel", () => $4dbc1d8df02dcff2$export$1188f179b2597821);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fR3z1 = parcelRequire("fR3z1");

var $gZXYp = parcelRequire("gZXYp");

var $4Osf0 = parcelRequire("4Osf0");

var $jOSzM = parcelRequire("jOSzM");

var $hzBt5 = parcelRequire("hzBt5");
var $4dbc1d8df02dcff2$var$LOCALE_ZH = 'ZH';
var $4dbc1d8df02dcff2$var$LOCALE_EN = 'EN';
var $4dbc1d8df02dcff2$var$DEFAULT_LOCALE = $4dbc1d8df02dcff2$var$LOCALE_EN;
var $4dbc1d8df02dcff2$var$localeStorage = {};
var $4dbc1d8df02dcff2$var$localeModels = {};
var $4dbc1d8df02dcff2$export$9a2147b3808d4c6b = !(0, $gZXYp.default).domSupported ? $4dbc1d8df02dcff2$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
    return langStr.indexOf($4dbc1d8df02dcff2$var$LOCALE_ZH) > -1 ? $4dbc1d8df02dcff2$var$LOCALE_ZH : $4dbc1d8df02dcff2$var$DEFAULT_LOCALE;
}();
function $4dbc1d8df02dcff2$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $4dbc1d8df02dcff2$var$localeModels[locale] = new (0, $fR3z1.default)(localeObj);
    $4dbc1d8df02dcff2$var$localeStorage[locale] = localeObj;
} // export function getLocale(locale: string) {
function $4dbc1d8df02dcff2$export$ddc371781a6af754(locale) {
    if ((0, $hzBt5.isString)(locale)) {
        var localeObj = $4dbc1d8df02dcff2$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $4dbc1d8df02dcff2$var$LOCALE_ZH || locale === $4dbc1d8df02dcff2$var$LOCALE_EN) return (0, $hzBt5.clone)(localeObj);
        else return (0, $hzBt5.merge)((0, $hzBt5.clone)(localeObj), (0, $hzBt5.clone)($4dbc1d8df02dcff2$var$localeStorage[$4dbc1d8df02dcff2$var$DEFAULT_LOCALE]), false);
    } else return (0, $hzBt5.merge)((0, $hzBt5.clone)(locale), (0, $hzBt5.clone)($4dbc1d8df02dcff2$var$localeStorage[$4dbc1d8df02dcff2$var$DEFAULT_LOCALE]), false);
}
function $4dbc1d8df02dcff2$export$37cc638e0e11865f(lang) {
    return $4dbc1d8df02dcff2$var$localeModels[lang];
}
function $4dbc1d8df02dcff2$export$1188f179b2597821() {
    return $4dbc1d8df02dcff2$var$localeModels[$4dbc1d8df02dcff2$var$DEFAULT_LOCALE];
} // Default locale
$4dbc1d8df02dcff2$export$bab6a7822cc1e2cd($4dbc1d8df02dcff2$var$LOCALE_EN, (0, $4Osf0.default));
$4dbc1d8df02dcff2$export$bab6a7822cc1e2cd($4dbc1d8df02dcff2$var$LOCALE_ZH, (0, $jOSzM.default));

});
parcelRegister("4Osf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3811bd09e64260b5$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Language: English.
 */ var $3811bd09e64260b5$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};

});

parcelRegister("jOSzM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6dd057bfc6d051a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $e6dd057bfc6d051a$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};

});



parcelRegister("iluMW", function(module, exports) {

$parcel$export(module.exports, "getTextRect", () => $d5b21213a7d74d8d$export$372ffda650a6e70d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kiooD = parcelRequire("kiooD");

var $6ds7H = parcelRequire("6ds7H");
function $d5b21213a7d74d8d$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
    (0, $6ds7H.deprecateLog)('getTextRect is deprecated.');
    var textEl = new (0, $kiooD.default)({
        style: {
            text: text,
            font: font,
            align: align,
            verticalAlign: verticalAlign,
            padding: padding,
            rich: rich,
            overflow: truncate ? 'truncate' : null,
            lineHeight: lineHeight
        }
    });
    return textEl.getBoundingRect();
}

});




parcelRegister("b7fr8", function(module, exports) {

$parcel$export(module.exports, "PaletteMixin", () => $817c5287d8edb57b$export$55a3c39e852b90f4);
$parcel$export(module.exports, "getDecalFromPalette", () => $817c5287d8edb57b$export$e4d892222945a227);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");
var $817c5287d8edb57b$var$innerColor = (0, $ckizb.makeInner)();
var $817c5287d8edb57b$var$innerDecal = (0, $ckizb.makeInner)();
var $817c5287d8edb57b$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $ckizb.normalizeToArray)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $817c5287d8edb57b$var$getFromPalette(this, $817c5287d8edb57b$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $817c5287d8edb57b$var$clearPalette(this, $817c5287d8edb57b$var$innerColor);
    };
    return PaletteMixin;
}();
function $817c5287d8edb57b$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $ckizb.normalizeToArray)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $817c5287d8edb57b$var$getFromPalette(ecModel, $817c5287d8edb57b$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $817c5287d8edb57b$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length; // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $817c5287d8edb57b$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $817c5287d8edb57b$var$getNearestPalette(layeredPalette, requestNum); // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $817c5287d8edb57b$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}

});

parcelRegister("93uXC", function(module, exports) {

$parcel$export(module.exports, "DataFormatMixin", () => $697c68fc7d38226f$export$f23396ae04ea95a7);
$parcel$export(module.exports, "normalizeTooltipFormatResult", () => $697c68fc7d38226f$export$2d16fa82a50c4741);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $kWuWu = parcelRequire("kWuWu");

var $gyplX = parcelRequire("gyplX");

var $697c68fc7d38226f$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $697c68fc7d38226f$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $hzBt5.isArray(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex); // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if (typeof formatter === 'function') {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if (typeof formatter === 'string') {
            var str = (0, $gyplX.formatTpl)(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($697c68fc7d38226f$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $kWuWu.retrieveRawValue)(data, dataIndex, dimLoose);
                if (extendParams && $hzBt5.isArray(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $kWuWu.retrieveRawValue)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $697c68fc7d38226f$export$2d16fa82a50c4741(result // markersExisting: Dictionary<ColorString>
) {
    var markupText; // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($hzBt5.isObject(result)) {
        if (result.type) markupFragment = result;
         // else {
    } else markupText = result;
    return {
        markupText: markupText,
        // markers: markers || markersExisting,
        markupFragment: markupFragment
    };
}

});

parcelRegister("bw304", function(module, exports) {

$parcel$export(module.exports, "createTask", () => $862502a1f4d033e1$export$f7292ab7796be73c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
function $862502a1f4d033e1$export$f7292ab7796be73c(define) {
    return new $862502a1f4d033e1$export$2dea7024bcdd7731(define);
}
var $862502a1f4d033e1$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip; // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
         // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
         // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $hzBt5.isArray)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $862502a1f4d033e1$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $862502a1f4d033e1$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            } // To simplify no progress checking, array must has item.
            if ((0, $hzBt5.isArray)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happend in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the setted end, in case
        // that the stub of dataZoom perform again and earse the
        // setted end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $862502a1f4d033e1$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
         : current;
        current++;
        return result;
    }
}(); ///////////////////////////////////////////////////////////
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };

});

parcelRegister("kNy1J", function(module, exports) {

$parcel$export(module.exports, "SourceManager", () => $f242c74a81525470$export$af4db9ec7e200ea2);
$parcel$export(module.exports, "disableTransformOptionMerge", () => $f242c74a81525470$export$9451f4e9047441ec);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8AzOm = parcelRequire("8AzOm");

var $8tpV4 = parcelRequire("8tpV4");

var $be33G = parcelRequire("be33G");

var $jjR5M = parcelRequire("jjR5M");

var $6Bzg6 = parcelRequire("6Bzg6");

var $kWuWu = parcelRequire("kWuWu");
/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transfroms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $f242c74a81525470$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = []; // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($f242c74a81525470$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0; // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $hzBt5.isTypedArray)(data) ? (0, $8tpV4.SOURCE_FORMAT_TYPED_ARRAY) : (0, $8tpV4.SOURCE_FORMAT_ORIGINAL);
                upstreamSignList = [];
            } // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $hzBt5.retrieve2)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $hzBt5.retrieve2)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader) || null; // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $hzBt5.retrieve2)(newMetaRawOption.dimensions, upMetaRawOption.dimensions); // We share source with dataset as much as possible
            // to avoid extra memroy cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $8AzOm.createSource)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost; // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $8AzOm.createSource)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $f242c74a81525470$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $hzBt5.each)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $f242c74a81525470$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $jjR5M.applyDataTransform)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $8AzOm.cloneSourceShallow)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
         // All sourceList is from the some upsteam.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By defualt 0, means "main source".
   *                    Most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($f242c74a81525470$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $6Bzg6.default)(); // Always create store from source of series.
                cachedStore.initData(new (0, $kWuWu.DefaultDataProvider)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PEDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // no need to update them when change happen.
        var sourceHost = this._sourceHost;
        if ($f242c74a81525470$var$isSeries(sourceHost)) {
            var datasetModel = (0, $be33G.querySeriesUpstreamDatasetModel)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $hzBt5.map)((0, $be33G.queryDatasetUpstreamDatasetModels)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($f242c74a81525470$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $f242c74a81525470$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $hzBt5.setAsPrimitive)(datasetModel.option.transform);
}
function $f242c74a81525470$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $f242c74a81525470$var$doThrow(errMsg) {
    throw new Error(errMsg);
}

});
parcelRegister("jjR5M", function(module, exports) {

$parcel$export(module.exports, "registerExternalTransform", () => $e108f9b2e624d0da$export$92c96c6d8b255b7d);
$parcel$export(module.exports, "applyDataTransform", () => $e108f9b2e624d0da$export$42a68f09db16803f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8tpV4 = parcelRequire("8tpV4");

var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $kWuWu = parcelRequire("kWuWu");

var $fJfRY = parcelRequire("fJfRY");

var $6ds7H = parcelRequire("6ds7H");

var $8AzOm = parcelRequire("8AzOm");
/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $e108f9b2e624d0da$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * becuase transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $fJfRY.parseDataValue)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $e108f9b2e624d0da$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $e108f9b2e624d0da$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN)) (0, $6ds7H.throwError)(errMsg);
     // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Becuase the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is relialbe and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $hzBt5.each)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt); // Users probably not sepcify dimension name. For simplicity, data transform
        // do not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbid name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $hzBt5.hasOwn)(dimsByName, name)) (0, $6ds7H.throwError)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
     // Implement public methods:
    var rawItemGetter = (0, $kWuWu.getRawSourceItemGetter)(sourceFormat, (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $hzBt5.bind)($e108f9b2e624d0da$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $hzBt5.bind)($e108f9b2e624d0da$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $kWuWu.getRawSourceDataCounter)(sourceFormat, (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN));
    extSource.count = (0, $hzBt5.bind)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $kWuWu.getRawSourceValueGetter)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex]; // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $hzBt5.bind)($e108f9b2e624d0da$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $hzBt5.bind)($e108f9b2e624d0da$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $e108f9b2e624d0da$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $6ds7H.throwError)(errMsg);
    }
    return upstream.data;
}
function $e108f9b2e624d0da$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $6ds7H.throwError)(errMsg);
    }
    if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $hzBt5.extend)({}, data[i]));
        return result;
    }
}
function $e108f9b2e624d0da$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
     // Keep the same logic as `List::getDimension` did.
    if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
     || !isNaN(dim) && !(0, $hzBt5.hasOwn)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $hzBt5.hasOwn)(dimsByName, dim)) return dimsByName[dim];
}
function $e108f9b2e624d0da$var$cloneAllDimensionInfo(dimensions) {
    return (0, $hzBt5.clone)(dimensions);
}
var $e108f9b2e624d0da$var$externalTransformMap = (0, $hzBt5.createHashMap)();
function $e108f9b2e624d0da$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $hzBt5.clone)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $6ds7H.throwError)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $6ds7H.throwError)(errMsg);
     // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $e108f9b2e624d0da$var$externalTransformMap.set(type, externalTransform);
}
function $e108f9b2e624d0da$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $ckizb.normalizeToArray)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $6ds7H.throwError)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $e108f9b2e624d0da$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i); // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $e108f9b2e624d0da$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $6ds7H.throwError)(errMsg);
    if (!(0, $hzBt5.isObject)(transOption)) (0, $6ds7H.throwError)(errMsg);
    var transType = transOption.type;
    var externalTransform = $e108f9b2e624d0da$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $6ds7H.throwError)(errMsg);
     // Prepare source
    var extUpSourceList = (0, $hzBt5.map)(upSourceList, function(upSource) {
        return $e108f9b2e624d0da$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $ckizb.normalizeToArray)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $hzBt5.clone)(transOption.config)
    }));
    var printStrArr;
    return (0, $hzBt5.map)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $hzBt5.isObject)(result)) (0, $6ds7H.throwError)(errMsg);
        if (!result.data) (0, $6ds7H.throwError)(errMsg);
        var sourceFormat = (0, $8AzOm.detectSourceFormat)(result.data);
        if (!$e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat)) (0, $6ds7H.throwError)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 // If transformer returns `dimensions`, it means that the transformer has different
         && !result.dimensions) {
            var startIndex = firstUpSource.startIndex; // We copy the header of upstream to the result becuase:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $8tpV4.SERIES_LAYOUT_BY_COLUMN),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $8AzOm.createSource)(result.data, resultMetaRawOption, null);
    });
}
function $e108f9b2e624d0da$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $8tpV4.SOURCE_FORMAT_ARRAY_ROWS) || sourceFormat === (0, $8tpV4.SOURCE_FORMAT_OBJECT_ROWS);
}

});


parcelRegister("4OBOS", function(module, exports) {

$parcel$export(module.exports, "defaultSeriesFormatTooltip", () => $38192b222cde5ead$export$3a110b9fb5c88b34);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $e0Zyb = parcelRequire("e0Zyb");

var $kWuWu = parcelRequire("kWuWu");

var $ckizb = parcelRequire("ckizb");
function $38192b222cde5ead$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $hzBt5.isArray)(value);
    var markerColor = (0, $e0Zyb.retrieveVisualColorForTooltipMarker)(series, dataIndex); // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $38192b222cde5ead$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks; // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $kWuWu.retrieveRawValue)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
     // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $ckizb.isNameSpecified)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $e0Zyb.createTooltipMarkup)('section', {
        header: seriesName,
        // When series name not specified, do not show a header line with only '-'.
        // This case alway happen in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $e0Zyb.createTooltipMarkup)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $hzBt5.trim)(inlineName),
                value: inlineValue,
                valueType: inlineValueType
            })
        ].concat(subBlocks || [])
    });
}
function $38192b222cde5ead$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $hzBt5.reduce)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $hzBt5.each)(tooltipDims, function(dim) {
        setEachItem((0, $kWuWu.retrieveRawValue)(data, dataIndex, dim), dim);
    }) // By default, all dims is used on tooltip.
     : (0, $hzBt5.each)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $e0Zyb.createTooltipMarkup)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}

});
parcelRegister("e0Zyb", function(module, exports) {

$parcel$export(module.exports, "createTooltipMarkup", () => $a340cf5f38f316a7$export$cf63b23ce77d1921);
$parcel$export(module.exports, "buildTooltipMarkup", () => $a340cf5f38f316a7$export$6969ffb02c1cb49a);
$parcel$export(module.exports, "retrieveVisualColorForTooltipMarker", () => $a340cf5f38f316a7$export$ea15628039c0fa93);
$parcel$export(module.exports, "getPaddingFromTooltipModel", () => $a340cf5f38f316a7$export$3048212c802df496);
$parcel$export(module.exports, "TooltipMarkupStyleCreator", () => $a340cf5f38f316a7$export$2fba3afbcdcf3e18);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gyplX = parcelRequire("gyplX");

var $hzBt5 = parcelRequire("hzBt5");

var $fJfRY = parcelRequire("fJfRY");

var $5BQXp = parcelRequire("5BQXp");
var $a340cf5f38f316a7$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1'; // TODO: more textStyle option
function $a340cf5f38f316a7$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || '#6e7079';
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || '#464646';
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $gyplX.encodeHTML)(nameFontSize + '') + "px;color:" + (0, $gyplX.encodeHTML)(nameFontColor) + ";font-weight:" + (0, $gyplX.encodeHTML)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $gyplX.encodeHTML)(valueFontSize + '') + "px;color:" + (0, $gyplX.encodeHTML)(valueFontColor) + ";font-weight:" + (0, $gyplX.encodeHTML)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
} // See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $a340cf5f38f316a7$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $a340cf5f38f316a7$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
]; // eslint-disable-next-line max-len
function $a340cf5f38f316a7$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $a340cf5f38f316a7$var$getBuilder(fragment) {
    return (0, $hzBt5.hasOwn)($a340cf5f38f316a7$var$builderMap, fragment.type) && $a340cf5f38f316a7$var$builderMap[fragment.type];
}
var $a340cf5f38f316a7$var$builderMap = {
    /**
   * A `section` block is like:
   * ```
   * header
   * subBlock
   * subBlock
   * ...
   * ```
   */ section: {
        planLayout: function(fragment) {
            var subBlockLen = fragment.blocks.length;
            var thisBlockHasInnerGap = subBlockLen > 1 || subBlockLen > 0 && !fragment.noHeader;
            var thisGapLevelBetweenSubBlocks = 0;
            (0, $hzBt5.each)(fragment.blocks, function(subBlock) {
                $a340cf5f38f316a7$var$getBuilder(subBlock).planLayout(subBlock);
                var subGapLevel = subBlock.__gapLevelBetweenSubBlocks; // If the some of the sub-blocks have some gaps (like 10px) inside, this block
                // should use a larger gap (like 20px) to distinguish those sub-blocks.
                if (subGapLevel >= thisGapLevelBetweenSubBlocks) thisGapLevelBetweenSubBlocks = subGapLevel + (thisBlockHasInnerGap && (!subGapLevel // If no header, always keep the sub gap level. Otherwise
                 || subBlock.type === 'section' && !subBlock.noHeader) ? 1 : 0);
            });
            fragment.__gapLevelBetweenSubBlocks = thisGapLevelBetweenSubBlocks;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var noHeader = fragment.noHeader;
            var gaps = $a340cf5f38f316a7$var$getGap(fragment);
            var subMarkupText = $a340cf5f38f316a7$var$buildSubBlocks(ctx, fragment, noHeader ? topMarginForOuterGap : gaps.html, toolTipTextStyle);
            if (noHeader) return subMarkupText;
            var displayableHeader = (0, $gyplX.makeValueReadable)(fragment.header, 'ordinal', ctx.useUTC);
            var nameStyle = $a340cf5f38f316a7$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
            if (ctx.renderMode === 'richText') return $a340cf5f38f316a7$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
            else return $a340cf5f38f316a7$var$wrapBlockHTML("<div style=\"" + nameStyle + ";" + $a340cf5f38f316a7$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + (0, $gyplX.encodeHTML)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
        }
    },
    /**
   * A `nameValue` block is like:
   * ```
   * marker  name  value
   * ```
   */ nameValue: {
        planLayout: function(fragment) {
            fragment.__gapLevelBetweenSubBlocks = 0;
        },
        build: function(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
            var renderMode = ctx.renderMode;
            var noName = fragment.noName;
            var noValue = fragment.noValue;
            var noMarker = !fragment.markerType;
            var name = fragment.name;
            var value = fragment.value;
            var useUTC = ctx.useUTC;
            if (noName && noValue) return;
            var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
            var readableName = noName ? '' : (0, $gyplX.makeValueReadable)(name, 'ordinal', useUTC);
            var valueTypeOption = fragment.valueType;
            var readableValueList = noValue ? [] : (0, $hzBt5.isArray)(value) ? (0, $hzBt5.map)(value, function(val, idx) {
                return (0, $gyplX.makeValueReadable)(val, (0, $hzBt5.isArray)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
            }) : [
                (0, $gyplX.makeValueReadable)(value, (0, $hzBt5.isArray)(valueTypeOption) ? valueTypeOption[0] : valueTypeOption, useUTC)
            ];
            var valueAlignRight = !noMarker || !noName; // It little weird if only value next to marker but far from marker.
            var valueCloseToMarker = !noMarker && noName;
            var _a = $a340cf5f38f316a7$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
            return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $a340cf5f38f316a7$var$wrapInlineNameRichText(ctx, readableName, nameStyle) // Value has commas inside, so use ' ' as delimiter for multiple values.
            ) + (noValue ? '' : $a340cf5f38f316a7$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $a340cf5f38f316a7$var$wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : $a340cf5f38f316a7$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $a340cf5f38f316a7$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
        }
    }
};
function $a340cf5f38f316a7$var$buildSubBlocks(ctx, fragment, topMarginForOuterGap, tooltipTextStyle) {
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $hzBt5.assert)(!subBlocks || (0, $hzBt5.isArray)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $hzBt5.hasOwn)(orderMap, orderMode)) {
            var comparator_1 = new (0, $fJfRY.SortOrderComparator)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    var gaps = $a340cf5f38f316a7$var$getGap(fragment);
    (0, $hzBt5.each)(subBlocks, function(subBlock, idx) {
        var subMarkupText = $a340cf5f38f316a7$var$getBuilder(subBlock).build(ctx, subBlock, idx > 0 ? gaps.html : 0, tooltipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    if (!subMarkupTextList.length) return;
    return ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $a340cf5f38f316a7$var$wrapBlockHTML(subMarkupTextList.join(''), topMarginForOuterGap);
}
function $a340cf5f38f316a7$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $a340cf5f38f316a7$var$getBuilder(fragment);
    builder.planLayout(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator
    };
    return builder.build(ctx, fragment, 0, toolTipTextStyle);
}
function $a340cf5f38f316a7$var$getGap(fragment) {
    var gapLevelBetweenSubBlocks = fragment.__gapLevelBetweenSubBlocks;
    return {
        html: $a340cf5f38f316a7$var$HTML_GAPS[gapLevelBetweenSubBlocks],
        richText: $a340cf5f38f316a7$var$RICH_TEXT_GAPS[gapLevelBetweenSubBlocks]
    };
}
function $a340cf5f38f316a7$var$wrapBlockHTML(encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    return "<div style=\"" + marginCSS + ";" + $a340cf5f38f316a7$var$TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
}
function $a340cf5f38f316a7$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $gyplX.encodeHTML)(name) + '</span>';
}
function $a340cf5f38f316a7$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    return "<span style=\"" + alignCSS + ";" + style + "\">" // Value has commas inside, so use '  ' as delimiter for multiple values.
     + (0, $hzBt5.map)(valueList, function(value) {
        return (0, $gyplX.encodeHTML)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $a340cf5f38f316a7$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $a340cf5f38f316a7$var$wrapInlineValueRichText(ctx, valueList, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    }); // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle(valueList.join('  '), styles);
}
function $a340cf5f38f316a7$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $gyplX.convertToColorString)(color);
}
function $a340cf5f38f316a7$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding // We give slightly different to look pretty.
     : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $a340cf5f38f316a7$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {}; // Notice that "generate a style name" usuall happens repeatly when mouse moving and
        // displaying a tooltip. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $5BQXp.getRandomIdBase)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $gyplX.getTooltipMarker)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $hzBt5.isString)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $hzBt5.isArray)(styles)) (0, $hzBt5.each)(styles, function(stl) {
            return (0, $hzBt5.extend)(finalStl, stl);
        });
        else (0, $hzBt5.extend)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();

});



parcelRegister("4TnMt", function(module, exports) {

$parcel$export(module.exports, "symbolBuildProxies", () => $38febedb95292fd7$export$33fc3b478d332725);
$parcel$export(module.exports, "createSymbol", () => $38febedb95292fd7$export$af050e04da3a02e8);
$parcel$export(module.exports, "normalizeSymbolSize", () => $38febedb95292fd7$export$a84524f03e8e8dfb);
$parcel$export(module.exports, "normalizeSymbolOffset", () => $38febedb95292fd7$export$e3e292895c033f6d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory

var $hzBt5 = parcelRequire("hzBt5");
parcelRequire("8q0E1");
var $aYBv9 = parcelRequire("aYBv9");
var $15UDR = parcelRequire("15UDR");
var $8q0E1 = parcelRequire("8q0E1");
var $hMiip = parcelRequire("hMiip");
var $aeCKo = parcelRequire("aeCKo");

var $lGSv6 = parcelRequire("lGSv6");

var $02NbV = parcelRequire("02NbV");

var $5BQXp = parcelRequire("5BQXp");
/**
 * Triangle shape
 * @inner
 */ var $38febedb95292fd7$var$Triangle = $hMiip.default.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $38febedb95292fd7$var$Diamond = $hMiip.default.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $38febedb95292fd7$var$Pin = $hMiip.default.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3; // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2; // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $38febedb95292fd7$var$Arrow = $hMiip.default.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path contructors
 */ // TODO Use function to build symbol path.
var $38febedb95292fd7$var$symbolCtors = {
    line: $15UDR.default,
    rect: $aeCKo.default,
    roundRect: $aeCKo.default,
    square: $aeCKo.default,
    circle: $aYBv9.default,
    diamond: $38febedb95292fd7$var$Diamond,
    pin: $38febedb95292fd7$var$Pin,
    arrow: $38febedb95292fd7$var$Arrow,
    triangle: $38febedb95292fd7$var$Triangle
};
var $38febedb95292fd7$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $38febedb95292fd7$export$33fc3b478d332725 = {};
(0, $hzBt5.each)($38febedb95292fd7$var$symbolCtors, function(Ctor, name) {
    $38febedb95292fd7$export$33fc3b478d332725[name] = new Ctor();
});
var $38febedb95292fd7$var$SymbolClz = $hMiip.default.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $02NbV.calculateTextPosition)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $38febedb95292fd7$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $38febedb95292fd7$export$33fc3b478d332725[symbolType];
            }
            $38febedb95292fd7$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
function $38febedb95292fd7$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || '#fff'; // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $38febedb95292fd7$export$af050e04da3a02e8(symbolType, x, y, w, h, color, keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $8q0E1.makeImage(symbolType.slice(8), new (0, $lGSv6.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $8q0E1.makePath(symbolType.slice(7), {}, new (0, $lGSv6.default)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $38febedb95292fd7$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty; // TODO Should deprecate setColor
    symbolPath.setColor = $38febedb95292fd7$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $38febedb95292fd7$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $hzBt5.isArray)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $38febedb95292fd7$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $hzBt5.isArray)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $5BQXp.parsePercent)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $5BQXp.parsePercent)((0, $hzBt5.retrieve2)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}

});


parcelRegister("cwcEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $91d24a9702707214$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $ffay8 = parcelRequire("ffay8");

var $jYHZD = parcelRequire("jYHZD");

var $d3Ews = parcelRequire("d3Ews");

var $hXAsm = parcelRequire("hXAsm");
var $9ubot = parcelRequire("9ubot");
var $4kdki = parcelRequire("4kdki");
var $kiooD = parcelRequire("kiooD");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");

var $ckizb = parcelRequire("ckizb");

var $eQ1J3 = parcelRequire("eQ1J3");

var $azEx8 = parcelRequire("azEx8");

var $d6Kps = parcelRequire("d6Kps");

var $gNqT1 = parcelRequire("gNqT1");

var $PS5GS = parcelRequire("PS5GS");

var $51xyq = parcelRequire("51xyq");

var $hcRXD = parcelRequire("hcRXD");

var $bY5Ss = parcelRequire("bY5Ss");

var $aly4X = parcelRequire("aly4X");

var $5GVHb = parcelRequire("5GVHb");

var $gyplX = parcelRequire("gyplX");

var $f7lrR = parcelRequire("f7lrR");
function $91d24a9702707214$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $91d24a9702707214$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $91d24a9702707214$var$getBoundingDiff(points1, points2) {
    var _a = $91d24a9702707214$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $91d24a9702707214$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1]; // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $91d24a9702707214$var$getSmooth(smooth) {
    return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
}
function $91d24a9702707214$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $5GVHb.createFloat32Array)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $d6Kps.getStackedOnPoint)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
function $91d24a9702707214$var$turnPointsIntoStep(points, coordSys, stepTurnAt) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    for(; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case 'end':
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case 'middle':
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    } // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $91d24a9702707214$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length; // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $f7lrR.lerp)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
             // All following stop will be out of range. So just ignore them.
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0)); // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $91d24a9702707214$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual('visualMeta');
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== 'cartesian2d') return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
        if (coordDim === 'x' || coordDim === 'y') {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
     // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim); // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $hzBt5.map(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $91d24a9702707214$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 0; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return 'transparent';
    $hzBt5.each(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || 'transparent'
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || 'transparent'
    });
    var gradient = new $4kdki.default(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + '2'] = maxCoord;
    return gradient;
}
function $91d24a9702707214$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get('showAllSymbol');
    var isAuto = showAllSymbol === 'auto';
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
    if (!categoryAxis) return;
     // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto // Simplify the logic, do not determine label overlap here.
     && $91d24a9702707214$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
     // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $hzBt5.each(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $91d24a9702707214$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In mose cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $jYHZD.default).getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
        )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
         * 1.5 > availSize) return false;
    }
    return true;
}
function $91d24a9702707214$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $91d24a9702707214$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$91d24a9702707214$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $91d24a9702707214$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $91d24a9702707214$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === 'x' ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $91d24a9702707214$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        'endLabel',
        'show'
    ])) return true;
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        if (seriesModel.get([
            (0, $51xyq.SPECIAL_STATES)[i],
            'endLabel',
            'show'
        ])) return true;
    }
    return false;
}
function $91d24a9702707214$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $PS5GS.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
        var endLabelModel_1 = seriesModel.getModel('endLabel');
        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $91d24a9702707214$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $gNqT1.createGridClipPath)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during); // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get('clip', true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        } // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $gNqT1.createPolarClipPath)(coordSys, hasAnimation, seriesModel);
}
function $91d24a9702707214$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
    var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
    return {
        normal: {
            align: endLabelModel.get('align') || align,
            verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
        }
    };
}
var $91d24a9702707214$var$LineView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $hXAsm.default();
        var symbolDraw = new (0, $ffay8.default)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel('lineStyle');
        var areaStyleModel = seriesModel.getModel('areaStyle');
        var points = data.getLayout('points') || [];
        var isCoordSysPolar = coordSys.type === 'polar';
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = seriesModel.get('animation');
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get('origin');
        var dataCoordInfo = (0, $d6Kps.prepareDataCoordInfo)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $91d24a9702707214$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get('showSymbol');
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $91d24a9702707214$var$getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        }); // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup); // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
            clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $91d24a9702707214$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')]; // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                // TODO If stacked series is not step
                points = $91d24a9702707214$var$turnPointsIntoStep(points, coordSys, step);
                if (stackedOnPoints) stackedOnPoints = $91d24a9702707214$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
             // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $gyplX.convertToColorString)(visualColor));
            lineGroup.setClipPath($91d24a9702707214$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            } // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $gyplX.convertToColorString)(visualColor));
             // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $91d24a9702707214$var$createLineClipPath(this, coordSys, false, seriesModel);
                $9ubot.initProps(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($91d24a9702707214$var$createLineClipPath(this, coordSys, true, seriesModel));
             // Always update, or it is wrong in the case turning on legend
            // because points are not changed
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            }); // In the case data zoom triggerred refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing
            if (!$91d24a9702707214$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$91d24a9702707214$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
                else {
                    // Not do it in update with animation
                    if (step) {
                        // TODO If stacked series is not step
                        points = $91d24a9702707214$var$turnPointsIntoStep(points, coordSys, step);
                        if (stackedOnPoints) stackedOnPoints = $91d24a9702707214$var$turnPointsIntoStep(stackedOnPoints, coordSys, step);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var focus = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        polyline.useStyle($hzBt5.defaults(lineStyleModel.getLineStyle(), {
            fill: 'none',
            stroke: visualColor,
            lineJoin: 'bevel'
        }));
        (0, $51xyq.setStatesStylesFromModel)(polyline, seriesModel, 'lineStyle');
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            'emphasis',
            'lineStyle',
            'width'
        ]) === 'bolder') {
            var emphasisLineStyle = polyline.getState('emphasis').style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        } // Needs seriesIndex for focus
        (0, $aly4X.getECData)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $51xyq.enableHoverEmphasis)(polyline, focus, blurScope);
        var smooth = $91d24a9702707214$var$getSmooth(seriesModel.get('smooth'));
        var smoothMonotone = seriesModel.get('smoothMonotone');
        var connectNulls = seriesModel.get('connectNulls');
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
            var stackedOnSmooth = 0;
            polygon.useStyle($hzBt5.defaults(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: 'bevel',
                decal: data.getVisual('style').decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $91d24a9702707214$var$getSmooth(stackedOnSeries.get('smooth'));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $51xyq.setStatesStylesFromModel)(polygon, seriesModel, 'areaStyle'); // Needs seriesIndex for focus
            (0, $aly4X.getECData)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $51xyq.enableHoverEmphasis)(polygon, focus, blurScope);
        }
        var changePolyState = function(toState) {
            _this._changePolyState(toState);
        };
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data; // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
    };
    LineView.prototype.dispose = function() {};
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $ckizb.queryDataIndex(data, payload);
        this._changePolyState('emphasis');
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout('points');
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                 // fix #11360: should't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get('zlevel');
                var z = seriesModel.get('z');
                symbol = new (0, $jYHZD.default)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z); // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $azEx8.default).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $ckizb.queryDataIndex(data, payload);
        this._changePolyState('normal');
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $azEx8.default).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $51xyq.setStatesFlag)(this._polyline, toState);
        polygon && (0, $51xyq.setStatesFlag)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline; // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $eQ1J3.ECPolyline)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon; // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $eQ1J3.ECPolygon)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === 'cartesian2d') {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === 'polar') {
            isHorizontalOrRadial = baseAxis.dim === 'angle';
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get('animationDuration');
        if (typeof seriesDuration === 'function') seriesDuration = seriesDuration(null);
        var seriesDalay = seriesModel.get('animationDelay') || 0;
        var seriesDalayValue = typeof seriesDalay === 'function' ? seriesDalay(null) : seriesDalay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = typeof seriesDalay === 'function' ? seriesDalay(idx) : seriesDuration * ratio + seriesDalayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel('endLabel');
        if ($91d24a9702707214$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $kiooD.default({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            } // Find last non-NaN data to display data
            var dataIndex = $91d24a9702707214$var$getLastIndexNotNull(data_2.getLayout('points'));
            if (dataIndex >= 0) {
                (0, $hcRXD.setLabelStyle)(polyline, (0, $hcRXD.getLabelStatesModels)(seriesModel, 'endLabel'), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $bY5Ss.getDefaultInterpolatedLabel)(data_2, interpolatedValue) : (0, $bY5Ss.getDefaultLabel)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $91d24a9702707214$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout('points');
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get('connectNulls');
            var precision = endLabelModel.get('precision');
            var distance = endLabelModel.get('distance') || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? 'x' : 'y';
            var dataIndexRange = $91d24a9702707214$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $91d24a9702707214$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $ckizb.interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $91d24a9702707214$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) (0, $hcRXD.labelInner)(endLabel).setLabelText(value);
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $d3Ews.default)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            current = $91d24a9702707214$var$turnPointsIntoStep(diff.current, coordSys, step);
            stackedOnCurrent = $91d24a9702707214$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
            next = $91d24a9702707214$var$turnPointsIntoStep(diff.next, coordSys, step);
            stackedOnNext = $91d24a9702707214$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
        } // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($91d24a9702707214$var$getBoundingDiff(current, next) > 3000 || polygon && $91d24a9702707214$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        }; // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
         // Stop previous animation.
        polyline.stopAnimation();
        $9ubot.updateProps(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $9ubot.updateProps(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel); // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === '=') {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = 'line';
    return LineView;
}((0, $azEx8.default));
var $91d24a9702707214$export$2e2bcd8739ae039 = $91d24a9702707214$var$LineView;

});
parcelRegister("ffay8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19070a46c0d3f3f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hXAsm = parcelRequire("hXAsm");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");

var $jYHZD = parcelRequire("jYHZD");

var $hzBt5 = parcelRequire("hzBt5");

var $hcRXD = parcelRequire("hcRXD");
function $b19070a46c0d3f3f$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx) // We do not set clipShape on group, because it will cut part of
    ) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
function $b19070a46c0d3f3f$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $hzBt5.isObject)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $b19070a46c0d3f3f$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel('emphasis');
    return {
        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle(),
        focus: emphasisModel.get('focus'),
        blurScope: emphasisModel.get('blurScope'),
        hoverScale: emphasisModel.get('scale'),
        labelStatesModels: (0, $hcRXD.getLabelStatesModels)(seriesModel),
        cursorStyle: seriesModel.get('cursor')
    };
}
var $b19070a46c0d3f3f$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $hXAsm.default();
        this._SymbolCtor = SymbolCtor || (0, $jYHZD.default);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        opt = $b19070a46c0d3f3f$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $b19070a46c0d3f3f$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        }; // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($b19070a46c0d3f3f$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$b19070a46c0d3f3f$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl // Create a new if symbol type changed.
             || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $9ubot.updateProps(symbolEl, target, seriesModel);
            } // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            });
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.isPersistent = function() {
        return true;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $b19070a46c0d3f3f$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        opt = $b19070a46c0d3f3f$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($b19070a46c0d3f3f$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
            }
        }
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data; // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            });
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $b19070a46c0d3f3f$export$2e2bcd8739ae039 = $b19070a46c0d3f3f$var$SymbolDraw;

});
parcelRegister("jYHZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b5bf02f312d853$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $4TnMt = parcelRequire("4TnMt");

var $hXAsm = parcelRequire("hXAsm");
var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");

var $aly4X = parcelRequire("aly4X");

var $51xyq = parcelRequire("51xyq");

var $bY5Ss = parcelRequire("bY5Ss");

var $hzBt5 = parcelRequire("hzBt5");

var $hcRXD = parcelRequire("hcRXD");

var $agXnr = parcelRequire("agXnr");

var $9ubot = parcelRequire("9ubot");
var $e8b5bf02f312d853$var$Symbol = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
        // Remove paths created before
        this.removeAll(); // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $4TnMt.createSymbol)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: 100,
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        }); // Rewrite drift method
        symbolPath.drift = $e8b5bf02f312d853$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $51xyq.enterEmphasis)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $51xyq.leaveEmphasis)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
            this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $9ubot.updateProps(symbolPath, target, seriesModel, idx);
            (0, $9ubot.saveOldStyle)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $9ubot.initProps(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop remove animation manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation('remove');
        this._seriesModel = seriesModel;
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            selectItemStyle = itemModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            labelStatesModels = (0, $hcRXD.getLabelStatesModels)(itemModel);
            hoverScale = emphasisModel.getShallow('scale');
            cursorStyle = itemModel.getShallow('cursor');
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $4TnMt.normalizeSymbolOffset)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr('cursor', cursorStyle);
        var symbolStyle = data.getItemVisual(idx, 'style');
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $agXnr.default)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $hzBt5.extend)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $hzBt5.extend)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
             // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, 'liftZ');
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $hcRXD.setLabelStyle)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        }); // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $bY5Ss.getDefaultLabel)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState('emphasis');
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState('select').style = selectItemStyle;
        symbolPath.ensureState('blur').style = blurItemStyle;
        if (hoverScale) {
            var scaleRatio = Math.max(1.1, 3 / this._sizeY);
            emphasisState.scaleX = this._sizeX * scaleRatio;
            emphasisState.scaleY = this._sizeY * scaleRatio;
        }
        this.setSymbolScale(1);
        (0, $51xyq.enableHoverEmphasis)(this, focus, blurScope);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, opt) {
        var symbolPath = this.childAt(0);
        var seriesModel = this._seriesModel;
        var dataIndex = (0, $aly4X.getECData)(this).dataIndex;
        var animationOpt = opt && opt.animation; // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true; // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $9ubot.removeElement(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $9ubot.removeElement(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $4TnMt.normalizeSymbolSize)(data.getItemVisual(idx, 'symbolSize'));
    };
    return Symbol;
}($hXAsm.default);
function $e8b5bf02f312d853$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $e8b5bf02f312d853$export$2e2bcd8739ae039 = $e8b5bf02f312d853$var$Symbol;

});
parcelRegister("bY5Ss", function(module, exports) {

$parcel$export(module.exports, "getDefaultLabel", () => $8b69db686b4b90ad$export$5ff20667590927ed);
$parcel$export(module.exports, "getDefaultInterpolatedLabel", () => $8b69db686b4b90ad$export$5f84815e91ca6775);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $kWuWu = parcelRequire("kWuWu");

var $hzBt5 = parcelRequire("hzBt5");
function $8b69db686b4b90ad$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $kWuWu.retrieveRawValue)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $kWuWu.retrieveRawValue)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $8b69db686b4b90ad$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $hzBt5.isArray)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}

});



parcelRegister("d3Ews", function(module, exports) {

$parcel$export(module.exports, "default", () => $02740c5723dbdb77$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $d6Kps = parcelRequire("d6Kps");

var $5GVHb = parcelRequire("5GVHb");
function $02740c5723dbdb77$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: '+',
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: '=',
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: '-',
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $02740c5723dbdb77$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $02740c5723dbdb77$var$diffData(oldData, newData); // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = []; // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $d6Kps.prepareDataCoordInfo)(oldCoordSys, newData, oldValueOrigin); // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout('points') || [];
    var newPoints = newData.getLayout('points') || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0; // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case '=':
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1]; // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case '+':
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $d6Kps.getStackedOnPoint)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case '-':
                pointAdded = false;
        } // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    } // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $5GVHb.createFloat32Array)(len);
    var sortedNextPoints = (0, $5GVHb.createFloat32Array)(len);
    var sortedCurrStackedPoints = (0, $5GVHb.createFloat32Array)(len);
    var sortedNextStackedPoints = (0, $5GVHb.createFloat32Array)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}

});
parcelRegister("d6Kps", function(module, exports) {

$parcel$export(module.exports, "prepareDataCoordInfo", () => $98afd5e42a9b9f7d$export$b488a529581b37e);
$parcel$export(module.exports, "getStackedOnPoint", () => $98afd5e42a9b9f7d$export$c1601aa630e7b5f8);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lljDt = parcelRequire("lljDt");

var $hzBt5 = parcelRequire("hzBt5");
function $98afd5e42a9b9f7d$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $98afd5e42a9b9f7d$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
    var dims = (0, $hzBt5.map)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo('stackResultDimension');
    if ((0, $lljDt.isDimensionStacked)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $lljDt.isDimensionStacked)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
    };
}
function $98afd5e42a9b9f7d$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === 'start') valueStart = extent[0];
    else if (valueOrigin === 'end') valueStart = extent[1];
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
         // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $98afd5e42a9b9f7d$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}

});

parcelRegister("5GVHb", function(module, exports) {

$parcel$export(module.exports, "createFloat32Array", () => $424da121dcfd0542$export$21d2298f3f56bbaf);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
/* global Float32Array */ var $424da121dcfd0542$var$supportFloat32Array = typeof Float32Array !== 'undefined';
var $424da121dcfd0542$var$Float32ArrayCtor = !$424da121dcfd0542$var$supportFloat32Array ? Array : Float32Array;
function $424da121dcfd0542$export$21d2298f3f56bbaf(arg) {
    if ((0, $hzBt5.isArray)(arg)) // Return self directly if don't support TypedArray.
    return $424da121dcfd0542$var$supportFloat32Array ? new Float32Array(arg) : arg;
     // Else is number
    return new $424da121dcfd0542$var$Float32ArrayCtor(arg);
}

});


parcelRegister("eQ1J3", function(module, exports) {

$parcel$export(module.exports, "ECPolyline", () => $acd742b8cfb0ce73$export$bf7c0585b8f7d00f);
$parcel$export(module.exports, "ECPolygon", () => $acd742b8cfb0ce73$export$6042a400d113f2bd);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hMiip = parcelRequire("hMiip");

var $fvvgx = parcelRequire("fvvgx");

var $jEMPh = parcelRequire("jEMPh");
var $acd742b8cfb0ce73$var$mathMin = Math.min;
var $acd742b8cfb0ce73$var$mathMax = Math.max;
function $acd742b8cfb0ce73$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $acd742b8cfb0ce73$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($acd742b8cfb0ce73$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY; // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($acd742b8cfb0ce73$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0; // Is last point
                if (tmpK >= segLen || $acd742b8cfb0ce73$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === 'x') {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        cpx1 = x - lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + lenPrevSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === 'y') {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        cpx1 = x;
                        cpy1 = y - lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + lenPrevSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1); // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg); // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg; // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $acd742b8cfb0ce73$var$mathMin(nextCpx0, $acd742b8cfb0ce73$var$mathMax(nextX, x));
                        nextCpy0 = $acd742b8cfb0ce73$var$mathMin(nextCpy0, $acd742b8cfb0ce73$var$mathMax(nextY, y));
                        nextCpx0 = $acd742b8cfb0ce73$var$mathMax(nextCpx0, $acd742b8cfb0ce73$var$mathMin(nextX, x));
                        nextCpy0 = $acd742b8cfb0ce73$var$mathMax(nextCpy0, $acd742b8cfb0ce73$var$mathMin(nextY, y)); // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg; // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $acd742b8cfb0ce73$var$mathMin(cpx1, $acd742b8cfb0ce73$var$mathMax(prevX, x));
                        cpy1 = $acd742b8cfb0ce73$var$mathMin(cpy1, $acd742b8cfb0ce73$var$mathMax(prevY, y));
                        cpx1 = $acd742b8cfb0ce73$var$mathMax(cpx1, $acd742b8cfb0ce73$var$mathMin(prevX, x));
                        cpy1 = $acd742b8cfb0ce73$var$mathMax(cpy1, $acd742b8cfb0ce73$var$mathMin(prevY, y)); // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $acd742b8cfb0ce73$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $acd742b8cfb0ce73$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polyline';
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $acd742b8cfb0ce73$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2; // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$acd742b8cfb0ce73$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$acd742b8cfb0ce73$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $acd742b8cfb0ce73$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $fvvgx.default).CMD;
        var x0;
        var y0;
        var isDimX = dim === 'x';
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $jEMPh.cubicRootAt)(x0, x, x2, x3, xOrY, roots) : (0, $jEMPh.cubicRootAt)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $jEMPh.cubicAt)(y0, y, y2, y3, t_1) : (0, $jEMPh.cubicAt)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $hMiip.default));
var $acd742b8cfb0ce73$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($acd742b8cfb0ce73$var$ECPolylineShape);
var $acd742b8cfb0ce73$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polygon';
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $acd742b8cfb0ce73$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$acd742b8cfb0ce73$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$acd742b8cfb0ce73$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $acd742b8cfb0ce73$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $acd742b8cfb0ce73$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $hMiip.default));

});

parcelRegister("azEx8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b2c9d57df7f60e3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $hXAsm = parcelRequire("hXAsm");

var $9aOrz = parcelRequire("9aOrz");

var $jKrBG = parcelRequire("jKrBG");

var $ckizb = parcelRequire("ckizb");

var $51xyq = parcelRequire("51xyq");

var $bw304 = parcelRequire("bw304");

var $xPMeE = parcelRequire("xPMeE");
var $7b2c9d57df7f60e3$var$inner = $ckizb.makeInner();
var $7b2c9d57df7f60e3$var$renderPlanner = (0, $xPMeE.default)();
var $7b2c9d57df7f60e3$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $hXAsm.default)();
        this.uid = $9aOrz.getUID('viewChart');
        this.renderTask = (0, $bw304.createTask)({
            plan: $7b2c9d57df7f60e3$var$renderTaskPlan,
            reset: $7b2c9d57df7f60e3$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        $7b2c9d57df7f60e3$var$toggleHighlight(seriesModel.getData(), payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        $7b2c9d57df7f60e3$var$toggleHighlight(seriesModel.getData(), payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    }; // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $7b2c9d57df7f60e3$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $7b2c9d57df7f60e3$var$elSetState(el, state, highlightDigit) {
    if (el) (state === 'emphasis' ? (0, $51xyq.enterEmphasis) : (0, $51xyq.leaveEmphasis))(el, highlightDigit);
}
function $7b2c9d57df7f60e3$var$toggleHighlight(data, payload, state) {
    var dataIndex = $ckizb.queryDataIndex(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $51xyq.getHighlightDigit)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $hzBt5.each)($ckizb.normalizeToArray(dataIndex), function(dataIdx) {
        $7b2c9d57df7f60e3$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $7b2c9d57df7f60e3$var$elSetState(el, state, highlightDigit);
    });
}
$jKrBG.enableClassExtend($7b2c9d57df7f60e3$var$ChartView, [
    'dispose'
]);
$jKrBG.enableClassManagement($7b2c9d57df7f60e3$var$ChartView);
function $7b2c9d57df7f60e3$var$renderTaskPlan(context) {
    return $7b2c9d57df7f60e3$var$renderPlanner(context.model);
}
function $7b2c9d57df7f60e3$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload; // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $7b2c9d57df7f60e3$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
     : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $7b2c9d57df7f60e3$var$progressMethodMap[methodName];
}
var $7b2c9d57df7f60e3$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $7b2c9d57df7f60e3$export$2e2bcd8739ae039 = $7b2c9d57df7f60e3$var$ChartView;

});
parcelRegister("xPMeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $065b3f0378fb8022$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");
function $065b3f0378fb8022$export$2e2bcd8739ae039() {
    var inner = (0, $ckizb.makeInner)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}

});


parcelRegister("gNqT1", function(module, exports) {

$parcel$export(module.exports, "createGridClipPath", () => $c3a6140b1e4a0074$export$83958787eb658d14);
$parcel$export(module.exports, "createPolarClipPath", () => $c3a6140b1e4a0074$export$13dc2b2230df3cb5);
$parcel$export(module.exports, "createClipPath", () => $c3a6140b1e4a0074$export$e0fe5081209d01c9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");
var $rnA7j = parcelRequire("rnA7j");

var $5BQXp = parcelRequire("5BQXp");
function $c3a6140b1e4a0074$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
    x = Math.floor(x);
    width = Math.round(width);
    var clipPath = new $aeCKo.default({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = typeof during === 'function' ? function(percent) {
            during(percent, clipPath);
        } : null;
        $9ubot.initProps(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $c3a6140b1e4a0074$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $5BQXp.round)(sectorArea.r0, 1);
    var r = (0, $5BQXp.round)(sectorArea.r, 1);
    var clipPath = new $rnA7j.default({
        shape: {
            cx: (0, $5BQXp.round)(polar.cx, 1),
            cy: (0, $5BQXp.round)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $9ubot.initProps(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $c3a6140b1e4a0074$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $c3a6140b1e4a0074$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $c3a6140b1e4a0074$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}

});

parcelRegister("PS5GS", function(module, exports) {

$parcel$export(module.exports, "isCoordinateSystemType", () => $09beb8d67d3f2200$export$8567506e6336616);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $09beb8d67d3f2200$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}

});


parcelRegister("icXd2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d41746b1a709ea63$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $xPMeE = parcelRequire("xPMeE");

var $lljDt = parcelRequire("lljDt");

var $5GVHb = parcelRequire("5GVHb");
function $d41746b1a709ea63$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $xPMeE.default)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $hzBt5.map)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            if ((0, $lljDt.isDimensionStacked)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $lljDt.isDimensionStacked)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $5GVHb.createFloat32Array)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i); // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i); // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout('points', points);
                }
            };
        }
    };
}

});

parcelRegister("d1Jiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $97be818e11f33dce$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $97be818e11f33dce$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
         // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
         // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $97be818e11f33dce$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $97be818e11f33dce$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count(); // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio(); // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if (typeof sampling === 'string') sampler = $97be818e11f33dce$var$samplers[sampling];
                    else if (typeof sampling === 'function') sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $97be818e11f33dce$var$indexSampler));
                }
            }
        }
    };
}

});


parcelRegister("j3E5n", function(module, exports) {

$parcel$export(module.exports, "install", () => $03949a647b4f2fbc$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lDnHX = parcelRequire("lDnHX");

var $hxCCu = parcelRequire("hxCCu");

var $YHaPr = parcelRequire("YHaPr");

var $jTM8g = parcelRequire("jTM8g");

var $icXd2 = parcelRequire("icXd2");
function $03949a647b4f2fbc$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $lDnHX.use)((0, $jTM8g.install));
    registers.registerSeriesModel((0, $hxCCu.default));
    registers.registerChartView((0, $YHaPr.default));
    registers.registerLayout((0, $icXd2.default)('scatter'));
}

});
parcelRegister("lDnHX", function(module, exports) {

$parcel$export(module.exports, "use", () => $fbffa16771d86969$export$1f96ae73734a86cc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $eLPvY = parcelRequire("eLPvY");

var $4uCJH = parcelRequire("4uCJH");

var $azEx8 = parcelRequire("azEx8");

var $6IEE1 = parcelRequire("6IEE1");

var $5vVec = parcelRequire("5vVec");

var $hzBt5 = parcelRequire("hzBt5");

var $fK0Gs = parcelRequire("fK0Gs");
var $fbffa16771d86969$var$extensions = [];
var $fbffa16771d86969$var$extensionRegisters = {
    registerPreprocessor: (0, $eLPvY.registerPreprocessor),
    registerProcessor: (0, $eLPvY.registerProcessor),
    registerPostInit: (0, $eLPvY.registerPostInit),
    registerPostUpdate: (0, $eLPvY.registerPostUpdate),
    registerUpdateLifecycle: (0, $eLPvY.registerUpdateLifecycle),
    registerAction: (0, $eLPvY.registerAction),
    registerCoordinateSystem: (0, $eLPvY.registerCoordinateSystem),
    registerLayout: (0, $eLPvY.registerLayout),
    registerVisual: (0, $eLPvY.registerVisual),
    registerTransform: (0, $eLPvY.registerTransform),
    registerLoading: (0, $eLPvY.registerLoading),
    registerMap: (0, $eLPvY.registerMap),
    PRIORITY: (0, $eLPvY.PRIORITY),
    ComponentModel: (0, $6IEE1.default),
    ComponentView: (0, $4uCJH.default),
    SeriesModel: (0, $5vVec.default),
    ChartView: (0, $azEx8.default),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $6IEE1.default).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $4uCJH.default).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $5vVec.default).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $azEx8.default).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $6IEE1.default).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $fK0Gs.registerPainter)(painterType, PainterCtor);
    }
};
function $fbffa16771d86969$export$1f96ae73734a86cc(ext) {
    if ((0, $hzBt5.isArray)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $hzBt5.each)(ext, function(singleExt) {
            $fbffa16771d86969$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $hzBt5.indexOf)($fbffa16771d86969$var$extensions, ext) >= 0) return;
    $fbffa16771d86969$var$extensions.push(ext);
    if ((0, $hzBt5.isFunction)(ext)) ext = {
        install: ext
    };
    ext.install($fbffa16771d86969$var$extensionRegisters);
}

});
parcelRegister("eLPvY", function(module, exports) {

$parcel$export(module.exports, "version", () => $ac0d6a32e251a4a9$export$83d89fbfd8236492);
$parcel$export(module.exports, "dependencies", () => $ac0d6a32e251a4a9$export$b74ff737e0e298b5);
$parcel$export(module.exports, "PRIORITY", () => $ac0d6a32e251a4a9$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "init", () => $ac0d6a32e251a4a9$export$2cd8252107eb640b);
$parcel$export(module.exports, "getInstanceByDom", () => $ac0d6a32e251a4a9$export$33b6fbccd4f643f8);
$parcel$export(module.exports, "connect", () => $ac0d6a32e251a4a9$export$64605811ab45167f);
$parcel$export(module.exports, "disConnect", () => $ac0d6a32e251a4a9$export$87cd6834112ecb52);
$parcel$export(module.exports, "disconnect", () => $ac0d6a32e251a4a9$export$37dfea93db2e14ed);
$parcel$export(module.exports, "dispose", () => $ac0d6a32e251a4a9$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "getInstanceById", () => $ac0d6a32e251a4a9$export$89b4be35062c4a3f);
$parcel$export(module.exports, "registerTheme", () => $ac0d6a32e251a4a9$export$f9c59eed5de5ff80);
$parcel$export(module.exports, "registerPreprocessor", () => $ac0d6a32e251a4a9$export$77095792a057b768);
$parcel$export(module.exports, "registerProcessor", () => $ac0d6a32e251a4a9$export$d575e6557ac1729f);
$parcel$export(module.exports, "registerPostInit", () => $ac0d6a32e251a4a9$export$c8c249911ee8c1ed);
$parcel$export(module.exports, "registerUpdateLifecycle", () => $ac0d6a32e251a4a9$export$c9ec4b5faef04865);
$parcel$export(module.exports, "registerPostUpdate", () => $ac0d6a32e251a4a9$export$99560909c18c76bb);
$parcel$export(module.exports, "registerAction", () => $ac0d6a32e251a4a9$export$408c24786cd729c6);
$parcel$export(module.exports, "registerCoordinateSystem", () => $ac0d6a32e251a4a9$export$1dd5e025a8a37dd);
$parcel$export(module.exports, "getCoordinateSystemDimensions", () => $ac0d6a32e251a4a9$export$fc2638719e4159b9);
$parcel$export(module.exports, "registerLayout", () => $ac0d6a32e251a4a9$export$d768f97700ca6bea);
$parcel$export(module.exports, "registerVisual", () => $ac0d6a32e251a4a9$export$5f32c1eb94c381bb);
$parcel$export(module.exports, "registerLoading", () => $ac0d6a32e251a4a9$export$e06b68a82007c015);
$parcel$export(module.exports, "setCanvasCreator", () => $ac0d6a32e251a4a9$export$10425ea7a243b114);
$parcel$export(module.exports, "registerMap", () => $ac0d6a32e251a4a9$export$d456de060be2dba1);
$parcel$export(module.exports, "getMap", () => $ac0d6a32e251a4a9$export$b8586192aead8a7e);
$parcel$export(module.exports, "registerTransform", () => $ac0d6a32e251a4a9$export$f01d71dd0389d7e4);
$parcel$export(module.exports, "dataTool", () => $ac0d6a32e251a4a9$export$73cae5e090579589);
$parcel$export(module.exports, "registerLocale", () => (parcelRequire("6FMoP")).registerLocale);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $fKE23 = parcelRequire("fKE23");

var $fK0Gs = parcelRequire("fK0Gs");

var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");

var $gZXYp = parcelRequire("gZXYp");

var $ishiy = parcelRequire("ishiy");

var $1J7Ke = parcelRequire("1J7Ke");

var $2dhmo = parcelRequire("2dhmo");

var $4npYR = parcelRequire("4npYR");

var $gwjrp = parcelRequire("gwjrp");

var $lphfQ = parcelRequire("lphfQ");

var $7OS81 = parcelRequire("7OS81");

var $5kOH0 = parcelRequire("5kOH0");

var $5vVec = parcelRequire("5vVec");

var $4uCJH = parcelRequire("4uCJH");

var $azEx8 = parcelRequire("azEx8");
parcelRequire("8q0E1");
var $agXnr = parcelRequire("agXnr");
var $hMiip = parcelRequire("hMiip");
var $aeCKo = parcelRequire("aeCKo");
var $9ubot = parcelRequire("9ubot");

var $aly4X = parcelRequire("aly4X");

var $51xyq = parcelRequire("51xyq");

var $ckizb = parcelRequire("ckizb");

var $7b8YY = parcelRequire("7b8YY");

var $4fAPP = parcelRequire("4fAPP");

var $b0zNB = parcelRequire("b0zNB");

var $86dkp = parcelRequire("86dkp");

var $dsS8i = parcelRequire("dsS8i");

var $85Dmy = parcelRequire("85Dmy");

var $jKrBG = parcelRequire("jKrBG");

var $9xw3H = parcelRequire("9xw3H");

var $fTE3u = parcelRequire("fTE3u");

var $3uf7q = parcelRequire("3uf7q");

var $6ds7H = parcelRequire("6ds7H");

var $kPQAq = parcelRequire("kPQAq");

var $jjR5M = parcelRequire("jjR5M");

var $6FMoP = parcelRequire("6FMoP");

var $1MZkk = parcelRequire("1MZkk");

var $aXrNM = parcelRequire("aXrNM");

var $lIsFn = parcelRequire("lIsFn");

var $3Vx2a = parcelRequire("3Vx2a");
var $ac0d6a32e251a4a9$var$hasWindow = typeof window !== 'undefined';
var $ac0d6a32e251a4a9$export$83d89fbfd8236492 = '5.2.1';
var $ac0d6a32e251a4a9$export$b74ff737e0e298b5 = {
    zrender: '5.2.1'
};
var $ac0d6a32e251a4a9$var$TEST_FRAME_REMAIN_TIME = 1;
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800; // Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DATASTACK = 900; // "Data filter" will block the stream, so it should be
// put at the begining of data processing.
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART = 3000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_COMPONENT = 4000; // Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500; // Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_BRUSH = 5000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_ARIA = 6000;
var $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_DECAL = 7000;
var $ac0d6a32e251a4a9$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_ARIA,
        DECAL: $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_DECAL
    }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var $ac0d6a32e251a4a9$var$PENDING_UPDATE = '__pendingUpdate';
var $ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $ac0d6a32e251a4a9$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_PENDING = 0;
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATING = 1;
var $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATED = 2;
function $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        return $ac0d6a32e251a4a9$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $ac0d6a32e251a4a9$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $ac0d6a32e251a4a9$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $1J7Ke.default).prototype[method].apply(host, args);
}
var $ac0d6a32e251a4a9$var$MessageCenter = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $1J7Ke.default));
var $ac0d6a32e251a4a9$var$messageCenterProto = $ac0d6a32e251a4a9$var$MessageCenter.prototype;
$ac0d6a32e251a4a9$var$messageCenterProto.on = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseMessageCenter('on');
$ac0d6a32e251a4a9$var$messageCenterProto.off = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseMessageCenter('off'); // ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $ac0d6a32e251a4a9$var$prepare;
var $ac0d6a32e251a4a9$var$prepareView;
var $ac0d6a32e251a4a9$var$updateDirectly;
var $ac0d6a32e251a4a9$var$updateMethods;
var $ac0d6a32e251a4a9$var$doConvertPixel;
var $ac0d6a32e251a4a9$var$updateStreamModes;
var $ac0d6a32e251a4a9$var$doDispatchAction;
var $ac0d6a32e251a4a9$var$flushPendingActions;
var $ac0d6a32e251a4a9$var$triggerUpdatedEvent;
var $ac0d6a32e251a4a9$var$bindRenderedEvent;
var $ac0d6a32e251a4a9$var$bindMouseEvent;
var $ac0d6a32e251a4a9$var$clearColorPalette;
var $ac0d6a32e251a4a9$var$render;
var $ac0d6a32e251a4a9$var$renderComponents;
var $ac0d6a32e251a4a9$var$renderSeries;
var $ac0d6a32e251a4a9$var$createExtensionAPI;
var $ac0d6a32e251a4a9$var$enableConnect;
var $ac0d6a32e251a4a9$var$markStatusToUpdate;
var $ac0d6a32e251a4a9$var$applyChangedStates;
var $ac0d6a32e251a4a9$var$ECharts = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ECharts, _super);
    function ECharts(dom, theme, opts) {
        var _this = _super.call(this, new (0, $9xw3H.ECEventProcessor)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {}; // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {}; // Get theme by name
        if (typeof theme === 'string') theme = $ac0d6a32e251a4a9$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultUseDirtyRect = false;
        var root, devUseDirtyRect;
        var zr = _this._zr = $fK0Gs.init(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            useDirtyRect: opts.useDirtyRect == null ? defaultUseDirtyRect : opts.useDirtyRect
        }); // Expect 60 fps.
        _this._throttledZrFlush = (0, $7b8YY.throttle)((0, $hzBt5.bind)(zr.flush, zr), 17);
        theme = (0, $hzBt5.clone)(theme);
        theme && (0, $7OS81.default)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $6FMoP.createLocaleObject)(opts.locale || (0, $6FMoP.SYSTEM_LANG));
        _this._coordSysMgr = new (0, $gwjrp.default)();
        var api = _this._api = $ac0d6a32e251a4a9$var$createExtensionAPI(_this); // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $ishiy.default)($ac0d6a32e251a4a9$var$visualFuncs, prioritySortFunc);
        (0, $ishiy.default)($ac0d6a32e251a4a9$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $86dkp.default)(_this, api, $ac0d6a32e251a4a9$var$dataProcessorFuncs, $ac0d6a32e251a4a9$var$visualFuncs);
        _this._messageCenter = new $ac0d6a32e251a4a9$var$MessageCenter(); // Init mouse events
        _this._initEvents(); // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $hzBt5.bind)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $ac0d6a32e251a4a9$var$bindRenderedEvent(zr, _this);
        $ac0d6a32e251a4a9$var$bindMouseEvent(zr, _this); // ECharts instance can be used as value.
        (0, $hzBt5.setAsPrimitive)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $ac0d6a32e251a4a9$var$applyChangedStates(this);
        var scheduler = this._scheduler; // Lazy update
        if (this[$ac0d6a32e251a4a9$var$PENDING_UPDATE]) {
            var silent = this[$ac0d6a32e251a4a9$var$PENDING_UPDATE].silent;
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
            $ac0d6a32e251a4a9$var$prepare(this);
            $ac0d6a32e251a4a9$var$updateMethods.update.call(this, null, this[$ac0d6a32e251a4a9$var$PENDING_UPDATE].updateParams); // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
            $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
            $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $ac0d6a32e251a4a9$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $ac0d6a32e251a4a9$var$updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determin in the first frame (the
                // frame is executed immedietely after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $ac0d6a32e251a4a9$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
             // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $hzBt5.isObject)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $lphfQ.default)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $2dhmo.default)();
            ecModel.scheduler = this._scheduler;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $ac0d6a32e251a4a9$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false; // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            $ac0d6a32e251a4a9$var$prepare(this);
            $ac0d6a32e251a4a9$var$updateMethods.update.call(this, null, updateParams); // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            this._zr.flush();
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
            $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
            $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @DEPRECATED
   */ ECharts.prototype.setTheme = function() {
        console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
    }; // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || $ac0d6a32e251a4a9$var$hasWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        if (!(0, $gZXYp.default).canvasSupported) return;
        opts = opts || {};
        return this._zr.painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $gZXYp.default).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList(); // Stop animations
        (0, $hzBt5.each)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $hzBt5.each)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $hzBt5.each)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $gZXYp.default).canvasSupported) return;
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($ac0d6a32e251a4a9$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $hzBt5.each)($ac0d6a32e251a4a9$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas((0, $hzBt5.clone)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $hzBt5.createCanvas)();
            var zr_1 = $fK0Gs.init(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $hzBt5.each)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $aeCKo.default({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $hzBt5.each)(canvasList_1, function(item) {
                    var img = new $agXnr.default({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $ac0d6a32e251a4a9$var$doConvertPixel(this, 'convertToPixel', finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $ac0d6a32e251a4a9$var$doConvertPixel(this, 'convertFromPixel', finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $ckizb.parseFinder(ecModel, finder);
        (0, $hzBt5.each)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $hzBt5.each)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $ckizb.parseFinder(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $3uf7q.getItemVisualFromData)(data, dataIndexInside, visualType) : (0, $3uf7q.getVisualFromData)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $hzBt5.each)($ac0d6a32e251a4a9$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $1MZkk.findEventDispatcher)(el, function(parent) {
                    var ecData = (0, $aly4X.getECData)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $hzBt5.extend)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                 // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            }; // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $hzBt5.each)($ac0d6a32e251a4a9$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        }); // Extra events
        // TODO register?
        (0, $hzBt5.each)([
            'selectchanged'
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $kPQAq.handleLegacySelectEvents)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        $ckizb.setAttribute(this.getDom(), $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $hzBt5.each)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $hzBt5.each)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        }); // Dispose after all views disposed
        chart._zr.dispose(); // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $ac0d6a32e251a4a9$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model; // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent; // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$ac0d6a32e251a4a9$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$ac0d6a32e251a4a9$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
        }
        this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
        needPrepare && $ac0d6a32e251a4a9$var$prepare(this);
        $ac0d6a32e251a4a9$var$updateMethods.update.call(this, {
            type: 'resize',
            animation: (0, $hzBt5.extend)({
                // Disable animation
                duration: 0
            }, opts && opts.animation)
        });
        this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
        $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
        $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        if ((0, $hzBt5.isObject)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$ac0d6a32e251a4a9$var$loadingEffects[name]) return;
        var el = $ac0d6a32e251a4a9$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $hzBt5.extend)({}, eventObj);
        payload.type = $ac0d6a32e251a4a9$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $hzBt5.isObject)(opt)) opt = {
            silent: !!opt
        };
        if (!$ac0d6a32e251a4a9$var$actions[payload.type]) return;
         // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
         // May dispatchAction in rendering procedure
        if (this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $ac0d6a32e251a4a9$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $gZXYp.default).browser.weChat) // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh util user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $ac0d6a32e251a4a9$var$flushPendingActions.call(this, silent);
        $ac0d6a32e251a4a9$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $3Vx2a.default).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $ac0d6a32e251a4a9$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    }; // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $ac0d6a32e251a4a9$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $ac0d6a32e251a4a9$var$prepareView(ecIns, true);
            $ac0d6a32e251a4a9$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $ac0d6a32e251a4a9$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By defaut view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView; // This command should not work twice.
                model.__requireNewView = false; // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $jKrBG.parseClassType)(model.type);
                    var Clazz = isComponent ? (0, $4uCJH.default).getClass(classType.main, classType.sub) : // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $azEx8.default).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $ac0d6a32e251a4a9$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload); // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $hzBt5.each)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $hzBt5.createHashMap)();
                (0, $hzBt5.each)($ckizb.normalizeToArray(excludeSeriesId), function(id) {
                    var modelId = $ckizb.convertOptionIdName(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            if ((0, $51xyq.isHighDownPayload)(payload)) (0, $51xyq.allLeaveBlur)(ecIns._api);
             // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                if ((0, $51xyq.isHighDownPayload)(payload)) {
                    if (model instanceof (0, $5vVec.default)) {
                        if (payload.type === (0, $51xyq.HIGHLIGHT_ACTION_TYPE) && !payload.notBlur) (0, $51xyq.blurSeriesFromHighlightPayload)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $51xyq.findComponentHighDownDispatchers)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $51xyq.HIGHLIGHT_ACTION_TYPE) && focusSelf && !payload.notBlur) (0, $51xyq.blurComponent)(model.mainType, model.componentIndex, ecIns._api);
                         // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $hzBt5.each)(dispatchers, function(dispatcher) {
                            payload.type === (0, $51xyq.HIGHLIGHT_ACTION_TYPE) ? (0, $51xyq.enterEmphasis)(dispatcher) : (0, $51xyq.leaveEmphasis)(dispatcher);
                        });
                    }
                } else if ((0, $51xyq.isSelectChangePayload)(payload)) // TODO geo
                {
                    if (model instanceof (0, $5vVec.default)) {
                        (0, $51xyq.toggleSelectionFromPayload)(model, payload, ecIns._api);
                        (0, $51xyq.updateSeriesElementSelection)(model);
                        $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) !== null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $ac0d6a32e251a4a9$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $ac0d6a32e251a4a9$var$prepare(this);
                $ac0d6a32e251a4a9$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel); // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the orignal point
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // deteming whether use progressive rendering.
                $ac0d6a32e251a4a9$var$updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not requied in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $ac0d6a32e251a4a9$var$render(this, ecModel, api, payload, updateParams); // Set background
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                var darkMode = ecModel.get('darkMode'); // In IE8
                if (!(0, $gZXYp.default).canvasSupported) {
                    var colorArr = $f7lrR.parse(backgroundColor);
                    backgroundColor = $f7lrR.stringify(colorArr, 'rgb');
                    if (colorArr[3] === 0) backgroundColor = 'transparent';
                } else {
                    zr.setBackgroundColor(backgroundColor); // Force set dark mode.
                    if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                }
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $hzBt5.createHashMap)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                }); // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $ac0d6a32e251a4a9$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $azEx8.default).markUpdateMethod(payload, 'updateView');
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $ac0d6a32e251a4a9$var$render(this, ecModel, this._api, payload, {});
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model; // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload); // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                }); // Perform visual
                (0, $azEx8.default).markUpdateMethod(payload, 'updateVisual');
                $ac0d6a32e251a4a9$var$clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $3Vx2a.default).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function(payload) {
                $ac0d6a32e251a4a9$var$updateMethods.update.call(this, payload);
            }
        };
        $ac0d6a32e251a4a9$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $ac0d6a32e251a4a9$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $ckizb.parseFinder(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $ac0d6a32e251a4a9$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $ac0d6a32e251a4a9$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $ac0d6a32e251a4a9$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $jKrBG.parseClassType)(cptTypeTmp[0]);
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false; // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $hzBt5.map)(payload.batch, function(item) {
                    item = (0, $hzBt5.defaults)((0, $hzBt5.extend)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $51xyq.isSelectChangePayload)(payload);
            var isHighDown = (0, $51xyq.isHighDownPayload)(payload);
            (0, $hzBt5.each)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api); // Emit event outside
                eventObj = eventObj || (0, $hzBt5.extend)({}, batchItem); // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $ckizb.preParseFinder(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $ac0d6a32e251a4a9$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $ac0d6a32e251a4a9$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(_this);
                } else if (cptType) $ac0d6a32e251a4a9$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
                // Still dirty
                if (this[$ac0d6a32e251a4a9$var$PENDING_UPDATE]) {
                    $ac0d6a32e251a4a9$var$prepare(this);
                    $ac0d6a32e251a4a9$var$updateMethods.update.call(this, payload);
                    this[$ac0d6a32e251a4a9$var$PENDING_UPDATE] = null;
                } else $ac0d6a32e251a4a9$var$updateMethods[updateMethod].call(this, payload);
            } // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$ac0d6a32e251a4a9$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj); // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: 'selectchanged',
                        escapeConnect: escapeConnect,
                        selected: (0, $51xyq.getAllSelectedIndices)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $ac0d6a32e251a4a9$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $ac0d6a32e251a4a9$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $ac0d6a32e251a4a9$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $ac0d6a32e251a4a9$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params); // The `finished` event should not be triggered repeatly,
                // so it should only be triggered when rendering indeed happend
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$ac0d6a32e251a4a9$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $ac0d6a32e251a4a9$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $1MZkk.findEventDispatcher)(el, (0, $51xyq.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $51xyq.handleGlobalMouseOverForHighDown)(dispatcher, e, ecIns._api);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $1MZkk.findEventDispatcher)(el, (0, $51xyq.isHighDownDispatcher));
                if (dispatcher) {
                    (0, $51xyq.handleGlboalMouseOutForHighDown)(dispatcher, e, ecIns._api);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $1MZkk.findEventDispatcher)(el, function(target) {
                    return (0, $aly4X.getECData)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $aly4X.getECData)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        $ac0d6a32e251a4a9$var$clearColorPalette = function(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        };
        $ac0d6a32e251a4a9$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            $ac0d6a32e251a4a9$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $hzBt5.each)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $ac0d6a32e251a4a9$var$renderSeries(ecIns, ecModel, api, payload, updateParams); // Remove groups of unrendered charts
            (0, $hzBt5.each)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $ac0d6a32e251a4a9$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $hzBt5.each)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $ac0d6a32e251a4a9$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $hzBt5.extend)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            }); // TODO progressive?
            (0, $3Vx2a.default).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload); // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent'); // Should not call markRedraw on group, because it will disable zrender
                // increamental render (alway render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $51xyq.updateSeriesElementSelection)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $3Vx2a.default).trigger('series:layoutlabels', ecModel, api, updateParams); // transition after label is layouted.
            (0, $3Vx2a.default).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId]; // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView); // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            }); // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $3Vx2a.default).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $ac0d6a32e251a4a9$var$markStatusToUpdate = function(ecIns) {
            ecIns[$ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY] = true; // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $ac0d6a32e251a4a9$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($9ubot.isElementRemoved(el)) return;
                applyElementStates(el);
            });
            ecIns[$ac0d6a32e251a4a9$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates; // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            } // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $51xyq.HOVER_STATE_EMPHASIS) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $51xyq.HOVER_STATE_BLUR) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $gZXYp.default).node && !(0, $gZXYp.default).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.group.traverse(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.group.traverse(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DONT mark the element dirty. In case element is incremental and don't wan't to rerender.
                el.style.blend = blendMode;
                if (el.eachPendingDisplayable) el.eachPendingDisplayable(function(displayable) {
                    displayable.style.blend = blendMode;
                });
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
             // Set z and zlevel
            _updateZ(view.group, model.get('z') || 0, model.get('zlevel') || 0, -Infinity);
        }
        function _updateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                // el.traverse((childEl: Element) => _updateZ(childEl, z, zlevel));
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(_updateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            } // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel; // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        } // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.group.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($9ubot.isElementRemoved(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                 // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing') // additive: stateAnimationModel.get('additive')
            } : null;
            view.group.traverse(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($9ubot.isElementRemoved(el)) return;
                    if (el instanceof $hMiip.default) (0, $51xyq.savePathStates)(el);
                     // Only updated on changed element. In case element is incremental and don't wan't to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates; // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    } // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine(); // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    } // The use higlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $ac0d6a32e251a4a9$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $fKE23.__extends)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $51xyq.enterEmphasis)(el, highlightDigit);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $51xyq.leaveEmphasis)(el, highlightDigit);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $51xyq.enterBlur)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $51xyq.leaveBlur)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $51xyq.enterSelect)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $51xyq.leaveSelect)(el);
                    $ac0d6a32e251a4a9$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $4npYR.default)))(ecIns);
        };
        $ac0d6a32e251a4a9$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $hzBt5.each)($ac0d6a32e251a4a9$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($ac0d6a32e251a4a9$var$connectedGroups[chart.group] && chart[$ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY] !== $ac0d6a32e251a4a9$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $hzBt5.each)($ac0d6a32e251a4a9$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $ac0d6a32e251a4a9$var$CONNECT_STATUS_PENDING);
                        (0, $hzBt5.each)(otherCharts_1, function(otherChart) {
                            if (otherChart[$ac0d6a32e251a4a9$var$CONNECT_STATUS_KEY] !== $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $ac0d6a32e251a4a9$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $1J7Ke.default));
var $ac0d6a32e251a4a9$var$echartsProto = $ac0d6a32e251a4a9$var$ECharts.prototype;
$ac0d6a32e251a4a9$var$echartsProto.on = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseECharts('on');
$ac0d6a32e251a4a9$var$echartsProto.off = $ac0d6a32e251a4a9$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$ac0d6a32e251a4a9$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $6ds7H.deprecateLog)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2); // @ts-ignore
        self.off(eventName, wrapped);
    }
    this.on.call(this, eventName, wrapped, ctx);
}; // /**
//  * Encode visual infomation from data after data processing
//  *
//  * @param {module:echarts/model/Global} ecModel
//  * @param {object} layout
//  * @param {boolean} [layoutFilter] `true`: only layout,
//  *                                 `false`: only not layout,
//  *                                 `null`/`undefined`: all.
//  * @param {string} taskBaseTag
//  * @private
//  */
// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
//     each(visualFuncs, function (visual, index) {
//         let isLayout = visual.isLayout;
//         if (layoutFilter == null
//             || (layoutFilter === false && !isLayout)
//             || (layoutFilter === true && isLayout)
//         ) {
//             visual.func(ecModel, api, payload);
//         }
//     });
// }
var $ac0d6a32e251a4a9$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $ac0d6a32e251a4a9$var$disposedWarning(id) {}
var $ac0d6a32e251a4a9$var$actions = {};
/**
 * Map eventType to actionType
 */ var $ac0d6a32e251a4a9$var$eventActionMap = {};
var $ac0d6a32e251a4a9$var$dataProcessorFuncs = [];
var $ac0d6a32e251a4a9$var$optionPreprocessorFuncs = [];
var $ac0d6a32e251a4a9$var$visualFuncs = [];
var $ac0d6a32e251a4a9$var$themeStorage = {};
var $ac0d6a32e251a4a9$var$loadingEffects = {};
var $ac0d6a32e251a4a9$var$instances = {};
var $ac0d6a32e251a4a9$var$connectedGroups = {};
var $ac0d6a32e251a4a9$var$idBase = +new Date() - 0;
var $ac0d6a32e251a4a9$var$groupIdBase = +new Date() - 0;
var $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $ac0d6a32e251a4a9$export$2cd8252107eb640b(dom, theme, opts) {
    var existInstance = $ac0d6a32e251a4a9$export$33b6fbccd4f643f8(dom);
    if (existInstance) return existInstance;
    var chart = new $ac0d6a32e251a4a9$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $ac0d6a32e251a4a9$var$idBase++;
    $ac0d6a32e251a4a9$var$instances[chart.id] = chart;
    $ckizb.setAttribute(dom, $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY, chart.id);
    $ac0d6a32e251a4a9$var$enableConnect(chart);
    (0, $3Vx2a.default).trigger('afterinit', chart);
    return chart;
}
function $ac0d6a32e251a4a9$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $hzBt5.isArray)(groupId)) {
        var charts = groupId;
        groupId = null; // If any chart has group
        (0, $hzBt5.each)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $ac0d6a32e251a4a9$var$groupIdBase++;
        (0, $hzBt5.each)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $ac0d6a32e251a4a9$var$connectedGroups[groupId] = true;
    return groupId;
}
function $ac0d6a32e251a4a9$export$87cd6834112ecb52(groupId) {
    $ac0d6a32e251a4a9$var$connectedGroups[groupId] = false;
}
var $ac0d6a32e251a4a9$export$37dfea93db2e14ed = $ac0d6a32e251a4a9$export$87cd6834112ecb52;
function $ac0d6a32e251a4a9$export$fcfbbcec2cb820d5(chart) {
    if (typeof chart === 'string') chart = $ac0d6a32e251a4a9$var$instances[chart];
    else if (!(chart instanceof $ac0d6a32e251a4a9$var$ECharts)) // Try to treat as dom
    chart = $ac0d6a32e251a4a9$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $ac0d6a32e251a4a9$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $ac0d6a32e251a4a9$export$33b6fbccd4f643f8(dom) {
    return $ac0d6a32e251a4a9$var$instances[$ckizb.getAttribute(dom, $ac0d6a32e251a4a9$var$DOM_ATTRIBUTE_KEY)];
}
function $ac0d6a32e251a4a9$export$89b4be35062c4a3f(key) {
    return $ac0d6a32e251a4a9$var$instances[key];
}
function $ac0d6a32e251a4a9$export$f9c59eed5de5ff80(name, theme) {
    $ac0d6a32e251a4a9$var$themeStorage[name] = theme;
}
function $ac0d6a32e251a4a9$export$77095792a057b768(preprocessorFunc) {
    if ((0, $hzBt5.indexOf)($ac0d6a32e251a4a9$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $ac0d6a32e251a4a9$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $ac0d6a32e251a4a9$export$d575e6557ac1729f(priority, processor) {
    $ac0d6a32e251a4a9$var$normalizeRegister($ac0d6a32e251a4a9$var$dataProcessorFuncs, priority, processor, $ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $ac0d6a32e251a4a9$export$c8c249911ee8c1ed(postInitFunc) {
    $ac0d6a32e251a4a9$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $ac0d6a32e251a4a9$export$99560909c18c76bb(postUpdateFunc) {
    $ac0d6a32e251a4a9$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $ac0d6a32e251a4a9$export$c9ec4b5faef04865(name, cb) {
    (0, $3Vx2a.default).on(name, cb);
}
function $ac0d6a32e251a4a9$export$408c24786cd729c6(actionInfo, eventName, action) {
    if (typeof eventName === 'function') {
        action = eventName;
        eventName = '';
    }
    var actionType = (0, $hzBt5.isObject)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0]; // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($ac0d6a32e251a4a9$var$eventActionMap[eventName]) // Already registered.
    return;
     // Validate action type and event name.
    (0, $hzBt5.assert)($ac0d6a32e251a4a9$var$ACTION_REG.test(actionType) && $ac0d6a32e251a4a9$var$ACTION_REG.test(eventName));
    if (!$ac0d6a32e251a4a9$var$actions[actionType]) $ac0d6a32e251a4a9$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $ac0d6a32e251a4a9$var$eventActionMap[eventName] = actionType;
}
function $ac0d6a32e251a4a9$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $gwjrp.default).register(type, coordSysCreator);
}
function $ac0d6a32e251a4a9$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $gwjrp.default).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $ac0d6a32e251a4a9$export$d768f97700ca6bea(priority, layoutTask) {
    $ac0d6a32e251a4a9$var$normalizeRegister($ac0d6a32e251a4a9$var$visualFuncs, priority, layoutTask, $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $ac0d6a32e251a4a9$export$5f32c1eb94c381bb(priority, visualTask) {
    $ac0d6a32e251a4a9$var$normalizeRegister($ac0d6a32e251a4a9$var$visualFuncs, priority, visualTask, $ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $ac0d6a32e251a4a9$var$registeredTasks = [];
function $ac0d6a32e251a4a9$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $hzBt5.isFunction)(priority) || (0, $hzBt5.isObject)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    if ((0, $hzBt5.indexOf)($ac0d6a32e251a4a9$var$registeredTasks, fn) >= 0) return;
    $ac0d6a32e251a4a9$var$registeredTasks.push(fn);
    var stageHandler = (0, $86dkp.default).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $ac0d6a32e251a4a9$export$e06b68a82007c015(name, loadingFx) {
    $ac0d6a32e251a4a9$var$loadingEffects[name] = loadingFx;
}
function $ac0d6a32e251a4a9$export$10425ea7a243b114(creator) {
    (0, $hzBt5.$override)('createCanvas', creator);
}
function $ac0d6a32e251a4a9$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    (0, $lIsFn.default).registerMap(mapName, geoJson, specialAreas);
}
function $ac0d6a32e251a4a9$export$b8586192aead8a7e(mapName) {
    return (0, $lIsFn.default).getMapForUser(mapName);
}
var $ac0d6a32e251a4a9$export$f01d71dd0389d7e4 = (0, $jjR5M.registerExternalTransform);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Buitlin global visual
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL, (0, $4fAPP.seriesStyleTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $4fAPP.dataStyleTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $4fAPP.dataColorPaletteTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_GLOBAL, (0, $fTE3u.seriesSymbolTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $fTE3u.dataSymbolTask));
$ac0d6a32e251a4a9$export$5f32c1eb94c381bb($ac0d6a32e251a4a9$var$PRIORITY_VISUAL_DECAL, (0, $aXrNM.default));
$ac0d6a32e251a4a9$export$77095792a057b768((0, $7OS81.default));
$ac0d6a32e251a4a9$export$d575e6557ac1729f($ac0d6a32e251a4a9$var$PRIORITY_PROCESSOR_DATASTACK, (0, $5kOH0.default));
$ac0d6a32e251a4a9$export$e06b68a82007c015('default', (0, $b0zNB.default)); // Default actions
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.HIGHLIGHT_ACTION_TYPE),
    event: (0, $51xyq.HIGHLIGHT_ACTION_TYPE),
    update: (0, $51xyq.HIGHLIGHT_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.DOWNPLAY_ACTION_TYPE),
    event: (0, $51xyq.DOWNPLAY_ACTION_TYPE),
    update: (0, $51xyq.DOWNPLAY_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.SELECT_ACTION_TYPE),
    event: (0, $51xyq.SELECT_ACTION_TYPE),
    update: (0, $51xyq.SELECT_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.UNSELECT_ACTION_TYPE),
    event: (0, $51xyq.UNSELECT_ACTION_TYPE),
    update: (0, $51xyq.UNSELECT_ACTION_TYPE)
}, (0, $hzBt5.noop));
$ac0d6a32e251a4a9$export$408c24786cd729c6({
    type: (0, $51xyq.TOGGLE_SELECT_ACTION_TYPE),
    event: (0, $51xyq.TOGGLE_SELECT_ACTION_TYPE),
    update: (0, $51xyq.TOGGLE_SELECT_ACTION_TYPE)
}, (0, $hzBt5.noop)); // Default theme
$ac0d6a32e251a4a9$export$f9c59eed5de5ff80('light', (0, $dsS8i.default));
$ac0d6a32e251a4a9$export$f9c59eed5de5ff80('dark', (0, $85Dmy.default)); // For backward compatibility, where the namespace `dataTool` will
var $ac0d6a32e251a4a9$export$73cae5e090579589 = {};

});
parcelRegister("fK0Gs", function(module, exports) {

$parcel$export(module.exports, "init", () => $b75baeaa5b677679$export$2cd8252107eb640b);
$parcel$export(module.exports, "dispose", () => $b75baeaa5b677679$export$fcfbbcec2cb820d5);
$parcel$export(module.exports, "disposeAll", () => $b75baeaa5b677679$export$825f692fb04800ef);
$parcel$export(module.exports, "getInstance", () => $b75baeaa5b677679$export$8bedcca5bbd73999);
$parcel$export(module.exports, "registerPainter", () => $b75baeaa5b677679$export$a3e793ccb11823a5);
$parcel$export(module.exports, "version", () => $b75baeaa5b677679$export$83d89fbfd8236492);
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ 
var $gZXYp = parcelRequire("gZXYp");

var $hzBt5 = parcelRequire("hzBt5");

var $5W9iv = parcelRequire("5W9iv");

var $lfoBJ = parcelRequire("lfoBJ");

var $j4zsp = parcelRequire("j4zsp");

var $h7l6S = parcelRequire("h7l6S");

var $f7lrR = parcelRequire("f7lrR");

var $2MY1H = parcelRequire("2MY1H");

var $hXAsm = parcelRequire("hXAsm");
var $b75baeaa5b677679$var$useVML = !(0, $gZXYp.default).canvasSupported;
var $b75baeaa5b677679$var$painterCtors = {};
var $b75baeaa5b677679$var$instances = {};
function $b75baeaa5b677679$var$delInstance(id) {
    delete $b75baeaa5b677679$var$instances[id];
}
function $b75baeaa5b677679$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $f7lrR.lum)(backgroundColor, 1) < (0, $2MY1H.DARK_MODE_THRESHOLD);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $f7lrR.lum)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $2MY1H.DARK_MODE_THRESHOLD);
    }
    return false;
}
var $b75baeaa5b677679$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $lfoBJ.default)();
        var rendererType = opts.renderer || 'canvas';
        if ($b75baeaa5b677679$var$useVML) throw new Error('IE8 support has been dropped since 5.0');
        if (!$b75baeaa5b677679$var$painterCtors[rendererType]) rendererType = $hzBt5.keys($b75baeaa5b677679$var$painterCtors)[0];
        if (!$b75baeaa5b677679$var$painterCtors[rendererType]) throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $b75baeaa5b677679$var$painterCtors[rendererType](dom, storage, opts, id);
        this.storage = storage;
        this.painter = painter;
        var handerProxy = !(0, $gZXYp.default).node && !(0, $gZXYp.default).worker ? new (0, $h7l6S.default)(painter.getViewportRoot(), painter.root) : null;
        this.handler = new (0, $5W9iv.default)(storage, painter, handerProxy, painter.root);
        this.animation = new (0, $j4zsp.default)({
            stage: {
                update: function() {
                    return _this._flush(true);
                }
            }
        });
        this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (!el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (!el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $b75baeaa5b677679$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = new Date().getTime();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = new Date().getTime();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.addHover = function(el) {};
    ZRender.prototype.removeHover = function(el) {};
    ZRender.prototype.clearHover = function() {};
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        return this.painter.getHeight();
    };
    ZRender.prototype.pathToImage = function(e, dpr) {
        if (this.painter.pathToImage) return this.painter.pathToImage(e, dpr);
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $hXAsm.default)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        $b75baeaa5b677679$var$delInstance(this.id);
    };
    return ZRender;
}();
function $b75baeaa5b677679$export$2cd8252107eb640b(dom, opts) {
    var zr = new $b75baeaa5b677679$var$ZRender($hzBt5.guid(), dom, opts);
    $b75baeaa5b677679$var$instances[zr.id] = zr;
    return zr;
}
function $b75baeaa5b677679$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $b75baeaa5b677679$export$825f692fb04800ef() {
    for(var key in $b75baeaa5b677679$var$instances)if ($b75baeaa5b677679$var$instances.hasOwnProperty(key)) $b75baeaa5b677679$var$instances[key].dispose();
    $b75baeaa5b677679$var$instances = {};
}
function $b75baeaa5b677679$export$8bedcca5bbd73999(id) {
    return $b75baeaa5b677679$var$instances[id];
}
function $b75baeaa5b677679$export$a3e793ccb11823a5(name, Ctor) {
    $b75baeaa5b677679$var$painterCtors[name] = Ctor;
}
var $b75baeaa5b677679$export$83d89fbfd8236492 = '5.2.1';

});
parcelRegister("5W9iv", function(module, exports) {

$parcel$export(module.exports, "default", () => $011d92ea87e5dba5$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $ef5pP = parcelRequire("ef5pP");

var $apbEE = parcelRequire("apbEE");

var $1J7Ke = parcelRequire("1J7Ke");

var $kcVwz = parcelRequire("kcVwz");

var $kRPD1 = parcelRequire("kRPD1");
var $011d92ea87e5dba5$var$SILENT = 'silent';
function $011d92ea87e5dba5$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $011d92ea87e5dba5$var$stopEvent
    };
}
function $011d92ea87e5dba5$var$stopEvent() {
    $kcVwz.stop(this.event);
}
var $011d92ea87e5dba5$var$EmptyProxy = function(_super) {
    (0, $fKE23.__extends)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $1J7Ke.default));
var $011d92ea87e5dba5$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $011d92ea87e5dba5$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $011d92ea87e5dba5$var$Handler = function(_super) {
    (0, $fKE23.__extends)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot) {
        var _this = _super.call(this) || this;
        _this._hovered = new $011d92ea87e5dba5$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        proxy = proxy || new $011d92ea87e5dba5$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $apbEE.default)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $hzBt5.each($011d92ea87e5dba5$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $011d92ea87e5dba5$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $011d92ea87e5dba5$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $011d92ea87e5dba5$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $011d92ea87e5dba5$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $011d92ea87e5dba5$var$HoveredResult(x, y);
        for(var i = list.length - 1; i >= 0; i--){
            var hoverCheckResult = void 0;
            if (list[i] !== exclude && !list[i].ignore && (hoverCheckResult = $011d92ea87e5dba5$var$isHover(list[i], x, y))) {
                !out.topTarget && (out.topTarget = list[i]);
                if (hoverCheckResult !== $011d92ea87e5dba5$var$SILENT) {
                    out.target = list[i];
                    break;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $kRPD1.GestureMgr)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $011d92ea87e5dba5$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $1J7Ke.default));
$hzBt5.each([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $011d92ea87e5dba5$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $011d92ea87e5dba5$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $ef5pP.dist(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $011d92ea87e5dba5$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
                if (el.silent) isSilent = true;
            }
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $011d92ea87e5dba5$var$SILENT : true;
    }
    return false;
}
function $011d92ea87e5dba5$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $011d92ea87e5dba5$export$2e2bcd8739ae039 = $011d92ea87e5dba5$var$Handler;

});
parcelRegister("apbEE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7935478a0fe49760$export$2e2bcd8739ae039);
var $7935478a0fe49760$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $7935478a0fe49760$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $7935478a0fe49760$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $7935478a0fe49760$export$2e2bcd8739ae039 = $7935478a0fe49760$var$Draggable;

});

parcelRegister("kcVwz", function(module, exports) {

$parcel$export(module.exports, "clientToLocal", () => $eb618cc8e782fd94$export$7d5fecde839eee88);
$parcel$export(module.exports, "getNativeEvent", () => $eb618cc8e782fd94$export$4abe0e945399ac1d);
$parcel$export(module.exports, "normalizeEvent", () => $eb618cc8e782fd94$export$40fadb093aebad71);
$parcel$export(module.exports, "addEventListener", () => $eb618cc8e782fd94$export$3f65cefe8380dbea);
$parcel$export(module.exports, "removeEventListener", () => $eb618cc8e782fd94$export$8ff9f68337b520c0);
$parcel$export(module.exports, "stop", () => $eb618cc8e782fd94$export$fa6813432f753b0d);
$parcel$export(module.exports, "isMiddleOrRightButtonOnMouseUpDown", () => $eb618cc8e782fd94$export$b7ae4cded3e71bd2);


var $gZXYp = parcelRequire("gZXYp");

var $bZSeh = parcelRequire("bZSeh");
var $eb618cc8e782fd94$var$isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
var $eb618cc8e782fd94$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $eb618cc8e782fd94$var$_calcOut = [];
function $eb618cc8e782fd94$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate || !(0, $gZXYp.default).canvasSupported) $eb618cc8e782fd94$var$calculateZrXY(el, e, out);
    else if ((0, $gZXYp.default).browser.firefox && (0, $gZXYp.default).browser.version < '39' && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $eb618cc8e782fd94$var$calculateZrXY(el, e, out);
    return out;
}
function $eb618cc8e782fd94$var$calculateZrXY(el, e, out) {
    if ((0, $gZXYp.default).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $bZSeh.isCanvasEl)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $bZSeh.transformCoordWithViewport)($eb618cc8e782fd94$var$_calcOut, el, ex, ey)) {
            out.zrX = $eb618cc8e782fd94$var$_calcOut[0];
            out.zrY = $eb618cc8e782fd94$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $eb618cc8e782fd94$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $eb618cc8e782fd94$export$40fadb093aebad71(el, e, calculate) {
    e = $eb618cc8e782fd94$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $eb618cc8e782fd94$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $eb618cc8e782fd94$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $eb618cc8e782fd94$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $eb618cc8e782fd94$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $eb618cc8e782fd94$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $eb618cc8e782fd94$export$3f65cefe8380dbea(el, name, handler, opt) {
    if ($eb618cc8e782fd94$var$isDomLevel2) el.addEventListener(name, handler, opt);
    else el.attachEvent('on' + name, handler);
}
function $eb618cc8e782fd94$export$8ff9f68337b520c0(el, name, handler, opt) {
    if ($eb618cc8e782fd94$var$isDomLevel2) el.removeEventListener(name, handler, opt);
    else el.detachEvent('on' + name, handler);
}
var $eb618cc8e782fd94$export$fa6813432f753b0d = $eb618cc8e782fd94$var$isDomLevel2 ? function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
} : function(e) {
    e.returnValue = false;
    e.cancelBubble = true;
};
function $eb618cc8e782fd94$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}
function $eb618cc8e782fd94$export$a564e1c0090572c3(e) {
    return e.which > 1;
}

});
parcelRegister("bZSeh", function(module, exports) {

$parcel$export(module.exports, "transformLocalCoord", () => $8bbf75058a6b57c9$export$8c5c02e118307e20);
$parcel$export(module.exports, "transformCoordWithViewport", () => $8bbf75058a6b57c9$export$1219648acc517df4);
$parcel$export(module.exports, "isCanvasEl", () => $8bbf75058a6b57c9$export$1b92e4fe606eff6d);

var $gZXYp = parcelRequire("gZXYp");

var $81CZA = parcelRequire("81CZA");
var $8bbf75058a6b57c9$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $8bbf75058a6b57c9$var$_calcOut = [];
function $8bbf75058a6b57c9$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $8bbf75058a6b57c9$export$1219648acc517df4($8bbf75058a6b57c9$var$_calcOut, elFrom, inX, inY, true) && $8bbf75058a6b57c9$export$1219648acc517df4(out, elTarget, $8bbf75058a6b57c9$var$_calcOut[0], $8bbf75058a6b57c9$var$_calcOut[1]);
}
function $8bbf75058a6b57c9$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $gZXYp.default).domSupported && !$8bbf75058a6b57c9$export$1b92e4fe606eff6d(el)) {
        var saved = el[$8bbf75058a6b57c9$var$EVENT_SAVED_PROP] || (el[$8bbf75058a6b57c9$var$EVENT_SAVED_PROP] = {});
        var markers = $8bbf75058a6b57c9$var$prepareCoordMarkers(el, saved);
        var transformer = $8bbf75058a6b57c9$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $8bbf75058a6b57c9$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $8bbf75058a6b57c9$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $81CZA.buildTransformer)(destCoords, srcCoords) : (0, $81CZA.buildTransformer)(srcCoords, destCoords));
}
function $8bbf75058a6b57c9$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}

});
parcelRegister("81CZA", function(module, exports) {

$parcel$export(module.exports, "buildTransformer", () => $5d7ca9ca97ec0f53$export$fbdb2748a8171a7e);
var $5d7ca9ca97ec0f53$var$LN2 = Math.log(2);
function $5d7ca9ca97ec0f53$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $5d7ca9ca97ec0f53$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $5d7ca9ca97ec0f53$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $5d7ca9ca97ec0f53$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $5d7ca9ca97ec0f53$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $5d7ca9ca97ec0f53$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}

});



parcelRegister("kRPD1", function(module, exports) {

$parcel$export(module.exports, "GestureMgr", () => $f310ce30087a842e$export$f7557d6f27e9503);

var $kcVwz = parcelRequire("kcVwz");
var $f310ce30087a842e$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $kcVwz.clientToLocal(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $f310ce30087a842e$var$recognizers)if ($f310ce30087a842e$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $f310ce30087a842e$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $f310ce30087a842e$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $f310ce30087a842e$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $f310ce30087a842e$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $f310ce30087a842e$var$dist(pinchEnd) / $f310ce30087a842e$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $f310ce30087a842e$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};

});


parcelRegister("lfoBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77e163c3eac4839$export$2e2bcd8739ae039);

var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $ishiy = parcelRequire("ishiy");

var $4rgPt = parcelRequire("4rgPt");
var $f77e163c3eac4839$var$invalidZErrorLogged = false;
function $f77e163c3eac4839$var$logInvalidZError() {
    if ($f77e163c3eac4839$var$invalidZErrorLogged) return;
    $f77e163c3eac4839$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $f77e163c3eac4839$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $f77e163c3eac4839$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $f77e163c3eac4839$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $gZXYp.default).canvasSupported && (0, $ishiy.default)(displayList, $f77e163c3eac4839$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $4rgPt.REDRAW_BIT);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $f77e163c3eac4839$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $f77e163c3eac4839$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $f77e163c3eac4839$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $hzBt5.indexOf(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $f77e163c3eac4839$export$2e2bcd8739ae039 = $f77e163c3eac4839$var$Storage;

});
parcelRegister("ishiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f8429c613e9f08$export$2e2bcd8739ae039);
var $d6f8429c613e9f08$var$DEFAULT_MIN_MERGE = 32;
var $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING = 7;
var $d6f8429c613e9f08$var$DEFAULT_TMP_STORAGE_LENGTH = 256;
function $d6f8429c613e9f08$var$minRunLength(n) {
    var r = 0;
    while(n >= $d6f8429c613e9f08$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $d6f8429c613e9f08$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $d6f8429c613e9f08$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $d6f8429c613e9f08$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $d6f8429c613e9f08$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $d6f8429c613e9f08$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $d6f8429c613e9f08$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $d6f8429c613e9f08$var$TimSort(array, compare) {
    var minGallop = $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING;
    var length = 0;
    var tmpStorageLength = $d6f8429c613e9f08$var$DEFAULT_TMP_STORAGE_LENGTH;
    var stackLength = 0;
    var runStart;
    var runLength;
    var stackSize = 0;
    length = array.length;
    if (length < 2 * $d6f8429c613e9f08$var$DEFAULT_TMP_STORAGE_LENGTH) tmpStorageLength = length >>> 1;
    var tmp = [];
    stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $d6f8429c613e9f08$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $d6f8429c613e9f08$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $d6f8429c613e9f08$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $d6f8429c613e9f08$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING || count2 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $d6f8429c613e9f08$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $d6f8429c613e9f08$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING || count2 >= $d6f8429c613e9f08$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $d6f8429c613e9f08$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $d6f8429c613e9f08$var$DEFAULT_MIN_MERGE) {
        runLength = $d6f8429c613e9f08$var$makeAscendingRun(array, lo, hi, compare);
        $d6f8429c613e9f08$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $d6f8429c613e9f08$var$TimSort(array, compare);
    var minRun = $d6f8429c613e9f08$var$minRunLength(remaining);
    do {
        runLength = $d6f8429c613e9f08$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $d6f8429c613e9f08$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}

});


parcelRegister("j4zsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $de29e51d8a0734e2$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $1J7Ke = parcelRequire("1J7Ke");

var $a1kVg = parcelRequire("a1kVg");

var $fyp5g = parcelRequire("fyp5g");
var $de29e51d8a0734e2$var$Animation = function(_super) {
    (0, $fKE23.__extends)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        _this.onframe = opts.onframe || function() {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._clipsHead) this._clipsHead = this._clipsTail = clip;
        else {
            this._clipsTail.next = clip;
            clip.prev = this._clipsTail;
            clip.next = null;
            this._clipsTail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._clipsHead = next;
        if (next) next.prev = prev;
        else this._clipsTail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = new Date().getTime() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy && clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.onframe(delta);
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $a1kVg.default)(step);
                !self._paused && self.update();
            }
        }
        (0, $a1kVg.default)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = new Date().getTime();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = new Date().getTime();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += new Date().getTime() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._clipsHead;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._clipsHead = this._clipsTail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._clipsHead == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $fyp5g.default)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $1J7Ke.default));
var $de29e51d8a0734e2$export$2e2bcd8739ae039 = $de29e51d8a0734e2$var$Animation;

});
parcelRegister("a1kVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ba3a2607959739$export$2e2bcd8739ae039);
var $74ba3a2607959739$var$requestAnimationFrame;
$74ba3a2607959739$var$requestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $74ba3a2607959739$export$2e2bcd8739ae039 = $74ba3a2607959739$var$requestAnimationFrame;

});


parcelRegister("h7l6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c763772147e79027$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $kcVwz = parcelRequire("kcVwz");

var $hzBt5 = parcelRequire("hzBt5");

var $1J7Ke = parcelRequire("1J7Ke");

var $gZXYp = parcelRequire("gZXYp");
var $c763772147e79027$var$TOUCH_CLICK_DELAY = 300;
var $c763772147e79027$var$globalEventSupported = (0, $gZXYp.default).domSupported;
var $c763772147e79027$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $hzBt5.map(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $c763772147e79027$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $c763772147e79027$var$wheelEventSupported = false;
function $c763772147e79027$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $c763772147e79027$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $c763772147e79027$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $c763772147e79027$var$normalizeGlobalEvent(instance, event) {
    return (0, $kcVwz.normalizeEvent)(instance.dom, new $c763772147e79027$var$FakeGlobalEvent(instance, event), true);
}
function $c763772147e79027$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $c763772147e79027$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $hzBt5.noop;
        this.stopImmediatePropagation = $hzBt5.noop;
        this.preventDefault = $hzBt5.noop;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $c763772147e79027$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$c763772147e79027$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $c763772147e79027$var$wheelEventSupported = true;
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($c763772147e79027$var$wheelEventSupported) return;
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        $c763772147e79027$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $c763772147e79027$var$localDOMHandlers.mousemove.call(this, event);
        $c763772147e79027$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        $c763772147e79027$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $c763772147e79027$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        $c763772147e79027$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $c763772147e79027$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $c763772147e79027$var$TOUCH_CLICK_DELAY) $c763772147e79027$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $c763772147e79027$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$c763772147e79027$var$isPointerFromTouch(event)) $c763772147e79027$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c763772147e79027$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$c763772147e79027$var$isPointerFromTouch(event)) $c763772147e79027$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$hzBt5.each([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $c763772147e79027$var$localDOMHandlers[name] = function(event) {
        event = (0, $kcVwz.normalizeEvent)(this.dom, event);
        this.trigger(name, event);
    };
});
var $c763772147e79027$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$c763772147e79027$var$isPointerFromTouch(event)) $c763772147e79027$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c763772147e79027$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $c763772147e79027$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $gZXYp.default).pointerEventsSupported) $hzBt5.each($c763772147e79027$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $gZXYp.default).touchEventsSupported) $hzBt5.each($c763772147e79027$var$localNativeListenerNames.touch, function(nativeEventName) {
            $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $c763772147e79027$var$setTouchTimer(scope);
            });
        });
        $hzBt5.each($c763772147e79027$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $kcVwz.getNativeEvent)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $c763772147e79027$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $gZXYp.default).pointerEventsSupported) $hzBt5.each($c763772147e79027$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $gZXYp.default).touchEventsSupported) $hzBt5.each($c763772147e79027$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $kcVwz.getNativeEvent)(event);
            if (!$c763772147e79027$var$isLocalEl(instance, event.target)) {
                event = $c763772147e79027$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $c763772147e79027$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $kcVwz.addEventListener)(scope.domTarget, nativeEventName, listener, opt);
}
function $c763772147e79027$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $kcVwz.removeEventListener)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $c763772147e79027$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $c763772147e79027$var$HandlerDomProxy = function(_super) {
    (0, $fKE23.__extends)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $c763772147e79027$var$DOMHandlerScope(dom, $c763772147e79027$var$localDOMHandlers);
        if ($c763772147e79027$var$globalEventSupported) _this._globalHandlerScope = new $c763772147e79027$var$DOMHandlerScope(document, $c763772147e79027$var$globalDOMHandlers);
        $c763772147e79027$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $c763772147e79027$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($c763772147e79027$var$globalEventSupported) $c763772147e79027$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($c763772147e79027$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $c763772147e79027$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $c763772147e79027$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $1J7Ke.default));
var $c763772147e79027$export$2e2bcd8739ae039 = $c763772147e79027$var$HandlerDomProxy;

});


parcelRegister("2dhmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ca430915a8c220$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $fR3z1 = parcelRequire("fR3z1");

var $6IEE1 = parcelRequire("6IEE1");

var $k23Xr = parcelRequire("k23Xr");

var $be33G = parcelRequire("be33G");

var $lmEWj = parcelRequire("lmEWj");

var $b7fr8 = parcelRequire("b7fr8");

var $6ds7H = parcelRequire("6ds7H");
// Internal method names:
// -----------------------
var $19ca430915a8c220$var$reCreateSeriesIndices;
var $19ca430915a8c220$var$assertSeriesInitialized;
var $19ca430915a8c220$var$initBase;
var $19ca430915a8c220$var$OPTION_INNER_KEY = '\0_ec_inner';
var $19ca430915a8c220$var$OPTION_INNER_VALUE = 1;
var $19ca430915a8c220$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $19ca430915a8c220$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $19ca430915a8c220$var$componetsMissingLogPrinted = {};
function $19ca430915a8c220$var$checkMissingComponents(option) {
    (0, $hzBt5.each)(option, function(componentOption, mainType) {
        if (!(0, $6IEE1.default).hasClass(mainType)) {
            var componentImportName = $19ca430915a8c220$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$19ca430915a8c220$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $6ds7H.error)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $19ca430915a8c220$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $19ca430915a8c220$var$GlobalModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $fR3z1.default)(theme);
        this._locale = new (0, $fR3z1.default)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $19ca430915a8c220$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $19ca430915a8c220$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $19ca430915a8c220$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
         // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Becuase either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $hzBt5.each)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $hzBt5.createHashMap)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $be33G.resetSourceDefaulter)(this); // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $hzBt5.each)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $6IEE1.default).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $hzBt5.clone)(componentOption) : (0, $hzBt5.merge)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $6IEE1.default).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $6IEE1.default).topologicalTravel(newCmptTypes, (0, $6IEE1.default).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $lmEWj.concatInternalOptions)(this, mainType, $ckizb.normalizeToArray(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $ckizb.mappingToExists(oldCmptList, newCmptOptionList, mergeMode); // Set mainType and complete subType.
            $ckizb.setComponentTypeToKeyInfo(mappingResult, mainType, (0, $6IEE1.default)); // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            (0, $hzBt5.each)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    } // If no both `resultItem.exist` and `resultItem.option`,
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $6IEE1.default).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $hzBt5.extend)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt); // Assign `keyInfo`
                        (0, $hzBt5.extend)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this); // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType); // Backup series for filtering.
            if (mainType === 'series') $19ca430915a8c220$var$reCreateSeriesIndices(this);
        } // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $19ca430915a8c220$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $hzBt5.clone)(this.option);
        (0, $hzBt5.each)(option, function(optInMainType, mainType) {
            if ((0, $6IEE1.default).hasClass(mainType)) {
                var opts = $ckizb.normalizeToArray(optInMainType); // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$ckizb.isComponentIdInternal(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$19ca430915a8c220$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $hzBt5.each)($ckizb.normalizeToArray(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $19ca430915a8c220$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $19ca430915a8c220$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $hzBt5.filter)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $19ca430915a8c220$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) // Retrieve all non-empty components.
         : (0, $hzBt5.filter)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($19ca430915a8c220$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $hzBt5.filter)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $hzBt5.isFunction)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $hzBt5.isString)(mainType) ? componentsMap.get(mainType) : (0, $hzBt5.isObject)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $ckizb.convertOptionIdName(name, null);
        return (0, $hzBt5.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $hzBt5.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $hzBt5.filter)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * frome raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        (0, $hzBt5.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $hzBt5.each)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * frome raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        (0, $hzBt5.each)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $hzBt5.each)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $19ca430915a8c220$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $hzBt5.each)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $hzBt5.createHashMap)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $19ca430915a8c220$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $6IEE1.default).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $6IEE1.default).topologicalTravel(componentTypes, (0, $6IEE1.default).getAllClassMainTypes(), function(componentType) {
            (0, $hzBt5.each)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$19ca430915a8c220$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $19ca430915a8c220$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $hzBt5.each)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $hzBt5.createHashMap)(seriesIndices);
        };
        $19ca430915a8c220$var$assertSeriesInitialized = function(ecModel) {};
        $19ca430915a8c220$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option can not be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
            ecModel.option = {};
            ecModel.option[$19ca430915a8c220$var$OPTION_INNER_KEY] = $19ca430915a8c220$var$OPTION_INNER_VALUE; // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $hzBt5.createHashMap)({
                series: []
            });
            ecModel._componentsCount = (0, $hzBt5.createHashMap)(); // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $hzBt5.isObject)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $19ca430915a8c220$var$mergeTheme(baseOption, ecModel._theme.option); // TODO Needs clone when merging to the unexisted property
            (0, $hzBt5.merge)(baseOption, (0, $k23Xr.default), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $fR3z1.default));
function $19ca430915a8c220$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $19ca430915a8c220$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $hzBt5.each)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer) return;
         // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $6IEE1.default).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $hzBt5.clone)(themeItem) : (0, $hzBt5.merge)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $19ca430915a8c220$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $hzBt5.isArray)(idOrName)) {
        var keyMap_1 = (0, $hzBt5.createHashMap)();
        (0, $hzBt5.each)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $ckizb.convertOptionIdName(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $hzBt5.filter)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $ckizb.convertOptionIdName(idOrName, null);
        return (0, $hzBt5.filter)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $19ca430915a8c220$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $hzBt5.filter)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $19ca430915a8c220$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $hzBt5.createHashMap)();
    opts && (0, $hzBt5.each)($ckizb.normalizeToArray(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $hzBt5.mixin)($19ca430915a8c220$var$GlobalModel, (0, $b7fr8.PaletteMixin));
var $19ca430915a8c220$export$2e2bcd8739ae039 = $19ca430915a8c220$var$GlobalModel;

});
parcelRegister("k23Xr", function(module, exports) {

$parcel$export(module.exports, "default", () => $e957107c4dffe14d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e957107c4dffe14d$var$platform = ''; // Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $e957107c4dffe14d$var$platform = navigator.platform || '';
var $e957107c4dffe14d$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $e957107c4dffe14d$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: [
        '#5470c6',
        '#91cc75',
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
    ],
    gradientColor: [
        '#f6efa6',
        '#d88273',
        '#bf444c'
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $e957107c4dffe14d$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $e957107c4dffe14d$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};

});

parcelRegister("lmEWj", function(module, exports) {

$parcel$export(module.exports, "registerInternalOptionCreator", () => $f8db68cd66566bc9$export$5a90be4668898d38);
$parcel$export(module.exports, "concatInternalOptions", () => $f8db68cd66566bc9$export$c713a6a3b43f401d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $f8db68cd66566bc9$var$internalOptionCreatorMap = (0, $hzBt5.createHashMap)();
function $f8db68cd66566bc9$export$5a90be4668898d38(mainType, creator) {
    (0, $hzBt5.assert)($f8db68cd66566bc9$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $f8db68cd66566bc9$var$internalOptionCreatorMap.set(mainType, creator);
}
function $f8db68cd66566bc9$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $f8db68cd66566bc9$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}

});


parcelRegister("4npYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $32fd769e3cea974a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $32fd769e3cea974a$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    'getOption',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $32fd769e3cea974a$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $hzBt5.each($32fd769e3cea974a$var$availableMethods, function(methodName) {
            this[methodName] = $hzBt5.bind(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $32fd769e3cea974a$export$2e2bcd8739ae039 = $32fd769e3cea974a$var$ExtensionAPI;

});

parcelRegister("lphfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f959512fe28bc5bf$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $f959512fe28bc5bf$var$QUERY_REG = /^(min|max)?(.+)$/; // Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $f959512fe28bc5bf$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $hzBt5.each)((0, $ckizb.normalizeToArray)(rawOption.series), function(series) {
                series && series.data && (0, $hzBt5.isTypedArray)(series.data) && (0, $hzBt5.setAsPrimitive)(series.data);
            });
            (0, $hzBt5.each)((0, $ckizb.normalizeToArray)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $hzBt5.isTypedArray)(dataset.source) && (0, $hzBt5.setAsPrimitive)(dataset.source);
            });
        } // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $hzBt5.clone)(rawOption); // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $f959512fe28bc5bf$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, becuase in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline opitons will not be merged to the formers, but just substitude them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $hzBt5.clone)(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
         ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $hzBt5.clone)(timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = []; // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
         // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($f959512fe28bc5bf$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
         // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$f959512fe28bc5bf$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $hzBt5.map)(indices, function(index) {
            return (0, $hzBt5.clone)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
         // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $f959512fe28bc5bf$var$parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption; // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption; // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $hzBt5.isArray)(mediaOnRoot)) (0, $hzBt5.each)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $hzBt5.each)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $hzBt5.each)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $hzBt5.each)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $f959512fe28bc5bf$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lowser case for convenientce.
    };
    var applicatable = true;
    (0, $hzBt5.each)(query, function(value, attr) {
        var matched = attr.match($f959512fe28bc5bf$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$f959512fe28bc5bf$var$compare(realMap[realAttr], value, operator)) applicatable = false;
    });
    return applicatable;
}
function $f959512fe28bc5bf$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $f959512fe28bc5bf$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handle its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performace expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$f959512fe28bc5bf$export$2e2bcd8739ae039 = $f959512fe28bc5bf$var$OptionManager;

});

parcelRegister("7OS81", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1730b18ead3c3c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $71SIS = parcelRequire("71SIS");

var $ckizb = parcelRequire("ckizb");

function $5b1730b18ead3c3c$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $5b1730b18ead3c3c$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $5b1730b18ead3c3c$var$compatLayoutProperties(option) {
    option && (0, $hzBt5.each)($5b1730b18ead3c3c$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $5b1730b18ead3c3c$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $5b1730b18ead3c3c$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $5b1730b18ead3c3c$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $5b1730b18ead3c3c$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $5b1730b18ead3c3c$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $5b1730b18ead3c3c$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $5b1730b18ead3c3c$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $5b1730b18ead3c3c$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $5b1730b18ead3c3c$var$traverseTree(data[i].children, cb);
    }
}
function $5b1730b18ead3c3c$export$2e2bcd8739ae039(option, isTheme) {
    (0, $71SIS.default)(option, isTheme); // Make sure series array for model initialization.
    option.series = (0, $ckizb.normalizeToArray)(option.series);
    (0, $hzBt5.each)(option.series, function(seriesOpt) {
        if (!(0, $hzBt5.isObject)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $5b1730b18ead3c3c$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $hzBt5.isTypedArray)(data)) for(var i = 0; i < data.length; i++)$5b1730b18ead3c3c$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $5b1730b18ead3c3c$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $5b1730b18ead3c3c$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $5b1730b18ead3c3c$var$compatBarItemStyle(seriesOpt);
            $5b1730b18ead3c3c$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $5b1730b18ead3c3c$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $hzBt5.isTypedArray)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $5b1730b18ead3c3c$var$compatBarItemStyle(data[i]);
                    $5b1730b18ead3c3c$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $5b1730b18ead3c3c$var$compatSunburstState(seriesOpt);
            $5b1730b18ead3c3c$var$traverseTree(seriesOpt.data, $5b1730b18ead3c3c$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $5b1730b18ead3c3c$var$compatGraphFocus(seriesOpt); // TODO nodes, edges?
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $hzBt5.defaults)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $5b1730b18ead3c3c$var$compatLayoutProperties(seriesOpt);
    }); // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $hzBt5.each)($5b1730b18ead3c3c$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $hzBt5.isArray)(options)) options = [
                options
            ];
            (0, $hzBt5.each)(options, function(option) {
                $5b1730b18ead3c3c$var$compatLayoutProperties(option);
            });
        }
    });
}

});
parcelRegister("71SIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e31339493b497f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $51e31339493b497f$var$each = $hzBt5.each;
var $51e31339493b497f$var$isObject = $hzBt5.isObject;
var $51e31339493b497f$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $51e31339493b497f$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $51e31339493b497f$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $51e31339493b497f$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $hzBt5.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $hzBt5.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $51e31339493b497f$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $hzBt5.defaults(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt; // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $51e31339493b497f$var$removeEC3NormalStatus(opt) {
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'itemStyle');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'lineStyle');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'areaStyle');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'label');
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'labelLine'); // treemap
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'upperLabel'); // graph
    $51e31339493b497f$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $51e31339493b497f$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $51e31339493b497f$var$isObject(opt) && opt[propName];
    var textStyle = $51e31339493b497f$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $ckizb.TEXT_STYLE_OPTIONS.length; i < len; i++){
        var textPropName = $ckizb.TEXT_STYLE_OPTIONS[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $51e31339493b497f$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $51e31339493b497f$var$removeEC3NormalStatus(opt);
        $51e31339493b497f$var$compatTextStyle(opt, 'label');
        opt.emphasis && $51e31339493b497f$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $51e31339493b497f$var$processSeries(seriesOpt) {
    if (!$51e31339493b497f$var$isObject(seriesOpt)) return;
    $51e31339493b497f$var$compatEC2ItemStyle(seriesOpt);
    $51e31339493b497f$var$removeEC3NormalStatus(seriesOpt);
    $51e31339493b497f$var$compatTextStyle(seriesOpt, 'label'); // treemap
    $51e31339493b497f$var$compatTextStyle(seriesOpt, 'upperLabel'); // graph
    $51e31339493b497f$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $51e31339493b497f$var$compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
        $51e31339493b497f$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
        $51e31339493b497f$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $51e31339493b497f$var$compatEC2ItemStyle(markPoint);
        $51e31339493b497f$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $51e31339493b497f$var$compatEC2ItemStyle(markLine);
        $51e31339493b497f$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $51e31339493b497f$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$hzBt5.isTypedArray(edgeData)) for(var i = 0; i < edgeData.length; i++)$51e31339493b497f$var$compatEC3CommonStyles(edgeData[i]);
        $hzBt5.each(seriesOpt.categories, function(opt) {
            $51e31339493b497f$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$hzBt5.isTypedArray(data)) for(var i = 0; i < data.length; i++)$51e31339493b497f$var$compatEC3CommonStyles(data[i]);
     // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$51e31339493b497f$var$compatEC3CommonStyles(mpData[i]);
    } // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($hzBt5.isArray(mlData[i])) {
            $51e31339493b497f$var$compatEC3CommonStyles(mlData[i][0]);
            $51e31339493b497f$var$compatEC3CommonStyles(mlData[i][1]);
        } else $51e31339493b497f$var$compatEC3CommonStyles(mlData[i]);
    } // Series
    if (seriesOpt.type === 'gauge') {
        $51e31339493b497f$var$compatTextStyle(seriesOpt, 'axisLabel');
        $51e31339493b497f$var$compatTextStyle(seriesOpt, 'title');
        $51e31339493b497f$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $51e31339493b497f$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $hzBt5.each(seriesOpt.levels, function(opt) {
            $51e31339493b497f$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $51e31339493b497f$var$removeEC3NormalStatus(seriesOpt.leaves);
     // sunburst starts from ec4, so it does not need to compat levels.
}
function $51e31339493b497f$var$toArr(o) {
    return $hzBt5.isArray(o) ? o : o ? [
        o
    ] : [];
}
function $51e31339493b497f$var$toObj(o) {
    return ($hzBt5.isArray(o) ? o[0] : o) || {};
}
function $51e31339493b497f$export$2e2bcd8739ae039(option, isTheme) {
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.series), function(seriesOpt) {
        $51e31339493b497f$var$isObject(seriesOpt) && $51e31339493b497f$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $51e31339493b497f$var$each(axes, function(axisName) {
        $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $51e31339493b497f$var$compatTextStyle(axisOpt, 'axisLabel');
                $51e31339493b497f$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $51e31339493b497f$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $51e31339493b497f$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.calendar), function(calendarOpt) {
        $51e31339493b497f$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $51e31339493b497f$var$compatTextStyle(calendarOpt, 'dayLabel');
        $51e31339493b497f$var$compatTextStyle(calendarOpt, 'monthLabel');
        $51e31339493b497f$var$compatTextStyle(calendarOpt, 'yearLabel');
    }); // radar.name.textStyle
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.radar), function(radarOpt) {
        $51e31339493b497f$var$compatTextStyle(radarOpt, 'name'); // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.geo), function(geoOpt) {
        if ($51e31339493b497f$var$isObject(geoOpt)) {
            $51e31339493b497f$var$compatEC3CommonStyles(geoOpt);
            $51e31339493b497f$var$each($51e31339493b497f$var$toArr(geoOpt.regions), function(regionObj) {
                $51e31339493b497f$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.timeline), function(timelineOpt) {
        $51e31339493b497f$var$compatEC3CommonStyles(timelineOpt);
        $51e31339493b497f$var$convertNormalEmphasis(timelineOpt, 'label');
        $51e31339493b497f$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $51e31339493b497f$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $hzBt5.isArray(data) && $hzBt5.each(data, function(item) {
            if ($hzBt5.isObject(item)) {
                $51e31339493b497f$var$convertNormalEmphasis(item, 'label');
                $51e31339493b497f$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $51e31339493b497f$var$each($51e31339493b497f$var$toArr(option.toolbox), function(toolboxOpt) {
        $51e31339493b497f$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $51e31339493b497f$var$each(toolboxOpt.feature, function(featureOpt) {
            $51e31339493b497f$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $51e31339493b497f$var$compatTextStyle($51e31339493b497f$var$toObj(option.axisPointer), 'label');
    $51e31339493b497f$var$compatTextStyle($51e31339493b497f$var$toObj(option.tooltip).axisPointer, 'label'); // Clean logs
// storedLogs = {};
}

});


parcelRegister("5kOH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e26247f8decc4fe$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");
function $3e26247f8decc4fe$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $hzBt5.createHashMap)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            }; // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($3e26247f8decc4fe$var$calculateStack);
}
function $3e26247f8decc4fe$var$calculateStack(stackInfoList) {
    (0, $hzBt5.each)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
             // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
                    if (sum >= 0 && val > 0 || // Positive stack
                    sum <= 0 && val < 0 // Negative stack
                    ) {
                        // The sum should be as less as possible to be effected
                        // by floating arithmetic problem. A wrong result probably
                        // filtered incorrectly by axis min/max.
                        sum = (0, $5BQXp.addSafe)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}

});

parcelRegister("4uCJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $345802f60717b6ff$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hXAsm = parcelRequire("hXAsm");

var $9aOrz = parcelRequire("9aOrz");

var $jKrBG = parcelRequire("jKrBG");
var $345802f60717b6ff$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $hXAsm.default)();
        this.uid = $9aOrz.getUID('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {};
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {};
    /**
   * Hook for blur target series.
   * Can be used in marker for blur the markers
   */ ComponentView.prototype.blurSeries = function(seriesModels, ecModel) {};
    return ComponentView;
}();
$jKrBG.enableClassExtend($345802f60717b6ff$var$ComponentView);
$jKrBG.enableClassManagement($345802f60717b6ff$var$ComponentView);
var $345802f60717b6ff$export$2e2bcd8739ae039 = $345802f60717b6ff$var$ComponentView;

});

parcelRegister("7b8YY", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $53a0873be950d098$export$de363e709c412c8a);
$parcel$export(module.exports, "createOrUpdate", () => $53a0873be950d098$export$958e3e1a02eac4b6);
$parcel$export(module.exports, "clear", () => $53a0873be950d098$export$42ffd38884aecdac);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $53a0873be950d098$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $53a0873be950d098$var$RATE = '\0__throttleRate';
var $53a0873be950d098$var$THROTTLE_TYPE = '\0__throttleType';
function $53a0873be950d098$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $53a0873be950d098$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$53a0873be950d098$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$53a0873be950d098$var$THROTTLE_TYPE];
    var lastRate = fn[$53a0873be950d098$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $53a0873be950d098$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$53a0873be950d098$var$ORIGIN_METHOD] = originFn;
        fn[$53a0873be950d098$var$THROTTLE_TYPE] = throttleType;
        fn[$53a0873be950d098$var$RATE] = rate;
    }
    return fn;
}
function $53a0873be950d098$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$53a0873be950d098$var$ORIGIN_METHOD]) obj[fnAttr] = fn[$53a0873be950d098$var$ORIGIN_METHOD];
}

});

parcelRegister("4fAPP", function(module, exports) {

$parcel$export(module.exports, "seriesStyleTask", () => $318522c9f54512f0$export$7ce4d65f9b69240);
$parcel$export(module.exports, "dataStyleTask", () => $318522c9f54512f0$export$f7dcb66a065003d1);
$parcel$export(module.exports, "dataColorPaletteTask", () => $318522c9f54512f0$export$cf9758b0d6dc0aa9);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $6CLz8 = parcelRequire("6CLz8");

var $9N9yS = parcelRequire("9N9yS");

var $5jmEk = parcelRequire("5jmEk");

var $fR3z1 = parcelRequire("fR3z1");

var $ckizb = parcelRequire("ckizb");
var $318522c9f54512f0$var$inner = (0, $ckizb.makeInner)();
var $318522c9f54512f0$var$defaultStyleMappers = {
    itemStyle: (0, $6CLz8.default)((0, $9N9yS.ITEM_STYLE_KEY_MAP), true),
    lineStyle: (0, $6CLz8.default)((0, $5jmEk.LINE_STYLE_KEY_MAP), true)
};
var $318522c9f54512f0$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $318522c9f54512f0$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $318522c9f54512f0$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return $318522c9f54512f0$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $318522c9f54512f0$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $318522c9f54512f0$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unkown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $318522c9f54512f0$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $318522c9f54512f0$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        } // TODO
        var colorKey = $318522c9f54512f0$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey]; // TODO style callback
        var colorCallback = (0, $hzBt5.isFunction)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto'; // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: if some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Bacause some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || typeof globalStyle.fill === 'function' ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || typeof globalStyle.stroke === 'function' ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey); // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $hzBt5.extend)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $318522c9f54512f0$var$sharedModel = new (0, $fR3z1.default)();
var $318522c9f54512f0$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle
        var getStyle = $318522c9f54512f0$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $318522c9f54512f0$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($318522c9f54512f0$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $hzBt5.extend)(existsStyle, style);
                    if ($318522c9f54512f0$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $318522c9f54512f0$var$sharedModel.option.decal);
                        $318522c9f54512f0$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
}; // Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $318522c9f54512f0$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series use one scope.
        // Pie and funnel are using diferrent scopes
        var paletteScopeGroupByType = (0, $hzBt5.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $318522c9f54512f0$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $318522c9f54512f0$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $318522c9f54512f0$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            }); // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette'); // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};

});

parcelRegister("b0zNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $803b76b761cf12ca$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
parcelRequire("8q0E1");
var $iMbRE = parcelRequire("iMbRE");
var $aeCKo = parcelRequire("aeCKo");
var $hXAsm = parcelRequire("hXAsm");
var $kiooD = parcelRequire("kiooD");
var $803b76b761cf12ca$var$PI = Math.PI;
function $803b76b761cf12ca$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $hzBt5.defaults(opts, {
        text: 'loading',
        textColor: '#000',
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        showSpinner: true,
        color: '#5470c6',
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $hXAsm.default();
    var mask = new $aeCKo.default({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $kiooD.default({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $aeCKo.default({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $iMbRE.default({
            shape: {
                startAngle: -$803b76b761cf12ca$var$PI / 2,
                endAngle: -$803b76b761cf12ca$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $803b76b761cf12ca$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $803b76b761cf12ca$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    } // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2 // only show the text
        ) + (opts.showSpinner ? 0 : textWidth / 2 // only show the spinner
        ) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}

});

parcelRegister("86dkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e5938f91d6a514e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $bw304 = parcelRequire("bw304");

var $9aOrz = parcelRequire("9aOrz");

var $2dhmo = parcelRequire("2dhmo");

var $4npYR = parcelRequire("4npYR");

var $ckizb = parcelRequire("ckizb");
var $5e5938f91d6a514e$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $hzBt5.createHashMap)();
        this.ecInstance = ecInstance;
        this.api = api; // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    }; // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $hzBt5.createHashMap)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $hzBt5.each)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $hzBt5.assert)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $hzBt5.each)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
                // if intending to decalare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because is a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operaions
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $hzBt5.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $bw304.createTask)({
                plan: $5e5938f91d6a514e$var$seriesTaskPlan,
                reset: $5e5938f91d6a514e$var$seriesTaskReset,
                count: $5e5938f91d6a514e$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
         || (0, $bw304.createTask)({
            reset: $5e5938f91d6a514e$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap; // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $hzBt5.createHashMap)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false; // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $hzBt5.assert)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $hzBt5.each)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $bw304.createTask)({
                reset: $5e5938f91d6a514e$var$stubReset,
                onDirty: $5e5938f91d6a514e$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress // FIXME:TS never used, so comment it
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $hzBt5.isFunction)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $5e5938f91d6a514e$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $9aOrz.getUID)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $5e5938f91d6a514e$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $5e5938f91d6a514e$var$stubReset(context) {
    return context.overallProgress && $5e5938f91d6a514e$var$stubProgress;
}
function $5e5938f91d6a514e$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $5e5938f91d6a514e$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $5e5938f91d6a514e$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $5e5938f91d6a514e$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $ckizb.normalizeToArray)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $hzBt5.map)(resetDefines, function(v, idx) {
        return $5e5938f91d6a514e$var$makeSeriesTaskProgress(idx);
    }) : $5e5938f91d6a514e$var$singleSeriesTaskProgress;
}
var $5e5938f91d6a514e$var$singleSeriesTaskProgress = $5e5938f91d6a514e$var$makeSeriesTaskProgress(0);
function $5e5938f91d6a514e$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $5e5938f91d6a514e$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $5e5938f91d6a514e$var$detectSeriseType(legacyFunc) {
    $5e5938f91d6a514e$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($5e5938f91d6a514e$var$ecModelMock, $5e5938f91d6a514e$var$apiMock);
    } catch (e) {}
    return $5e5938f91d6a514e$var$seriesType;
}
var $5e5938f91d6a514e$var$ecModelMock = {};
var $5e5938f91d6a514e$var$apiMock = {};
var $5e5938f91d6a514e$var$seriesType;
$5e5938f91d6a514e$var$mockMethods($5e5938f91d6a514e$var$ecModelMock, (0, $2dhmo.default));
$5e5938f91d6a514e$var$mockMethods($5e5938f91d6a514e$var$apiMock, (0, $4npYR.default));
$5e5938f91d6a514e$var$ecModelMock.eachSeriesByType = $5e5938f91d6a514e$var$ecModelMock.eachRawSeriesByType = function(type) {
    $5e5938f91d6a514e$var$seriesType = type;
};
$5e5938f91d6a514e$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $5e5938f91d6a514e$var$seriesType = cond.subType;
};
function $5e5938f91d6a514e$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $hzBt5.noop);
/* eslint-enable */ }
var $5e5938f91d6a514e$export$2e2bcd8739ae039 = $5e5938f91d6a514e$var$Scheduler;

});

parcelRegister("dsS8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $02879c6959dcaf87$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $02879c6959dcaf87$var$colorAll = [
    '#37A2DA',
    '#32C5E9',
    '#67E0E3',
    '#9FE6B8',
    '#FFDB5C',
    '#ff9f7f',
    '#fb7293',
    '#E062AE',
    '#E690D1',
    '#e7bcf3',
    '#9d96f5',
    '#8378EA',
    '#96BFFF'
];
var $02879c6959dcaf87$export$2e2bcd8739ae039 = {
    color: $02879c6959dcaf87$var$colorAll,
    colorLayer: [
        [
            '#37A2DA',
            '#ffd85c',
            '#fd7b5f'
        ],
        [
            '#37A2DA',
            '#67E0E3',
            '#FFDB5C',
            '#ff9f7f',
            '#E062AE',
            '#9d96f5'
        ],
        [
            '#37A2DA',
            '#32C5E9',
            '#9FE6B8',
            '#FFDB5C',
            '#ff9f7f',
            '#fb7293',
            '#e7bcf3',
            '#8378EA',
            '#96BFFF'
        ],
        $02879c6959dcaf87$var$colorAll
    ]
};

});

parcelRegister("85Dmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e3d52fa3989b456$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5e3d52fa3989b456$var$contrastColor = '#B9B8CE';
var $5e3d52fa3989b456$var$backgroundColor = '#100C2A';
var $5e3d52fa3989b456$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $5e3d52fa3989b456$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: '#484753'
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    'rgba(255,255,255,0.02)',
                    'rgba(255,255,255,0.05)'
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: '#20203B'
            }
        }
    };
};
var $5e3d52fa3989b456$var$colorPalette = [
    '#4992ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
];
var $5e3d52fa3989b456$var$theme = {
    darkMode: true,
    color: $5e3d52fa3989b456$var$colorPalette,
    backgroundColor: $5e3d52fa3989b456$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: '#817f91'
        },
        crossStyle: {
            color: '#817f91'
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: '#fff'
        }
    },
    legend: {
        textStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        }
    },
    textStyle: {
        color: $5e3d52fa3989b456$var$contrastColor
    },
    title: {
        textStyle: {
            color: '#EEF1FA'
        },
        subtextStyle: {
            color: '#B9B8CE'
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $5e3d52fa3989b456$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: '#71708A',
        textStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        brushStyle: {
            color: 'rgba(135,163,206,0.3)'
        },
        handleStyle: {
            color: '#353450',
            borderColor: '#C5CBE3'
        },
        moveHandleStyle: {
            color: '#B0B6C3',
            opacity: 0.3
        },
        fillerColor: 'rgba(135,163,206,0.2)',
        emphasis: {
            handleStyle: {
                borderColor: '#91B7F2',
                color: '#4D587D'
            },
            moveHandleStyle: {
                color: '#636D9A',
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: '#71708A',
                width: 1
            },
            areaStyle: {
                color: '#71708A'
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#87A3CE'
            },
            areaStyle: {
                color: '#87A3CE'
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        label: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        controlStyle: {
            color: $5e3d52fa3989b456$var$contrastColor,
            borderColor: $5e3d52fa3989b456$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $5e3d52fa3989b456$var$backgroundColor
        },
        dayLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        monthLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        yearLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        }
    },
    timeAxis: $5e3d52fa3989b456$var$axisCommon(),
    logAxis: $5e3d52fa3989b456$var$axisCommon(),
    valueAxis: $5e3d52fa3989b456$var$axisCommon(),
    categoryAxis: $5e3d52fa3989b456$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $5e3d52fa3989b456$var$colorPalette
    },
    gauge: {
        title: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        'rgba(207,212,219,0.2)'
                    ]
                ]
            }
        },
        axisLabel: {
            color: $5e3d52fa3989b456$var$contrastColor
        },
        detail: {
            color: '#EEF1FA'
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92' // borderColor: '#ca2824',
        }
    }
};
$5e3d52fa3989b456$var$theme.categoryAxis.splitLine.show = false;
var $5e3d52fa3989b456$export$2e2bcd8739ae039 = $5e3d52fa3989b456$var$theme;

});

parcelRegister("9xw3H", function(module, exports) {

$parcel$export(module.exports, "ECEventProcessor", () => $6f20104e8ac2b01c$export$d0fd09f950257b52);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $jKrBG = parcelRequire("jKrBG");
/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $6f20104e8ac2b01c$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
        if ($hzBt5.isString(query)) {
            var condCptType = (0, $jKrBG.parseClassType)(query); // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $hzBt5.each(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view; // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo wont be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();

});

parcelRegister("fTE3u", function(module, exports) {

$parcel$export(module.exports, "seriesSymbolTask", () => $b92b10342c0e83bd$export$144ac3beded415d9);
$parcel$export(module.exports, "dataSymbolTask", () => $b92b10342c0e83bd$export$435b956f7f1071fb);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $b92b10342c0e83bd$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolType = seriesModel.get('symbol');
        var symbolSize = seriesModel.get('symbolSize');
        var keepAspect = seriesModel.get('symbolKeepAspect');
        var symbolRotate = seriesModel.get('symbolRotate');
        var symbolOffset = seriesModel.get('symbolOffset');
        var hasSymbolTypeCallback = (0, $hzBt5.isFunction)(symbolType);
        var hasSymbolSizeCallback = (0, $hzBt5.isFunction)(symbolSize);
        var hasSymbolRotateCallback = (0, $hzBt5.isFunction)(symbolRotate);
        var hasSymbolOffsetCallback = (0, $hzBt5.isFunction)(symbolOffset);
        var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback || hasSymbolOffsetCallback;
        var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : seriesModel.defaultSymbol;
        var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
        var seriesSymbolRotate = !hasSymbolRotateCallback ? symbolRotate : null;
        var seriesSymbolOffset = !hasSymbolOffsetCallback ? symbolOffset : null;
        data.setVisual({
            legendIcon: seriesModel.legendIcon || seriesSymbol,
            // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
            // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
            // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
            // some cases but generally it is not recommanded.
            symbol: seriesSymbol,
            symbolSize: seriesSymbolSize,
            symbolKeepAspect: keepAspect,
            symbolRotate: seriesSymbolRotate,
            symbolOffset: seriesSymbolOffset
        }); // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
            hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
            hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
            hasSymbolOffsetCallback && data.setItemVisual(idx, 'symbolOffset', symbolOffset(rawValue, params));
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $b92b10342c0e83bd$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
         // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var itemSymbolType = itemModel.getShallow('symbol', true);
            var itemSymbolSize = itemModel.getShallow('symbolSize', true);
            var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
            var itemSymbolOffset = itemModel.getShallow('symbolOffset', true);
            var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
            if (itemSymbolType != null) data.setItemVisual(idx, 'symbol', itemSymbolType);
            if (itemSymbolSize != null) // PENDING Transform symbolSize ?
            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
            if (itemSymbolRotate != null) data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
            if (itemSymbolOffset != null) data.setItemVisual(idx, 'symbolOffset', itemSymbolOffset);
            if (itemSymbolKeepAspect != null) data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};

});

parcelRegister("3uf7q", function(module, exports) {

$parcel$export(module.exports, "getItemVisualFromData", () => $289fe6b61c2cc1b6$export$91d919a86b2df624);
$parcel$export(module.exports, "getVisualFromData", () => $289fe6b61c2cc1b6$export$d76e333a86ea1a2);
$parcel$export(module.exports, "setItemVisualFromData", () => $289fe6b61c2cc1b6$export$3aab879e9d0e7c75);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $289fe6b61c2cc1b6$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $289fe6b61c2cc1b6$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $289fe6b61c2cc1b6$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value; // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}

});

parcelRegister("kPQAq", function(module, exports) {

$parcel$export(module.exports, "createLegacyDataSelectAction", () => $f2b15ca7d2e037ba$export$62942ba95693dbfc);
$parcel$export(module.exports, "handleLegacySelectEvents", () => $f2b15ca7d2e037ba$export$2575c83262e49d0c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");


var $ckizb = parcelRequire("ckizb");
function $f2b15ca7d2e037ba$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $hzBt5.each)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $hzBt5.extend)({}, payload);
            api.dispatchAction((0, $hzBt5.extend)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $ckizb.queryDataIndex)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $hzBt5.isArray)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $hzBt5.extend)({}, seriesModel.option.selectedMap)
            });
        }
    });
}
function $f2b15ca7d2e037ba$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $f2b15ca7d2e037ba$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}

});

parcelRegister("1MZkk", function(module, exports) {

$parcel$export(module.exports, "findEventDispatcher", () => $14d9d861e24a3bd8$export$8a4fca9e04eb4df6);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $14d9d861e24a3bd8$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}

});

parcelRegister("aXrNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa4faf409a9030d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7Y3oh = parcelRequire("7Y3oh");
function $7fa4faf409a9030d$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $7Y3oh.createOrUpdatePatternFromDecal)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $7Y3oh.createOrUpdatePatternFromDecal)(decal, api);
        }
    });
}

});
parcelRegister("7Y3oh", function(module, exports) {

$parcel$export(module.exports, "createOrUpdatePatternFromDecal", () => $5cd0c44c08f62803$export$a3ba048e1a648972);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lasoJ = parcelRequire("lasoJ");

var $lXNaK = parcelRequire("lXNaK");

var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $4TnMt = parcelRequire("4TnMt");

var $2Zzmo = parcelRequire("2Zzmo");
var $5cd0c44c08f62803$var$decalMap = new (0, $lasoJ.default)();
var $5cd0c44c08f62803$var$decalCache = new (0, $lXNaK.default)(100);
var $5cd0c44c08f62803$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $5cd0c44c08f62803$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $5cd0c44c08f62803$var$decalMap["delete"](decalObject);
    var oldPattern = $5cd0c44c08f62803$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $hzBt5.defaults)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $5cd0c44c08f62803$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $5cd0c44c08f62803$var$decalKeys.length; ++i){
            var value = decalOpt[$5cd0c44c08f62803$var$decalKeys[i]];
            var valueType = typeof value;
            if (value != null && !(0, $hzBt5.isArray)(value) && valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $5cd0c44c08f62803$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $5cd0c44c08f62803$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $5cd0c44c08f62803$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $5cd0c44c08f62803$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $5cd0c44c08f62803$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $5cd0c44c08f62803$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $hzBt5.createCanvas)();
        var svgRoot = isSVG && zr.painter.createSVGElement('g');
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $5cd0c44c08f62803$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minumum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minumum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $5BQXp.getLeastCommonMultiple)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $5BQXp.getLeastCommonMultiple)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                         // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $4TnMt.createSymbol)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) svgRoot.appendChild(zr.painter.paintOne(symbol));
                else // Paint to canvas for all other renderers.
                (0, $2Zzmo.brushSingle)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $5cd0c44c08f62803$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if (typeof symbol === 'string') return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] !== 'string') {
        isAllString = false;
        break;
    }
    if (isAllString) return $5cd0c44c08f62803$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if (typeof symbol[i] === 'string') result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $5cd0c44c08f62803$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if (typeof dash === 'number') {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] !== 'number') {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $5cd0c44c08f62803$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if (typeof dash[i] === 'number') {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $hzBt5.map)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $5cd0c44c08f62803$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if (typeof dash === 'number') {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $hzBt5.map)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash arrary of X or Y
 * @return {number[]} block length of each line
 */ function $5cd0c44c08f62803$var$getLineBlockLengthX(dash) {
    return (0, $hzBt5.map)(dash, function(line) {
        return $5cd0c44c08f62803$var$getLineBlockLengthY(line);
    });
}
function $5cd0c44c08f62803$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}

});
parcelRegister("lasoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6908f659109ff21$export$2e2bcd8739ae039);
var $f6908f659109ff21$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $f6908f659109ff21$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $f6908f659109ff21$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $f6908f659109ff21$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($f6908f659109ff21$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $f6908f659109ff21$export$2e2bcd8739ae039 = $f6908f659109ff21$var$WeakMap;

});

parcelRegister("2Zzmo", function(module, exports) {

$parcel$export(module.exports, "createCanvasPattern", () => $22dcb511a0158474$export$8eb5db6b7bc27903);
$parcel$export(module.exports, "brushSingle", () => $22dcb511a0158474$export$567881adfc3eb7f3);
$parcel$export(module.exports, "brush", () => $22dcb511a0158474$export$da5d6544e8c27bc1);

var $g1Uer = parcelRequire("g1Uer");

var $fvvgx = parcelRequire("fvvgx");

var $3RCXB = parcelRequire("3RCXB");

var $geJzd = parcelRequire("geJzd");

var $hMiip = parcelRequire("hMiip");

var $agXnr = parcelRequire("agXnr");

var $lm58d = parcelRequire("lm58d");

var $02NbV = parcelRequire("02NbV");

var $hzBt5 = parcelRequire("hzBt5");

var $jJSZho = parcelRequire("jJSZho");

var $4Nii9 = parcelRequire("4Nii9");

var $4rgPt = parcelRequire("4rgPt");
var $22dcb511a0158474$var$pathProxyForDraw = new (0, $fvvgx.default)(true);
function $22dcb511a0158474$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $22dcb511a0158474$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $22dcb511a0158474$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $22dcb511a0158474$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $22dcb511a0158474$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $22dcb511a0158474$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $3RCXB.createOrUpdateImage)(pattern.image, pattern.__image, el);
    if ((0, $3RCXB.isImageReady)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) / Math.PI * 180);
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $22dcb511a0158474$var$brushPath(ctx, el, style, inBatch) {
    var hasStroke = $22dcb511a0158474$var$styleHasStroke(style);
    var hasFill = $22dcb511a0158474$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $22dcb511a0158474$var$pathProxyForDraw;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = el.__dirty ? (0, $geJzd.getCanvasGradient)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = el.__dirty ? (0, $geJzd.getCanvasGradient)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = el.__dirty || !el.__canvasFillPattern ? $22dcb511a0158474$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = el.__dirty || !el.__canvasStrokePattern ? $22dcb511a0158474$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var lineDash = style.lineDash && style.lineWidth > 0 && (0, $jJSZho.normalizeLineDash)(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    var ctxLineDash = !!ctx.setLineDash;
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $hzBt5.map)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    var needsRebuild = true;
    if (firstDraw || el.__dirty & (0, $4rgPt.SHAPE_CHANGED_BIT) || lineDash && !ctxLineDash && hasStroke) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        if (lineDash && !ctxLineDash) {
            path.setLineDash(lineDash);
            path.setLineDashOffset(lineDashOffset);
        }
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash && ctxLineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $22dcb511a0158474$var$doStrokePath(ctx, style);
            if (hasFill) $22dcb511a0158474$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $22dcb511a0158474$var$doFillPath(ctx, style);
            if (hasStroke) $22dcb511a0158474$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash && ctxLineDash) ctx.setLineDash([]);
}
function $22dcb511a0158474$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $3RCXB.createOrUpdateImage)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $3RCXB.isImageReady)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $22dcb511a0158474$var$brushText(ctx, el, style) {
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $02NbV.DEFAULT_FONT);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var hasLineDash = void 0;
        if (ctx.setLineDash) {
            var lineDash = style.lineDash && style.lineWidth > 0 && (0, $jJSZho.normalizeLineDash)(style.lineDash, style.lineWidth);
            var lineDashOffset = style.lineDashOffset;
            if (lineDash) {
                var lineScale_2 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
                if (lineScale_2 && lineScale_2 !== 1) {
                    lineDash = (0, $hzBt5.map)(lineDash, function(rawVal) {
                        return rawVal / lineScale_2;
                    });
                    lineDashOffset /= lineScale_2;
                }
                ctx.setLineDash(lineDash);
                ctx.lineDashOffset = lineDashOffset;
                hasLineDash = true;
            }
        }
        if (style.strokeFirst) {
            if ($22dcb511a0158474$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($22dcb511a0158474$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($22dcb511a0158474$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($22dcb511a0158474$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (hasLineDash) ctx.setLineDash([]);
    }
}
var $22dcb511a0158474$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $22dcb511a0158474$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $22dcb511a0158474$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $g1Uer.DEFAULT_COMMON_STYLE).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $g1Uer.DEFAULT_COMMON_STYLE).blend;
    }
    for(var i = 0; i < $22dcb511a0158474$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $22dcb511a0158474$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $g1Uer.DEFAULT_COMMON_STYLE).shadowColor;
    }
    return styleChanged;
}
function $22dcb511a0158474$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $22dcb511a0158474$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $22dcb511a0158474$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $22dcb511a0158474$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $22dcb511a0158474$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $22dcb511a0158474$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $22dcb511a0158474$var$STROKE_PROPS.length; i++){
        var prop = $22dcb511a0158474$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $22dcb511a0158474$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $22dcb511a0158474$var$bindCommonProps(ctx, $22dcb511a0158474$var$getStyle(el, scope.inHover), prevEl && $22dcb511a0158474$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $22dcb511a0158474$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $22dcb511a0158474$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $22dcb511a0158474$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $22dcb511a0158474$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $22dcb511a0158474$var$DRAW_TYPE_PATH = 1;
var $22dcb511a0158474$var$DRAW_TYPE_IMAGE = 2;
var $22dcb511a0158474$var$DRAW_TYPE_TEXT = 3;
var $22dcb511a0158474$var$DRAW_TYPE_INCREMENTAL = 4;
function $22dcb511a0158474$var$canPathBatch(style) {
    var hasFill = $22dcb511a0158474$var$styleHasFill(style);
    var hasStroke = $22dcb511a0158474$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $22dcb511a0158474$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $22dcb511a0158474$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $22dcb511a0158474$export$567881adfc3eb7f3(ctx, el) {
    $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $4rgPt.REDRAW_BIT);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $geJzd.isClipPathChanged)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $22dcb511a0158474$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $hMiip.default) && el.autoBatch && $22dcb511a0158474$var$canPathBatch(el.style);
    if (forceSetTransform || $22dcb511a0158474$var$isTransformChanged(m, prevEl.transform)) {
        $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
        $22dcb511a0158474$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
    var style = $22dcb511a0158474$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $hMiip.default)) {
        if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_PATH;
        }
        $22dcb511a0158474$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $22dcb511a0158474$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $lm58d.default)) {
            if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_TEXT;
            }
            $22dcb511a0158474$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $22dcb511a0158474$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $agXnr.default)) {
            if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_IMAGE;
            }
            $22dcb511a0158474$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $22dcb511a0158474$var$brushImage(ctx, el, style);
        } else if (el instanceof (0, $4Nii9.default)) {
            if (scope.lastDrawType !== $22dcb511a0158474$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $22dcb511a0158474$var$DRAW_TYPE_INCREMENTAL;
            }
            $22dcb511a0158474$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $22dcb511a0158474$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $22dcb511a0158474$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $22dcb511a0158474$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}

});
parcelRegister("geJzd", function(module, exports) {

$parcel$export(module.exports, "getCanvasGradient", () => $bd214cd252565598$export$3dab6afd018d48c7);
$parcel$export(module.exports, "isClipPathChanged", () => $bd214cd252565598$export$beeddc5150cb2e83);
function $bd214cd252565598$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = isNaN(x) ? 0 : x;
    x2 = isNaN(x2) ? 1 : x2;
    y = isNaN(y) ? 0 : y;
    y2 = isNaN(y2) ? 0 : y2;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $bd214cd252565598$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $bd214cd252565598$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $bd214cd252565598$export$57f098206d57a443(ctx, obj, rect) : $bd214cd252565598$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $bd214cd252565598$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}

});

parcelRegister("jJSZho", function(module, exports) {

$parcel$export(module.exports, "normalizeLineDash", () => $e5ecdfa291d5fe1b$export$9efb2ae8a603855d);

var $hzBt5 = parcelRequire("hzBt5");
function $e5ecdfa291d5fe1b$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    lineWidth = lineWidth || 1;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $hzBt5.isNumber)(lineType) ? [
        lineType
    ] : (0, $hzBt5.isArray)(lineType) ? lineType : null;
}

});




parcelRegister("lIsFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf3f197899e27c0$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $iHhub = parcelRequire("iHhub");

var $iDQ2S = parcelRequire("iDQ2S");
var $fcf3f197899e27c0$var$storage = (0, $hzBt5.createHashMap)();
var $fcf3f197899e27c0$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $iHhub.GeoSVGResource)(mapName, rawDef.svg);
            $fcf3f197899e27c0$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $iDQ2S.GeoJSONResource)(mapName, geoJSON, rawSpecialAreas);
            $fcf3f197899e27c0$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $fcf3f197899e27c0$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $fcf3f197899e27c0$var$storage.get(mapName); // Do not support return SVG until some real requirement come.
        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $fcf3f197899e27c0$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};

});
parcelRegister("iHhub", function(module, exports) {

$parcel$export(module.exports, "GeoSVGResource", () => $d9c9ce73bb397579$export$be52c950efae1f84);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3mJ7S = parcelRequire("3mJ7S");

var $hXAsm = parcelRequire("hXAsm");

var $aeCKo = parcelRequire("aeCKo");

var $hzBt5 = parcelRequire("hzBt5");

var $lGSv6 = parcelRequire("lGSv6");

var $236og = parcelRequire("236og");

var $84Tkq = parcelRequire("84Tkq");
/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $d9c9ce73bb397579$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $hzBt5.createHashMap)([
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path',
    // but still need to trigger events or tooltip.
    'text',
    'tspan',
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    'g'
]);
var $d9c9ce73bb397579$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = 'geoSVG'; // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $hzBt5.createHashMap)(); // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName; // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $236og.parseXML)(svg);
    }
    GeoSVGResource.prototype.load = function() /* nameMap: NameMap */ {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic; // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone(); // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $d9c9ce73bb397579$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $3mJ7S.parseSVG)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $hzBt5.assert)(rootFromParse != null);
        } catch (e) {
            throw new Error('Invalid svg format\n' + e.message);
        } // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $hXAsm.default)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true; // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only suport `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            } // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $lGSv6.default)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $3mJ7S.makeViewBoxTransform)(viewBoxRect, boundingRect); // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        } // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $aeCKo.default)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $hzBt5.each)(result.named, function(namedItem) {
            if ($d9c9ce73bb397579$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $d9c9ce73bb397579$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() // use the first boundingRect to avoid duplicated boundingRect calculation.
         || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic); // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $d9c9ce73bb397579$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false; // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $d9c9ce73bb397579$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $hzBt5.createHashMap)(); // Create resions only for the first graphic.
    (0, $hzBt5.each)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $84Tkq.GeoSVGRegion)(namedItem.name, namedItem.el); // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region); // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }

});
parcelRegister("3mJ7S", function(module, exports) {

$parcel$export(module.exports, "makeViewBoxTransform", () => $27366e3eab380188$export$3e2db4420f14f50f);
$parcel$export(module.exports, "parseSVG", () => $27366e3eab380188$export$1919f5101c220601);

var $hXAsm = parcelRequire("hXAsm");

var $agXnr = parcelRequire("agXnr");

var $aYBv9 = parcelRequire("aYBv9");

var $aeCKo = parcelRequire("aeCKo");

var $gwELx = parcelRequire("gwELx");

var $15UDR = parcelRequire("15UDR");

var $cjY1b = parcelRequire("cjY1b");

var $9dsiU = parcelRequire("9dsiU");

var $crEgd = parcelRequire("crEgd");

var $lJlYD = parcelRequire("lJlYD");

var $hzBt5 = parcelRequire("hzBt5");

var $4kdki = parcelRequire("4kdki");

var $hkgm4 = parcelRequire("hkgm4");

var $lm58d = parcelRequire("lm58d");

var $236og = parcelRequire("236og");
var $27366e3eab380188$var$nodeParsers;
var $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $hzBt5.keys)($27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $hzBt5.keys)($27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP);
var $27366e3eab380188$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $236og.parseXML)(xml);
        if (!svg) throw new Error('Illegal svg');
        this._defsUsePending = [];
        var root = new (0, $hXAsm.default)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat(svg.getAttribute('width') || opt.width);
        var height = parseFloat(svg.getAttribute('height') || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $27366e3eab380188$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $27366e3eab380188$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $27366e3eab380188$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $27366e3eab380188$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $hXAsm.default)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $aeCKo.default)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') isInDefs = true;
        if (nodeName === 'text') isInText = true;
        if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $27366e3eab380188$var$nodeParsers[nodeName];
                if (parser_1 && (0, $hzBt5.hasOwn)($27366e3eab380188$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $27366e3eab380188$var$paintServerParsers[nodeName];
            if (parser && (0, $hzBt5.hasOwn)($27366e3eab380188$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $lm58d.default)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $27366e3eab380188$var$inheritStyle(parentGroup, text);
        $27366e3eab380188$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $27366e3eab380188$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $27366e3eab380188$var$nodeParsers = {
            'g': function(xmlNode, parentGroup) {
                var g = new (0, $hXAsm.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, g);
                $27366e3eab380188$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function(xmlNode, parentGroup) {
                var rect = new (0, $aeCKo.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, rect);
                $27366e3eab380188$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function(xmlNode, parentGroup) {
                var circle = new (0, $aYBv9.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, circle);
                $27366e3eab380188$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function(xmlNode, parentGroup) {
                var line = new (0, $15UDR.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, line);
                $27366e3eab380188$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function(xmlNode, parentGroup) {
                var ellipse = new (0, $gwELx.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, ellipse);
                $27366e3eab380188$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $27366e3eab380188$var$parsePoints(pointsStr);
                var polygon = new (0, $cjY1b.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $27366e3eab380188$var$inheritStyle(parentGroup, polygon);
                $27366e3eab380188$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $27366e3eab380188$var$parsePoints(pointsStr);
                var polyline = new (0, $9dsiU.default)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $27366e3eab380188$var$inheritStyle(parentGroup, polyline);
                $27366e3eab380188$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function(xmlNode, parentGroup) {
                var img = new (0, $agXnr.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, img);
                $27366e3eab380188$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $hXAsm.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, g);
                $27366e3eab380188$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new (0, $hXAsm.default)();
                $27366e3eab380188$var$inheritStyle(parentGroup, g);
                $27366e3eab380188$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = (0, $lJlYD.createFromString)(d);
                $27366e3eab380188$var$inheritStyle(parentGroup, path);
                $27366e3eab380188$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $27366e3eab380188$var$paintServerParsers = {
    'lineargradient': function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new (0, $4kdki.default)(x1, y1, x2, y2);
        $27366e3eab380188$var$parsePaintServerUnit(xmlNode, gradient);
        $27366e3eab380188$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new (0, $hkgm4.default)(cx, cy, r);
        $27366e3eab380188$var$parsePaintServerUnit(xmlNode, gradient);
        $27366e3eab380188$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $27366e3eab380188$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
}
function $27366e3eab380188$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $27366e3eab380188$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $27366e3eab380188$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $hzBt5.defaults)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $27366e3eab380188$var$parsePoints(pointsString) {
    var list = $27366e3eab380188$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $27366e3eab380188$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $27366e3eab380188$var$parseTransformAttribute(xmlNode, el);
        $27366e3eab380188$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $27366e3eab380188$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $27366e3eab380188$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $27366e3eab380188$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    (0, $hzBt5.each)([
        'lineWidth',
        'opacity',
        'fillOpacity',
        'strokeOpacity',
        'miterLimit',
        'fontSize'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $hzBt5.each)([
        'lineDashOffset',
        'lineCap',
        'lineJoin',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'textAlign'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $hzBt5.map)($27366e3eab380188$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
    if (inheritedStyle.display === 'none') disp.ignore = true;
}
function $27366e3eab380188$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
        else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') zrTextAlign = 'center';
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $27366e3eab380188$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $27366e3eab380188$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($27366e3eab380188$var$urlRegex);
    if (urlMatch) {
        var url = (0, $hzBt5.trim)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === 'none') str = null;
    return str;
}
function $27366e3eab380188$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $27366e3eab380188$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $27366e3eab380188$var$splitNumberSequence(rawStr) {
    return rawStr.match($27366e3eab380188$var$numberReg) || [];
}
var $27366e3eab380188$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $27366e3eab380188$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $27366e3eab380188$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace($27366e3eab380188$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $27366e3eab380188$var$splitNumberSequence(value);
            mt = mt || $crEgd.create();
            switch(type){
                case 'translate':
                    $crEgd.translate(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || '0')
                    ]);
                    break;
                case 'scale':
                    $crEgd.scale(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case 'rotate':
                    $crEgd.rotate(mt, mt, -parseFloat(valueArr[0]) * $27366e3eab380188$var$DEGREE_TO_ANGLE);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * $27366e3eab380188$var$DEGREE_TO_ANGLE);
                    $crEgd.mul(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * $27366e3eab380188$var$DEGREE_TO_ANGLE);
                    $crEgd.mul(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $27366e3eab380188$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $27366e3eab380188$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) return;
    $27366e3eab380188$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $27366e3eab380188$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $hzBt5.hasOwn)($27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $hzBt5.hasOwn)($27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $27366e3eab380188$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$27366e3eab380188$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$27366e3eab380188$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $27366e3eab380188$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $27366e3eab380188$export$1919f5101c220601(xml, opt) {
    var parser = new $27366e3eab380188$var$SVGParser();
    return parser.parse(xml, opt);
}

});
parcelRegister("236og", function(module, exports) {

$parcel$export(module.exports, "parseXML", () => $17e0d1955c2d9cc9$export$eacefc55fad2867e);

var $hzBt5 = parcelRequire("hzBt5");
function $17e0d1955c2d9cc9$export$eacefc55fad2867e(svg) {
    if ((0, $hzBt5.isString)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}

});


parcelRegister("84Tkq", function(module, exports) {

$parcel$export(module.exports, "GeoJSONRegion", () => $5e199d860f8f66fd$export$ee84fcb463f24b3d);
$parcel$export(module.exports, "GeoSVGRegion", () => $5e199d860f8f66fd$export$5f3d89e7254f3e69);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $lGSv6 = parcelRequire("lGSv6");

var $eVhyd = parcelRequire("eVhyd");

var $ef5pP = parcelRequire("ef5pP");

var $kb4w8 = parcelRequire("kb4w8");

var $crEgd = parcelRequire("crEgd");
var $5e199d860f8f66fd$var$TMP_TRANSFORM = [];
var $5e199d860f8f66fd$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        return;
    };
    return Region;
}();
var $5e199d860f8f66fd$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoJSON';
        _this.geometries = geometries;
        if (!cp) {
            var rect = _this.getBoundingRect();
            cp = [
                rect.x + rect.width / 2,
                rect.y + rect.height / 2
            ];
        } else cp = [
            cp[0],
            cp[1]
        ];
        _this._center = cp;
        return _this;
    }
    GeoJSONRegion.prototype.getBoundingRect = function() {
        var rect = this._rect;
        if (rect) return rect;
        var MAX_NUMBER = Number.MAX_VALUE;
        var min = [
            MAX_NUMBER,
            MAX_NUMBER
        ];
        var max = [
            -MAX_NUMBER,
            -MAX_NUMBER
        ];
        var min2 = [];
        var max2 = [];
        var geometries = this.geometries;
        var i = 0;
        for(; i < geometries.length; i++){
            // Only support polygon
            if (geometries[i].type !== 'polygon') continue;
             // Doesn't consider hole
            var exterior = geometries[i].exterior;
            $eVhyd.fromPoints(exterior, min2, max2);
            $ef5pP.min(min, min, min2);
            $ef5pP.max(max, max, max2);
        } // No data
        if (i === 0) min[0] = min[1] = max[0] = max[1] = 0;
        return this._rect = new (0, $lGSv6.default)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            if ($kb4w8.contain(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($kb4w8.contain(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $lGSv6.default)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            // Only support polygon.
            if (geometries[i].type !== 'polygon') continue;
            var exterior = geometries[i].exterior;
            var interiors = geometries[i].interiors;
            for(var p = 0; p < exterior.length; p++)$ef5pP.applyTransform(exterior[p], exterior[p], transform);
            for(var h = 0; h < (interiors ? interiors.length : 0); h++)for(var p = 0; p < interiors[h].length; p++)$ef5pP.applyTransform(interiors[h][p], interiors[h][p], transform);
        }
        rect = this._rect;
        rect.copy(target); // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    GeoJSONRegion.prototype.getCenter = function() {
        return this._center;
    };
    GeoJSONRegion.prototype.setCenter = function(center) {
        this._center = center;
    };
    return GeoJSONRegion;
}($5e199d860f8f66fd$export$b1f97c3099fc6872);
var $5e199d860f8f66fd$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoSVG';
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this._calculateCenter();
        return center;
    };
    GeoSVGRegion.prototype._calculateCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $crEgd.identity($5e199d860f8f66fd$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $crEgd.mul(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $crEgd.invert(mat, mat);
        $ef5pP.applyTransform(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($5e199d860f8f66fd$export$b1f97c3099fc6872);

});
parcelRegister("kb4w8", function(module, exports) {

$parcel$export(module.exports, "contain", () => $eb0856c310682b69$export$8893e2b90ba10d92);

var $j53mu = parcelRequire("j53mu");
var $eb0856c310682b69$var$EPSILON = 1e-8;
function $eb0856c310682b69$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $eb0856c310682b69$var$EPSILON;
}
function $eb0856c310682b69$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $j53mu.default)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$eb0856c310682b69$var$isAroundEqual(p[0], p0[0]) || !$eb0856c310682b69$var$isAroundEqual(p[1], p0[1])) w += (0, $j53mu.default)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}

});



parcelRegister("iDQ2S", function(module, exports) {

$parcel$export(module.exports, "GeoJSONResource", () => $d9243da321b85586$export$859cf85c67f2df51);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $7gQBi = parcelRequire("7gQBi");

var $h9nHC = parcelRequire("h9nHC");

var $hvA1X = parcelRequire("hvA1X");

var $22U1g = parcelRequire("22U1g");

var $5nz70 = parcelRequire("5nz70");

var $lGSv6 = parcelRequire("lGSv6");
var $d9243da321b85586$var$DEFAULT_NAME_PROPERTY = 'name';
var $d9243da321b85586$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = 'geoJSON';
        this._parsedMap = (0, $hzBt5.createHashMap)();
        this._mapName = mapName;
        this._specialAreas = specialAreas; // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $d9243da321b85586$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $d9243da321b85586$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $d9243da321b85586$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $hzBt5.createHashMap)();
        var finalRegions = [];
        (0, $hzBt5.each)(parsed.regions, function(region) {
            var regionName = region.name; // Try use the alias in geoNameMap
            if (nameMap && nameMap.hasOwnProperty(regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $lGSv6.default)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions; // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $7gQBi.default)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error('Invalid geoJson format\n' + e.message);
        }
        (0, $h9nHC.default)(mapName, rawRegions);
        (0, $hzBt5.each)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $hvA1X.default)(mapName, region);
            (0, $22U1g.default)(mapName, region);
            (0, $5nz70.default)(mapName, region); // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $d9243da321b85586$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $d9243da321b85586$var$parseInput(source) {
    return !(0, $hzBt5.isString)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}

});
parcelRegister("7gQBi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54b2d45ff40edf24$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 
var $hzBt5 = parcelRequire("hzBt5");

var $84Tkq = parcelRequire("84Tkq");
function $54b2d45ff40edf24$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    for(var f = 0; f < features.length; f++){
        var feature = features[f];
        var geometry = feature.geometry;
        if (geometry.type === 'Polygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++)coordinates[c] = $54b2d45ff40edf24$var$decodePolygon(coordinates[c], geometry.encodeOffsets[c], encodeScale);
        } else if (geometry.type === 'MultiPolygon') {
            var coordinates = geometry.coordinates;
            for(var c = 0; c < coordinates.length; c++){
                var coordinate = coordinates[c];
                for(var c2 = 0; c2 < coordinate.length; c2++)coordinate[c2] = $54b2d45ff40edf24$var$decodePolygon(coordinate[c2], geometry.encodeOffsets[c][c2], encodeScale);
            }
        }
    } // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $54b2d45ff40edf24$var$decodePolygon(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1); // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y; // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $54b2d45ff40edf24$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $54b2d45ff40edf24$var$decode(geoJson);
    return $hzBt5.map($hzBt5.filter(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        if (geo.type === 'Polygon') {
            var coordinates = geo.coordinates;
            geometries.push({
                type: 'polygon',
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                exterior: coordinates[0],
                interiors: coordinates.slice(1)
            });
        }
        if (geo.type === 'MultiPolygon') {
            var coordinates = geo.coordinates;
            $hzBt5.each(coordinates, function(item) {
                if (item[0]) geometries.push({
                    type: 'polygon',
                    exterior: item[0],
                    interiors: item.slice(1)
                });
            });
        }
        var region = new (0, $84Tkq.GeoJSONRegion)(properties[nameProperty || 'name'], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}

});

parcelRegister("h9nHC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c5a9c5e2acd596$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛

var $hzBt5 = parcelRequire("hzBt5");

var $84Tkq = parcelRequire("84Tkq");
var $c7c5a9c5e2acd596$var$geoCoord = [
    126,
    25
];
var $c7c5a9c5e2acd596$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $c7c5a9c5e2acd596$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $c7c5a9c5e2acd596$var$i = 0; $c7c5a9c5e2acd596$var$i < $c7c5a9c5e2acd596$var$points.length; $c7c5a9c5e2acd596$var$i++)for(var $c7c5a9c5e2acd596$var$k = 0; $c7c5a9c5e2acd596$var$k < $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i].length; $c7c5a9c5e2acd596$var$k++){
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][0] /= 10.5;
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][1] /= -14;
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][0] += $c7c5a9c5e2acd596$var$geoCoord[0];
    $c7c5a9c5e2acd596$var$points[$c7c5a9c5e2acd596$var$i][$c7c5a9c5e2acd596$var$k][1] += $c7c5a9c5e2acd596$var$geoCoord[1];
}
function $c7c5a9c5e2acd596$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === 'china') {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $c7c5a9c5e2acd596$var$nanhaiName) return;
        }
        regions.push(new (0, $84Tkq.GeoJSONRegion)($c7c5a9c5e2acd596$var$nanhaiName, $hzBt5.map($c7c5a9c5e2acd596$var$points, function(exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), $c7c5a9c5e2acd596$var$geoCoord));
    }
}

});

parcelRegister("hvA1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf147d6c100fd6e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $cbf147d6c100fd6e$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    //'北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $cbf147d6c100fd6e$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china') {
        var coordFix = $cbf147d6c100fd6e$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("22U1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d738f445a604e2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $17d738f445a604e2$var$geoCoordMap = {
    'Russia': [
        100,
        60
    ],
    'United States': [
        -99,
        38
    ],
    'United States of America': [
        -99,
        38
    ]
};
function $17d738f445a604e2$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'world') {
        var geoCoord = $17d738f445a604e2$var$geoCoordMap[region.name];
        if (geoCoord) {
            var cp = [
                geoCoord[0],
                geoCoord[1]
            ];
            region.setCenter(cp);
        }
    }
}

});

parcelRegister("5nz70", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eaa563c9e4fe182$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $3eaa563c9e4fe182$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $3eaa563c9e4fe182$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: 'polygon',
        exterior: $3eaa563c9e4fe182$var$points[0]
    });
}

});



parcelRegister("3Vx2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc051d8dc36b810$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1J7Ke = parcelRequire("1J7Ke");
var $2dc051d8dc36b810$var$lifecycle = new (0, $1J7Ke.default)();
var $2dc051d8dc36b810$export$2e2bcd8739ae039 = $2dc051d8dc36b810$var$lifecycle;

});



parcelRegister("hxCCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc5379cea00cbc64$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $3OWAv = parcelRequire("3OWAv");

var $5vVec = parcelRequire("5vVec");
var $cc5379cea00cbc64$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $3OWAv.default)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get('progressive');
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.type = 'series.scatter';
    ScatterSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8 // color: 各异
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        universalTransition: {
            divideShape: 'clone'
        } // progressive: null
    };
    return ScatterSeriesModel;
}((0, $5vVec.default));
var $cc5379cea00cbc64$export$2e2bcd8739ae039 = $cc5379cea00cbc64$var$ScatterSeriesModel;

});

parcelRegister("YHaPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b671819bb1d68b8$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $ffay8 = parcelRequire("ffay8");

var $1ZQ1S = parcelRequire("1ZQ1S");

var $icXd2 = parcelRequire("icXd2");

var $azEx8 = parcelRequire("azEx8");
var $0b671819bb1d68b8$var$ScatterView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) return {
            update: true
        };
        else {
            var res = (0, $icXd2.default)('').reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get('clip', true) ? clipArea : null;
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $1ZQ1S.default)() : new (0, $ffay8.default)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = 'scatter';
    return ScatterView;
}((0, $azEx8.default));
var $0b671819bb1d68b8$export$2e2bcd8739ae039 = $0b671819bb1d68b8$var$ScatterView;

});
parcelRegister("1ZQ1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $1743d8ded44526ad$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hXAsm = parcelRequire("hXAsm");parcelRequire("8q0E1");
var $hMiip = parcelRequire("hMiip");

var $4TnMt = parcelRequire("4TnMt");

var $4Nii9 = parcelRequire("4Nii9");

var $aly4X = parcelRequire("aly4X");
var $1743d8ded44526ad$var$BOOST_SIZE_THRESHOLD = 4;
var $1743d8ded44526ad$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $1743d8ded44526ad$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $fKE23.__extends)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        return _super.call(this, opts) || this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $1743d8ded44526ad$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $1743d8ded44526ad$var$BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        if (!ctx) return;
         // PENDING If style or other canvas status changed?
        for(var i = 0; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (this.softClipShape && !this.softClipShape.contain(x, y)) continue;
             // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4); // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    return LargeSymbolPath;
}($hMiip.default);
var $1743d8ded44526ad$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $hXAsm.default();
    }
    LargeSymbolDraw.prototype.isPersistent = function() {
        return !this._incremental;
    };
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this.group.removeAll();
        var symbolEl = new $1743d8ded44526ad$var$LargeSymbolPath({
            rectHover: true,
            cursor: 'default'
        });
        symbolEl.setShape({
            points: data.getLayout('points')
        });
        this._setCommon(symbolEl, data, false, opt);
        this.group.add(symbolEl);
        this._incremental = null;
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        if (this._incremental) return;
        var points = data.getLayout('points');
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape('points', points);
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
        // PENDING Incremental data?
        if (data.count() > 2e6) {
            if (!this._incremental) this._incremental = new (0, $4Nii9.default)({
                silent: true
            });
            this.group.add(this._incremental);
        } else this._incremental = null;
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var symbolEl;
        if (this._incremental) {
            symbolEl = new $1743d8ded44526ad$var$LargeSymbolPath();
            this._incremental.addDisplayable(symbolEl, true);
        } else {
            symbolEl = new $1743d8ded44526ad$var$LargeSymbolPath({
                rectHover: true,
                cursor: 'default',
                startIndex: taskParams.start,
                endIndex: taskParams.end
            });
            symbolEl.incremental = true;
            this.group.add(symbolEl);
        }
        symbolEl.setShape({
            points: data.getLayout('points')
        });
        this._setCommon(symbolEl, data, !!this._incremental, opt);
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, isIncremental, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual('symbolSize');
        symbolEl.setShape('size', size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $4TnMt.createSymbol)(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $1743d8ded44526ad$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? [
            'color',
            'shadowBlur',
            'shadowColor'
        ] : [
            'color'
        ]));
        var globalStyle = data.getVisual('style');
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        if (!isIncremental) {
            var ecData_1 = (0, $aly4X.getECData)(symbolEl); // Enable tooltip
            // PENDING May have performance issue when path is extremely large
            ecData_1.seriesIndex = hostModel.seriesIndex;
            symbolEl.on('mousemove', function(e) {
                ecData_1.dataIndex = null;
                var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
                if (dataIndex >= 0) // Provide dataIndex for tooltip
                ecData_1.dataIndex = dataIndex + (symbolEl.startIndex || 0);
            });
        }
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clearIncremental();
        this._incremental = null;
        this.group.removeAll();
    };
    LargeSymbolDraw.prototype._clearIncremental = function() {
        var incremental = this._incremental;
        if (incremental) incremental.clearDisplaybles();
    };
    return LargeSymbolDraw;
}();
var $1743d8ded44526ad$export$2e2bcd8739ae039 = $1743d8ded44526ad$var$LargeSymbolDraw;

});


parcelRegister("jTM8g", function(module, exports) {

$parcel$export(module.exports, "install", () => $e7c87d713e83226d$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $4uCJH = parcelRequire("4uCJH");

var $9iciO = parcelRequire("9iciO");
parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");

var $hzBt5 = parcelRequire("hzBt5");

var $db0cX = parcelRequire("db0cX");

var $5gJmr = parcelRequire("5gJmr");

var $a91qA = parcelRequire("a91qA");

var $9SXxl = parcelRequire("9SXxl");
var $e7c87d713e83226d$var$GridView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $aeCKo.default)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $hzBt5.defaults)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $4uCJH.default));
var $e7c87d713e83226d$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $e7c87d713e83226d$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($e7c87d713e83226d$var$GridView);
    registers.registerComponentModel((0, $9iciO.default));
    registers.registerCoordinateSystem('cartesian2d', (0, $a91qA.default));
    (0, $5gJmr.default)(registers, 'x', (0, $db0cX.CartesianAxisModel), $e7c87d713e83226d$var$extraOption);
    (0, $5gJmr.default)(registers, 'y', (0, $db0cX.CartesianAxisModel), $e7c87d713e83226d$var$extraOption);
    registers.registerComponentView((0, $9SXxl.CartesianXAxisView));
    registers.registerComponentView((0, $9SXxl.CartesianYAxisView));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}

});
parcelRegister("9iciO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3f567a5987591d$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $6IEE1 = parcelRequire("6IEE1");
var $6c3f567a5987591d$var$GridModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        zlevel: 0,
        z: 0,
        left: '10%',
        top: 60,
        right: '10%',
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: 'rgba(0,0,0,0)',
        borderWidth: 1,
        borderColor: '#ccc'
    };
    return GridModel;
}((0, $6IEE1.default));
var $6c3f567a5987591d$export$2e2bcd8739ae039 = $6c3f567a5987591d$var$GridModel;

});

parcelRegister("db0cX", function(module, exports) {

$parcel$export(module.exports, "CartesianAxisModel", () => $997c76b868ef464d$export$483dc37e6ad83a3c);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $6IEE1 = parcelRequire("6IEE1");

var $kN6By = parcelRequire("kN6By");

var $ckizb = parcelRequire("ckizb");
var $997c76b868ef464d$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $ckizb.SINGLE_REFERRING)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $6IEE1.default));
$hzBt5.mixin($997c76b868ef464d$export$483dc37e6ad83a3c, (0, $kN6By.AxisModelCommonMixin));
var $997c76b868ef464d$export$2e2bcd8739ae039 = $997c76b868ef464d$export$483dc37e6ad83a3c;

});
parcelRegister("kN6By", function(module, exports) {

$parcel$export(module.exports, "AxisModelCommonMixin", () => $f22d81d59d03880b$export$5c54b224726edb5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $f22d81d59d03880b$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();

});


parcelRegister("5gJmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d61a220882361ee$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $aBFQR = parcelRequire("aBFQR");

var $e4mIu = parcelRequire("e4mIu");

var $gVr2C = parcelRequire("gVr2C");

var $8qCTD = parcelRequire("8qCTD");

var $hzBt5 = parcelRequire("hzBt5");
function $3d61a220882361ee$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $hzBt5.each)((0, $8qCTD.AXIS_TYPES), function(v, axisType) {
        var defaultOption = (0, $hzBt5.merge)((0, $hzBt5.merge)({}, (0, $aBFQR.default)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $fKE23.__extends)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $e4mIu.fetchLayoutMode)(this);
                var inputPositionParams = layoutMode ? (0, $e4mIu.getLayoutParams)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $hzBt5.merge)(option, themeModel.get(axisType + 'Axis'));
                (0, $hzBt5.merge)(option, this.getDefaultOption());
                option.type = $3d61a220882361ee$var$getAxisType(option);
                if (layoutMode) (0, $e4mIu.mergeLayoutParam)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $gVr2C.default).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option; // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $3d61a220882361ee$var$getAxisType);
}
function $3d61a220882361ee$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}

});
parcelRegister("aBFQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b8dd2ed4a973225$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $7b8dd2ed4a973225$var$defaultOption = {
    show: true,
    zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: '#6E7079',
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        lineStyle: {
            color: [
                '#E0E6F1'
            ],
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                'rgba(250,250,250,0.2)',
                'rgba(210,219,238,0.2)'
            ]
        }
    }
};
var $7b8dd2ed4a973225$var$categoryAxis = $hzBt5.merge({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $7b8dd2ed4a973225$var$defaultOption);
var $7b8dd2ed4a973225$var$valueAxis = $hzBt5.merge({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Lenght of minor tick
        length: 3,
        // Line style
        lineStyle: {}
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: '#F4F7FD',
            width: 1
        }
    }
}, $7b8dd2ed4a973225$var$defaultOption);
var $7b8dd2ed4a973225$var$timeAxis = $hzBt5.merge({
    scale: true,
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $7b8dd2ed4a973225$var$valueAxis);
var $7b8dd2ed4a973225$var$logAxis = $hzBt5.defaults({
    scale: true,
    logBase: 10
}, $7b8dd2ed4a973225$var$valueAxis);
var $7b8dd2ed4a973225$export$2e2bcd8739ae039 = {
    category: $7b8dd2ed4a973225$var$categoryAxis,
    value: $7b8dd2ed4a973225$var$valueAxis,
    time: $7b8dd2ed4a973225$var$timeAxis,
    log: $7b8dd2ed4a973225$var$logAxis
};

});

parcelRegister("gVr2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $c526f20861d11227$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $c526f20861d11227$var$uidBase = 0;
var $c526f20861d11227$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$c526f20861d11227$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $hzBt5.map)(data, $c526f20861d11227$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (typeof category !== 'string' && !needCollect) return category;
         // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap(); // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category; // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    }; // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $hzBt5.createHashMap)(this.categories));
    };
    return OrdinalMeta;
}();
function $c526f20861d11227$var$getName(obj) {
    if ((0, $hzBt5.isObject)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $c526f20861d11227$export$2e2bcd8739ae039 = $c526f20861d11227$var$OrdinalMeta;

});

parcelRegister("8qCTD", function(module, exports) {

$parcel$export(module.exports, "AXIS_TYPES", () => $622eec6b1b3cf382$export$2e0057d176d6f690);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $622eec6b1b3cf382$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};

});


parcelRegister("a91qA", function(module, exports) {

$parcel$export(module.exports, "default", () => $762bda27db553b3c$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 
var $hzBt5 = parcelRequire("hzBt5");

var $e4mIu = parcelRequire("e4mIu");

var $ekDcz = parcelRequire("ekDcz");

var $4OY0R = parcelRequire("4OY0R");

var $jhbA1 = parcelRequire("jhbA1");

var $ckizb = parcelRequire("ckizb");

var $aV7Yx = parcelRequire("aV7Yx");
var $762bda27db553b3c$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $4OY0R.cartesian2DDimensions);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        (0, $hzBt5.each)(axesMap.x, function(xAxis) {
            (0, $ekDcz.niceScaleExtent)(xAxis.scale, xAxis.model);
        });
        (0, $hzBt5.each)(axesMap.y, function(yAxis) {
            (0, $ekDcz.niceScaleExtent)(yAxis.scale, yAxis.model);
        }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $hzBt5.each)(axesMap.x, function(xAxis) {
            $762bda27db553b3c$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $hzBt5.each)(axesMap.y, function(yAxis) {
            $762bda27db553b3c$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        }); // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
        var gridRect = (0, $e4mIu.getLayoutRect)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes(); // Minus label size
        if (isContainLabel) {
            (0, $hzBt5.each)(axesList, function(axis) {
                if (!axis.model.get([
                    'axisLabel',
                    'inside'
                ])) {
                    var labelUnionRect = (0, $ekDcz.estimateLabelUnionRect)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? 'height' : 'width';
                        var margin = axis.model.get([
                            'axisLabel',
                            'margin'
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $hzBt5.each)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $hzBt5.each)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $762bda27db553b3c$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0]; // if (axisIndex == null) {
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $hzBt5.isObject)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $ckizb.SINGLE_REFERRING)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $hzBt5.indexOf)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        }; /// Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap; /// Create cartesian2d
        (0, $hzBt5.each)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $hzBt5.each)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $4OY0R.default)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$762bda27db553b3c$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $jhbA1.default)(dimName, (0, $ekDcz.createScaleByModel)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
                axisModel.axis = axis; // Inject axisModel into axis
                axis.model = axisModel; // Inject grid info axis
                axis.grid = grid; // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $hzBt5.each)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $aV7Yx.isCartesian2DSeries)(seriesModel)) {
                var axesModelMap = (0, $aV7Yx.findAxisModels)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$762bda27db553b3c$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$762bda27db553b3c$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                if (data.type === 'list') {
                    unionExtent(data, xAxis);
                    unionExtent(data, yAxis);
                }
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $hzBt5.each)((0, $ekDcz.getDataDimensionsOnAxis)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $hzBt5.each)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $hzBt5.indexOf)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $hzBt5.indexOf)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        }); // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $aV7Yx.isCartesian2DSeries)(seriesModel)) return;
            var axesModelMap = (0, $aV7Yx.findAxisModels)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    }; // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $4OY0R.cartesian2DDimensions);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $762bda27db553b3c$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $762bda27db553b3c$var$fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    }; // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
     // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($762bda27db553b3c$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $762bda27db553b3c$var$canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
         && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $762bda27db553b3c$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $ekDcz.ifAxisCrossZero)(axis);
}
function $762bda27db553b3c$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $762bda27db553b3c$export$2e2bcd8739ae039 = $762bda27db553b3c$var$Grid;

});
parcelRegister("ekDcz", function(module, exports) {

$parcel$export(module.exports, "getScaleExtent", () => $a6f1579ebd91fed2$export$9c0ba8df7eb7b328);
$parcel$export(module.exports, "niceScaleExtent", () => $a6f1579ebd91fed2$export$51f3e70a54405d5a);
$parcel$export(module.exports, "createScaleByModel", () => $a6f1579ebd91fed2$export$8941c4cacdc8f5a5);
$parcel$export(module.exports, "ifAxisCrossZero", () => $a6f1579ebd91fed2$export$3eac36a69f37d52);
$parcel$export(module.exports, "makeLabelFormatter", () => $a6f1579ebd91fed2$export$742f19a75415b2ae);
$parcel$export(module.exports, "getAxisRawValue", () => $a6f1579ebd91fed2$export$a5a32f324c1fa457);
$parcel$export(module.exports, "estimateLabelUnionRect", () => $a6f1579ebd91fed2$export$fef1c7f0af0b48d);
$parcel$export(module.exports, "getOptionCategoryInterval", () => $a6f1579ebd91fed2$export$6d0bc2429155c088);
$parcel$export(module.exports, "shouldShowAllLabels", () => $a6f1579ebd91fed2$export$c2911c025243d6a6);
$parcel$export(module.exports, "getDataDimensionsOnAxis", () => $a6f1579ebd91fed2$export$e4cf30b1e74cd69d);
$parcel$export(module.exports, "unionAxisExtentFromData", () => $a6f1579ebd91fed2$export$635fe7f20d0f4c70);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $7eBWJ = parcelRequire("7eBWJ");

var $aRcTH = parcelRequire("aRcTH");

var $fUFf0 = parcelRequire("fUFf0");

var $hMtFz = parcelRequire("hMtFz");

var $lGSv6 = parcelRequire("lGSv6");

var $kXmQc = parcelRequire("kXmQc");

var $76hW4 = parcelRequire("76hW4");

var $lljDt = parcelRequire("lljDt");

var $h3hFK = parcelRequire("h3hFK");
function $a6f1579ebd91fed2$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $h3hFK.ensureScaleRawExtentInfo)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max; // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time') {
        var barSeriesModels = (0, $hMtFz.prepareLayoutBarSeries)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $hzBt5.each(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $hMtFz.makeColumnLayout)(barSeriesModels); // Adjust axis min and max to account for overflow
            var adjustedScale = $a6f1579ebd91fed2$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $a6f1579ebd91fed2$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $hMtFz.retrieveColumnLayout)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $hzBt5.each(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $hzBt5.each(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow; // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
} // Precondition of calling this method:
function $a6f1579ebd91fed2$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $a6f1579ebd91fed2$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $76hW4.default)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    scale.setExtent(extent[0], extent[1]);
    scale.niceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
        maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
    }); // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    var interval = model.get('interval');
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $a6f1579ebd91fed2$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $7eBWJ.default)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $kXmQc.default)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $fUFf0.default).getClass(axisType) || (0, $aRcTH.default))();
    }
}
function $a6f1579ebd91fed2$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $a6f1579ebd91fed2$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === 'time') return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'string') return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace('{value}', label != null ? label : '');
            return text;
        };
    }(labelFormatter);
    else if (typeof labelFormatter === 'function') return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($a6f1579ebd91fed2$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $a6f1579ebd91fed2$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $a6f1579ebd91fed2$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        'axisLabel',
        'show'
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $7eBWJ.default)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $a6f1579ebd91fed2$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1; // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $a6f1579ebd91fed2$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $a6f1579ebd91fed2$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $lGSv6.default)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $a6f1579ebd91fed2$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $a6f1579ebd91fed2$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $a6f1579ebd91fed2$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $a6f1579ebd91fed2$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {}; // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $hzBt5.each(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $lljDt.getStackedDimension)(data, dataDim)] = true;
    });
    return $hzBt5.keys(dataDimMap);
}
function $a6f1579ebd91fed2$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $hzBt5.each($a6f1579ebd91fed2$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}

});
parcelRegister("7eBWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5447468bef84e5be$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $fUFf0 = parcelRequire("fUFf0");

var $gVr2C = parcelRequire("gVr2C");

var $9A4zx = parcelRequire("9A4zx");

var $hzBt5 = parcelRequire("hzBt5");
var $5447468bef84e5be$var$OrdinalScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta'); // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $gVr2C.default)({});
        if ((0, $hzBt5.isArray)(ordinalMeta)) ordinalMeta = new (0, $gVr2C.default)({
            categories: (0, $hzBt5.map)(ordinalMeta, function(item) {
                return (0, $hzBt5.isObject)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
         : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $9A4zx.contain(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $9A4zx.normalize(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($9A4zx.scale(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = []; // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        } // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber; // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick; // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber]; // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.niceTicks = function() {};
    OrdinalScale.prototype.niceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $fUFf0.default));
(0, $fUFf0.default).registerClass($5447468bef84e5be$var$OrdinalScale);
var $5447468bef84e5be$export$2e2bcd8739ae039 = $5447468bef84e5be$var$OrdinalScale;

});
parcelRegister("fUFf0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95c139b91880cb7$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $jKrBG = parcelRequire("jKrBG");
var $b95c139b91880cb7$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$jKrBG.enableClassManagement($b95c139b91880cb7$var$Scale);
var $b95c139b91880cb7$export$2e2bcd8739ae039 = $b95c139b91880cb7$var$Scale;

});

parcelRegister("9A4zx", function(module, exports) {

$parcel$export(module.exports, "intervalScaleNiceTicks", () => $6f9b05c8b09f6a8d$export$eeea879a611eb991);
$parcel$export(module.exports, "getIntervalPrecision", () => $6f9b05c8b09f6a8d$export$86a060b060d3d31a);
$parcel$export(module.exports, "contain", () => $6f9b05c8b09f6a8d$export$8893e2b90ba10d92);
$parcel$export(module.exports, "normalize", () => $6f9b05c8b09f6a8d$export$a3295358bff77e);
$parcel$export(module.exports, "scale", () => $6f9b05c8b09f6a8d$export$dcdf75081b88279d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");
var $6f9b05c8b09f6a8d$var$roundNumber = $5BQXp.round;
function $6f9b05c8b09f6a8d$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = $5BQXp.nice(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
     // Tow more digital for tick.
    var precision = result.intervalPrecision = $6f9b05c8b09f6a8d$export$86a060b060d3d31a(interval); // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        $6f9b05c8b09f6a8d$var$roundNumber(Math.ceil(extent[0] / interval) * interval, precision),
        $6f9b05c8b09f6a8d$var$roundNumber(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $6f9b05c8b09f6a8d$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $6f9b05c8b09f6a8d$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return $5BQXp.getPrecision(interval) + 2;
}
function $6f9b05c8b09f6a8d$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
function $6f9b05c8b09f6a8d$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $6f9b05c8b09f6a8d$var$clamp(niceTickExtent, 0, extent);
    $6f9b05c8b09f6a8d$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $6f9b05c8b09f6a8d$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $6f9b05c8b09f6a8d$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $6f9b05c8b09f6a8d$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}

});


parcelRegister("aRcTH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e78dbc9db2b6379$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $5BQXp = parcelRequire("5BQXp");

var $gyplX = parcelRequire("gyplX");

var $fUFf0 = parcelRequire("fUFf0");

var $9A4zx = parcelRequire("9A4zx");
var $7e78dbc9db2b6379$var$roundNumber = $5BQXp.round;
var $7e78dbc9db2b6379$var$IntervalScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval'; // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $9A4zx.contain(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $9A4zx.normalize(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $9A4zx.scale(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent; // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
        // We assume user wan't to set both interval, min, max to get a better result
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $9A4zx.getIntervalPrecision(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
         // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $7e78dbc9db2b6379$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            }); // Avoid rounding error
            tick = $7e78dbc9db2b6379$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        } // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $7e78dbc9db2b6379$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $7e78dbc9db2b6379$var$roundNumber(prevTick.value + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $5BQXp.getPrecision(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
         // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $7e78dbc9db2b6379$var$roundNumber(data.value, precision, true);
        return $gyplX.addCommas(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.niceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
         // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $9A4zx.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                var expandSize = extent[0]; // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $7e78dbc9db2b6379$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $7e78dbc9db2b6379$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $fUFf0.default));
(0, $fUFf0.default).registerClass($7e78dbc9db2b6379$var$IntervalScale);
var $7e78dbc9db2b6379$export$2e2bcd8739ae039 = $7e78dbc9db2b6379$var$IntervalScale;

});

parcelRegister("hMtFz", function(module, exports) {

$parcel$export(module.exports, "getLayoutOnAxis", () => $cf1def1f853d8378$export$658df087977b9e84);
$parcel$export(module.exports, "prepareLayoutBarSeries", () => $cf1def1f853d8378$export$efbd0c3f5ab0d5e4);
$parcel$export(module.exports, "makeColumnLayout", () => $cf1def1f853d8378$export$20769dafc84e0299);
$parcel$export(module.exports, "retrieveColumnLayout", () => $cf1def1f853d8378$export$35920bb6556da1c2);
$parcel$export(module.exports, "layout", () => $cf1def1f853d8378$export$b3219800bda33a1f);
$parcel$export(module.exports, "largeLayout", () => $cf1def1f853d8378$export$1fcd87ee6628f095);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $lljDt = parcelRequire("lljDt");

var $xPMeE = parcelRequire("xPMeE");
var $cf1def1f853d8378$var$STACK_PREFIX = '__ec_stack_';
var $cf1def1f853d8378$var$LARGE_BAR_MIN_WIDTH = 0.5;
var $cf1def1f853d8378$var$LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
function $cf1def1f853d8378$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $cf1def1f853d8378$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $cf1def1f853d8378$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $cf1def1f853d8378$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push($hzBt5.defaults({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $cf1def1f853d8378$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $cf1def1f853d8378$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$cf1def1f853d8378$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $cf1def1f853d8378$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($cf1def1f853d8378$var$isOnCartesian(seriesModel) && !$cf1def1f853d8378$var$isInLargeMode(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $cf1def1f853d8378$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    $hzBt5.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
             // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            } // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $cf1def1f853d8378$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $cf1def1f853d8378$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    $hzBt5.each(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $5BQXp.parsePercent)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $5BQXp.parsePercent)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $5BQXp.parsePercent)(// the auto-calculated bar width might be less than 1.
        seriesModel.get('barMinWidth') || 1, bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $cf1def1f853d8378$var$getAxisKey(baseAxis),
            stackId: $cf1def1f853d8378$var$getSeriesStackId(seriesModel)
        });
    });
    return $cf1def1f853d8378$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $cf1def1f853d8378$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    $hzBt5.each(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: '20%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        }; // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $hzBt5.each(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = $hzBt5.keys(stacks).length; // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $5BQXp.parsePercent)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $5BQXp.parsePercent)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
        $hzBt5.each(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                 // `minWidth` has higher priority. `minWidth` decide that wheter the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Becuase barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                 // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        }); // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $hzBt5.each(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $hzBt5.each(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $cf1def1f853d8378$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$cf1def1f853d8378$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$cf1def1f853d8378$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $cf1def1f853d8378$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $cf1def1f853d8378$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $cf1def1f853d8378$export$20769dafc84e0299(seriesModels);
    var lastStackCoords = {};
    $hzBt5.each(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $cf1def1f853d8378$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$cf1def1f853d8378$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var barMinHeight = seriesModel.get('barMinHeight') || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $lljDt.isDimensionStacked)(data, valueDim);
        var isValueAxisH = valueAxis.isHorizontal();
        var valueAxisStart = $cf1def1f853d8378$var$getValueAxisStart(baseAxis, valueAxis, stacked);
        var store = data.getStore();
        var valueDimIdx = data.getDimensionIndex(valueDim);
        var baseDimIdx = data.getDimensionIndex(baseDim);
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var value = store.get(valueDimIdx, idx);
            var baseValue = store.get(baseDimIdx, idx);
            var sign = value >= 0 ? 'p' : 'n';
            var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            if (stacked) {
                // Only ordinal axis can be stacked.
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                 // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;
            if (isValueAxisH) {
                var coord = cartesian.dataToPoint([
                    value,
                    baseValue
                ]);
                x = baseCoord;
                y = coord[1] + columnOffset;
                width = coord[0] - valueAxisStart;
                height = columnWidth;
                if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(width)) stacked && (lastStackCoords[stackId][baseValue][sign] += width);
            } else {
                var coord = cartesian.dataToPoint([
                    baseValue,
                    value
                ]);
                x = coord[0] + columnOffset;
                y = baseCoord;
                width = columnWidth;
                height = coord[1] - valueAxisStart;
                if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                height = (height <= 0 ? -1 : 1) * barMinHeight;
                 // Ignore stack from NaN value
                if (!isNaN(height)) stacked && (lastStackCoords[stackId][baseValue][sign] += height);
            }
            data.setItemLayout(idx, {
                x: x,
                y: y,
                width: width,
                height: height
            });
        }
    });
} // TODO: Do not support stack in large mode yet.
var $cf1def1f853d8378$export$1fcd87ee6628f095 = {
    seriesType: 'bar',
    plan: (0, $xPMeE.default)(),
    reset: function(seriesModel) {
        if (!$cf1def1f853d8378$var$isOnCartesian(seriesModel) || !$cf1def1f853d8378$var$isInLargeMode(seriesModel)) return;
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var coordLayout = cartesian.master.getRect();
        var baseAxis = cartesian.getBaseAxis();
        var valueAxis = cartesian.getOtherAxis(baseAxis);
        var valueDimI = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
        var baseDimI = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var valueAxisHorizontal = valueAxis.isHorizontal();
        var valueDimIdx = valueAxisHorizontal ? 0 : 1;
        var barWidth = $cf1def1f853d8378$export$35920bb6556da1c2($cf1def1f853d8378$export$20769dafc84e0299([
            seriesModel
        ]), baseAxis, seriesModel).width;
        if (!(barWidth > $cf1def1f853d8378$var$LARGE_BAR_MIN_WIDTH)) // jshint ignore:line
        barWidth = $cf1def1f853d8378$var$LARGE_BAR_MIN_WIDTH;
        return {
            progress: function(params, data) {
                var count = params.count;
                var largePoints = new $cf1def1f853d8378$var$LargeArr(count * 2);
                var largeBackgroundPoints = new $cf1def1f853d8378$var$LargeArr(count * 2);
                var largeDataIndices = new $cf1def1f853d8378$var$LargeArr(count);
                var dataIndex;
                var coord = [];
                var valuePair = [];
                var pointsOffset = 0;
                var idxOffset = 0;
                var store = data.getStore();
                while((dataIndex = params.next()) != null){
                    valuePair[valueDimIdx] = store.get(valueDimI, dataIndex);
                    valuePair[1 - valueDimIdx] = store.get(baseDimI, dataIndex);
                    coord = cartesian.dataToPoint(valuePair, null); // Data index might not be in order, depends on `progressiveChunkMode`.
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
                    largePoints[pointsOffset++] = coord[0];
                    largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
                    largePoints[pointsOffset++] = coord[1];
                    largeDataIndices[idxOffset++] = dataIndex;
                }
                data.setLayout({
                    largePoints: largePoints,
                    largeDataIndices: largeDataIndices,
                    largeBackgroundPoints: largeBackgroundPoints,
                    barWidth: barWidth,
                    valueAxisStart: $cf1def1f853d8378$var$getValueAxisStart(baseAxis, valueAxis, false),
                    backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
                    valueAxisHorizontal: valueAxisHorizontal
                });
            }
        };
    }
};
function $cf1def1f853d8378$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $cf1def1f853d8378$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $cf1def1f853d8378$var$getValueAxisStart(baseAxis, valueAxis, stacked) {
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

});

parcelRegister("kXmQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41b090cc8e9c237$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $5BQXp = parcelRequire("5BQXp");

var $24InP = parcelRequire("24InP");

var $9A4zx = parcelRequire("9A4zx");

var $aRcTH = parcelRequire("aRcTH");

var $fUFf0 = parcelRequire("fUFf0");


var $hzBt5 = parcelRequire("hzBt5");
var $f41b090cc8e9c237$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $f41b090cc8e9c237$var$TimeScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $24InP.format)(tick.value, (0, $24InP.fullLeveledFormatter)[(0, $24InP.getDefaultFormatPrecisionOfInterval)((0, $24InP.getPrimaryTimeUnit)(this._minLevelUnit))] || (0, $24InP.fullLeveledFormatter).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $24InP.leveledFormat)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ TimeScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = []; // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting('useUTC');
        var innerTicks = $f41b090cc8e9c237$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.niceExtent = function(opt) {
        var extent = this._extent; // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $24InP.ONE_DAY);
            extent[1] += (0, $24InP.ONE_DAY);
        } // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $24InP.ONE_DAY);
        }
        this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.niceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $f41b090cc8e9c237$var$scaleIntervals.length;
        var idx = Math.min($f41b090cc8e9c237$var$bisect($f41b090cc8e9c237$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1); // Interval that can be used to calculate ticks
        this._interval = $f41b090cc8e9c237$var$scaleIntervals[idx][1]; // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $f41b090cc8e9c237$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return typeof val === 'number' ? val : +$5BQXp.parseDate(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $9A4zx.contain(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $9A4zx.normalize(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $9A4zx.scale(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $aRcTH.default));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $f41b090cc8e9c237$var$scaleIntervals = [
    [
        'second',
        (0, $24InP.ONE_SECOND)
    ],
    [
        'minute',
        (0, $24InP.ONE_MINUTE)
    ],
    [
        'hour',
        (0, $24InP.ONE_HOUR)
    ],
    [
        'quarter-day',
        (0, $24InP.ONE_HOUR) * 6
    ],
    [
        'half-day',
        (0, $24InP.ONE_HOUR) * 12
    ],
    [
        'day',
        (0, $24InP.ONE_DAY) * 1.2
    ],
    [
        'half-week',
        (0, $24InP.ONE_DAY) * 3.5
    ],
    [
        'week',
        (0, $24InP.ONE_DAY) * 7
    ],
    [
        'month',
        (0, $24InP.ONE_DAY) * 31
    ],
    [
        'quarter',
        (0, $24InP.ONE_DAY) * 95
    ],
    [
        'half-year',
        (0, $24InP.ONE_YEAR) / 2
    ],
    [
        'year',
        (0, $24InP.ONE_YEAR)
    ] // 1Y
];
function $f41b090cc8e9c237$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $5BQXp.parseDate(valueA);
    var dateB = $5BQXp.parseDate(valueB);
    var isSame = function(unit) {
        return (0, $24InP.getUnitValue)(dateA, unit, isUTC) === (0, $24InP.getUnitValue)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame('year');
    }; // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame('month');
    };
    var isSameDay = function() {
        return isSameMonth() && isSame('day');
    }; // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame('hour');
    };
    var isSameMinute = function() {
        return isSameHour() && isSame('minute');
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame('second');
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame('millisecond');
    };
    switch(unit){
        case 'year':
            return isSameYear();
        case 'month':
            return isSameMonth();
        case 'day':
            return isSameDay();
        case 'hour':
            return isSameHour();
        case 'minute':
            return isSameMinute();
        case 'second':
            return isSameSecond();
        case 'millisecond':
            return isSameMilliSecond();
    }
} // const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $f41b090cc8e9c237$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $24InP.ONE_DAY);
    return approxInterval > 16 ? 16 // Math.floor(daysInMonth / 2) + 1  // In this case we only want one tick betwen two month.
     : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $24InP.ONE_DAY);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $24InP.ONE_HOUR);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $24InP.ONE_MINUTE) : (0, $24InP.ONE_SECOND);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $f41b090cc8e9c237$var$getMillisecondsInterval(approxInterval) {
    return $5BQXp.nice(approxInterval, true);
}
function $f41b090cc8e9c237$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $24InP.getPrimaryTimeUnit)(unitName)){
        case 'year':
        case 'month':
            outDate[(0, $24InP.monthSetterName)(isUTC)](0);
        case 'day':
            outDate[(0, $24InP.dateSetterName)(isUTC)](1);
        case 'hour':
            outDate[(0, $24InP.hoursSetterName)(isUTC)](0);
        case 'minute':
            outDate[(0, $24InP.minutesSetterName)(isUTC)](0);
        case 'second':
            outDate[(0, $24InP.secondsSetterName)(isUTC)](0);
            outDate[(0, $24InP.millisecondsSetterName)(isUTC)](0);
    }
    return outDate.getTime();
}
function $f41b090cc8e9c237$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $24InP.timeUnits);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName](); // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        } // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($f41b090cc8e9c237$var$isUnitValueSame((0, $24InP.getPrimaryTimeUnit)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $f41b090cc8e9c237$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $24InP.ONE_DAY) / 365));
                    getterName = (0, $24InP.fullYearGetterName)(isUTC);
                    setterName = (0, $24InP.fullYearSetterName)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $f41b090cc8e9c237$var$getMonthInterval(approxInterval);
                    getterName = (0, $24InP.monthGetterName)(isUTC);
                    setterName = (0, $24InP.monthSetterName)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $f41b090cc8e9c237$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $24InP.dateGetterName)(isUTC);
                    setterName = (0, $24InP.dateSetterName)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $f41b090cc8e9c237$var$getHourInterval(approxInterval);
                    getterName = (0, $24InP.hoursGetterName)(isUTC);
                    setterName = (0, $24InP.hoursSetterName)(isUTC);
                    break;
                case 'minute':
                    interval = $f41b090cc8e9c237$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $24InP.minutesGetterName)(isUTC);
                    setterName = (0, $24InP.minutesSetterName)(isUTC);
                    break;
                case 'second':
                    interval = $f41b090cc8e9c237$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $24InP.secondsGetterName)(isUTC);
                    setterName = (0, $24InP.secondsSetterName)(isUTC);
                    break;
                case 'millisecond':
                    interval = $f41b090cc8e9c237$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $24InP.millisecondsGetterName)(isUTC);
                    setterName = (0, $24InP.millisecondsSetterName)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
         // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $24InP.getPrimaryTimeUnit)(unitNames[i]);
        if (!(0, $24InP.isPrimaryTimeUnit)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $24InP.getPrimaryTimeUnit)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount; // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval; // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                 // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            } // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $hzBt5.filter)((0, $hzBt5.map)(levelsTicks, function(levelTicks) {
        return (0, $hzBt5.filter)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    }); // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $fUFf0.default).registerClass($f41b090cc8e9c237$var$TimeScale);
var $f41b090cc8e9c237$export$2e2bcd8739ae039 = $f41b090cc8e9c237$var$TimeScale;

});

parcelRegister("76hW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $52b70196934cb73f$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $fUFf0 = parcelRequire("fUFf0");

var $5BQXp = parcelRequire("5BQXp");

var $9A4zx = parcelRequire("9A4zx");

var $aRcTH = parcelRequire("aRcTH");
var $52b70196934cb73f$var$scaleProto = (0, $fUFf0.default).prototype; // FIXME:TS refactor: not good to call it directly with `this`?
var $52b70196934cb73f$var$intervalScaleProto = (0, $aRcTH.default).prototype;
var $52b70196934cb73f$var$roundingErrorFix = $5BQXp.round;
var $52b70196934cb73f$var$mathFloor = Math.floor;
var $52b70196934cb73f$var$mathCeil = Math.ceil;
var $52b70196934cb73f$var$mathPow = Math.pow;
var $52b70196934cb73f$var$mathLog = Math.log;
var $52b70196934cb73f$var$LogScale = /** @class */ function(_super) {
    (0, $fKE23.__extends)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $aRcTH.default)(); // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $52b70196934cb73f$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $hzBt5.map(ticks, function(tick) {
            var val = tick.value;
            var powVal = $5BQXp.round($52b70196934cb73f$var$mathPow(this.base, val)); // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $52b70196934cb73f$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $52b70196934cb73f$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = this.base;
        start = $52b70196934cb73f$var$mathLog(start) / $52b70196934cb73f$var$mathLog(base);
        end = $52b70196934cb73f$var$mathLog(end) / $52b70196934cb73f$var$mathLog(base);
        $52b70196934cb73f$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $52b70196934cb73f$var$scaleProto.getExtent.call(this);
        extent[0] = $52b70196934cb73f$var$mathPow(base, extent[0]);
        extent[1] = $52b70196934cb73f$var$mathPow(base, extent[1]); // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $52b70196934cb73f$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $52b70196934cb73f$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $52b70196934cb73f$var$mathLog(extent[0]) / $52b70196934cb73f$var$mathLog(base);
        extent[1] = $52b70196934cb73f$var$mathLog(extent[1]) / $52b70196934cb73f$var$mathLog(base);
        $52b70196934cb73f$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.niceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $5BQXp.quantity(span);
        var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
         // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $5BQXp.round($52b70196934cb73f$var$mathCeil(extent[0] / interval) * interval),
            $5BQXp.round($52b70196934cb73f$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.niceExtent = function(opt) {
        $52b70196934cb73f$var$intervalScaleProto.niceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $52b70196934cb73f$var$mathLog(val) / $52b70196934cb73f$var$mathLog(this.base);
        return $9A4zx.contain(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $52b70196934cb73f$var$mathLog(val) / $52b70196934cb73f$var$mathLog(this.base);
        return $9A4zx.normalize(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $9A4zx.scale(val, this._extent);
        return $52b70196934cb73f$var$mathPow(this.base, val);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $fUFf0.default));
var $52b70196934cb73f$var$proto = $52b70196934cb73f$var$LogScale.prototype;
$52b70196934cb73f$var$proto.getMinorTicks = $52b70196934cb73f$var$intervalScaleProto.getMinorTicks;
$52b70196934cb73f$var$proto.getLabel = $52b70196934cb73f$var$intervalScaleProto.getLabel;
function $52b70196934cb73f$var$fixRoundingError(val, originalVal) {
    return $52b70196934cb73f$var$roundingErrorFix(val, $5BQXp.getPrecision(originalVal));
}
(0, $fUFf0.default).registerClass($52b70196934cb73f$var$LogScale);
var $52b70196934cb73f$export$2e2bcd8739ae039 = $52b70196934cb73f$var$LogScale;

});

parcelRegister("h3hFK", function(module, exports) {

$parcel$export(module.exports, "parseAxisModelMinMax", () => $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b);
$parcel$export(module.exports, "ensureScaleRawExtentInfo", () => $c6a06cd3efaf7d9a$export$5c3dbcbeb9ce7f5a);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");
var $c6a06cd3efaf7d9a$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on ouside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = model.getNeedCrossZero && model.getNeedCrossZero();
        var modelMinRaw = this._modelMinRaw = model.get('min', true);
        if ((0, $hzBt5.isFunction)(modelMinRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMinNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $hzBt5.isFunction)(modelMaxRaw)) // This callback alway provide users the full data extent (before data filtered).
        this._modelMaxNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $hzBt5.isArray)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $02NbV.parsePercent)(boundaryGapArr[0], 1),
                (0, $02NbV.parsePercent)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null; // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum; // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        if (min > max) {
            min = NaN;
            max = NaN;
        }
        var isBlank = (0, $hzBt5.eqNaN)(min) || (0, $hzBt5.eqNaN)(max) || isOrdinal && !axisDataLen; // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0; // minFixed = true;
             // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0; // maxFixed = true;
             // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        } // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$c6a06cd3efaf7d9a$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $c6a06cd3efaf7d9a$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $c6a06cd3efaf7d9a$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $c6a06cd3efaf7d9a$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $c6a06cd3efaf7d9a$export$5c3dbcbeb9ce7f5a(scale, model, originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $c6a06cd3efaf7d9a$export$c35454f678e99c82(scale, model, originalExtent); // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $c6a06cd3efaf7d9a$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $hzBt5.eqNaN)(minMax) ? NaN : scale.parse(minMax);
}

});


parcelRegister("4OY0R", function(module, exports) {

$parcel$export(module.exports, "cartesian2DDimensions", () => $382a624382bad5e0$export$988a008d2b9120f4);
$parcel$export(module.exports, "default", () => $382a624382bad5e0$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $lGSv6 = parcelRequire("lGSv6");

var $gdoyf = parcelRequire("gdoyf");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");
var $382a624382bad5e0$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $382a624382bad5e0$var$canCalculateAffineTransform(scale) {
    return scale.type === 'interval' || scale.type === 'time';
}
var $382a624382bad5e0$var$Cartesian2D = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $382a624382bad5e0$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$382a624382bad5e0$var$canCalculateAffineTransform(xAxisScale) || !$382a624382bad5e0$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
         // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $crEgd.invert)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1]; // Fast path
        if (this._transform // It's supported that if data is like `[Inifity, 123]`, where only Y pixel calculated.
         && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $ef5pP.applyTransform)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $ef5pP.applyTransform)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function() {
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]);
        var y = Math.min(yExtent[0], yExtent[1]);
        var width = Math.max(xExtent[0], xExtent[1]) - x;
        var height = Math.max(yExtent[0], yExtent[1]) - y;
        return new (0, $lGSv6.default)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $gdoyf.default));
var $382a624382bad5e0$export$2e2bcd8739ae039 = $382a624382bad5e0$var$Cartesian2D;

});
parcelRegister("gdoyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce0e7a893aee0b4$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
var $bce0e7a893aee0b4$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $hzBt5.map(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $hzBt5.filter(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $bce0e7a893aee0b4$export$2e2bcd8739ae039 = $bce0e7a893aee0b4$var$Cartesian;

});


parcelRegister("jhbA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e08896631375e7ab$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $ewaMj = parcelRequire("ewaMj");
var $e08896631375e7ab$var$Axis2D = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $ewaMj.default));
var $e08896631375e7ab$export$2e2bcd8739ae039 = $e08896631375e7ab$var$Axis2D;

});
parcelRegister("ewaMj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91c6a27dcb231fa$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $5BQXp = parcelRequire("5BQXp");

var $avVVg = parcelRequire("avVVg");
var $a91c6a27dcb231fa$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $a91c6a27dcb231fa$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $5BQXp.getPixelPrecision)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $a91c6a27dcb231fa$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $5BQXp.linearMap)(data, $a91c6a27dcb231fa$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $a91c6a27dcb231fa$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $5BQXp.linearMap)(coord, extent, $a91c6a27dcb231fa$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $avVVg.createAxisTicks)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $hzBt5.map)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $a91c6a27dcb231fa$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber'); // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $hzBt5.map)(minorTicks, function(minorTicksGroup) {
            return (0, $hzBt5.map)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $avVVg.createAxisLabels)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overrided to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overrided, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $avVVg.calculateCategoryInterval)(this);
    };
    return Axis;
}();
function $a91c6a27dcb231fa$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $a91c6a27dcb231fa$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[0]
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $hzBt5.each)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unecessary tick added.
        a = (0, $5BQXp.round)(a);
        b = (0, $5BQXp.round)(b);
        return inverse ? a > b : a < b;
    }
}
var $a91c6a27dcb231fa$export$2e2bcd8739ae039 = $a91c6a27dcb231fa$var$Axis;

});
parcelRegister("avVVg", function(module, exports) {

$parcel$export(module.exports, "createAxisLabels", () => $7a79bad7d16623cc$export$10216ebd3e3e485e);
$parcel$export(module.exports, "createAxisTicks", () => $7a79bad7d16623cc$export$7cccf6836ae8323c);
$parcel$export(module.exports, "calculateCategoryInterval", () => $7a79bad7d16623cc$export$9ea1d3f146a5a65f);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $02NbV = parcelRequire("02NbV");

var $ckizb = parcelRequire("ckizb");

var $ekDcz = parcelRequire("ekDcz");
var $7a79bad7d16623cc$var$inner = (0, $ckizb.makeInner)();
function $7a79bad7d16623cc$export$10216ebd3e3e485e(axis) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $7a79bad7d16623cc$var$makeCategoryLabels(axis) : $7a79bad7d16623cc$var$makeRealNumberLabels(axis);
}
function $7a79bad7d16623cc$export$7cccf6836ae8323c(axis, tickModel) {
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $7a79bad7d16623cc$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $hzBt5.map(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $7a79bad7d16623cc$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $7a79bad7d16623cc$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $7a79bad7d16623cc$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $7a79bad7d16623cc$var$getListCache(axis, 'labels');
    var optionLabelInterval = (0, $ekDcz.getOptionCategoryInterval)(labelModel);
    var result = $7a79bad7d16623cc$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($hzBt5.isFunction(optionLabelInterval)) labels = $7a79bad7d16623cc$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $7a79bad7d16623cc$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $7a79bad7d16623cc$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    } // Cache to avoid calling interval function repeatly.
    return $7a79bad7d16623cc$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $7a79bad7d16623cc$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $7a79bad7d16623cc$var$getListCache(axis, 'ticks');
    var optionTickInterval = (0, $ekDcz.getOptionCategoryInterval)(tickModel);
    var result = $7a79bad7d16623cc$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($hzBt5.isFunction(optionTickInterval)) ticks = $7a79bad7d16623cc$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $7a79bad7d16623cc$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $hzBt5.map(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $7a79bad7d16623cc$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatly.
    return $7a79bad7d16623cc$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $7a79bad7d16623cc$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    return {
        labels: $hzBt5.map(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $7a79bad7d16623cc$var$getListCache(axis, prop) {
    // Because key can be funciton, and cache size always be small, we use array cache.
    return $7a79bad7d16623cc$var$inner(axis)[prop] || ($7a79bad7d16623cc$var$inner(axis)[prop] = []);
}
function $7a79bad7d16623cc$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $7a79bad7d16623cc$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $7a79bad7d16623cc$var$makeAutoCategoryInterval(axis) {
    var result = $7a79bad7d16623cc$var$inner(axis).autoInterval;
    return result != null ? result : $7a79bad7d16623cc$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $7a79bad7d16623cc$export$9ea1d3f146a5a65f(axis) {
    var params = $7a79bad7d16623cc$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0; // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0; // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $02NbV.getBoundingRect(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top'); // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3; // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $7a79bad7d16623cc$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
     && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
     && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $7a79bad7d16623cc$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $7a79bad7d16623cc$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
     // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $ekDcz.shouldShowAllLabels)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
     // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $7a79bad7d16623cc$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $ekDcz.makeLabelFormatter)(axis);
    var result = [];
    $hzBt5.each(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}

});



parcelRegister("aV7Yx", function(module, exports) {

$parcel$export(module.exports, "layout", () => $7f3569ffac744ed1$export$b3219800bda33a1f);
$parcel$export(module.exports, "isCartesian2DSeries", () => $7f3569ffac744ed1$export$c2a0b77974c5e35d);
$parcel$export(module.exports, "findAxisModels", () => $7f3569ffac744ed1$export$8220131ac1d61d28);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
function $7f3569ffac744ed1$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    } // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ]; // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($hzBt5.retrieve(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
     // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $7f3569ffac744ed1$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $7f3569ffac744ed1$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $hzBt5.each(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $ckizb.SINGLE_REFERRING)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}

});


parcelRegister("9SXxl", function(module, exports) {

$parcel$export(module.exports, "CartesianXAxisView", () => $732756f43565e121$export$b6d40cd875b8a1c8);
$parcel$export(module.exports, "CartesianYAxisView", () => $732756f43565e121$export$417e1bdd0616e0dc);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $hXAsm = parcelRequire("hXAsm");
var $8q0E1 = parcelRequire("8q0E1");
var $15UDR = parcelRequire("15UDR");

var $3yIQS = parcelRequire("3yIQS");

var $75jQl = parcelRequire("75jQl");

var $aV7Yx = parcelRequire("aV7Yx");

var $1MvRH = parcelRequire("1MvRH");
var $732756f43565e121$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $732756f43565e121$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine'
];
var $732756f43565e121$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $hXAsm.default();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $aV7Yx.layout(gridModel, axisModel);
        var axisBuilder = new (0, $3yIQS.default)(axisModel, $hzBt5.extend({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    var otherAxisType = cartesians[i].getOtherAxis(axisModel.axis).type;
                    if (otherAxisType === 'value' || otherAxisType === 'log') // Still show axis tick or axisLine if other axis is value / log
                    return true;
                } // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $hzBt5.each($732756f43565e121$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $hzBt5.each($732756f43565e121$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $732756f43565e121$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this); // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $8q0E1.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $1MvRH.rectCoordAxisHandleRemove)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $75jQl.default));
var $732756f43565e121$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        lineColors = $hzBt5.isArray(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var tickValue = ticksCoords[i].tickValue;
            axisGroup.add(new $15UDR.default({
                anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $hzBt5.defaults({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            }));
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            axisGroup.add(new $15UDR.default({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                subPixelOptimize: true,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            }));
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $1MvRH.rectCoordAxisBuildSplitArea)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $732756f43565e121$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($732756f43565e121$var$CartesianAxisView);
var $732756f43565e121$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $732756f43565e121$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($732756f43565e121$var$CartesianAxisView);
var $732756f43565e121$export$2e2bcd8739ae039 = $732756f43565e121$var$CartesianAxisView;

});
parcelRegister("3yIQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $297756b269af41f1$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $hXAsm = parcelRequire("hXAsm");parcelRequire("8q0E1");
var $15UDR = parcelRequire("15UDR");
var $8q0E1 = parcelRequire("8q0E1");
var $kiooD = parcelRequire("kiooD");

var $aly4X = parcelRequire("aly4X");

var $hcRXD = parcelRequire("hcRXD");

var $fR3z1 = parcelRequire("fR3z1");

var $5BQXp = parcelRequire("5BQXp");

var $4TnMt = parcelRequire("4TnMt");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $ekDcz = parcelRequire("ekDcz");

var $hJQJ0 = parcelRequire("hJQJ0");
var $297756b269af41f1$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $297756b269af41f1$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $hXAsm.default();
        this.opt = opt;
        this.axisModel = axisModel; // Default value
        (0, $hzBt5.defaults)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        }); // FIXME Not use a seperate text group?
        var transformGroup = new $hXAsm.default({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        }); // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$297756b269af41f1$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $297756b269af41f1$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $5BQXp.remRadian)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $5BQXp.isRadianAroundZero)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $5BQXp.isRadianAroundZero)(rotationDiff - $297756b269af41f1$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $297756b269af41f1$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
         || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $297756b269af41f1$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        if (matrix) {
            (0, $ef5pP.applyTransform)(pt1, pt1, matrix);
            (0, $ef5pP.applyTransform)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $hzBt5.extend)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var line = new $15UDR.default({
            // Id for animation
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        line.anid = 'line';
        group.add(line);
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if (typeof arrows === 'string') // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if (typeof arrowSize === 'string' || typeof arrowSize === 'number') // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $4TnMt.normalizeSymbolOffset)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $hzBt5.each)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $4TnMt.createSymbol)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true); // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt1[0] + r * Math.cos(opt.rotation),
                        y: pt1[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $297756b269af41f1$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $297756b269af41f1$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $297756b269af41f1$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $297756b269af41f1$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection); // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            'axisLabel',
            'hideOverlap'
        ])) {
            var labelList = (0, $hJQJ0.prepareLayoutList)((0, $hzBt5.map)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $hJQJ0.hideOverlap)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $hzBt5.retrieve)(opt.axisName, axisModel.get('name'));
        if (!name) return;
        var nameLocation = axisModel.get('nameLocation');
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            $297756b269af41f1$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $297756b269af41f1$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($297756b269af41f1$var$isNameLocationCenter(nameLocation)) labelLayout = $297756b269af41f1$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, nameDirection);
        else {
            labelLayout = $297756b269af41f1$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $hzBt5.retrieve)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $kiooD.default({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $297756b269af41f1$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $hcRXD.createTextStyle)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $8q0E1.setTooltipConfig({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name; // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $297756b269af41f1$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $aly4X.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $297756b269af41f1$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $5BQXp.remRadian)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $5BQXp.isRadianAroundZero)(rotationDiff - $297756b269af41f1$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $5BQXp.isRadianAroundZero)(rotationDiff - $297756b269af41f1$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $297756b269af41f1$var$PI * 1.5 && rotationDiff > $297756b269af41f1$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $297756b269af41f1$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $ekDcz.shouldShowAllLabels)(axisModel.axis)) return;
     // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]); // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $297756b269af41f1$var$ignoreEl(firstLabel);
        $297756b269af41f1$var$ignoreEl(firstTick);
    } else if ($297756b269af41f1$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $297756b269af41f1$var$ignoreEl(nextLabel);
            $297756b269af41f1$var$ignoreEl(nextTick);
        } else {
            $297756b269af41f1$var$ignoreEl(firstLabel);
            $297756b269af41f1$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $297756b269af41f1$var$ignoreEl(lastLabel);
        $297756b269af41f1$var$ignoreEl(lastTick);
    } else if ($297756b269af41f1$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $297756b269af41f1$var$ignoreEl(prevLabel);
            $297756b269af41f1$var$ignoreEl(prevTick);
        } else {
            $297756b269af41f1$var$ignoreEl(lastLabel);
            $297756b269af41f1$var$ignoreEl(lastTick);
        }
    }
}
function $297756b269af41f1$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $297756b269af41f1$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
     // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $crEgd.identity([]);
    $crEgd.rotate(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($crEgd.mul([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($crEgd.mul([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $297756b269af41f1$var$isNameLocationCenter(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $297756b269af41f1$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $ef5pP.applyTransform)(pt1, pt1, tickTransform);
            (0, $ef5pP.applyTransform)(pt2, pt2, tickTransform);
        } // Tick line, Not use group transform to have better line draw
        var tickEl = new $15UDR.default({
            subPixelOptimize: true,
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $297756b269af41f1$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = opt.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $297756b269af41f1$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $hzBt5.defaults)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $297756b269af41f1$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $hzBt5.defaults)(lineStyleModel.getLineStyle(), (0, $hzBt5.defaults)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $297756b269af41f1$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $297756b269af41f1$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $hzBt5.retrieve)(opt.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel('axisLabel');
    var labelMargin = labelModel.get('margin');
    var labels = axis.getViewLabels(); // Special label rotate.
    var labelRotation = ((0, $hzBt5.retrieve)(opt.labelRotate, labelModel.get('rotate')) || 0) * $297756b269af41f1$var$PI / 180;
    var labelLayout = $297756b269af41f1$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $297756b269af41f1$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get('triggerEvent');
    (0, $hzBt5.each)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $hzBt5.isObject)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $fR3z1.default)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var textEl = new $kiooD.default({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $hcRXD.createTextStyle)(itemLabelModel, {
                text: formattedLabel,
                align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
                verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
                fill: typeof textColor === 'function' ? textColor(// index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user repalce ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue; // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $297756b269af41f1$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            (0, $aly4X.getECData)(textEl).eventData = eventData;
        } // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $297756b269af41f1$export$2e2bcd8739ae039 = $297756b269af41f1$var$AxisBuilder;

});
parcelRegister("hJQJ0", function(module, exports) {

$parcel$export(module.exports, "prepareLayoutList", () => $ce9f89b610653ca5$export$6c403cad1ae3e239);
$parcel$export(module.exports, "shiftLayoutOnX", () => $ce9f89b610653ca5$export$b6b2b07f8ed32bd6);
$parcel$export(module.exports, "shiftLayoutOnY", () => $ce9f89b610653ca5$export$118c25e0932528e4);
$parcel$export(module.exports, "hideOverlap", () => $ce9f89b610653ca5$export$8ce774e164a49410);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $lGSv6 = parcelRequire("lGSv6");
var $fi3eW = parcelRequire("fi3eW");
function $ce9f89b610653ca5$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform(); // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $fi3eW.default)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $ce9f89b610653ca5$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
     // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap(); // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1); // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    } // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent; // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $ce9f89b610653ca5$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $ce9f89b610653ca5$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
function $ce9f89b610653ca5$export$118c25e0932528e4(list, topBound, bottomBound, balanceShift) {
    return $ce9f89b610653ca5$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function $ce9f89b610653ca5$export$8ce774e164a49410(labelList) {
    var displayedLabels = []; // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $lGSv6.default)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect); // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j]; // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $fi3eW.default)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $fi3eW.default)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        } // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr('ignore', labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}

});


parcelRegister("75jQl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5288647e8c2800b1$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $bztnt = parcelRequire("bztnt");

var $4uCJH = parcelRequire("4uCJH");
var $5288647e8c2800b1$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $5288647e8c2800b1$var$AxisView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $bztnt.fixValue(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $bztnt.getAxisPointerModel(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $5288647e8c2800b1$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $5288647e8c2800b1$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $4uCJH.default));
var $5288647e8c2800b1$export$2e2bcd8739ae039 = $5288647e8c2800b1$var$AxisView;

});
parcelRegister("bztnt", function(module, exports) {

$parcel$export(module.exports, "collect", () => $86c9c06360945b11$export$bb44f104e3c54dae);
$parcel$export(module.exports, "makeKey", () => $86c9c06360945b11$export$d01b444bafb1a792);
$parcel$export(module.exports, "fixValue", () => $86c9c06360945b11$export$f5ea32e3629d8043);
$parcel$export(module.exports, "getAxisInfo", () => $86c9c06360945b11$export$bd39458db76002ab);
$parcel$export(module.exports, "getAxisPointerModel", () => $86c9c06360945b11$export$3b06fce3f68b734);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fR3z1 = parcelRequire("fR3z1");

var $hzBt5 = parcelRequire("hzBt5");
function $86c9c06360945b11$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $86c9c06360945b11$var$collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $86c9c06360945b11$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $86c9c06360945b11$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = []; // Collect axes info.
    (0, $hzBt5.each)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $86c9c06360945b11$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
        // for user. So we enable seting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $hzBt5.each)(coordSys.getAxes(), (0, $hzBt5.curry)(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
         && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $hzBt5.each)(tooltipAxes.baseAxes, (0, $hzBt5.curry)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $hzBt5.each)(tooltipAxes.otherAxes, (0, $hzBt5.curry)(saveTooltipAxisInfo, 'cross', false));
        } // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$86c9c06360945b11$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $86c9c06360945b11$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var axisKey = $86c9c06360945b11$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $86c9c06360945b11$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $86c9c06360945b11$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $86c9c06360945b11$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $hzBt5.each)(fields, function(field) {
        volatileOption[field] = (0, $hzBt5.clone)(tooltipAxisPointerModel.get(field));
    }); // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
    // Only these properties can be overrided from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $hzBt5.defaults)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $fR3z1.default)(volatileOption, globalAxisPointerModel, ecModel));
}
function $86c9c06360945b11$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $hzBt5.each)(result.coordSysAxesInfo[$86c9c06360945b11$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $86c9c06360945b11$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($86c9c06360945b11$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $86c9c06360945b11$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $86c9c06360945b11$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $86c9c06360945b11$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $hzBt5.isArray)(linkPropValue) && (0, $hzBt5.indexOf)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $86c9c06360945b11$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $86c9c06360945b11$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $86c9c06360945b11$var$isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
     || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $86c9c06360945b11$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$86c9c06360945b11$export$d01b444bafb1a792(axisModel)];
}
function $86c9c06360945b11$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $86c9c06360945b11$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $86c9c06360945b11$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $86c9c06360945b11$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}

});


parcelRegister("1MvRH", function(module, exports) {

$parcel$export(module.exports, "rectCoordAxisBuildSplitArea", () => $14c2fde1996caecc$export$c80b7ef1527ec8c9);
$parcel$export(module.exports, "rectCoordAxisHandleRemove", () => $14c2fde1996caecc$export$48ebf2d6ce8ad076);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");

var $ckizb = parcelRequire("ckizb");
var $14c2fde1996caecc$var$inner = (0, $ckizb.makeInner)();
function $14c2fde1996caecc$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
     // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
     // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $14c2fde1996caecc$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $hzBt5.createHashMap();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $hzBt5.isArray(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $aeCKo.default({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $hzBt5.defaults({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $14c2fde1996caecc$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $14c2fde1996caecc$export$48ebf2d6ce8ad076(axisView) {
    $14c2fde1996caecc$var$inner(axisView).splitAreaColors = null;
}

});




parcelRegister("aw6hh", function(module, exports) {

$parcel$export(module.exports, "install", () => $7a81c32cf46f7806$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $75jQl = parcelRequire("75jQl");

var $7nTJK = parcelRequire("7nTJK");

var $dZhKR = parcelRequire("dZhKR");

var $d7lrG = parcelRequire("d7lrG");

var $hzBt5 = parcelRequire("hzBt5");

var $bztnt = parcelRequire("bztnt");

var $7KJPQ = parcelRequire("7KJPQ");
function $7a81c32cf46f7806$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $75jQl.default).registerAxisPointerClass('CartesianAxisPointer', (0, $7nTJK.default));
    registers.registerComponentModel((0, $dZhKR.default));
    registers.registerComponentView((0, $d7lrG.default));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $hzBt5.isArray)(link)) option.axisPointer.link = [
                link
            ];
        }
    }); // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $bztnt.collect)(ecModel, api);
    }); // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $7KJPQ.default));
}

});
parcelRegister("7nTJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5605ea9498afdc26$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $3l2JP = parcelRequire("3l2JP");

var $35drB = parcelRequire("35drB");

var $aV7Yx = parcelRequire("aV7Yx");
var $5605ea9498afdc26$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $5605ea9498afdc26$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $35drB.buildElStyle(axisPointerModel);
            var pointerOption = $5605ea9498afdc26$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $aV7Yx.layout(grid.model, axisModel);
        $35drB.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $aV7Yx.layout(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        }); // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $35drB.getTransformedPosition(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $5605ea9498afdc26$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $3l2JP.default));
function $5605ea9498afdc26$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $5605ea9498afdc26$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $35drB.makeLineShape([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $5605ea9498afdc26$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $35drB.makeRectShape([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $5605ea9498afdc26$var$getAxisDimIndex(axis))
        };
    }
};
function $5605ea9498afdc26$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $5605ea9498afdc26$export$2e2bcd8739ae039 = $5605ea9498afdc26$var$CartesianAxisPointer;

});
parcelRegister("3l2JP", function(module, exports) {

$parcel$export(module.exports, "default", () => $26e574fff45e59ab$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8q0E1 = parcelRequire("8q0E1");

var $bztnt = parcelRequire("bztnt");

var $kcVwz = parcelRequire("kcVwz");

var $7b8YY = parcelRequire("7b8YY");

var $ckizb = parcelRequire("ckizb");
var $26e574fff45e59ab$var$inner = (0, $ckizb.makeInner)();
var $26e574fff45e59ab$var$clone = $hzBt5.clone;
var $26e574fff45e59ab$var$bind = $hzBt5.bind;
/**
 * Base axis pointer class in 2D.
 */ var $26e574fff45e59ab$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api; // Optimize: `render` will be called repeatly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show(); // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $8q0E1.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $hzBt5.curry($26e574fff45e59ab$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $26e574fff45e59ab$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
             // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $bztnt.getAxisInfo(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent(); // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {};
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $26e574fff45e59ab$var$inner(group).pointerEl = new $8q0E1[pointerOption.type]($26e574fff45e59ab$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $26e574fff45e59ab$var$inner(group).labelEl = new $8q0E1.Text($26e574fff45e59ab$var$clone(elOption.label));
            group.add(labelEl);
            $26e574fff45e59ab$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $26e574fff45e59ab$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $26e574fff45e59ab$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $26e574fff45e59ab$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $8q0E1.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // Fot mobile devicem, prevent screen slider on the button.
                    $kcVwz.stop(e.event);
                },
                onmousedown: $26e574fff45e59ab$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $26e574fff45e59ab$var$bind(this._onHandleDragMove, this),
                ondragend: $26e574fff45e59ab$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $26e574fff45e59ab$var$updateMandatoryProps(handle, axisPointerModel, false); // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ])); // update position
        var handleSize = handleModel.get('size');
        if (!$hzBt5.isArray(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $7b8YY.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $26e574fff45e59ab$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $26e574fff45e59ab$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true; // Persistent for throttle.
        var trans = this.updateHandleTransform($26e574fff45e59ab$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($26e574fff45e59ab$var$getHandleTransProps(trans));
        $26e574fff45e59ab$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {};
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $26e574fff45e59ab$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$26e574fff45e59ab$var$propsEqual($26e574fff45e59ab$var$inner(el).lastProp, props)) {
        $26e574fff45e59ab$var$inner(el).lastProp = props;
        moveAnimation ? $8q0E1.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $26e574fff45e59ab$var$propsEqual(lastProps, newProps) {
    if ($hzBt5.isObject(lastProps) && $hzBt5.isObject(newProps)) {
        var equals_1 = true;
        $hzBt5.each(newProps, function(item, key) {
            equals_1 = equals_1 && $26e574fff45e59ab$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $26e574fff45e59ab$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $26e574fff45e59ab$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $26e574fff45e59ab$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $26e574fff45e59ab$export$2e2bcd8739ae039 = $26e574fff45e59ab$var$BaseAxisPointer;

});

parcelRegister("35drB", function(module, exports) {

$parcel$export(module.exports, "buildElStyle", () => $23ec447b978aad75$export$b7fe459c7cc50060);
$parcel$export(module.exports, "buildLabelElOption", () => $23ec447b978aad75$export$8206a9937c45910f);
$parcel$export(module.exports, "getValueLabel", () => $23ec447b978aad75$export$7cffee0f9aed39d0);
$parcel$export(module.exports, "getTransformedPosition", () => $23ec447b978aad75$export$4bb66440324c3a3d);
$parcel$export(module.exports, "buildCartesianSingleLabelElOption", () => $23ec447b978aad75$export$fd3eb3812211a173);
$parcel$export(module.exports, "makeLineShape", () => $23ec447b978aad75$export$885fa0ad5a826207);
$parcel$export(module.exports, "makeRectShape", () => $23ec447b978aad75$export$a8b35248bcc02756);
$parcel$export(module.exports, "makeSectorShape", () => $23ec447b978aad75$export$b0cf82e7ebc0d7d0);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $8q0E1 = parcelRequire("8q0E1");

var $02NbV = parcelRequire("02NbV");

var $gyplX = parcelRequire("gyplX");

var $crEgd = parcelRequire("crEgd");

var $ekDcz = parcelRequire("ekDcz");

var $3yIQS = parcelRequire("3yIQS");

var $hcRXD = parcelRequire("hcRXD");
function $23ec447b978aad75$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $23ec447b978aad75$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $23ec447b978aad75$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $gyplX.normalizeCssArray(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $02NbV.getBoundingRect(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
    $23ec447b978aad75$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $hcRXD.createTextStyle)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Lable should be over axisPointer.
        z2: 10
    };
} // Do not overflow ec container
function $23ec447b978aad75$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $23ec447b978aad75$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $ekDcz.getAxisRawValue(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $hzBt5.each(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($hzBt5.isString(formatter)) text = formatter.replace('{value}', text);
        else if ($hzBt5.isFunction(formatter)) text = formatter(params_1);
    }
    return text;
}
function $23ec447b978aad75$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $crEgd.create();
    $crEgd.rotate(transform, transform, layoutInfo.rotation);
    $crEgd.translate(transform, transform, layoutInfo.position);
    return $8q0E1.applyTransform([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $23ec447b978aad75$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $3yIQS.default).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $23ec447b978aad75$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $23ec447b978aad75$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $23ec447b978aad75$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $23ec447b978aad75$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $23ec447b978aad75$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}

});


parcelRegister("dZhKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2eebe9e7e405bcb$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $6IEE1 = parcelRequire("6IEE1");
var $a2eebe9e7e405bcb$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: '#B9BEC9',
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: 'rgba(210,219,238,0.2)'
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: '#fff',
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: 'auto',
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: '#333',
            shadowBlur: 3,
            shadowColor: '#aaa',
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $6IEE1.default));
var $a2eebe9e7e405bcb$export$2e2bcd8739ae039 = $a2eebe9e7e405bcb$var$AxisPointerModel;

});

parcelRegister("d7lrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $98cc9074b5c0aca3$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $lMUEI = parcelRequire("lMUEI");

var $4uCJH = parcelRequire("4uCJH");
var $98cc9074b5c0aca3$var$AxisPointerView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $lMUEI.register('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $lMUEI.unregister('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $lMUEI.unregister('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $4uCJH.default));
var $98cc9074b5c0aca3$export$2e2bcd8739ae039 = $98cc9074b5c0aca3$var$AxisPointerView;

});
parcelRegister("lMUEI", function(module, exports) {

$parcel$export(module.exports, "register", () => $fdca075177a2cf01$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $fdca075177a2cf01$export$d07f55d4c15c0440);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $ckizb = parcelRequire("ckizb");
var $fdca075177a2cf01$var$inner = (0, $ckizb.makeInner)();
var $fdca075177a2cf01$var$each = $hzBt5.each;
function $fdca075177a2cf01$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $gZXYp.default).node) return;
    var zr = api.getZr();
    $fdca075177a2cf01$var$inner(zr).records || ($fdca075177a2cf01$var$inner(zr).records = {});
    $fdca075177a2cf01$var$initGlobalListeners(zr, api);
    var record = $fdca075177a2cf01$var$inner(zr).records[key] || ($fdca075177a2cf01$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $fdca075177a2cf01$var$initGlobalListeners(zr, api) {
    if ($fdca075177a2cf01$var$inner(zr).initialized) return;
    $fdca075177a2cf01$var$inner(zr).initialized = true;
    useHandler('click', $hzBt5.curry($fdca075177a2cf01$var$doEnter, 'click'));
    useHandler('mousemove', $hzBt5.curry($fdca075177a2cf01$var$doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
    useHandler('globalout', $fdca075177a2cf01$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $fdca075177a2cf01$var$makeDispatchAction(api);
            $fdca075177a2cf01$var$each($fdca075177a2cf01$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $fdca075177a2cf01$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $fdca075177a2cf01$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $fdca075177a2cf01$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $fdca075177a2cf01$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $fdca075177a2cf01$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    }; // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $fdca075177a2cf01$export$d07f55d4c15c0440(key, api) {
    if ((0, $gZXYp.default).node) return;
    var zr = api.getZr();
    var record = ($fdca075177a2cf01$var$inner(zr).records || {})[key];
    if (record) $fdca075177a2cf01$var$inner(zr).records[key] = null;
}

});


parcelRegister("7KJPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a50622cb8cf958a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $bztnt = parcelRequire("bztnt");

var $hKxet = parcelRequire("hKxet");

var $hzBt5 = parcelRequire("hzBt5");
var $5a50622cb8cf958a$var$inner = (0, $ckizb.makeInner)();
function $5a50622cb8cf958a$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $hzBt5.bind)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($5a50622cb8cf958a$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $hKxet.default)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $5a50622cb8cf958a$var$illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $5a50622cb8cf958a$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $hzBt5.curry)($5a50622cb8cf958a$var$showPointer, showValueMap),
        showTooltip: (0, $hzBt5.curry)($5a50622cb8cf958a$var$showTooltip, dataByCoordSys)
    }; // Process for triggered axes.
    (0, $hzBt5.each)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $hzBt5.each)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $5a50622cb8cf958a$var$findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $5a50622cb8cf958a$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    }); // Process for linked axes.
    var linkTriggers = {};
    (0, $hzBt5.each)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $hzBt5.each)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $5a50622cb8cf958a$var$makeMapperParam(srcAxisInfo), $5a50622cb8cf958a$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $hzBt5.each)(linkTriggers, function(val, tarKey) {
        $5a50622cb8cf958a$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $5a50622cb8cf958a$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $5a50622cb8cf958a$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $5a50622cb8cf958a$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $5a50622cb8cf958a$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    } // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $5a50622cb8cf958a$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $hzBt5.extend)(outputFinder, payloadBatch[0]);
     // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch); // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $5a50622cb8cf958a$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $hzBt5.each)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff); // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $hzBt5.each)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $5a50622cb8cf958a$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $5a50622cb8cf958a$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $bztnt.makeKey(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $5a50622cb8cf958a$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $hzBt5.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value; // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
         // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $5a50622cb8cf958a$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($5a50622cb8cf958a$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    } // In most case only one axis (or event one series is used). It is
    // convinient to fetch payload.seriesIndex and payload.dataIndex
    // dirtectly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $5a50622cb8cf958a$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification shoule be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $5a50622cb8cf958a$var$inner(zr)[highDownKey] || {};
    var newHighlights = $5a50622cb8cf958a$var$inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $hzBt5.each)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && (0, $hzBt5.each)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    }); // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $hzBt5.each)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $hzBt5.each)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $5a50622cb8cf958a$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $5a50622cb8cf958a$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $5a50622cb8cf958a$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

});
parcelRegister("hKxet", function(module, exports) {

$parcel$export(module.exports, "default", () => $0355af8786b7b54e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");
function $0355af8786b7b54e$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $ckizb.queryDataIndex(data, finder);
    if (dataIndex == null || dataIndex < 0 || $hzBt5.isArray(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($hzBt5.map(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}

});



parcelRegister("kdava", function(module, exports) {

$parcel$export(module.exports, "install", () => $eb6d2af60117dcd9$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $do8IZ = parcelRequire("do8IZ");

var $j6qEz = parcelRequire("j6qEz");

var $RfoFo = parcelRequire("RfoFo");
function $eb6d2af60117dcd9$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $j6qEz.default));
    registers.registerComponentView((0, $RfoFo.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $do8IZ.default)(opt.series, 'markArea')) // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });
}

});
parcelRegister("do8IZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bf448cc48a7d7f9$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");
function $9bf448cc48a7d7f9$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $hzBt5.isArray)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}

});

parcelRegister("j6qEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $de8340a67a8a63e2$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $kaSb3 = parcelRequire("kaSb3");
var $de8340a67a8a63e2$var$MarkAreaModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MarkAreaModel, _super);
    function MarkAreaModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaModel.type;
        return _this;
    }
    MarkAreaModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkAreaModel.type = 'markArea';
    MarkAreaModel.defaultOption = {
        zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: 'item'
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: 'top'
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: 'top'
            }
        }
    };
    return MarkAreaModel;
}((0, $kaSb3.default));
var $de8340a67a8a63e2$export$2e2bcd8739ae039 = $de8340a67a8a63e2$var$MarkAreaModel;

});
parcelRegister("kaSb3", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafec451b63b6961$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $93uXC = parcelRequire("93uXC");

var $6IEE1 = parcelRequire("6IEE1");

var $ckizb = parcelRequire("ckizb");

var $e0Zyb = parcelRequire("e0Zyb");
function $eafec451b63b6961$var$fillLabel(opt) {
    (0, $ckizb.defaultEmphasis)(opt, 'label', [
        'show'
    ]);
} // { [componentType]: MarkerModel }
var $eafec451b63b6961$var$inner = (0, $ckizb.makeInner)();
var $eafec451b63b6961$var$MarkerModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $gZXYp.default).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $eafec451b63b6961$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $eafec451b63b6961$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $eafec451b63b6961$var$fillLabel(markerOpt);
                $hzBt5.each(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $eafec451b63b6961$var$fillLabel(item[0]);
                        $eafec451b63b6961$var$fillLabel(item[1]);
                    } else $eafec451b63b6961$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel); // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $hzBt5.extend(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $eafec451b63b6961$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $e0Zyb.createTooltipMarkup)('section', {
            header: this.name,
            blocks: [
                (0, $e0Zyb.createTooltipMarkup)('nameValue', {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, componentType) {
        return $eafec451b63b6961$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = 'marker';
    MarkerModel.dependencies = [
        'series',
        'grid',
        'polar',
        'geo'
    ];
    return MarkerModel;
}((0, $6IEE1.default));
$hzBt5.mixin($eafec451b63b6961$var$MarkerModel, (0, $93uXC.DataFormatMixin).prototype);
var $eafec451b63b6961$export$2e2bcd8739ae039 = $eafec451b63b6961$var$MarkerModel;

});


parcelRegister("RfoFo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a00e4d870f17d2b$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $f7lrR = parcelRequire("f7lrR");

var $kyX7l = parcelRequire("kyX7l");

var $5BQXp = parcelRequire("5BQXp");

var $hXAsm = parcelRequire("hXAsm");parcelRequire("8q0E1");
var $cjY1b = parcelRequire("cjY1b");
var $9ubot = parcelRequire("9ubot");

var $51xyq = parcelRequire("51xyq");

var $dMpb0 = parcelRequire("dMpb0");

var $kCRBc = parcelRequire("kCRBc");

var $hzBt5 = parcelRequire("hzBt5");

var $PS5GS = parcelRequire("PS5GS");

var $kaSb3 = parcelRequire("kaSb3");

var $ckizb = parcelRequire("ckizb");

var $3uf7q = parcelRequire("3uf7q");

var $hcRXD = parcelRequire("hcRXD");

var $aly4X = parcelRequire("aly4X");

var $fJfRY = parcelRequire("fJfRY");
var $0a00e4d870f17d2b$var$inner = (0, $ckizb.makeInner)();
var $0a00e4d870f17d2b$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    var lt = $dMpb0.dataTransform(seriesModel, item[0]);
    var rb = $dMpb0.dataTransform(seriesModel, item[1]); // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = (0, $hzBt5.retrieve)(ltCoord[0], -Infinity);
    ltCoord[1] = (0, $hzBt5.retrieve)(ltCoord[1], -Infinity);
    rbCoord[0] = (0, $hzBt5.retrieve)(rbCoord[0], Infinity);
    rbCoord[1] = (0, $hzBt5.retrieve)(rbCoord[1], Infinity); // Merge option into one
    var result = (0, $hzBt5.mergeAll)([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $0a00e4d870f17d2b$var$isInifinity(val) {
    return !isNaN(val) && !isFinite(val);
} // If a markArea has one dim
function $0a00e4d870f17d2b$var$ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $0a00e4d870f17d2b$var$isInifinity(fromCoord[otherDimIndex]) && $0a00e4d870f17d2b$var$isInifinity(toCoord[otherDimIndex]);
}
function $0a00e4d870f17d2b$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    if ((0, $PS5GS.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($0a00e4d870f17d2b$var$ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || $0a00e4d870f17d2b$var$ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $dMpb0.dataFilter(coordSys, {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    }) || $dMpb0.dataFilter(coordSys, {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    });
} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $0a00e4d870f17d2b$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $5BQXp.parsePercent(itemModel.get(dims[0]), api.getWidth());
    var yPx = $5BQXp.parsePercent(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
        else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if ((0, $PS5GS.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($0a00e4d870f17d2b$var$isInifinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
            else if ($0a00e4d870f17d2b$var$isInifinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $0a00e4d870f17d2b$var$dimPermutations = [
    [
        'x0',
        'y0'
    ],
    [
        'x1',
        'y0'
    ],
    [
        'x1',
        'y1'
    ],
    [
        'x0',
        'y1'
    ]
];
var $0a00e4d870f17d2b$var$MarkAreaView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MarkAreaView, _super);
    function MarkAreaView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaView.type;
        return _this;
    }
    MarkAreaView.prototype.updateTransform = function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = (0, $kaSb3.default).getMarkerModelFromSeries(seriesModel, 'markArea');
            if (maModel) {
                var areaData_1 = maModel.getData();
                areaData_1.each(function(idx) {
                    var points = (0, $hzBt5.map)($0a00e4d870f17d2b$var$dimPermutations, function(dim) {
                        return $0a00e4d870f17d2b$var$getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
                    }); // Layout
                    areaData_1.setItemLayout(idx, points);
                    var el = areaData_1.getItemGraphicEl(idx);
                    el.setShape('points', points);
                });
            }
        }, this);
    };
    MarkAreaView.prototype.renderSeries = function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $hXAsm.default()
        });
        this.group.add(polygonGroup.group);
        this.markKeep(polygonGroup);
        var areaData = $0a00e4d870f17d2b$var$createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
        maModel.setData(areaData); // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = (0, $hzBt5.map)($0a00e4d870f17d2b$var$dimPermutations, function(dim) {
                return $0a00e4d870f17d2b$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            });
            var xAxisScale = coordSys.getAxis('x').scale;
            var yAxisScale = coordSys.getAxis('y').scale;
            var xAxisExtent = xAxisScale.getExtent();
            var yAxisExtent = yAxisScale.getExtent();
            var xPointExtent = [
                xAxisScale.parse(areaData.get('x0', idx)),
                xAxisScale.parse(areaData.get('x1', idx))
            ];
            var yPointExtent = [
                yAxisScale.parse(areaData.get('y0', idx)),
                yAxisScale.parse(areaData.get('y1', idx))
            ];
            $5BQXp.asc(xPointExtent);
            $5BQXp.asc(yPointExtent);
            var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]); // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = !overlapped;
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            });
            var style = areaData.getItemModel(idx).getModel('itemStyle').getItemStyle();
            var color = (0, $3uf7q.getVisualFromData)(seriesData, 'color');
            if (!style.fill) {
                style.fill = color;
                if (typeof style.fill === 'string') style.fill = $f7lrR.modifyAlpha(style.fill, 0.4);
            }
            if (!style.stroke) style.stroke = color;
             // Visual
            areaData.setItemVisual(idx, 'style', style);
        });
        areaData.diff($0a00e4d870f17d2b$var$inner(polygonGroup).data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            if (!layout.allClipped) {
                var polygon = new $cjY1b.default({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = $0a00e4d870f17d2b$var$inner(polygonGroup).data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            if (!layout.allClipped) {
                if (polygon) $9ubot.updateProps(polygon, {
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $cjY1b.default({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = $0a00e4d870f17d2b$var$inner(polygonGroup).data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var style = areaData.getItemVisual(idx, 'style');
            polygon.useStyle(areaData.getItemVisual(idx, 'style'));
            (0, $hcRXD.setLabelStyle)(polygon, (0, $hcRXD.getLabelStatesModels)(itemModel), {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || '',
                inheritColor: typeof style.fill === 'string' ? $f7lrR.modifyAlpha(style.fill, 1) : '#000'
            });
            (0, $51xyq.setStatesStylesFromModel)(polygon, itemModel);
            (0, $51xyq.enableHoverEmphasis)(polygon);
            (0, $aly4X.getECData)(polygon).dataModel = maModel;
        });
        $0a00e4d870f17d2b$var$inner(polygonGroup).data = areaData;
        polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
    };
    MarkAreaView.type = 'markArea';
    return MarkAreaView;
}((0, $kCRBc.default));
function $0a00e4d870f17d2b$var$createList(coordSys, seriesModel, maModel) {
    var areaData;
    var dataDims;
    var dims = [
        'x0',
        'y0',
        'x1',
        'y1'
    ];
    if (coordSys) {
        var coordDimsInfos_1 = (0, $hzBt5.map)(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return (0, $hzBt5.extend)((0, $hzBt5.extend)({}, info), {
                name: coordDim,
                // DON'T use ordinalMeta to parse and collect ordinal.
                ordinalMeta: null
            });
        });
        dataDims = (0, $hzBt5.map)(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos_1[idx % 2].type
            };
        });
        areaData = new (0, $kyX7l.default)(dataDims, maModel);
    } else {
        dataDims = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        areaData = new (0, $kyX7l.default)(dataDims, maModel);
    }
    var optData = (0, $hzBt5.map)(maModel.get('data'), (0, $hzBt5.curry)($0a00e4d870f17d2b$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = (0, $hzBt5.filter)(optData, (0, $hzBt5.curry)($0a00e4d870f17d2b$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        // TODO should convert to ParsedValue?
        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
        return (0, $fJfRY.parseDataValue)(rawVal, dataDims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $fJfRY.parseDataValue)(item.value, dataDims[dimIndex]);
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}
var $0a00e4d870f17d2b$export$2e2bcd8739ae039 = $0a00e4d870f17d2b$var$MarkAreaView;

});
parcelRegister("dMpb0", function(module, exports) {

$parcel$export(module.exports, "numCalculate", () => $a08349939f2a1e9d$export$18ddefb55c03640b);
$parcel$export(module.exports, "dataTransform", () => $a08349939f2a1e9d$export$3eebd2d54b98c04f);
$parcel$export(module.exports, "getAxisInfo", () => $a08349939f2a1e9d$export$bd39458db76002ab);
$parcel$export(module.exports, "dataFilter", () => $a08349939f2a1e9d$export$179695f4a9040f73);
$parcel$export(module.exports, "createMarkerDimValueGetter", () => $a08349939f2a1e9d$export$a53767c3c8f69cf7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

var $lljDt = parcelRequire("lljDt");

var $hzBt5 = parcelRequire("hzBt5");

var $fJfRY = parcelRequire("fJfRY");
function $a08349939f2a1e9d$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $a08349939f2a1e9d$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $a08349939f2a1e9d$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $lljDt.isDimensionStacked)(data, targetDataDim);
    var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
    var value = $a08349939f2a1e9d$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
    var precision = $5BQXp.getPrecision(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
} // TODO Specified percent
var $a08349939f2a1e9d$var$markerTypeCalculator = {
    min: (0, $hzBt5.curry)($a08349939f2a1e9d$var$markerTypeCalculatorWithExtent, 'min'),
    max: (0, $hzBt5.curry)($a08349939f2a1e9d$var$markerTypeCalculatorWithExtent, 'max'),
    average: (0, $hzBt5.curry)($a08349939f2a1e9d$var$markerTypeCalculatorWithExtent, 'average'),
    median: (0, $hzBt5.curry)($a08349939f2a1e9d$var$markerTypeCalculatorWithExtent, 'median')
};
function $a08349939f2a1e9d$export$3eebd2d54b98c04f(seriesModel, item) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (item && !$a08349939f2a1e9d$var$hasXAndY(item) && !(0, $hzBt5.isArray)(item.coord) && coordSys) {
        var dims = coordSys.dimensions;
        var axisInfo = $a08349939f2a1e9d$export$bd39458db76002ab(item, data, coordSys, seriesModel); // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $hzBt5.clone)(item);
        if (item.type && $a08349939f2a1e9d$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $hzBt5.indexOf)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $hzBt5.indexOf)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $a08349939f2a1e9d$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0]; // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else {
            // FIXME Only has one of xAxis and yAxis.
            var coord = [
                item.xAxis != null ? item.xAxis : item.radiusAxis,
                item.yAxis != null ? item.yAxis : item.angleAxis
            ]; // Each coord support max, min, average
            for(var i = 0; i < 2; i++)if ($a08349939f2a1e9d$var$markerTypeCalculator[coord[i]]) coord[i] = $a08349939f2a1e9d$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
            item.coord = coord;
        }
    }
    return item;
}
function $a08349939f2a1e9d$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($a08349939f2a1e9d$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $a08349939f2a1e9d$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $a08349939f2a1e9d$export$179695f4a9040f73(coordSys, item) {
    // Alwalys return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$a08349939f2a1e9d$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $a08349939f2a1e9d$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 // x, y, radius, angle
         ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $fJfRY.parseDataValue)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $fJfRY.parseDataValue)(item.value, dims[dimIndex]);
    };
}
function $a08349939f2a1e9d$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === 'average') {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === 'median') return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
}

});

parcelRegister("kCRBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f040eee32466ab23$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $4uCJH = parcelRequire("4uCJH");

var $hzBt5 = parcelRequire("hzBt5");

var $kaSb3 = parcelRequire("kaSb3");

var $ckizb = parcelRequire("ckizb");

var $51xyq = parcelRequire("51xyq");
var $f040eee32466ab23$var$inner = (0, $ckizb.makeInner)();
var $f040eee32466ab23$var$MarkerView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $hzBt5.createHashMap)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $f040eee32466ab23$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $kaSb3.default).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$f040eee32466ab23$var$inner(item).keep && _this.group.remove(item.group);
        });
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $f040eee32466ab23$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.blurSeries = function(seriesModelList) {
        var _this = this;
        (0, $hzBt5.each)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $kaSb3.default).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) (0, $51xyq.enterBlur)(el);
                });
            }
        });
    };
    MarkerView.type = 'marker';
    return MarkerView;
}((0, $4uCJH.default));
var $f040eee32466ab23$export$2e2bcd8739ae039 = $f040eee32466ab23$var$MarkerView;

});



parcelRegister("5Rjce", function(module, exports) {

$parcel$export(module.exports, "install", () => $4440cafa960ab049$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $do8IZ = parcelRequire("do8IZ");

var $2dXSb = parcelRequire("2dXSb");

var $fj5WN = parcelRequire("fj5WN");
function $4440cafa960ab049$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2dXSb.default));
    registers.registerComponentView((0, $fj5WN.default));
    registers.registerPreprocessor(function(opt) {
        if ((0, $do8IZ.default)(opt.series, 'markLine')) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

});
parcelRegister("2dXSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $19eb3d31bfd36bce$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $kaSb3 = parcelRequire("kaSb3");
var $19eb3d31bfd36bce$var$MarkLineModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = 'markLine';
    MarkLineModel.defaultOption = {
        zlevel: 0,
        z: 5,
        symbol: [
            'circle',
            'arrow'
        ],
        symbolSize: [
            8,
            16
        ],
        //symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'end',
            distance: 5
        },
        lineStyle: {
            type: 'dashed'
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: 'linear'
    };
    return MarkLineModel;
}((0, $kaSb3.default));
var $19eb3d31bfd36bce$export$2e2bcd8739ae039 = $19eb3d31bfd36bce$var$MarkLineModel;

});

parcelRegister("fj5WN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b24d3e62b978bb04$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $kyX7l = parcelRequire("kyX7l");

var $5BQXp = parcelRequire("5BQXp");

var $dMpb0 = parcelRequire("dMpb0");

var $5ysr6 = parcelRequire("5ysr6");

var $kCRBc = parcelRequire("kCRBc");

var $lljDt = parcelRequire("lljDt");

var $PS5GS = parcelRequire("PS5GS");

var $aly4X = parcelRequire("aly4X");

var $kaSb3 = parcelRequire("kaSb3");

var $hzBt5 = parcelRequire("hzBt5");

var $ckizb = parcelRequire("ckizb");

var $3uf7q = parcelRequire("3uf7q");
var $b24d3e62b978bb04$var$inner = (0, $ckizb.makeInner)();
var $b24d3e62b978bb04$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $hzBt5.isArray)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
         || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                value = (0, $hzBt5.retrieve)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $dMpb0.getAxisInfo(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $lljDt.getStackedDimension)(data, axisInfo.valueDataDim);
                value = $dMpb0.numCalculate(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
            var baseIndex = 1 - valueIndex; // Normized to 2d data with start and end point
            var mlFrom = (0, $hzBt5.clone)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get('precision');
            if (precision >= 0 && typeof value === 'number') value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $dMpb0.dataTransform(seriesModel, itemArray[0]),
        $dMpb0.dataTransform(seriesModel, itemArray[1]),
        (0, $hzBt5.extend)({}, itemArray[2])
    ]; // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null; // Merge from option and to option into line option
    (0, $hzBt5.merge)(normalizedItem[2], normalizedItem[0]);
    (0, $hzBt5.merge)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $b24d3e62b978bb04$var$isInifinity(val) {
    return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim
function $b24d3e62b978bb04$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $b24d3e62b978bb04$var$isInifinity(fromCoord[otherDimIndex]) && $b24d3e62b978bb04$var$isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $b24d3e62b978bb04$var$markLineFilter(coordSys, item) {
    if (coordSys.type === 'cartesian2d') {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord; // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($b24d3e62b978bb04$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $b24d3e62b978bb04$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $dMpb0.dataFilter(coordSys, item[0]) && $dMpb0.dataFilter(coordSys, item[1]);
}
function $b24d3e62b978bb04$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $5BQXp.parsePercent(itemModel.get('x'), api.getWidth());
    var yPx = $5BQXp.parsePercent(itemModel.get('y'), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPoisition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        } // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $PS5GS.isCoordinateSystemType)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var dims = coordSys.dimensions;
            if ($b24d3e62b978bb04$var$isInifinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($b24d3e62b978bb04$var$isInifinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        } // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $b24d3e62b978bb04$var$MarkLineView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $kaSb3.default).getMarkerModelFromSeries(seriesModel, 'markLine');
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $b24d3e62b978bb04$var$inner(mlModel).from;
                var toData_1 = $b24d3e62b978bb04$var$inner(mlModel).to; // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $b24d3e62b978bb04$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $b24d3e62b978bb04$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                }); // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $5ysr6.default)());
        this.group.add(lineDraw.group);
        var mlData = $b24d3e62b978bb04$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $b24d3e62b978bb04$var$inner(mlModel).from = fromData;
        $b24d3e62b978bb04$var$inner(mlModel).to = toData; // Line data for tooltip and formatter
        mlModel.setData(lineData); // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get('symbol');
        var symbolSize = mlModel.get('symbolSize');
        var symbolRotate = mlModel.get('symbolRotate');
        var symbolOffset = mlModel.get('symbolOffset'); // TODO: support callback function like markPoint
        if (!(0, $hzBt5.isArray)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $hzBt5.isArray)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $hzBt5.isArray)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $hzBt5.isArray)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
         // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        }); // Update visual and layout of line
        lineData.each(function(idx) {
            var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle(); // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
            lineData.setItemVisual(idx, {
                fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                toSymbol: toData.getItemVisual(idx, 'symbol'),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData); // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el, idx) {
            el.traverse(function(child) {
                (0, $aly4X.getECData)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $b24d3e62b978bb04$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (style.fill == null) style.fill = (0, $3uf7q.getVisualFromData)(seriesData, 'color');
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $hzBt5.retrieve2)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $hzBt5.retrieve2)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $hzBt5.retrieve2)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $hzBt5.retrieve2)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
    };
    MarkLineView.type = 'markLine';
    return MarkLineView;
}((0, $kCRBc.default));
function $b24d3e62b978bb04$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $hzBt5.map)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $hzBt5.extend)((0, $hzBt5.extend)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var fromData = new (0, $kyX7l.default)(coordDimsInfos, mlModel);
    var toData = new (0, $kyX7l.default)(coordDimsInfos, mlModel); // No dimensions
    var lineData = new (0, $kyX7l.default)([], mlModel);
    var optData = (0, $hzBt5.map)(mlModel.get('data'), (0, $hzBt5.curry)($b24d3e62b978bb04$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $hzBt5.filter)(optData, (0, $hzBt5.curry)($b24d3e62b978bb04$var$markLineFilter, coordSys));
    var dimValueGetter = $dMpb0.createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
    fromData.initData((0, $hzBt5.map)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $hzBt5.map)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $hzBt5.map)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $b24d3e62b978bb04$export$2e2bcd8739ae039 = $b24d3e62b978bb04$var$MarkLineView;

});
parcelRegister("5ysr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b62f8f64a818d5$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hXAsm = parcelRequire("hXAsm");

var $jrChB = parcelRequire("jrChB");

var $hcRXD = parcelRequire("hcRXD");
var $40b62f8f64a818d5$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $hXAsm.default();
        this._LineCtor = LineCtor || (0, $jrChB.default);
    }
    LineDraw.prototype.isPersistent = function() {
        return true;
    };
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $40b62f8f64a818d5$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData; // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $40b62f8f64a818d5$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$40b62f8f64a818d5$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($40b62f8f64a818d5$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$40b62f8f64a818d5$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$40b62f8f64a818d5$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $40b62f8f64a818d5$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $40b62f8f64a818d5$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    return {
        lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
        emphasisLineStyle: hostModel.getModel([
            'emphasis',
            'lineStyle'
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            'blur',
            'lineStyle'
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            'select',
            'lineStyle'
        ]).getLineStyle(),
        labelStatesModels: (0, $hcRXD.getLabelStatesModels)(hostModel)
    };
}
function $40b62f8f64a818d5$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $40b62f8f64a818d5$var$lineNeedsDraw(pts) {
    return !$40b62f8f64a818d5$var$isPointNaN(pts[0]) && !$40b62f8f64a818d5$var$isPointNaN(pts[1]);
}
var $40b62f8f64a818d5$export$2e2bcd8739ae039 = $40b62f8f64a818d5$var$LineDraw;

});
parcelRegister("jrChB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e27e3c224f5bc7c4$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $ef5pP = parcelRequire("ef5pP");

var $4TnMt = parcelRequire("4TnMt");

var $eX4SC = parcelRequire("eX4SC");

var $hXAsm = parcelRequire("hXAsm");
var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");

var $51xyq = parcelRequire("51xyq");

var $hcRXD = parcelRequire("hcRXD");

var $5BQXp = parcelRequire("5BQXp");
var $e27e3c224f5bc7c4$var$SYMBOL_CATEGORIES = [
    'fromSymbol',
    'toSymbol'
];
function $e27e3c224f5bc7c4$var$makeSymbolTypeKey(symbolCategory) {
    return '_' + symbolCategory + 'Type';
}
/**
 * @inner
 */ function $e27e3c224f5bc7c4$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $4TnMt.normalizeSymbolSize(symbolSize);
    var symbolOffsetArr = $4TnMt.normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $4TnMt.createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $e27e3c224f5bc7c4$var$createLine(points) {
    var line = new (0, $eX4SC.default)({
        name: 'line',
        subPixelOptimize: true
    });
    $e27e3c224f5bc7c4$var$setLinePoints(line.shape, points);
    return line;
}
function $e27e3c224f5bc7c4$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $e27e3c224f5bc7c4$var$Line = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var line = $e27e3c224f5bc7c4$var$createLine(linePoints);
        line.shape.percent = 0;
        $9ubot.initProps(line, {
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $hzBt5.each)($e27e3c224f5bc7c4$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $e27e3c224f5bc7c4$var$createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$e27e3c224f5bc7c4$var$makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    }; // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $e27e3c224f5bc7c4$var$setLinePoints(target.shape, linePoints);
        $9ubot.updateProps(line, target, seriesModel, idx);
        (0, $hzBt5.each)($e27e3c224f5bc7c4$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = lineData.getItemVisual(idx, symbolCategory);
            var key = $e27e3c224f5bc7c4$var$makeSymbolTypeKey(symbolCategory); // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $e27e3c224f5bc7c4$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels; // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            emphasisLineStyle = itemModel.getModel([
                'emphasis',
                'lineStyle'
            ]).getLineStyle();
            blurLineStyle = itemModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle();
            labelStatesModels = (0, $hcRXD.getLabelStatesModels)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState('emphasis').style = emphasisLineStyle;
        line.ensureState('blur').style = blurLineStyle;
        line.ensureState('select').style = selectLineStyle; // Update symbol
        (0, $hzBt5.each)($e27e3c224f5bc7c4$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
                    var stateName = (0, $51xyq.SPECIAL_STATES)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $hcRXD.setLabelStyle)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || '#000',
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $5BQXp.round)(rawVal) : rawVal) + ''
        });
        var label = this.getTextContent(); // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign; // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get('position') || 'middle';
            var distance = labelNormalModel.get('distance');
            if (!(0, $hzBt5.isArray)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $51xyq.enableHoverEmphasis)(this);
    };
    Line.prototype.highlight = function() {
        (0, $51xyq.enterEmphasis)(this);
    };
    Line.prototype.downplay = function() {
        (0, $51xyq.leaveEmphasis)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName('line');
        $e27e3c224f5bc7c4$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName('fromSymbol');
        var symbolTo = lineGroup.childOfName('toSymbol');
        var label = lineGroup.getTextContent(); // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName('line'); // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $ef5pP.sub([], toPos, fromPos);
        $ef5pP.normalize(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr('rotation', specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== 'start' && label.__position !== 'end') {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case 'insideStartTop':
                case 'insideMiddleTop':
                case 'insideEndTop':
                case 'middle':
                    dy = -distanceY;
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideStartBottom':
                case 'insideMiddleBottom':
                case 'insideEndBottom':
                    dy = distanceY;
                    textVerticalAlign = 'top';
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = 'middle';
            }
            switch(label.__position){
                case 'end':
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                    break;
                case 'start':
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                    break;
                case 'insideStartTop':
                case 'insideStart':
                case 'insideStartBottom':
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? 'right' : 'left';
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case 'insideMiddleTop':
                case 'insideMiddle':
                case 'insideMiddleBottom':
                case 'middle':
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = 'center';
                    label.originY = -dy;
                    break;
                case 'insideEndTop':
                case 'insideEnd':
                case 'insideEndBottom':
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? 'right' : 'left';
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($hXAsm.default);
var $e27e3c224f5bc7c4$export$2e2bcd8739ae039 = $e27e3c224f5bc7c4$var$Line;

});
parcelRegister("eX4SC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae2a5c6d1d0fecc0$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");
parcelRequire("8q0E1");
var $6RZy2 = parcelRequire("6RZy2");
var $15UDR = parcelRequire("15UDR");
var $hMiip = parcelRequire("hMiip");

var $ef5pP = parcelRequire("ef5pP");
var $ae2a5c6d1d0fecc0$var$straightLineProto = $15UDR.default.prototype;
var $ae2a5c6d1d0fecc0$var$bezierCurveProto = $6RZy2.default.prototype;
var $ae2a5c6d1d0fecc0$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0; // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $ae2a5c6d1d0fecc0$var$CurveShape = /** @class */ function(_super) {
    (0, $fKE23.__extends)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($ae2a5c6d1d0fecc0$var$StraightLineShape);
function $ae2a5c6d1d0fecc0$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $ae2a5c6d1d0fecc0$var$ECLinePath = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-line';
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $ae2a5c6d1d0fecc0$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($ae2a5c6d1d0fecc0$var$isStraightLine(shape)) $ae2a5c6d1d0fecc0$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $ae2a5c6d1d0fecc0$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($ae2a5c6d1d0fecc0$var$isStraightLine(this.shape)) return $ae2a5c6d1d0fecc0$var$straightLineProto.pointAt.call(this, t);
        else return $ae2a5c6d1d0fecc0$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $ae2a5c6d1d0fecc0$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $ae2a5c6d1d0fecc0$var$bezierCurveProto.tangentAt.call(this, t);
        return $ef5pP.normalize(p, p);
    };
    return ECLinePath;
}($hMiip.default);
var $ae2a5c6d1d0fecc0$export$2e2bcd8739ae039 = $ae2a5c6d1d0fecc0$var$ECLinePath;

});





parcelRegister("aiDtf", function(module, exports) {

$parcel$export(module.exports, "install", () => $77fa33e25b69e2a0$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $aw6hh = parcelRequire("aw6hh");

var $lDnHX = parcelRequire("lDnHX");

var $kj0Pb = parcelRequire("kj0Pb");

var $iVVHr = parcelRequire("iVVHr");
function $77fa33e25b69e2a0$export$4b3e715f166fdd78(registers) {
    (0, $lDnHX.use)((0, $aw6hh.install));
    registers.registerComponentModel((0, $kj0Pb.default));
    registers.registerComponentView((0, $iVVHr.default));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, function() {});
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, function() {});
}

});
parcelRegister("kj0Pb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec8638bbf9c054ea$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $fKE23 = parcelRequire("fKE23");

var $6IEE1 = parcelRequire("6IEE1");
var $ec8638bbf9c054ea$var$TooltipModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click',
        alwaysShowContent: false,
        displayMode: 'single',
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaut false (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        enterable: false,
        backgroundColor: '#fff',
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: '#999',
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            } // lineStyle and shadowStyle should not be specified here,
        },
        textStyle: {
            color: '#666',
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $6IEE1.default));
var $ec8638bbf9c054ea$export$2e2bcd8739ae039 = $ec8638bbf9c054ea$var$TooltipModel;

});

parcelRegister("iVVHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8a4ed52ff0d738$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $gZXYp = parcelRequire("gZXYp");

var $i3KYA = parcelRequire("i3KYA");

var $ebSeC = parcelRequire("ebSeC");

var $gyplX = parcelRequire("gyplX");

var $5BQXp = parcelRequire("5BQXp");
parcelRequire("8q0E1");
var $aeCKo = parcelRequire("aeCKo");

var $hKxet = parcelRequire("hKxet");

var $e4mIu = parcelRequire("e4mIu");

var $fR3z1 = parcelRequire("fR3z1");

var $lMUEI = parcelRequire("lMUEI");

var $ekDcz = parcelRequire("ekDcz");

var $35drB = parcelRequire("35drB");

var $ckizb = parcelRequire("ckizb");

var $4uCJH = parcelRequire("4uCJH");

var $24InP = parcelRequire("24InP");

var $aly4X = parcelRequire("aly4X");

var $3mo35 = parcelRequire("3mo35");

var $93uXC = parcelRequire("93uXC");

var $e0Zyb = parcelRequire("e0Zyb");

var $1MZkk = parcelRequire("1MZkk");

var $7b8YY = parcelRequire("7b8YY");
var $dc8a4ed52ff0d738$var$bind = $hzBt5.bind;
var $dc8a4ed52ff0d738$var$each = $hzBt5.each;
var $dc8a4ed52ff0d738$var$parsePercent = $5BQXp.parsePercent;
var $dc8a4ed52ff0d738$var$proxyRect = new $aeCKo.default({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $dc8a4ed52ff0d738$var$TooltipView = /** @class */ function(_super) {
    (0, $fKE23.__extends)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $gZXYp.default).node) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = tooltipModel.get('renderMode');
        this._renderMode = (0, $ckizb.getTooltipRenderMode)(renderMode);
        this._tooltipContent = this._renderMode === 'richText' ? new (0, $ebSeC.default)(api) : new (0, $i3KYA.default)(api.getDom(), api, {
            appendToBody: tooltipModel.get('appendToBody', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $gZXYp.default).node) return;
         // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        /**
     * @private
     * @type {boolean}
     */ this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow(); // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the updatePosition was also called very frequently.
        // In Chrome with devtools open and Firefox, tooltip looks lagged and shaked around. See #14695.
        // To avoid the frequent triggering,
        // consider throttling it in 50ms. (the tested result may need to validate)
        this._updatePosition = this._renderMode === 'html' ? (0, $7b8YY.throttle)($dc8a4ed52ff0d738$var$bind(this._doUpdatePosition, this), 50) : this._doUpdatePosition;
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $lMUEI.register('itemTooltip', this._api, $dc8a4ed52ff0d738$var$bind(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api; // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
         && tooltipModel.get('triggerOn') !== 'none') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $gZXYp.default).node) return;
        var dispatchAction = $dc8a4ed52ff0d738$var$makeDispatchAction(payload, api); // Reset ticket
        this._ticket = ''; // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $dc8a4ed52ff0d738$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $dc8a4ed52ff0d738$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $aly4X.getECData)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            }; // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $hKxet.default)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (!this._alwaysShowContent && this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($dc8a4ed52ff0d738$var$makeDispatchAction(payload, api));
    }; // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex; // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $dc8a4ed52ff0d738$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
         // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $1MZkk.findEventDispatcher)(el, function(target) {
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $aly4X.getECData)(target).dataIndex != null) {
                    seriesDispatcher_1 = target;
                    return true;
                } // Tooltip provided directly. Like legend.
                if ((0, $aly4X.getECData)(target).tooltipConfig != null) {
                    cmptDispatcher_1 = target;
                    return true;
                }
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = $hzBt5.bind(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $dc8a4ed52ff0d738$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $e0Zyb.createTooltipMarkup)('section', {
            blocks: [],
            noHeader: true
        }); // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $e0Zyb.TooltipMarkupStyleCreator)();
        $dc8a4ed52ff0d738$var$each(dataByCoordSys, function(itemCoordSys) {
            $dc8a4ed52ff0d738$var$each(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                var axisValueLabel = $35drB.getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $e0Zyb.createTooltipMarkup)('section', {
                    header: axisValueLabel,
                    noHeader: !$hzBt5.trim(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                $hzBt5.each(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex); // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $ekDcz.getAxisRawValue(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel; // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', $gyplX.convertToColorString(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $93uXC.normalizeTooltipFormatResult)(series.formatTooltip(dataIndex, true, null));
                    if (seriesTooltipResult.markupFragment) axisSectionMarkup.blocks.push(seriesTooltipResult.markupFragment);
                    if (seriesTooltipResult.markupText) markupTextArrLegacy.push(seriesTooltipResult.markupText);
                    cbParamsList.push(cbParams);
                });
            });
        }); // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $e0Zyb.buildTooltipMarkup)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $aly4X.getECData)(dispatcher); // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $dc8a4ed52ff0d738$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $e0Zyb.TooltipMarkupStyleCreator)(); // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', $gyplX.convertToColorString(params.color), renderMode);
        var seriesTooltipResult = (0, $93uXC.normalizeTooltipFormatResult)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var markupText = seriesTooltipResult.markupFragment ? (0, $e0Zyb.buildTooltipMarkup)(seriesTooltipResult.markupFragment, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.markupText;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        }); // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var ecData = (0, $aly4X.getECData)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        if ($hzBt5.isString(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
         // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they can not share the same formatter. Since the global tooltip formatter is used for series
        // by convension, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $dc8a4ed52ff0d738$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + ''; // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $e0Zyb.TooltipMarkupStyleCreator)(); // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = $hzBt5.clone(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        }); // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ($hzBt5.isString(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = $hzBt5.isArray(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $24InP.format)(params0.axisValue, html, useUTC);
                html = $gyplX.formatTpl(html, params, true);
            } else if ($hzBt5.isFunction(formatter)) {
                var callback = $dc8a4ed52ff0d738$var$bind(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
        if (trigger === 'axis' || $hzBt5.isArray(tooltipDataParams)) return {
            color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
        };
        if (!$hzBt5.isArray(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._doUpdatePosition = function(tooltipModel, positionExpr, x, y, content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ($hzBt5.isFunction(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ($hzBt5.isArray(positionExpr)) {
            x = $dc8a4ed52ff0d738$var$parsePercent(positionExpr[0], viewWidth);
            y = $dc8a4ed52ff0d738$var$parsePercent(positionExpr[1], viewHeight);
        } else if ($hzBt5.isObject(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = $e4mIu.getLayoutRect(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null; // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ($hzBt5.isString(positionExpr) && el) {
            var pos = $dc8a4ed52ff0d738$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $dc8a4ed52ff0d738$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $dc8a4ed52ff0d738$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $dc8a4ed52ff0d738$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $3mo35.shouldTooltipConfine)(tooltipModel)) {
            var pos = $dc8a4ed52ff0d738$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    }; // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && $dc8a4ed52ff0d738$var$each(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && $dc8a4ed52ff0d738$var$each(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && $dc8a4ed52ff0d738$var$each(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                }); // check is cbParams data value changed
                lastCbParamsList && $hzBt5.each(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $gZXYp.default).node) return;
        this._tooltipContent.dispose();
        $lMUEI.unregister('itemTooltip', api);
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $4uCJH.default));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $dc8a4ed52ff0d738$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $fR3z1.default)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $fR3z1.default)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $fR3z1.default)) tooltipOpt = tooltipOpt.get('tooltip', true);
             // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ($hzBt5.isString(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $fR3z1.default)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $dc8a4ed52ff0d738$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || $hzBt5.bind(api.dispatchAction, api);
}
function $dc8a4ed52ff0d738$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in defaut tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $dc8a4ed52ff0d738$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $dc8a4ed52ff0d738$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $dc8a4ed52ff0d738$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $dc8a4ed52ff0d738$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $ckizb.preParseFinder)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $ckizb.queryReferringComponents)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $aly4X.getECData)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $dc8a4ed52ff0d738$export$2e2bcd8739ae039 = $dc8a4ed52ff0d738$var$TooltipView;

});
parcelRegister("i3KYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d25cf251f0b5ea1e$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");

var $kcVwz = parcelRequire("kcVwz");

var $bZSeh = parcelRequire("bZSeh");

var $gZXYp = parcelRequire("gZXYp");

var $gyplX = parcelRequire("gyplX");

var $3mo35 = parcelRequire("3mo35");

var $e0Zyb = parcelRequire("e0Zyb");
/* global document, window */ var $d25cf251f0b5ea1e$var$CSS_TRANSITION_VENDOR = (0, $3mo35.toCSSVendorPrefix)((0, $3mo35.TRANSITION_VENDOR), 'transition');
var $d25cf251f0b5ea1e$var$CSS_TRANSFORM_VENDOR = (0, $3mo35.toCSSVendorPrefix)((0, $3mo35.TRANSFORM_VENDOR), 'transform'); // eslint-disable-next-line
var $d25cf251f0b5ea1e$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $gZXYp.default).transform3dSupported ? 'will-change:transform;' : '');
function $d25cf251f0b5ea1e$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $d25cf251f0b5ea1e$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $hzBt5.isString)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $gyplX.convertToColorString)(borderColor);
    var arrowPos = $d25cf251f0b5ea1e$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $d25cf251f0b5ea1e$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $hzBt5.indexOf)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $d25cf251f0b5ea1e$var$assembleTransition(duration, onlyFade) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = " " + duration / 2 + "s " + transitionCurve;
    var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    if (!onlyFade) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (0, $gZXYp.default).transformSupported ? "," + $d25cf251f0b5ea1e$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
    }
    return $d25cf251f0b5ea1e$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $d25cf251f0b5ea1e$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px'; // not support transform, use `left` and `top` instead.
    if (!(0, $gZXYp.default).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
     // support transform
    var is3d = (0, $gZXYp.default).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $d25cf251f0b5ea1e$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $3mo35.TRANSFORM_VENDOR),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $d25cf251f0b5ea1e$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    fontSize // @ts-ignore, leave it to the tooltip refactor.
     && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $hzBt5.each)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $d25cf251f0b5ea1e$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $e0Zyb.getPaddingFromTooltipModel)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow); // Animation transition. Do not animate when transitionDuration is 0.
    enableTransition && transitionDuration && cssText.push($d25cf251f0b5ea1e$var$assembleTransition(transitionDuration, onlyFade));
    if (backgroundColor) {
        if ((0, $gZXYp.default).canvasSupported) cssText.push('background-color:' + backgroundColor);
        else {
            // for ie
            cssText.push('background-color:#' + (0, $f7lrR.toHex)(backgroundColor));
            cssText.push('filter:alpha(opacity=70)');
        }
    } // Border style
    (0, $hzBt5.each)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $gyplX.toCamelCase)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    }); // Text style
    cssText.push($d25cf251f0b5ea1e$var$assembleFont(textStyleModel)); // Padding
    if (padding != null) cssText.push('padding:' + (0, $gyplX.normalizeCssArray)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
} // If not able to make, do not modify the input `out`.
function $d25cf251f0b5ea1e$var$makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (appendToBody) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $bZSeh.transformLocalCoord)(out, zrViewportRoot, document.body, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $d25cf251f0b5ea1e$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(container, api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $gZXYp.default).wxa) return null;
        var el = document.createElement('div'); // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendToBody = this._appendToBody = opt && opt.appendToBody;
        $d25cf251f0b5ea1e$var$makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
        if (appendToBody) document.body.appendChild(el);
        else container.appendChild(el);
        this._container = container; // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $kcVwz.normalizeEvent)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        var container = this._container;
        var position = (0, $3mo35.getComputedStyle)(container, 'position');
        var domStyle = container.style;
        if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
         // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized(); // update className
        this.el.className = tooltipModel.get('className') || ''; // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $d25cf251f0b5ea1e$var$gCssText + $d25cf251f0b5ea1e$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) // initial transform
         + $d25cf251f0b5ea1e$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $gyplX.convertToColorString)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '' // If mouse occasionally move over the tooltip, a mouseout event will be
        ) + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $hzBt5.isString)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $3mo35.shouldTooltipConfine)(tooltipModel)) arrow = $d25cf251f0b5ea1e$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $hzBt5.isString)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $hzBt5.isArray)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $hzBt5.isDom)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
             // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return [
            el.offsetWidth,
            el.offsetHeight
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        var styleCoord = this._styleCoord;
        $d25cf251f0b5ea1e$var$makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $d25cf251f0b5ea1e$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $hzBt5.each)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2]; // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        style.visibility = 'hidden';
        style.opacity = '0';
        (0, $gZXYp.default).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $hzBt5.bind)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        this.el.parentNode.removeChild(this.el);
    };
    return TooltipHTMLContent;
}();
var $d25cf251f0b5ea1e$export$2e2bcd8739ae039 = $d25cf251f0b5ea1e$var$TooltipHTMLContent;

});
parcelRegister("3mo35", function(module, exports) {

$parcel$export(module.exports, "shouldTooltipConfine", () => $272614c050772754$export$a309528050824ba4);
$parcel$export(module.exports, "TRANSFORM_VENDOR", () => $272614c050772754$export$7b4286b1e4a23439);
$parcel$export(module.exports, "TRANSITION_VENDOR", () => $272614c050772754$export$70a631ae991b5e76);
$parcel$export(module.exports, "toCSSVendorPrefix", () => $272614c050772754$export$5886acafe29a08d1);
$parcel$export(module.exports, "getComputedStyle", () => $272614c050772754$export$3735103072e4a80);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gyplX = parcelRequire("gyplX");

var $gZXYp = parcelRequire("gZXYp");
function $272614c050772754$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption // In richText mode, the outside part can not be visible.
     : tooltipModel.get('renderMode') === 'richText';
}
function $272614c050772754$var$testStyle(styleProps) {
    if (!(0, $gZXYp.default).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $272614c050772754$export$7b4286b1e4a23439 = $272614c050772754$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $272614c050772754$export$70a631ae991b5e76 = $272614c050772754$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $272614c050772754$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $gyplX.toCamelCase)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $272614c050772754$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}

});


parcelRegister("ebSeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a54c29adc6034785$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

var $kiooD = parcelRequire("kiooD");

var $e0Zyb = parcelRequire("e0Zyb");

var $6ds7H = parcelRequire("6ds7H");
var $a54c29adc6034785$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._zr = api.getZr();
        $a54c29adc6034785$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        if ($hzBt5.isObject(content)) (0, $6ds7H.throwError)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $kiooD.default)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                backgroundColor: tooltipModel.get('backgroundColor'),
                borderRadius: tooltipModel.get('borderRadius'),
                borderWidth: 1,
                borderColor: borderColor,
                shadowColor: tooltipModel.get('shadowColor'),
                shadowBlur: tooltipModel.get('shadowBlur'),
                shadowOffsetX: tooltipModel.get('shadowOffsetX'),
                shadowOffsetY: tooltipModel.get('shadowOffsetY'),
                textShadowColor: textStyleModel.get('textShadowColor'),
                textShadowBlur: textStyleModel.get('textShadowBlur') || 0,
                textShadowOffsetX: textStyleModel.get('textShadowOffsetX') || 0,
                textShadowOffsetY: textStyleModel.get('textShadowOffsetY') || 0,
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $e0Zyb.getPaddingFromTooltipModel)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect(); // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $a54c29adc6034785$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $a54c29adc6034785$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $a54c29adc6034785$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $a54c29adc6034785$var$calcShadowOuterSize(style); // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2]; // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable)) {
            if (time) {
                this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($hzBt5.bind(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $a54c29adc6034785$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $a54c29adc6034785$var$calcShadowOuterSize(style) {
    var shadowBlur = $a54c29adc6034785$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $a54c29adc6034785$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $a54c29adc6034785$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $a54c29adc6034785$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $a54c29adc6034785$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $a54c29adc6034785$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $a54c29adc6034785$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $a54c29adc6034785$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $a54c29adc6034785$export$2e2bcd8739ae039 = $a54c29adc6034785$var$TooltipRichContent;

});



parcelRegister("5vRmQ", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4RCLD = parcelRequire("4RCLD");
$parcel$exportWildcard(module.exports, $4RCLD);

});
parcelRegister("4RCLD", function(module, exports) {
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Core API from echarts/src/echarts

var $eLPvY = parcelRequire("eLPvY");

var $6hcJs = parcelRequire("6hcJs");

var $lDnHX = parcelRequire("lDnHX");

var $kM74L = parcelRequire("kM74L");
(0, $lDnHX.use)((0, $kM74L.installLabelLayout));
$parcel$exportWildcard(module.exports, $eLPvY);
$parcel$exportWildcard(module.exports, $6hcJs);

});
parcelRegister("6hcJs", function(module, exports) {

$parcel$export(module.exports, "extendComponentModel", () => $491e34f747420328$export$4dd01020bb736662);
$parcel$export(module.exports, "extendComponentView", () => $491e34f747420328$export$a4336148da8ef02);
$parcel$export(module.exports, "extendSeriesModel", () => $491e34f747420328$export$fe6d3114e3fc260c);
$parcel$export(module.exports, "extendChartView", () => $491e34f747420328$export$c750883d1b603e83);
$parcel$export(module.exports, "zrender", () => (parcelRequire("fK0Gs")));
$parcel$export(module.exports, "matrix", () => (parcelRequire("crEgd")));
$parcel$export(module.exports, "vector", () => (parcelRequire("ef5pP")));
$parcel$export(module.exports, "zrUtil", () => (parcelRequire("hzBt5")));
$parcel$export(module.exports, "color", () => (parcelRequire("f7lrR")));
$parcel$export(module.exports, "throttle", () => (parcelRequire("7b8YY")).throttle);
$parcel$export(module.exports, "helper", () => (parcelRequire("86vkv")));
$parcel$export(module.exports, "use", () => (parcelRequire("lDnHX")).use);
$parcel$export(module.exports, "parseGeoJSON", () => (parcelRequire("7gQBi")).default);
$parcel$export(module.exports, "parseGeoJson", () => (parcelRequire("7gQBi")).default);
$parcel$export(module.exports, "number", () => (parcelRequire("1CMtG")));
$parcel$export(module.exports, "time", () => (parcelRequire("hq8bW")));
$parcel$export(module.exports, "graphic", () => (parcelRequire("eVazI")));
$parcel$export(module.exports, "format", () => (parcelRequire("bYXDT")));
$parcel$export(module.exports, "util", () => (parcelRequire("13Qhq")));
$parcel$export(module.exports, "env", () => (parcelRequire("gZXYp")).default);
$parcel$export(module.exports, "List", () => (parcelRequire("kyX7l")).default);
$parcel$export(module.exports, "Model", () => (parcelRequire("fR3z1")).default);
$parcel$export(module.exports, "Axis", () => (parcelRequire("ewaMj")).default);
$parcel$export(module.exports, "ComponentModel", () => (parcelRequire("6IEE1")).default);
$parcel$export(module.exports, "ComponentView", () => (parcelRequire("4uCJH")).default);
$parcel$export(module.exports, "SeriesModel", () => (parcelRequire("5vVec")).default);
$parcel$export(module.exports, "ChartView", () => (parcelRequire("azEx8")).default);
$parcel$export(module.exports, "innerDrawElementOnCanvas", () => (parcelRequire("2Zzmo")).brushSingle);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // These APIs are for more advanced usages
// For example extend charts and components, creating graphic elements, formatting.

var $6IEE1 = parcelRequire("6IEE1");

var $4uCJH = parcelRequire("4uCJH");

var $5vVec = parcelRequire("5vVec");

var $azEx8 = parcelRequire("azEx8");

var $kyX7l = parcelRequire("kyX7l");

var $fK0Gs = parcelRequire("fK0Gs");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $hzBt5 = parcelRequire("hzBt5");

var $f7lrR = parcelRequire("f7lrR");

var $7b8YY = parcelRequire("7b8YY");

var $86vkv = parcelRequire("86vkv");

var $lDnHX = parcelRequire("lDnHX");

var $7gQBi = parcelRequire("7gQBi");

var $1CMtG = parcelRequire("1CMtG");

var $hq8bW = parcelRequire("hq8bW");

var $eVazI = parcelRequire("eVazI");

var $bYXDT = parcelRequire("bYXDT");

var $13Qhq = parcelRequire("13Qhq");

var $gZXYp = parcelRequire("gZXYp");

var $fR3z1 = parcelRequire("fR3z1");

var $ewaMj = parcelRequire("ewaMj");

var $2Zzmo = parcelRequire("2Zzmo");
function $491e34f747420328$export$4dd01020bb736662(proto) {
    var Model = (0, $6IEE1.default).extend(proto);
    (0, $6IEE1.default).registerClass(Model);
    return Model;
}
function $491e34f747420328$export$a4336148da8ef02(proto) {
    var View = (0, $4uCJH.default).extend(proto);
    (0, $4uCJH.default).registerClass(View);
    return View;
}
function $491e34f747420328$export$fe6d3114e3fc260c(proto) {
    var Model = (0, $5vVec.default).extend(proto);
    (0, $5vVec.default).registerClass(Model);
    return Model;
}
function $491e34f747420328$export$c750883d1b603e83(proto) {
    var View = (0, $azEx8.default).extend(proto);
    (0, $azEx8.default).registerClass(View);
    return View;
}

});
parcelRegister("86vkv", function(module, exports) {

$parcel$export(module.exports, "createList", () => $5e672faeb355e945$export$5897d8d7c7a3d871);
$parcel$export(module.exports, "dataStack", () => $5e672faeb355e945$export$d6100971d5a3a0a7);
$parcel$export(module.exports, "createScale", () => $5e672faeb355e945$export$587d9c3c553380c6);
$parcel$export(module.exports, "mixinAxisModelCommonMethods", () => $5e672faeb355e945$export$4665cbe3470e4d57);
$parcel$export(module.exports, "createTextStyle", () => $5e672faeb355e945$export$f8998c3d0a13de59);
$parcel$export(module.exports, "getLayoutRect", () => (parcelRequire("e4mIu")).getLayoutRect);
$parcel$export(module.exports, "createDimensions", () => (parcelRequire("jrSv6")).createDimensions);
$parcel$export(module.exports, "createSymbol", () => (parcelRequire("4TnMt")).createSymbol);
$parcel$export(module.exports, "getECData", () => (parcelRequire("aly4X")).getECData);
$parcel$export(module.exports, "enableHoverEmphasis", () => (parcelRequire("51xyq")).enableHoverEmphasis);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * This module exposes helper functions for developing extensions.
 */ 
var $hzBt5 = parcelRequire("hzBt5");

var $3OWAv = parcelRequire("3OWAv");

var $ekDcz = parcelRequire("ekDcz");

var $kN6By = parcelRequire("kN6By");

var $fR3z1 = parcelRequire("fR3z1");

var $e4mIu = parcelRequire("e4mIu");

var $lljDt = parcelRequire("lljDt");

var $aly4X = parcelRequire("aly4X");

var $hcRXD = parcelRequire("hcRXD");

var $jrSv6 = parcelRequire("jrSv6");

var $4TnMt = parcelRequire("4TnMt");

var $51xyq = parcelRequire("51xyq");
function $5e672faeb355e945$export$5897d8d7c7a3d871(seriesModel) {
    return (0, $3OWAv.default)(null, seriesModel);
} // export function createGraph(seriesModel) {
var $5e672faeb355e945$export$d6100971d5a3a0a7 = {
    isDimensionStacked: (0, $lljDt.isDimensionStacked),
    enableDataStack: (0, $lljDt.enableDataStack),
    getStackedDimension: (0, $lljDt.getStackedDimension)
};
function $5e672faeb355e945$export$587d9c3c553380c6(dataExtent, option) {
    var axisModel = option;
    if (!(option instanceof (0, $fR3z1.default))) axisModel = new (0, $fR3z1.default)(option); // FIXME
    var scale = $ekDcz.createScaleByModel(axisModel);
    scale.setExtent(dataExtent[0], dataExtent[1]);
    $ekDcz.niceScaleExtent(scale, axisModel);
    return scale;
}
function $5e672faeb355e945$export$4665cbe3470e4d57(Model) {
    $hzBt5.mixin(Model, (0, $kN6By.AxisModelCommonMixin));
}
function $5e672faeb355e945$export$f8998c3d0a13de59(textStyleModel, opts) {
    opts = opts || {};
    return (0, $hcRXD.createTextStyle)(textStyleModel, null, null, opts.state !== 'normal');
}

});

parcelRegister("1CMtG", function(module, exports) {

$parcel$export(module.exports, "linearMap", () => (parcelRequire("5BQXp")).linearMap);
$parcel$export(module.exports, "round", () => (parcelRequire("5BQXp")).round);
$parcel$export(module.exports, "asc", () => (parcelRequire("5BQXp")).asc);
$parcel$export(module.exports, "getPrecision", () => (parcelRequire("5BQXp")).getPrecision);
$parcel$export(module.exports, "getPrecisionSafe", () => (parcelRequire("5BQXp")).getPrecisionSafe);
$parcel$export(module.exports, "getPixelPrecision", () => (parcelRequire("5BQXp")).getPixelPrecision);
$parcel$export(module.exports, "getPercentWithPrecision", () => (parcelRequire("5BQXp")).getPercentWithPrecision);
$parcel$export(module.exports, "MAX_SAFE_INTEGER", () => (parcelRequire("5BQXp")).MAX_SAFE_INTEGER);
$parcel$export(module.exports, "remRadian", () => (parcelRequire("5BQXp")).remRadian);
$parcel$export(module.exports, "isRadianAroundZero", () => (parcelRequire("5BQXp")).isRadianAroundZero);
$parcel$export(module.exports, "parseDate", () => (parcelRequire("5BQXp")).parseDate);
$parcel$export(module.exports, "quantity", () => (parcelRequire("5BQXp")).quantity);
$parcel$export(module.exports, "quantityExponent", () => (parcelRequire("5BQXp")).quantityExponent);
$parcel$export(module.exports, "nice", () => (parcelRequire("5BQXp")).nice);
$parcel$export(module.exports, "quantile", () => (parcelRequire("5BQXp")).quantile);
$parcel$export(module.exports, "reformIntervals", () => (parcelRequire("5BQXp")).reformIntervals);
$parcel$export(module.exports, "isNumeric", () => (parcelRequire("5BQXp")).isNumeric);
$parcel$export(module.exports, "numericToNumber", () => (parcelRequire("5BQXp")).numericToNumber);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

});

parcelRegister("hq8bW", function(module, exports) {

$parcel$export(module.exports, "parse", () => (parcelRequire("5BQXp")).parseDate);
$parcel$export(module.exports, "format", () => (parcelRequire("24InP")).format);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5BQXp = parcelRequire("5BQXp");

var $24InP = parcelRequire("24InP");

});

parcelRegister("eVazI", function(module, exports) {

$parcel$export(module.exports, "extendShape", () => (parcelRequire("8q0E1")).extendShape);
$parcel$export(module.exports, "extendPath", () => (parcelRequire("8q0E1")).extendPath);
$parcel$export(module.exports, "makePath", () => (parcelRequire("8q0E1")).makePath);
$parcel$export(module.exports, "makeImage", () => (parcelRequire("8q0E1")).makeImage);
$parcel$export(module.exports, "mergePath", () => (parcelRequire("8q0E1")).mergePath);
$parcel$export(module.exports, "resizePath", () => (parcelRequire("8q0E1")).resizePath);
$parcel$export(module.exports, "createIcon", () => (parcelRequire("8q0E1")).createIcon);
$parcel$export(module.exports, "updateProps", () => (parcelRequire("9ubot")).updateProps);
$parcel$export(module.exports, "initProps", () => (parcelRequire("9ubot")).initProps);
$parcel$export(module.exports, "getTransform", () => (parcelRequire("8q0E1")).getTransform);
$parcel$export(module.exports, "clipPointsByRect", () => (parcelRequire("8q0E1")).clipPointsByRect);
$parcel$export(module.exports, "clipRectByRect", () => (parcelRequire("8q0E1")).clipRectByRect);
$parcel$export(module.exports, "registerShape", () => (parcelRequire("8q0E1")).registerShape);
$parcel$export(module.exports, "getShapeClass", () => (parcelRequire("8q0E1")).getShapeClass);
$parcel$export(module.exports, "Group", () => (parcelRequire("hXAsm")).default);
$parcel$export(module.exports, "Image", () => (parcelRequire("agXnr")).default);
$parcel$export(module.exports, "Text", () => (parcelRequire("kiooD")).default);
$parcel$export(module.exports, "Circle", () => (parcelRequire("aYBv9")).default);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("gwELx")).default);
$parcel$export(module.exports, "Sector", () => (parcelRequire("rnA7j")).default);
$parcel$export(module.exports, "Ring", () => (parcelRequire("IXyXP")).default);
$parcel$export(module.exports, "Polygon", () => (parcelRequire("cjY1b")).default);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("9dsiU")).default);
$parcel$export(module.exports, "Rect", () => (parcelRequire("aeCKo")).default);
$parcel$export(module.exports, "Line", () => (parcelRequire("15UDR")).default);
$parcel$export(module.exports, "BezierCurve", () => (parcelRequire("6RZy2")).default);
$parcel$export(module.exports, "Arc", () => (parcelRequire("iMbRE")).default);
$parcel$export(module.exports, "IncrementalDisplayable", () => (parcelRequire("4Nii9")).default);
$parcel$export(module.exports, "CompoundPath", () => (parcelRequire("juJV6")).default);
$parcel$export(module.exports, "LinearGradient", () => (parcelRequire("4kdki")).default);
$parcel$export(module.exports, "RadialGradient", () => (parcelRequire("hkgm4")).default);
$parcel$export(module.exports, "BoundingRect", () => (parcelRequire("lGSv6")).default);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("8q0E1");
var $iMbRE = parcelRequire("iMbRE");
var $6RZy2 = parcelRequire("6RZy2");
var $aYBv9 = parcelRequire("aYBv9");
var $8q0E1 = parcelRequire("8q0E1");
var $gwELx = parcelRequire("gwELx");
var $agXnr = parcelRequire("agXnr");
var $15UDR = parcelRequire("15UDR");
var $cjY1b = parcelRequire("cjY1b");
var $9dsiU = parcelRequire("9dsiU");
var $aeCKo = parcelRequire("aeCKo");
var $IXyXP = parcelRequire("IXyXP");
var $rnA7j = parcelRequire("rnA7j");
var $9ubot = parcelRequire("9ubot");
var $lGSv6 = parcelRequire("lGSv6");
var $juJV6 = parcelRequire("juJV6");
var $hXAsm = parcelRequire("hXAsm");
var $4Nii9 = parcelRequire("4Nii9");
var $9ubot = parcelRequire("9ubot");
var $4kdki = parcelRequire("4kdki");
var $hkgm4 = parcelRequire("hkgm4");
var $kiooD = parcelRequire("kiooD");

});

parcelRegister("bYXDT", function(module, exports) {

$parcel$export(module.exports, "addCommas", () => (parcelRequire("gyplX")).addCommas);
$parcel$export(module.exports, "toCamelCase", () => (parcelRequire("gyplX")).toCamelCase);
$parcel$export(module.exports, "normalizeCssArray", () => (parcelRequire("gyplX")).normalizeCssArray);
$parcel$export(module.exports, "encodeHTML", () => (parcelRequire("gyplX")).encodeHTML);
$parcel$export(module.exports, "formatTpl", () => (parcelRequire("gyplX")).formatTpl);
$parcel$export(module.exports, "getTooltipMarker", () => (parcelRequire("gyplX")).getTooltipMarker);
$parcel$export(module.exports, "formatTime", () => (parcelRequire("gyplX")).formatTime);
$parcel$export(module.exports, "capitalFirst", () => (parcelRequire("gyplX")).capitalFirst);
$parcel$export(module.exports, "truncateText", () => (parcelRequire("h0yya")).truncateText);
$parcel$export(module.exports, "getTextRect", () => (parcelRequire("iluMW")).getTextRect);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $gyplX = parcelRequire("gyplX");
var $iluMW = parcelRequire("iluMW");
var $h0yya = parcelRequire("h0yya");

});

parcelRegister("13Qhq", function(module, exports) {

$parcel$export(module.exports, "map", () => (parcelRequire("hzBt5")).map);
$parcel$export(module.exports, "each", () => (parcelRequire("hzBt5")).each);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("hzBt5")).indexOf);
$parcel$export(module.exports, "inherits", () => (parcelRequire("hzBt5")).inherits);
$parcel$export(module.exports, "reduce", () => (parcelRequire("hzBt5")).reduce);
$parcel$export(module.exports, "filter", () => (parcelRequire("hzBt5")).filter);
$parcel$export(module.exports, "bind", () => (parcelRequire("hzBt5")).bind);
$parcel$export(module.exports, "curry", () => (parcelRequire("hzBt5")).curry);
$parcel$export(module.exports, "isArray", () => (parcelRequire("hzBt5")).isArray);
$parcel$export(module.exports, "isString", () => (parcelRequire("hzBt5")).isString);
$parcel$export(module.exports, "isObject", () => (parcelRequire("hzBt5")).isObject);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("hzBt5")).isFunction);
$parcel$export(module.exports, "extend", () => (parcelRequire("hzBt5")).extend);
$parcel$export(module.exports, "defaults", () => (parcelRequire("hzBt5")).defaults);
$parcel$export(module.exports, "clone", () => (parcelRequire("hzBt5")).clone);
$parcel$export(module.exports, "merge", () => (parcelRequire("hzBt5")).merge);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $hzBt5 = parcelRequire("hzBt5");

});


parcelRegister("kM74L", function(module, exports) {

$parcel$export(module.exports, "installLabelLayout", () => $f1fdc76eb387316d$export$5320d1b3745c02a5);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ckizb = parcelRequire("ckizb");

var $989ab = parcelRequire("989ab");
var $f1fdc76eb387316d$var$getLabelManager = (0, $ckizb.makeInner)();
function $f1fdc76eb387316d$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $f1fdc76eb387316d$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $f1fdc76eb387316d$var$getLabelManager(api).labelManager = new (0, $989ab.default)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
        var labelManager = $f1fdc76eb387316d$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

});
parcelRegister("989ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a5bf80975ef2a5a$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.

var $lGSv6 = parcelRequire("lGSv6");
var $9ubot = parcelRequire("9ubot");parcelRequire("8q0E1");
var $9ubot = parcelRequire("9ubot");

var $aly4X = parcelRequire("aly4X");

var $5BQXp = parcelRequire("5BQXp");

var $kVlB5 = parcelRequire("kVlB5");

var $1n5dQ = parcelRequire("1n5dQ");

var $ckizb = parcelRequire("ckizb");

var $hzBt5 = parcelRequire("hzBt5");

var $hJQJ0 = parcelRequire("hJQJ0");

var $hcRXD = parcelRequire("hcRXD");
function $6a5bf80975ef2a5a$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $6a5bf80975ef2a5a$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $6a5bf80975ef2a5a$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $6a5bf80975ef2a5a$var$LABEL_OPTION_TO_STYLE_KEYS = [
    'align',
    'verticalAlign',
    'width',
    'height',
    'fontSize'
];
var $6a5bf80975ef2a5a$var$dummyTransformable = new (0, $kVlB5.default)();
var $6a5bf80975ef2a5a$var$labelLayoutInnerStore = (0, $ckizb.makeInner)();
var $6a5bf80975ef2a5a$var$labelLineAnimationStore = (0, $ckizb.makeInner)();
function $6a5bf80975ef2a5a$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS = [
    'x',
    'y',
    'rotation'
];
var $6a5bf80975ef2a5a$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {}; // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $lGSv6.default).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $6a5bf80975ef2a5a$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $6a5bf80975ef2a5a$var$dummyTransformable.x = $6a5bf80975ef2a5a$var$dummyTransformable.y = $6a5bf80975ef2a5a$var$dummyTransformable.rotation = $6a5bf80975ef2a5a$var$dummyTransformable.originX = $6a5bf80975ef2a5a$var$dummyTransformable.originY = 0;
            $6a5bf80975ef2a5a$var$dummyTransformable.scaleX = $6a5bf80975ef2a5a$var$dummyTransformable.scaleY = 1;
        }
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $lGSv6.default).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $6a5bf80975ef2a5a$var$dummyTransformable.x,
                y: $6a5bf80975ef2a5a$var$dummyTransformable.y,
                scaleX: $6a5bf80975ef2a5a$var$dummyTransformable.scaleX,
                scaleY: $6a5bf80975ef2a5a$var$dummyTransformable.scaleY,
                rotation: $6a5bf80975ef2a5a$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get('labelLayout');
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $hzBt5.isFunction)(layoutOption) || (0, $hzBt5.keys)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
             // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $aly4X.getECData)(child); // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $1n5dQ.updateLabelLinePoints)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0; // TODO A global layout option?
            if (typeof labelItem.layoutOption === 'function') layoutOption = labelItem.layoutOption($6a5bf80975ef2a5a$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180; // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $5BQXp.parsePercent)(layoutOption.x, width);
                label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle('x', defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $5BQXp.parsePercent)(layoutOption.y, height);
                label.setStyle('y', 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle('y', defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    }); // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $6a5bf80975ef2a5a$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $6a5bf80975ef2a5a$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $6a5bf80975ef2a5a$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = 'move';
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                }
            } else {
                // TODO Other drag functions?
                label.off('drag');
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $hJQJ0.prepareLayoutList)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $hzBt5.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftX';
        });
        var labelsNeedsAdjustOnY = (0, $hzBt5.filter)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftY';
        });
        (0, $hJQJ0.shiftLayoutOnX)(labelsNeedsAdjustOnX, 0, width);
        (0, $hJQJ0.shiftLayoutOnY)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $hzBt5.filter)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $hJQJ0.hideOverlap)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $hzBt5.each)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $6a5bf80975ef2a5a$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent(); // Update label line style.
        var ecData = (0, $aly4X.getECData)(el);
        var dataIndex = ecData.dataIndex; // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, 'style');
            var visualType = data.getVisual('drawType'); // Default to be same with main color
            defaultStyle.stroke = visualStyle[visualType];
            var labelLineModel = itemModel.getModel('labelLine');
            (0, $1n5dQ.setLabelLineStyle)(el, (0, $1n5dQ.getLabelLineStatesModels)(itemModel), defaultStyle);
            (0, $1n5dQ.updateLabelLinePoints)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine(); // Animate
        if (textEl && !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $9ubot.isElementRemoved)(el)) {
            var layoutStore = $6a5bf80975ef2a5a$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $aly4X.getECData)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps); // Disable fade in animation if value animation is enabled.
                if (!(0, $hcRXD.labelInner)(textEl).valueAnimation) {
                    var oldOpacity = (0, $hzBt5.retrieve2)(textEl.style.opacity, 1); // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $9ubot.initProps)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout); // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $hzBt5.indexOf)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $hzBt5.indexOf)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $9ubot.updateProps)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutSelect, newProps, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutSelect, textEl.states.select, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutEmphasis, newProps, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
                $6a5bf80975ef2a5a$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $6a5bf80975ef2a5a$var$LABEL_LAYOUT_PROPS);
            }
            (0, $hcRXD.animateLabelValue)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $6a5bf80975ef2a5a$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $9ubot.initProps)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $9ubot.updateProps)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $6a5bf80975ef2a5a$export$2e2bcd8739ae039 = $6a5bf80975ef2a5a$var$LabelManager;

});
parcelRegister("1n5dQ", function(module, exports) {

$parcel$export(module.exports, "updateLabelLinePoints", () => $0ffbfd715e97313b$export$cc93ba643cd97d83);
$parcel$export(module.exports, "limitTurnAngle", () => $0ffbfd715e97313b$export$ac52062003fbe6a);
$parcel$export(module.exports, "limitSurfaceAngle", () => $0ffbfd715e97313b$export$973e1fdb2708f71b);
$parcel$export(module.exports, "setLabelLineStyle", () => $0ffbfd715e97313b$export$c09e0b0574bdd2dc);
$parcel$export(module.exports, "getLabelLineStatesModels", () => $0ffbfd715e97313b$export$2979fdbf5ebce521);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ parcelRequire("8q0E1");
var $hMiip = parcelRequire("hMiip");
var $9dsiU = parcelRequire("9dsiU");
var $4vVC3 = parcelRequire("4vVC3");

var $fvvgx = parcelRequire("fvvgx");

var $kqaXh = parcelRequire("kqaXh");

var $jEMPh = parcelRequire("jEMPh");

var $hzBt5 = parcelRequire("hzBt5");

var $crEgd = parcelRequire("crEgd");

var $ef5pP = parcelRequire("ef5pP");

var $51xyq = parcelRequire("51xyq");
var $0ffbfd715e97313b$var$PI2 = Math.PI * 2;
var $0ffbfd715e97313b$var$CMD = (0, $fvvgx.default).CMD;
var $0ffbfd715e97313b$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $0ffbfd715e97313b$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $0ffbfd715e97313b$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d; // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $0ffbfd715e97313b$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $kqaXh.normalizeRadian)(endAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(tmp);
    } else {
        startAngle = (0, $kqaXh.normalizeRadian)(startAngle);
        endAngle = (0, $kqaXh.normalizeRadian)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $0ffbfd715e97313b$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $0ffbfd715e97313b$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $0ffbfd715e97313b$var$PI2 >= startAngle && angle + $0ffbfd715e97313b$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $0ffbfd715e97313b$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen; // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $0ffbfd715e97313b$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $0ffbfd715e97313b$var$tmpPt = [];
function $0ffbfd715e97313b$var$nearestPointOnRect(pt, rect, out) {
    var dist = $0ffbfd715e97313b$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $0ffbfd715e97313b$var$tmpPt);
    out.set($0ffbfd715e97313b$var$tmpPt[0], $0ffbfd715e97313b$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $0ffbfd715e97313b$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $0ffbfd715e97313b$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $0ffbfd715e97313b$var$CMD.L:
                d = $0ffbfd715e97313b$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $0ffbfd715e97313b$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $0ffbfd715e97313b$var$CMD.C:
                d = (0, $jEMPh.cubicProjectPoint)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $0ffbfd715e97313b$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $0ffbfd715e97313b$var$CMD.Q:
                d = (0, $jEMPh.quadraticProjectPoint)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $0ffbfd715e97313b$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $0ffbfd715e97313b$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++]; // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $0ffbfd715e97313b$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $0ffbfd715e97313b$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $0ffbfd715e97313b$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $0ffbfd715e97313b$var$projectPointToRect(x0, y0, width, height, x, y, $0ffbfd715e97313b$var$tmpPt);
                break;
            case $0ffbfd715e97313b$var$CMD.Z:
                d = $0ffbfd715e97313b$var$projectPointToLine(xi, yi, x0, y0, x, y, $0ffbfd715e97313b$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($0ffbfd715e97313b$var$tmpPt[0], $0ffbfd715e97313b$var$tmpPt[1]);
        }
    }
    return minDist;
} // Temporal varible for intermediate usage.
var $0ffbfd715e97313b$var$pt0 = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$pt1 = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$pt2 = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$dir = new (0, $4vVC3.default)();
var $0ffbfd715e97313b$var$dir2 = new (0, $4vVC3.default)();
function $0ffbfd715e97313b$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent(); // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $0ffbfd715e97313b$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $crEgd.invert)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $0ffbfd715e97313b$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $0ffbfd715e97313b$var$getCandidateAnchor(candidate, 0, labelRect, $0ffbfd715e97313b$var$pt0, $0ffbfd715e97313b$var$dir);
        (0, $4vVC3.default).scaleAndAdd($0ffbfd715e97313b$var$pt1, $0ffbfd715e97313b$var$pt0, $0ffbfd715e97313b$var$dir, len); // Transform to target coord space.
        $0ffbfd715e97313b$var$pt1.transform(targetInversedTransform); // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($0ffbfd715e97313b$var$pt1) : target instanceof (0, $hMiip.default) ? $0ffbfd715e97313b$var$nearestPointOnPath($0ffbfd715e97313b$var$pt1, target.path, $0ffbfd715e97313b$var$pt2) : $0ffbfd715e97313b$var$nearestPointOnRect($0ffbfd715e97313b$var$pt1, boundingRect, $0ffbfd715e97313b$var$pt2); // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist; // Transform back to global space.
            $0ffbfd715e97313b$var$pt1.transform(targetTransform);
            $0ffbfd715e97313b$var$pt2.transform(targetTransform);
            $0ffbfd715e97313b$var$pt2.toArray(points[0]);
            $0ffbfd715e97313b$var$pt1.toArray(points[1]);
            $0ffbfd715e97313b$var$pt0.toArray(points[2]);
        }
    }
    $0ffbfd715e97313b$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
} // Temporal variable for the limitTurnAngle function
var $0ffbfd715e97313b$var$tmpArr = [];
var $0ffbfd715e97313b$var$tmpProjPoint = new (0, $4vVC3.default)();
function $0ffbfd715e97313b$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI; // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $0ffbfd715e97313b$var$pt0.fromArray(linePoints[0]);
    $0ffbfd715e97313b$var$pt1.fromArray(linePoints[1]);
    $0ffbfd715e97313b$var$pt2.fromArray(linePoints[2]);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir, $0ffbfd715e97313b$var$pt0, $0ffbfd715e97313b$var$pt1);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir2, $0ffbfd715e97313b$var$pt2, $0ffbfd715e97313b$var$pt1);
    var len1 = $0ffbfd715e97313b$var$dir.len();
    var len2 = $0ffbfd715e97313b$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $0ffbfd715e97313b$var$dir.scale(1 / len1);
    $0ffbfd715e97313b$var$dir2.scale(1 / len2);
    var angleCos = $0ffbfd715e97313b$var$dir.dot($0ffbfd715e97313b$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $0ffbfd715e97313b$var$projectPointToLine($0ffbfd715e97313b$var$pt1.x, $0ffbfd715e97313b$var$pt1.y, $0ffbfd715e97313b$var$pt2.x, $0ffbfd715e97313b$var$pt2.y, $0ffbfd715e97313b$var$pt0.x, $0ffbfd715e97313b$var$pt0.y, $0ffbfd715e97313b$var$tmpArr, false);
        $0ffbfd715e97313b$var$tmpProjPoint.fromArray($0ffbfd715e97313b$var$tmpArr); // Calculate new projected length with limited minTurnAngle and get the new connect point
        $0ffbfd715e97313b$var$tmpProjPoint.scaleAndAdd($0ffbfd715e97313b$var$dir2, d / Math.tan(Math.PI - minTurnAngle)); // Limit the new calculated connect point between pt1 and pt2.
        var t = $0ffbfd715e97313b$var$pt2.x !== $0ffbfd715e97313b$var$pt1.x ? ($0ffbfd715e97313b$var$tmpProjPoint.x - $0ffbfd715e97313b$var$pt1.x) / ($0ffbfd715e97313b$var$pt2.x - $0ffbfd715e97313b$var$pt1.x) : ($0ffbfd715e97313b$var$tmpProjPoint.y - $0ffbfd715e97313b$var$pt1.y) / ($0ffbfd715e97313b$var$pt2.y - $0ffbfd715e97313b$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt1);
        else if (t > 1) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt2);
        $0ffbfd715e97313b$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $0ffbfd715e97313b$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $0ffbfd715e97313b$var$pt0.fromArray(linePoints[0]);
    $0ffbfd715e97313b$var$pt1.fromArray(linePoints[1]);
    $0ffbfd715e97313b$var$pt2.fromArray(linePoints[2]);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir, $0ffbfd715e97313b$var$pt1, $0ffbfd715e97313b$var$pt0);
    (0, $4vVC3.default).sub($0ffbfd715e97313b$var$dir2, $0ffbfd715e97313b$var$pt2, $0ffbfd715e97313b$var$pt1);
    var len1 = $0ffbfd715e97313b$var$dir.len();
    var len2 = $0ffbfd715e97313b$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $0ffbfd715e97313b$var$dir.scale(1 / len1);
    $0ffbfd715e97313b$var$dir2.scale(1 / len2);
    var angleCos = $0ffbfd715e97313b$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $0ffbfd715e97313b$var$projectPointToLine($0ffbfd715e97313b$var$pt1.x, $0ffbfd715e97313b$var$pt1.y, $0ffbfd715e97313b$var$pt2.x, $0ffbfd715e97313b$var$pt2.y, $0ffbfd715e97313b$var$pt0.x, $0ffbfd715e97313b$var$pt0.y, $0ffbfd715e97313b$var$tmpArr, false);
        $0ffbfd715e97313b$var$tmpProjPoint.fromArray($0ffbfd715e97313b$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($0ffbfd715e97313b$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $0ffbfd715e97313b$var$tmpProjPoint.scaleAndAdd($0ffbfd715e97313b$var$dir2, d / Math.tan(Math.PI / 2 - newAngle)); // Limit the new calculated connect point between pt1 and pt2.
            var t = $0ffbfd715e97313b$var$pt2.x !== $0ffbfd715e97313b$var$pt1.x ? ($0ffbfd715e97313b$var$tmpProjPoint.x - $0ffbfd715e97313b$var$pt1.x) / ($0ffbfd715e97313b$var$pt2.x - $0ffbfd715e97313b$var$pt1.x) : ($0ffbfd715e97313b$var$tmpProjPoint.y - $0ffbfd715e97313b$var$pt1.y) / ($0ffbfd715e97313b$var$pt2.y - $0ffbfd715e97313b$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt1);
            else if (t > 1) (0, $4vVC3.default).copy($0ffbfd715e97313b$var$tmpProjPoint, $0ffbfd715e97313b$var$pt2);
        }
        $0ffbfd715e97313b$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $0ffbfd715e97313b$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName); // Make sure display.
    stateObj.ignore = ignore; // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $0ffbfd715e97313b$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $ef5pP.dist(points[0], points[1]);
        var len2 = $ef5pP.dist(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $ef5pP.lerp([], points[1], points[0], moveLen / len1);
        var midPoint2 = $ef5pP.lerp([], points[1], points[2], moveLen / len2);
        var midPoint1 = $ef5pP.lerp([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $0ffbfd715e97313b$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $51xyq.DISPLAY_STATES).length; i++){
        var stateName = (0, $51xyq.DISPLAY_STATES)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $hzBt5.retrieve2)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $hzBt5.retrieve2)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states.normal;
                if (stateObj) stateObj.ignore = true;
                continue;
            } // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $9dsiU.default)();
                targetEl.setTextGuideLine(labelLine); // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $0ffbfd715e97313b$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                 // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $0ffbfd715e97313b$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $hzBt5.defaults)(labelLine.style, defaultStyle); // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false; // Custom the buildPath.
        labelLine.buildPath = $0ffbfd715e97313b$var$buildLabelLinePath;
    }
}
function $0ffbfd715e97313b$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $51xyq.SPECIAL_STATES).length; i++){
        var stateName = (0, $51xyq.SPECIAL_STATES)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}

});





parcelRegister("kPSHX", function(module, exports) {

$parcel$export(module.exports, "install", () => $f2b301f1b507b753$export$4b3e715f166fdd78);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8jBif = parcelRequire("8jBif");
function $f2b301f1b507b753$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('canvas', (0, $8jBif.default));
}

});
parcelRegister("8jBif", function(module, exports) {

$parcel$export(module.exports, "default", () => $60dd06c793ae0607$export$2e2bcd8739ae039);

var $2MY1H = parcelRequire("2MY1H");

var $hzBt5 = parcelRequire("hzBt5");

var $eO9PU = parcelRequire("eO9PU");

var $a1kVg = parcelRequire("a1kVg");

var $agXnr = parcelRequire("agXnr");

var $gZXYp = parcelRequire("gZXYp");

var $2Zzmo = parcelRequire("2Zzmo");

var $4rgPt = parcelRequire("4rgPt");
var $60dd06c793ae0607$var$HOVER_LAYER_ZLEVEL = 1e5;
var $60dd06c793ae0607$var$CANVAS_ZLEVEL = 314159;
var $60dd06c793ae0607$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $60dd06c793ae0607$var$INCREMENTAL_INC = 0.001;
function $60dd06c793ae0607$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $60dd06c793ae0607$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') return false;
    return true;
}
function $60dd06c793ae0607$var$createRoot(width, height) {
    var domRoot = document.createElement('div');
    domRoot.style.cssText = [
        'position:relative',
        'width:' + width + 'px',
        'height:' + height + 'px',
        'padding:0',
        'margin:0',
        'border-width:0'
    ].join(';') + ';';
    return domRoot;
}
var $60dd06c793ae0607$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = 'canvas';
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = 'canvas';
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === 'CANVAS';
        this._opts = opts = $hzBt5.extend({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $2MY1H.devicePixelRatio);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            rootStyle.webkitTapHighlightColor = 'transparent';
            rootStyle.webkitUserSelect = 'none';
            rootStyle.userSelect = 'none';
            rootStyle['-webkit-touch-callout'] = 'none';
            root.innerHTML = '';
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = this._getSize(0);
            this._height = this._getSize(1);
            var domRoot = this._domRoot = $60dd06c793ae0607$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $eO9PU.default)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$60dd06c793ae0607$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $60dd06c793ae0607$var$CANVAS_ZLEVEL;
            zlevelList.push($60dd06c793ae0607$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return 'canvas';
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($60dd06c793ae0607$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $2Zzmo.brush)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($60dd06c793ae0607$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $2Zzmo.brushSingle)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $a1kVg.default)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($60dd06c793ae0607$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error('For some unknown reason. drawIndex is -1');
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $gZXYp.default).wxa) $hzBt5.each(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $2Zzmo.brush)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $2Zzmo.brush)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $60dd06c793ae0607$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $eO9PU.default)('zr_' + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $hzBt5.merge(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $60dd06c793ae0607$var$EL_AFTER_INCREMENTAL_INC]) $hzBt5.merge(layer, this._layerConfig[zlevel - $60dd06c793ae0607$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) {
            $hzBt5.logError('ZLevel ' + zlevel + ' has been used already');
            return;
        }
        if (!$60dd06c793ae0607$var$isLayerValid(layer)) {
            $hzBt5.logError('Layer of zlevel ' + zlevel + ' is not valid');
            return;
        }
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.__painter = this;
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $60dd06c793ae0607$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $60dd06c793ae0607$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $hzBt5.logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $4rgPt.REDRAW_BIT) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $hzBt5.each(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $hzBt5.merge(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $60dd06c793ae0607$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $hzBt5.merge(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($hzBt5.indexOf(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($60dd06c793ae0607$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = 'none';
            var opts = this._opts;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = this._getSize(0);
            height = this._getSize(1);
            domRoot.style.display = '';
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + 'px';
                domRoot.style.height = height + 'px';
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = '';
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$60dd06c793ae0607$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $eO9PU.default)('image', this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $2Zzmo.brush)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    CanvasPainter.prototype._getSize = function(whIdx) {
        var opts = this._opts;
        var wh = [
            'width',
            'height'
        ][whIdx];
        var cwh = [
            'clientWidth',
            'clientHeight'
        ][whIdx];
        var plt = [
            'paddingLeft',
            'paddingTop'
        ][whIdx];
        var prb = [
            'paddingRight',
            'paddingBottom'
        ][whIdx];
        if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
        var root = this.root;
        var stl = document.defaultView.getComputedStyle(root);
        return (root[cwh] || $60dd06c793ae0607$var$parseInt10(stl[wh]) || $60dd06c793ae0607$var$parseInt10(root.style[wh])) - ($60dd06c793ae0607$var$parseInt10(stl[plt]) || 0) - ($60dd06c793ae0607$var$parseInt10(stl[prb]) || 0) | 0;
    };
    CanvasPainter.prototype.pathToImage = function(path, dpr) {
        dpr = dpr || this.dpr;
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var rect = path.getBoundingRect();
        var style = path.style;
        var shadowBlurSize = style.shadowBlur * dpr;
        var shadowOffsetX = style.shadowOffsetX * dpr;
        var shadowOffsetY = style.shadowOffsetY * dpr;
        var lineWidth = path.hasStroke() ? style.lineWidth : 0;
        var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
        var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
        var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
        var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
        var width = rect.width + leftMargin + rightMargin;
        var height = rect.height + topMargin + bottomMargin;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, width, height);
        ctx.dpr = dpr;
        var pathTransform = {
            x: path.x,
            y: path.y,
            scaleX: path.scaleX,
            scaleY: path.scaleY,
            rotation: path.rotation,
            originX: path.originX,
            originY: path.originY
        };
        path.x = leftMargin - rect.x;
        path.y = topMargin - rect.y;
        path.rotation = 0;
        path.scaleX = 1;
        path.scaleY = 1;
        path.updateTransform();
        if (path) (0, $2Zzmo.brush)(ctx, path, {
            inHover: false,
            viewWidth: this._width,
            viewHeight: this._height
        }, true);
        var imgShape = new (0, $agXnr.default)({
            style: {
                x: 0,
                y: 0,
                image: canvas
            }
        });
        $hzBt5.extend(path, pathTransform);
        return imgShape;
    };
    return CanvasPainter;
}();
var $60dd06c793ae0607$export$2e2bcd8739ae039 = $60dd06c793ae0607$var$CanvasPainter;

});
parcelRegister("eO9PU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7d5d7dc37fe970$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hzBt5 = parcelRequire("hzBt5");

var $2MY1H = parcelRequire("2MY1H");

var $1J7Ke = parcelRequire("1J7Ke");

var $geJzd = parcelRequire("geJzd");

var $2Zzmo = parcelRequire("2Zzmo");

var $lGSv6 = parcelRequire("lGSv6");

var $4rgPt = parcelRequire("4rgPt");
function $ac7d5d7dc37fe970$var$returnFalse() {
    return false;
}
function $ac7d5d7dc37fe970$var$createDom(id, painter, dpr) {
    var newDom = $hzBt5.createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = 'absolute';
        newDomStyle.left = '0';
        newDomStyle.top = '0';
        newDomStyle.width = width + 'px';
        newDomStyle.height = height + 'px';
        newDom.setAttribute('data-zr-dom-id', id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $ac7d5d7dc37fe970$var$Layer = function(_super) {
    (0, $fKE23.__extends)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $2MY1H.devicePixelRatio);
        if (typeof id === 'string') dom = $ac7d5d7dc37fe970$var$createDom(id, painter, dpr);
        else if ($hzBt5.isObject(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            dom.onselectstart = $ac7d5d7dc37fe970$var$returnFalse;
            domStyle.webkitUserSelect = 'none';
            domStyle.userSelect = 'none';
            domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
            domStyle['-webkit-touch-callout'] = 'none';
            domStyle.padding = '0';
            domStyle.margin = '0';
            domStyle.borderWidth = '0';
        }
        _this.domBack = null;
        _this.ctxBack = null;
        _this.painter = painter;
        _this.config = null;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext('2d');
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $ac7d5d7dc37fe970$var$createDom('back-' + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext('2d');
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $lGSv6.default)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $lGSv6.default)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $lGSv6.default)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $lGSv6.default)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $4rgPt.REDRAW_BIT) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $4rgPt.REDRAW_BIT) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + 'px';
            domStyle.height = height + 'px';
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = 'copy';
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== 'transparent') {
                var clearColorGradientOrPattern = void 0;
                if ($hzBt5.isGradientObject(clearColor)) {
                    clearColorGradientOrPattern = clearColor.__canvasGradient || (0, $geJzd.getCanvasGradient)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                } else if ($hzBt5.isImagePatternObject(clearColor)) clearColorGradientOrPattern = (0, $2Zzmo.createCanvasPattern)(ctx, clearColor, {
                    dirty: function() {
                        self.setUnpainted();
                        self.__painter.refresh();
                    }
                });
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $hzBt5.each(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $1J7Ke.default));
var $ac7d5d7dc37fe970$export$2e2bcd8739ae039 = $ac7d5d7dc37fe970$var$Layer;

});



parcelRegister("4cuuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $873373c67c1a2752$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $873373c67c1a2752$var$ChartLegendItem = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($873373c67c1a2752$var$ChartLegendItemContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($873373c67c1a2752$var$ChartLegendItemBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($873373c67c1a2752$var$ChartLegendItemLine, {
        color: props.color
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($873373c67c1a2752$var$ChartLegendItemText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($873373c67c1a2752$var$ChartLegendItemName, null, props.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($873373c67c1a2752$var$ChartLegendItemDescription, null, props.description)));
var $873373c67c1a2752$export$2e2bcd8739ae039 = $873373c67c1a2752$var$ChartLegendItem;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $873373c67c1a2752$var$ChartLegendItemContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxpxbi _1xoqidpf",
            __cmplp.className
        ])
    });
});
const $873373c67c1a2752$var$ChartLegendItemBox = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2rko1l7b _4cvr1h6o _1bah1h6o _4t3i1ul9 _1bsb1ul9",
            __cmplp.className
        ])
    });
});
const $873373c67c1a2752$var$ChartLegendItemLine = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk1cj8 _4t3i1l7b _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $873373c67c1a2752$var$ChartLegendItemText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1h6o _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $873373c67c1a2752$var$ChartLegendItemName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng _1wyb1oud",
            __cmplp.className
        ])
    });
});
const $873373c67c1a2752$var$ChartLegendItemDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazna9s _11c81vlj _k48powjs _19pkv77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ewTkV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bfa38dea6d25d10$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $0bfa38dea6d25d10$export$420ac06db41dd9da = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0bfa38dea6d25d10$var$ChartLegendContainer, null, children);
var $0bfa38dea6d25d10$export$2e2bcd8739ae039 = $0bfa38dea6d25d10$export$420ac06db41dd9da;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0bfa38dea6d25d10$var$ChartLegendContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _19bvxy5q _18s81mcs",
            __cmplp.className
        ])
    });
});

});

parcelRegister("16ODO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af2055e24f30c40$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1af2055e24f30c40$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    completedName: {
        "id": "software-burnup-report.chart.completed-name",
        "defaultMessage": "Completed work"
    },
    remainingStoriesDescription: {
        "id": "software-burnup-report.chart.remaining-stories-description",
        "defaultMessage": "Number of story points completed this sprint"
    },
    remainingTimeDescription: {
        "id": "software-burnup-report.chart.remaining-time-description",
        "defaultMessage": "Hours of work completed this sprint"
    },
    remainingIssuesDescription: {
        "id": "software-burnup-report.chart.remaining-issues-description",
        "defaultMessage": "Number of issues completed this sprint"
    },
    guidelineName: {
        "id": "software-burnup-report.chart.guideline-name",
        "defaultMessage": "Guideline"
    },
    guidelineDescription: {
        "id": "software-burnup-report.chart.guideline-description",
        "defaultMessage": "Ideal burn rate"
    },
    scope: {
        "id": "software-burnup-report.chart.scope",
        "defaultMessage": "Work Scope"
    },
    scopeStories: {
        "id": "software-burnup-report.chart.scope-stories",
        "defaultMessage": "Number of story points to be completed this sprint"
    },
    scopeTime: {
        "id": "software-burnup-report.chart.scope-time",
        "defaultMessage": "Hours of work to be completed this sprint"
    },
    scopeIssues: {
        "id": "software-burnup-report.chart.scope-issues",
        "defaultMessage": "Number of issues to be completed this sprint"
    }
});

});

parcelRegister("5FspW", function(module, exports) {

$parcel$export(module.exports, "makeRenderTooltip", () => $b2796d823525df0b$export$e1cc4503850e11d6);

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");

var $lcnyw = parcelRequire("lcnyw");

var $IXOMa = parcelRequire("IXOMa");

var $6j0nJ = parcelRequire("6j0nJ");

var $8rQVt = parcelRequire("8rQVt");

var $aIwQg = parcelRequire("aIwQg");

var $hSP3p = parcelRequire("hSP3p");

var $aXVPn = parcelRequire("aXVPn");
const $b2796d823525df0b$var$getMessageByEstimationStatistic = (estimationStatistic)=>{
    switch(estimationStatistic){
        case 0, $IXOMa.ESTIMATION_STORY_POINTS:
            return (0, $8rQVt.default).optionStatisticStoryPoints;
        case 0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE:
            return (0, $aXVPn.default).statisticOriginalEstimate;
        default:
            return (0, $8rQVt.default).optionStatisticIssueCount;
    }
};
const $b2796d823525df0b$export$10e23dfcd136e11c = (scopeChange, isCompletion, intl, statisticField, timeTrackingOptions)=>{
    const deltaChange = isCompletion ? scopeChange.completion - scopeChange.prevCompletion : scopeChange.scope - scopeChange.prevScope;
    const deltaChangeAsString = (0, $IXOMa.formatEstimateForTooltip)(Math.abs(deltaChange), timeTrackingOptions, statisticField, intl);
    const formattedDelta = deltaChange > 0 ? `+${deltaChangeAsString}` : `-${deltaChangeAsString}`;
    const deltaMessage = `${intl.formatMessage($b2796d823525df0b$var$getMessageByEstimationStatistic(statisticField))} ${formattedDelta}`;
    const tooltipText = (0, $hSP3p.getTooltipText)({
        intl: intl,
        event: scopeChange
    });
    return `
        ${tooltipText}
        <br />
        <span>${deltaMessage}</span>
    `;
};
const $b2796d823525df0b$export$1083d127c5e46665 = (isCompletion, statisticField, timeTrackingOptions, intl, event)=>{
    const statistic = isCompletion ? (0, $aIwQg.getCompletion)(event) : (0, $aIwQg.getScope)(event);
    const formattedStatistic = (0, $IXOMa.formatEstimateForTooltip)(statistic, timeTrackingOptions, statisticField, intl);
    const storyPointsOrOriginalEstimateMessage = statisticField !== (0, $IXOMa.ESTIMATION_ISSUE_COUNT) ? `${intl.formatMessage($b2796d823525df0b$var$getMessageByEstimationStatistic(statisticField))} ${formattedStatistic}` : '';
    // Dont want issuelist on start of completion line
    const issueCount = event.type === 'end' || event.type === 'start' && !isCompletion ? event.data.issueList.length : 0;
    const issueCountMessage = `${intl.formatMessage((0, $8rQVt.default).optionStatisticIssueCount)} ${issueCount}`;
    return `
        <b>
          ${intl.formatMessage(event.type === 'start' ? (0, $aXVPn.default).sprintStarted : (0, $aXVPn.default).sprintEnded)}
        </b>
        <br />
        ${storyPointsOrOriginalEstimateMessage}
        <br />
        ${issueCountMessage}
    `;
};
const $b2796d823525df0b$export$c5a66b516d147ffd = (intl, statisticField, timeTrackingOptions, event, isCompletion)=>{
    if (event.type === 'start' || event.type === 'end') return $b2796d823525df0b$export$1083d127c5e46665(isCompletion, statisticField, timeTrackingOptions, intl, event);
    if (event.type !== 'scope') return '';
    return $b2796d823525df0b$export$10e23dfcd136e11c(event.data, isCompletion, intl, statisticField, timeTrackingOptions);
};
const $b2796d823525df0b$export$e1cc4503850e11d6 = ({ userTimeZone: userTimeZone, intl: intl, statisticField: statisticField, timeTrackingOptions: timeTrackingOptions })=>(params)=>{
        if (!params || !params.data || !params.data.meta) return '';
        const { event: event } = params.data.meta;
        if (!event) return '';
        const tooltipContent = $b2796d823525df0b$export$c5a66b516d147ffd(intl, statisticField, timeTrackingOptions, event, params.seriesName === (0, $6j0nJ.COMPLETION_SCATTER_SERIES));
        const formattedTimestamp = (0, $4p54N.default)((0, $bbmZl.default)((0, $aIwQg.getTimestamp)(event), userTimeZone), 'dd/MMM/yy h:mm aa');
        const color = params.seriesName === (0, $6j0nJ.COMPLETION_SCATTER_SERIES) ? `var(--ds-text-success, ${(0, $73a5c9d720aa66e1$exports).G400})` : `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`;
        return `<div style="padding: 8px; border-left: 8px solid ${color}">
        <div>
            ${tooltipContent}
        </div>

        <span style="color: ${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N90})`}; font-weight: 400; font-size: ${(0, $lcnyw.fontSizeSmall)()}px;">
            ${formattedTimestamp}
        </span>
    </div>`;
    };

});
parcelRegister("8rQVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb6ee253eda5d721$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb6ee253eda5d721$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    optionStatisticIssueCount: {
        "id": "software-burnup-report.common.option-statistic-issue-count",
        "defaultMessage": "Issue count"
    },
    optionStatisticStoryPoints: {
        "id": "software-burnup-report.common.option-statistic-story-points",
        "defaultMessage": "Story points"
    },
    optionStatisticOriginalEstimate: {
        "id": "software-burnup-report.common.option-statistic-original-estimate",
        "defaultMessage": "Original estimate (Hours)"
    },
    time: {
        "id": "software-burnup-report.common.time",
        "defaultMessage": "Date"
    },
    colLabelDate: {
        "id": "software-burnup-report.common.col-label-date",
        "defaultMessage": "Date"
    },
    colLabelSummary: {
        "id": "software-burnup-report.common.col-label-summary",
        "defaultMessage": "Summary"
    },
    colLabelKey: {
        "id": "software-burnup-report.common.col-label-key",
        "defaultMessage": "Key"
    },
    colLabelIssueType: {
        "id": "software-burnup-report.common.col-label-issue-type",
        "defaultMessage": "Issue type"
    },
    colLabelEpic: {
        "id": "software-burnup-report.common.col-label-epic",
        "defaultMessage": "Epic"
    },
    colLabelScopeChangeDetails: {
        "id": "software-burnup-report.common.col-label-scope-change-details",
        "defaultMessage": "Details of scope change"
    },
    colLabelEstimationChange: {
        "id": "software-burnup-report.common.col-label-estimation-change",
        "defaultMessage": "Change in estimation"
    },
    colLabelStoryPoints: {
        "id": "software-burnup-report.common.col-label-story-points",
        "defaultMessage": "Story points"
    },
    colLabelIssueCount: {
        "id": "software-burnup-report.common.col-label-issue-count",
        "defaultMessage": "Issue count"
    },
    colLabelStatus: {
        "id": "software-burnup-report.common.col-label-status",
        "defaultMessage": "Status"
    },
    colLabelAssignee: {
        "id": "software-burnup-report.common.col-label-assignee",
        "defaultMessage": "Assignee"
    }
});

});

parcelRegister("aIwQg", function(module, exports) {

$parcel$export(module.exports, "getTimestamp", () => $215c438c86d9c9d0$export$3c95c4c8b671ef0);
$parcel$export(module.exports, "getCompletion", () => $215c438c86d9c9d0$export$6c69e642446172b6);
$parcel$export(module.exports, "getScope", () => $215c438c86d9c9d0$export$5d887aaef2abf9e2);
$parcel$export(module.exports, "buildEvents", () => $215c438c86d9c9d0$export$f575cae50c008afe);
const $215c438c86d9c9d0$export$3c95c4c8b671ef0 = ({ data: { timestamp: timestamp } })=>timestamp;
const $215c438c86d9c9d0$export$6c69e642446172b6 = (anyEvent)=>{
    if (anyEvent.type === 'start') return 0;
    if (anyEvent.type === 'end') return anyEvent.data.completion;
    return anyEvent.data.completion;
};
const $215c438c86d9c9d0$export$5d887aaef2abf9e2 = (anyEvent)=>{
    if (anyEvent.type === 'start') return anyEvent.data.scopeEstimate;
    return anyEvent.data.scope;
};
const $215c438c86d9c9d0$export$e8465396fe25480e = (now, { sprintEndEvent: sprintEndEvent, scopeChangeEvents: scopeChangeEvents, sprintStartEvent: sprintStartEvent })=>{
    if (sprintEndEvent) return [
        {
            type: 'end',
            data: sprintEndEvent
        }
    ];
    const lastEvent = scopeChangeEvents[scopeChangeEvents.length - 1];
    if (lastEvent && new Date(lastEvent.timestamp).getTime() > now.getTime()) return [];
    return [
        {
            type: 'today',
            data: {
                timestamp: now.toISOString(),
                completion: lastEvent ? lastEvent.completion : 0,
                scope: lastEvent ? lastEvent.scope : sprintStartEvent.scopeEstimate
            }
        }
    ];
};
const $215c438c86d9c9d0$export$f575cae50c008afe = (now, burnup)=>[
        {
            type: 'start',
            data: burnup.sprintStartEvent
        },
        // @ts-expect-error - TS2322 - Type '{ type: string; data: SprintScopeChangeData; }' is not assignable to type 'SprintEvent'.
        ...burnup.scopeChangeEvents.map((event)=>({
                type: 'scope',
                data: event
            })),
        // The last event is either the end event or the current date.
        // @ts-expect-error - TS2322 - Type 'SprintEvent | { type: string; data: SprintScopeChangeData; }' is not assignable to type 'SprintEvent'.
        ...$215c438c86d9c9d0$export$e8465396fe25480e(now, burnup)
    ];

});

parcelRegister("hSP3p", function(module, exports) {

$parcel$export(module.exports, "getTooltipText", () => $e8107ad7e51a2b70$export$3c8120d2b233073c);

var $6j0nJ = parcelRequire("6j0nJ");

var $1hvou = parcelRequire("1hvou");
const $e8107ad7e51a2b70$export$3c8120d2b233073c = ({ event: event, intl: intl })=>{
    switch(event.eventType){
        case 0, $6j0nJ.ESTIMATION_CHANGE:
            return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage((0, $1hvou.default).estimationUpdated)}
            `;
        case 0, $6j0nJ.TRANSITION_TO_DONE:
            return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage((0, $1hvou.default).transitionToDone)}
            `;
        case 0, $6j0nJ.TRANSITION_TO_NOT_DONE:
            return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage((0, $1hvou.default).transitionToNotDone)}
            `;
        case 0, $6j0nJ.ISSUE_REMOVED:
            return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage((0, $1hvou.default).issueRemoved)}
            `;
        case 0, $6j0nJ.ISSUE_ADDED:
            return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage((0, $1hvou.default).issueAdded)}
            `;
        // These two last are other events, but if they get here it's because their issues did
        // change estimation.
        case 0, $6j0nJ.COLUMN_CHANGE:
            return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage((0, $1hvou.default).estimationUpdated)}
            `;
        case 0, $6j0nJ.UNKNOWN_EVENT:
            return `
                <b>${event.issueKey}</b>
                <br />
                ${intl.formatMessage((0, $1hvou.default).estimationUpdated)}
            `;
        default:
            return '';
    }
};

});
parcelRegister("1hvou", function(module, exports) {

$parcel$export(module.exports, "default", () => $b512efeea20cb77e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $b512efeea20cb77e$var$messages = (0, $90IgZ.defineMessages)({
    estimationUpdated: {
        "id": "software-burnup-report.chart.tooltip.get-tooltip-text.estimation-updated",
        "defaultMessage": "Estimate updated"
    },
    transitionToDone: {
        "id": "software-burnup-report.chart.tooltip.get-tooltip-text.transition-to-done",
        "defaultMessage": "Transition to done"
    },
    transitionToNotDone: {
        "id": "software-burnup-report.chart.tooltip.get-tooltip-text.transition-to-not-done",
        "defaultMessage": "Transition to not done"
    },
    issueRemoved: {
        "id": "software-burnup-report.chart.tooltip.get-tooltip-text.issue-removed",
        "defaultMessage": "Issue removed from sprint"
    },
    issueAdded: {
        "id": "software-burnup-report.chart.tooltip.get-tooltip-text.issue-added",
        "defaultMessage": "Issue added to sprint"
    }
});
var $b512efeea20cb77e$export$2e2bcd8739ae039 = $b512efeea20cb77e$var$messages;

});


parcelRegister("aXVPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d21016e4aedfa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $f94d21016e4aedfa$var$messages = (0, $90IgZ.defineMessages)({
    sprintStarted: {
        "id": "software-burnup-report.chart.tooltip.sprint-started",
        "defaultMessage": "Sprint started"
    },
    sprintEnded: {
        "id": "software-burnup-report.chart.tooltip.sprint-ended",
        "defaultMessage": "Sprint ended"
    },
    statisticOriginalEstimate: {
        "id": "software-burnup-report.chart.tooltip.statistic-original-estimate",
        "defaultMessage": "Original estimate"
    }
});
var $f94d21016e4aedfa$export$2e2bcd8739ae039 = $f94d21016e4aedfa$var$messages;

});


parcelRegister("Mv60I", function(module, exports) {

$parcel$export(module.exports, "getOptions", () => $7354b8d98911c3aa$export$d2312e68e1f5ad00);
// TODO: https://product-fabric.atlassian.net/browse/DSP-3792
// Use tokens to all the color in this file for the echart


var $awnLj = parcelRequire("awnLj");

var $6j0nJ = parcelRequire("6j0nJ");

var $8rQVt = parcelRequire("8rQVt");

var $aIwQg = parcelRequire("aIwQg");

var $3gpIm = parcelRequire("3gpIm");

var $8HYxp = parcelRequire("8HYxp");

var $5Vs6Q = parcelRequire("5Vs6Q");

var $6tZj1 = parcelRequire("6tZj1");

var $jU7M3 = parcelRequire("jU7M3");
const $7354b8d98911c3aa$export$d2312e68e1f5ad00 = ({ burnup: burnup, isMouseOver: isMouseOver, renderTooltip: renderTooltip, now: now, intl: intl, statisticField: statisticField, userTimeZone: userTimeZone, prefersReducedMotion: prefersReducedMotion // eslint-disable-next-line @typescript-eslint/no-explicit-any
 })=>{
    const sprintEvents = (0, $aIwQg.buildEvents)(now, burnup);
    const minDate = new Date(burnup.sprintStartEvent.timestamp);
    const maxDate = (0, $8HYxp.getLastKnownSprintDate)(burnup, now);
    const series = [
        (0, $5Vs6Q.default)(isMouseOver, sprintEvents, (0, $6j0nJ.SCOPE_SCATTER_SERIES), (0, $73a5c9d720aa66e1$exports).R400, (0, $aIwQg.getScope), (0, $5Vs6Q.hasDeltaScope)),
        (0, $5Vs6Q.default)(isMouseOver, sprintEvents, (0, $6j0nJ.COMPLETION_SCATTER_SERIES), (0, $73a5c9d720aa66e1$exports).G400, (0, $aIwQg.getCompletion), (0, $5Vs6Q.hasDeltaCompletion)),
        (0, $8HYxp.default)(burnup, now, maxDate, sprintEvents),
        (0, $3gpIm.default)(burnup, sprintEvents, now, maxDate),
        (0, $6tZj1.default)(burnup, now, maxDate)
    ];
    return {
        animation: !prefersReducedMotion,
        xAxis: {
            name: intl.formatMessage((0, $8rQVt.default).time),
            nameLocation: 'center',
            nameGap: 50,
            type: 'time',
            max: maxDate,
            min: minDate,
            nameTextStyle: {
                color: '#707070',
                fontSize: 14,
                fontWeight: 500
            },
            splitLine: {
                show: false
            },
            boundaryGap: false,
            axisLine: {
                lineStyle: {
                    color: '#c0c0c1'
                }
            },
            axisLabel: {
                color: '#545454',
                formatter: (0, $awnLj.default)({
                    userTimeZone: userTimeZone,
                    min: minDate.getTime(),
                    max: maxDate.getTime(),
                    ticks: 5
                }),
                showMinLabel: false,
                showMaxLabel: false
            }
        },
        yAxis: {
            splitLine: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    color: '#c0c0c1'
                }
            },
            axisPointer: {
                snap: true
            },
            axisLabel: {
                color: '#545454',
                showMaxLabel: false
            },
            axisTick: {
                show: true
            },
            nameLocation: 'center',
            nameGap: 56,
            nameTextStyle: {
                color: '#707070',
                fontSize: 14,
                fontWeight: 500
            },
            name: statisticField ? (0, $jU7M3.default)(statisticField, intl) : null,
            type: 'value'
        },
        grid: {
            show: true,
            borderColor: '#c0c0c1',
            top: 28,
            left: 72,
            right: 40,
            bottom: 96
        },
        tooltip: {
            show: true,
            transitionDuration: 0,
            extraCssText: 'overflow: hidden; box-shadow: 0 0 8px rgba(0, 0, 0, 0.3)',
            backgroundColor: 'white',
            textStyle: {
                color: 'rgb(66, 82, 110)'
            },
            trigger: 'item',
            padding: 0,
            formatter: renderTooltip
        },
        series: series
    };
};

});
parcelRegister("awnLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1339e7a968b556f2$export$2e2bcd8739ae039);

var $EN9B6 = parcelRequire("EN9B6");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");
// Number of milliseconds in a year
const $1339e7a968b556f2$var$YEAR = 31536000000;
// Number of milliseconds in a month
const $1339e7a968b556f2$var$MONTH = 2592000000;
// Number of milliseconds in a day
const $1339e7a968b556f2$var$DAY = 86400000;
/**
 * Based on a certain time range and a number of ticks, generates a `DateFormatterFunction` for
 * formatting dates.
 */ const $1339e7a968b556f2$var$makeDateFormatter = (options)=>{
    const dateFormat = (()=>{
        // Get the actually visible boundaries
        // Time difference that is in the range
        const diff = options.max - options.min;
        // Time difference between each tick of the time axis
        const ticksDiff = diff / options.ticks;
        if (ticksDiff > $1339e7a968b556f2$var$YEAR) return 'yyyy';
        if (ticksDiff > $1339e7a968b556f2$var$MONTH) return 'MMM yyyy';
        if (ticksDiff > $1339e7a968b556f2$var$DAY) return 'MMM dd';
        return 'hh:mm dd MMM';
    })();
    return (timestamp)=>{
        const momentTimestamp = new Date(timestamp);
        if (options.userTimeZone) return (0, $4p54N.default)((0, $bbmZl.default)(momentTimestamp, options.userTimeZone), dateFormat);
        return (0, $EN9B6.default)(momentTimestamp, dateFormat);
    };
};
var $1339e7a968b556f2$export$2e2bcd8739ae039 = $1339e7a968b556f2$var$makeDateFormatter;

});

parcelRegister("3gpIm", function(module, exports) {

$parcel$export(module.exports, "shouldRenderTodayLine", () => $ff21b745fefd8200$export$88f62d09357a3c2);
$parcel$export(module.exports, "default", () => $ff21b745fefd8200$export$2e2bcd8739ae039);


var $iX87Q = parcelRequire("iX87Q");

var $aIwQg = parcelRequire("aIwQg");
const $ff21b745fefd8200$export$88f62d09357a3c2 = (burnup, now, maxDate)=>burnup.sprintEndEvent == null && now.getTime() < maxDate.getTime();
const $ff21b745fefd8200$var$createSeries = (series, point)=>{
    if (series.length) {
        const lastPoint = series[series.length - 1];
        const lastValue = lastPoint[1];
        series.push([
            point.data.timestamp,
            lastValue
        ]);
    }
    series.push([
        point.data.timestamp,
        (0, $aIwQg.getCompletion)(point)
    ]);
    return series;
};
const $ff21b745fefd8200$var$getCompletedWorkSeries = (burnup, sprintEvents, now, maxDate)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = sprintEvents.reduce($ff21b745fefd8200$var$createSeries, []);
    return {
        type: 'line',
        symbol: 'none',
        cursor: 'initial',
        lineStyle: {
            color: (0, $iX87Q.default)('color.chart.success', (0, $73a5c9d720aa66e1$exports).G400)
        },
        markLine: $ff21b745fefd8200$export$88f62d09357a3c2(burnup, now, maxDate) ? {
            lineStyle: {
                color: (0, $73a5c9d720aa66e1$exports).N50,
                type: 'dashed'
            },
            silent: true,
            symbol: 'none',
            label: {
                color: (0, $73a5c9d720aa66e1$exports).N100,
                formatter: 'Today'
            },
            data: [
                {
                    xAxis: now.getTime()
                }
            ]
        } : null,
        data: data,
        z: 3
    };
};
var $ff21b745fefd8200$export$2e2bcd8739ae039 = $ff21b745fefd8200$var$getCompletedWorkSeries;

});

parcelRegister("8HYxp", function(module, exports) {

$parcel$export(module.exports, "getLastKnownSprintDate", () => $aeffde1af3361ee5$export$54d1ea478e090890);
$parcel$export(module.exports, "default", () => $aeffde1af3361ee5$export$2e2bcd8739ae039);

var $5Yqat = parcelRequire("5Yqat");

var $cD8SO = parcelRequire("cD8SO");


var $iX87Q = parcelRequire("iX87Q");

var $6j0nJ = parcelRequire("6j0nJ");

var $j6qVB = parcelRequire("j6qVB");

var $aIwQg = parcelRequire("aIwQg");
const $aeffde1af3361ee5$export$615fc8ae64a5a2c0 = (range)=>range.rate === (0, $6j0nJ.NON_WORKING);
const $aeffde1af3361ee5$export$93a0e79425d81c16 = (range)=>[
        {
            xAxis: range.start
        },
        {
            xAxis: range.end
        }
    ];
const $aeffde1af3361ee5$export$b44086d3f45a4df3 = (plannedEndTime, now, maxDate)=>plannedEndTime.getTime() < now.getTime() && maxDate.getTime() - plannedEndTime.getTime() > 86400000;
const $aeffde1af3361ee5$export$54d1ea478e090890 = (burnup, now)=>{
    const knownEndTimes = (0, (/*@__PURE__*/$parcel$interopDefault($5Yqat)))([
        // If the sprint has ended then its end is a candidate. Otherwise the current time is used.
        burnup.sprintEndEvent ? new Date(burnup.sprintEndEvent.timestamp).getTime() : now.getTime(),
        // The last event in the series is a candidate to the edge boundary
        burnup.scopeChangeEvents[burnup.scopeChangeEvents.length - 1] && new Date(burnup.scopeChangeEvents[burnup.scopeChangeEvents.length - 1].timestamp).getTime(),
        // The planned end time is what should be shown while the sprint is on track
        burnup.endTime && new Date(burnup.endTime).getTime()
    ]);
    // @ts-expect-error - TS2769 - No overload matches this call.
    return new Date((0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))(knownEndTimes));
};
/**
 * Generate ECharts series for the ideal work rate guideline
 */ const $aeffde1af3361ee5$var$getGuideline = (burnup, now, maxDate, sprintEvents)=>{
    const plannedEndTime = new Date(burnup.endTime);
    // The end date for the guideline the planned time if the sprint hasn't ended and isn't overtime
    const endDate = $aeffde1af3361ee5$export$54d1ea478e090890(burnup, now);
    const guideline = (0, $j6qVB.calculateIdealWorkRate)({
        startDate: new Date(burnup.sprintStartEvent.timestamp),
        scope: sprintEvents.length ? (0, $aIwQg.getScope)(sprintEvents[sprintEvents.length - 1]) : 0,
        endDate: endDate
    });
    const plannedEndLine = $aeffde1af3361ee5$export$b44086d3f45a4df3(plannedEndTime, now, maxDate) ? {
        z: 1,
        lineStyle: {
            color: (0, $73a5c9d720aa66e1$exports).N50A,
            type: 'solid'
        },
        symbol: 'none',
        label: {
            color: (0, $73a5c9d720aa66e1$exports).N100,
            formatter: 'Planned end'
        },
        data: [
            {
                xAxis: new Date(burnup.endTime).getTime()
            }
        ]
    } : null;
    return {
        silent: true,
        type: 'line',
        symbol: 'none',
        lineStyle: {
            color: (0, $iX87Q.default)('color.chart.neutral', (0, $73a5c9d720aa66e1$exports).N60)
        },
        z: 1,
        data: guideline,
        // We render a line at the planned end if the sprint went overtime
        markLine: plannedEndLine
    };
};
var $aeffde1af3361ee5$export$2e2bcd8739ae039 = $aeffde1af3361ee5$var$getGuideline;

});
parcelRegister("5Yqat", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $4596dac18914dac8$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $4596dac18914dac8$var$compact;

});

parcelRegister("j6qVB", function(module, exports) {

$parcel$export(module.exports, "calculateIdealWorkRate", () => $c2ae1b7c3474d22f$export$551362fd4113f76f);
const $c2ae1b7c3474d22f$export$551362fd4113f76f = (inputs)=>{
    const { startDate: startDate, scope: scope, endDate: endDate } = inputs;
    return [
        [
            startDate.toISOString(),
            0
        ],
        [
            endDate.toISOString(),
            scope
        ]
    ];
};

});


parcelRegister("5Vs6Q", function(module, exports) {

$parcel$export(module.exports, "hasDeltaScope", () => $7515b046a1f04aee$export$c487d50840265b00);
$parcel$export(module.exports, "hasDeltaCompletion", () => $7515b046a1f04aee$export$cf2e1371db3d1e30);
$parcel$export(module.exports, "default", () => $7515b046a1f04aee$export$2e2bcd8739ae039);

var $aIwQg = parcelRequire("aIwQg");
// copied from the deprecated @atlassian/jira-board package
// https://design.atlassian.com/brand/colors/
const $7515b046a1f04aee$var$colors = {
    navy: '#205081',
    cyan: '#59afe1',
    white: '#ffffff',
    lightGray: '#f5f5f5',
    charcoal: '#333333',
    green: '#14892c',
    midGreen: '#67ab49',
    yellow: '#f6c342',
    red: '#d04437',
    cheetoOrange: '#f79232',
    blue: '#3572b0',
    coolBlue: '#84bbc6',
    violet: '#654982',
    mediumGray: '#707070',
    gray: '#999999',
    ashGray: '#cccccc',
    silver: '#e9e9e9',
    // other
    // used for selected state in jira software
    otherSoftBlue: '#ebf2f9',
    paleBlue: '#ccd9ea',
    otherSoftGreen: '#f3f9f4',
    flashYellow: 'rgba(255, 255, 153, 0.8)',
    shadow: 'rgba(0, 0, 0, 0.2)'
};
const $7515b046a1f04aee$export$c487d50840265b00 = ({ prevScope: prevScope, scope: scope })=>Math.abs(scope - prevScope) > 0;
const $7515b046a1f04aee$export$cf2e1371db3d1e30 = ({ prevCompletion: prevCompletion, completion: completion })=>Math.abs(prevCompletion - completion) > 0;
const $7515b046a1f04aee$export$b7ea6af7571e6dec = (event, hasDelta)=>event.type === 'start' || event.type === 'end' || event.type === 'scope' && hasDelta(event.data);
const $7515b046a1f04aee$export$f699a9976e668638 = (event, valueResolver)=>({
        value: [
            (0, $aIwQg.getTimestamp)(event),
            valueResolver(event)
        ],
        meta: {
            event: event
        }
    });
/**
 * Generate ECharts series for the events' scatter dots
 */ const $7515b046a1f04aee$var$getScatterSeries = (isMouseOver, allEvents, seriesName, color, valueResolver, hasDelta)=>({
        type: 'scatter',
        symbolSize: !isMouseOver ? 0 : 8,
        cursor: 'initial',
        z: 3,
        name: seriesName,
        itemStyle: {
            color: $7515b046a1f04aee$var$colors.white,
            borderWidth: 2,
            borderColor: color
        },
        // The line is for any event that actually had a delta in the remaining or start/end events.
        // We enrich the points with themselves so we can get the event when rendering the tooltip.
        data: allEvents.filter((event)=>$7515b046a1f04aee$export$b7ea6af7571e6dec(event, hasDelta)).map((event)=>$7515b046a1f04aee$export$f699a9976e668638(event, valueResolver))
    });
var $7515b046a1f04aee$export$2e2bcd8739ae039 = $7515b046a1f04aee$var$getScatterSeries;

});

parcelRegister("6tZj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fd1b2b28ef21d4a$export$2e2bcd8739ae039);


var $iX87Q = parcelRequire("iX87Q");

var $3gpIm = parcelRequire("3gpIm");
const $2fd1b2b28ef21d4a$var$reduceScopeChangeEvents = (series, event)=>{
    // Need to push twice to create the blocky line effect on the graph
    series.push([
        event.timestamp,
        event.prevScope
    ]);
    series.push([
        event.timestamp,
        event.scope
    ]);
    return series;
};
const $2fd1b2b28ef21d4a$var$getEndEvent = (endEvent, now, maxDate, lastVal)=>{
    if (endEvent) return [
        [
            endEvent.timestamp,
            endEvent.scope
        ]
    ];
    if (now < maxDate) return [
        [
            now.toISOString(),
            lastVal
        ]
    ];
    return [
        [
            maxDate.toISOString(),
            lastVal
        ]
    ];
};
const $2fd1b2b28ef21d4a$export$8a420ffed26b13d8 = (burnup, now, maxDate)=>{
    const { sprintStartEvent: sprintStartEvent, scopeChangeEvents: scopeChangeEvents, sprintEndEvent: sprintEndEvent } = burnup;
    const startEvent = [
        [
            sprintStartEvent.timestamp,
            sprintStartEvent.scopeEstimate
        ]
    ]; // types enforcing the non null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = scopeChangeEvents.reduce($2fd1b2b28ef21d4a$var$reduceScopeChangeEvents, []);
    // Find the last point in the series
    const previousPoint = data.length ? data[data.length - 1] : startEvent[0];
    // Get the scope from the last point
    const previousValue = previousPoint[1];
    // if there is no sprint end event then we need to send the lastval through to create the line
    const endEvent = $2fd1b2b28ef21d4a$var$getEndEvent(sprintEndEvent, now, maxDate, previousValue);
    return [
        ...startEvent,
        ...data,
        ...endEvent
    ];
};
const $2fd1b2b28ef21d4a$var$getScopeChangeLine = (burnup, now, maxDate)=>{
    const dataTillToday = $2fd1b2b28ef21d4a$export$8a420ffed26b13d8(burnup, now, maxDate);
    const prev = dataTillToday.length ? dataTillToday[dataTillToday.length - 1][1] : 0;
    return {
        type: 'line',
        symbol: 'none',
        cursor: 'initial',
        lineStyle: {
            color: (0, $iX87Q.default)('color.chart.danger', (0, $73a5c9d720aa66e1$exports).R400)
        },
        markLine: (0, $3gpIm.shouldRenderTodayLine)(burnup, now, maxDate) ? {
            lineStyle: {
                color: (0, $73a5c9d720aa66e1$exports).R400,
                width: 3,
                type: 'dotted'
            },
            silent: true,
            symbol: 'none',
            data: [
                [
                    {
                        coord: [
                            now.getTime(),
                            prev
                        ]
                    },
                    {
                        coord: [
                            maxDate.getTime(),
                            prev
                        ]
                    }
                ]
            ]
        } : null,
        data: dataTillToday,
        z: 3
    };
};
var $2fd1b2b28ef21d4a$export$2e2bcd8739ae039 = $2fd1b2b28ef21d4a$var$getScopeChangeLine;

});

parcelRegister("jU7M3", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa53ec6073a2b112$export$2e2bcd8739ae039);

var $IXOMa = parcelRequire("IXOMa");

var $8rQVt = parcelRequire("8rQVt");
/**
 * Render an axis' statistic field to a string
 */ const $aa53ec6073a2b112$var$renderStatisticField = (statisticField, intl)=>{
    switch(statisticField){
        case 0, $IXOMa.ESTIMATION_STORY_POINTS:
            return intl.formatMessage((0, $8rQVt.default).optionStatisticStoryPoints);
        case 0, $IXOMa.ESTIMATION_ORIGINAL_ESTIMATE:
            return intl.formatMessage((0, $8rQVt.default).optionStatisticOriginalEstimate);
        default:
            return intl.formatMessage((0, $8rQVt.default).optionStatisticIssueCount);
    }
};
var $aa53ec6073a2b112$export$2e2bcd8739ae039 = $aa53ec6073a2b112$var$renderStatisticField;

});



parcelRegister("kZ5e1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a96d8895ba814ad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $EN9B6 = parcelRequire("EN9B6");
var $3xcI8 = parcelRequire("3xcI8");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");

var $9nkwJ = parcelRequire("9nkwJ");

var $cGL6G = parcelRequire("cGL6G");

var $cSu9v = parcelRequire("cSu9v");

var $5OdZ3 = parcelRequire("5OdZ3");

var $5JgJ2 = parcelRequire("5JgJ2");

var $IXOMa = parcelRequire("IXOMa");

var $gd0Sp = parcelRequire("gd0Sp");

var $6j0nJ = parcelRequire("6j0nJ");

var $5LQic = parcelRequire("5LQic");
const $8a96d8895ba814ad$var$buildStartEvent = ({ timestamp: timestamp, issueList: issueList, scopeEstimate: scopeEstimate })=>({
        timestamp: timestamp,
        type: (0, $6j0nJ.START_EVENT),
        issues: issueList,
        prevCompletion: 0,
        completion: 0,
        prevScope: scopeEstimate,
        scope: scopeEstimate
    });
const $8a96d8895ba814ad$var$buildEndEvent = ({ timestamp: timestamp, issueList: issueList, scope: scope, completion: completion })=>({
        timestamp: timestamp,
        type: (0, $6j0nJ.END_EVENT),
        issues: issueList,
        prevCompletion: completion,
        completion: completion,
        prevScope: scope,
        scope: scope
    });
const $8a96d8895ba814ad$export$f575cae50c008afe = ({ sprintStartEvent: sprintStartEvent, scopeChangeEvents: scopeChangeEvents, sprintEndEvent: sprintEndEvent })=>{
    const startEvent = $8a96d8895ba814ad$var$buildStartEvent(sprintStartEvent);
    const tableScopeChangeEvents = scopeChangeEvents.map((event)=>({
            timestamp: event.timestamp,
            type: event.eventType,
            issues: [
                {
                    issueKey: event.issueKey,
                    issueSummary: event.issueSummary,
                    estimate: event.estimate
                }
            ],
            prevCompletion: event.prevCompletion,
            completion: event.completion,
            prevScope: event.prevScope,
            scope: event.scope
        }));
    const eventsToReturn = [
        startEvent,
        ...tableScopeChangeEvents
    ];
    if (sprintEndEvent) eventsToReturn.push($8a96d8895ba814ad$var$buildEndEvent(sprintEndEvent));
    return eventsToReturn;
};
const $8a96d8895ba814ad$var$renderCompletedScope = ({ prevCompletion: prevCompletion, completion: completion }, timeTrackingOptions, statisticField, intl)=>{
    if (prevCompletion === completion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 0
    }, (0, $IXOMa.formatEstimate)(prevCompletion, timeTrackingOptions, statisticField, intl));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8a96d8895ba814ad$var$ScopeWrap, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 0
    }, (0, $IXOMa.formatEstimate)(prevCompletion, timeTrackingOptions, statisticField, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        size: "small",
        label: intl.formatMessage((0, $5LQic.default).scopeArrowLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 0
    }, (0, $IXOMa.formatEstimate)(completion, timeTrackingOptions, statisticField, intl)));
};
const $8a96d8895ba814ad$var$renderTotalScope = ({ prevScope: prevScope, scope: scope }, timeTrackingOptions, statisticField, intl)=>{
    if (prevScope === scope) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 0
    }, (0, $IXOMa.formatEstimate)(prevScope, timeTrackingOptions, statisticField, intl));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8a96d8895ba814ad$var$ScopeWrap, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 0
    }, (0, $IXOMa.formatEstimate)(prevScope, timeTrackingOptions, statisticField, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        size: "small",
        label: intl.formatMessage((0, $5LQic.default).scopeArrowLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        max: 0
    }, (0, $IXOMa.formatEstimate)(scope, timeTrackingOptions, statisticField, intl)));
};
const $8a96d8895ba814ad$var$renderTimeFromTimestamp = (timestamp, timeZone)=>{
    const dateFnsTimestamp = (0, $3xcI8.default)(timestamp);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(timeZone)) return (0, $4p54N.default)((0, $bbmZl.default)(dateFnsTimestamp, timeZone), 'E, MMM dd yyyy, h:mmaaa');
    return (0, $EN9B6.default)(dateFnsTimestamp, 'E, MMM dd yyyy, h:mmaaa');
};
const $8a96d8895ba814ad$var$renderIssueDetails = (issues, baseUrl, intl)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, issues.map((issue, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: index.toString()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
            href: `${baseUrl}/browse/${issue.issueKey}`
        }, issue.issueKey), ' ', issue.issueSummary || intl.formatMessage((0, $5LQic.default).issueRemovedFromSprint), index < issues.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))));
const $8a96d8895ba814ad$var$renderEventType = (eventType, intl)=>{
    switch(eventType){
        case 0, $6j0nJ.ESTIMATION_CHANGE:
            return intl.formatMessage((0, $5LQic.default).estimateUpdated);
        case 0, $6j0nJ.TRANSITION_TO_DONE:
            return intl.formatMessage((0, $5LQic.default).issueCompleted);
        case 0, $6j0nJ.TRANSITION_TO_NOT_DONE:
            return intl.formatMessage((0, $5LQic.default).issueReopened);
        case 0, $6j0nJ.ISSUE_REMOVED:
            return intl.formatMessage((0, $5LQic.default).issueRemoved);
        case 0, $6j0nJ.ISSUE_ADDED:
            return intl.formatMessage((0, $5LQic.default).issueAdded);
        case 0, $6j0nJ.START_EVENT:
            return intl.formatMessage((0, $5LQic.default).sprintStarted);
        case 0, $6j0nJ.END_EVENT:
            return intl.formatMessage((0, $5LQic.default).sprintCompleted);
        default:
            return eventType;
    }
};
const $8a96d8895ba814ad$export$ef2184bd89960b14 = ({ burnup: burnup, onExperienceSuccess: onExperienceSuccess, timeTrackingOptions: timeTrackingOptions, statisticField: statisticField })=>{
    const intl = (0, $5JgJ2.default)();
    const events = (0, $eUqFw.useMemo)(()=>$8a96d8895ba814ad$export$f575cae50c008afe(burnup), [
        burnup
    ]);
    const { baseUrl: baseUrl } = (0, $gd0Sp.useTenantContext)();
    const head = {
        cells: [
            {
                key: 'date',
                content: intl.formatMessage((0, $5LQic.default).date),
                isSortable: false,
                width: 10
            },
            {
                key: 'event',
                content: intl.formatMessage((0, $5LQic.default).event),
                isSortable: false,
                width: 15
            },
            {
                key: 'issue',
                content: intl.formatMessage((0, $5LQic.default).issue),
                isSortable: false,
                width: 45
            },
            {
                key: 'completed',
                content: intl.formatMessage((0, $5LQic.default).completed),
                isSortable: false,
                width: 15
            },
            {
                key: 'scope',
                content: intl.formatMessage((0, $5LQic.default).scope),
                isSortable: false,
                width: 15
            }
        ]
    };
    const rows = events.map((event, index)=>({
            key: `row-${index}-${event.timestamp}`,
            cells: [
                {
                    key: 'date',
                    content: $8a96d8895ba814ad$var$renderTimeFromTimestamp(event.timestamp, burnup.timeZone)
                },
                {
                    key: 'event',
                    content: $8a96d8895ba814ad$var$renderEventType(event.type, intl)
                },
                {
                    key: 'issue',
                    content: $8a96d8895ba814ad$var$renderIssueDetails(event.issues, baseUrl, intl)
                },
                {
                    key: 'completed',
                    content: $8a96d8895ba814ad$var$renderCompletedScope(event, timeTrackingOptions, statisticField, intl)
                },
                {
                    key: 'scope',
                    content: $8a96d8895ba814ad$var$renderTotalScope(event, timeTrackingOptions, statisticField, intl)
                }
            ]
        }));
    (0, $eUqFw.useEffect)(()=>{
        if (onExperienceSuccess) onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]); // @ts-expect-error - TS2769 - No overload matches this call.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cGL6G.default), {
        head: head,
        rows: rows,
        paginationi18n: {
            next: '',
            prev: ''
        }
    });
};
var $8a96d8895ba814ad$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8a96d8895ba814ad$export$ef2184bd89960b14;
const $8a96d8895ba814ad$var$ScopeWrap = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("cGL6G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee9e861fc13653b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $fVXMO = parcelRequire("fVXMO");

var $clqWl = parcelRequire("clqWl");
class $fee9e861fc13653b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            defaultPage: 1,
            isLoading: false,
            isFixedSize: false,
            isRankable: false,
            onSetPage: (0, $5Q9wj.default),
            onSort: (0, $5Q9wj.default),
            rowsPerPage: Infinity
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $fVXMO.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("fVXMO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $9778ffcbc0ef1196$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9778ffcbc0ef1196$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9778ffcbc0ef1196$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9778ffcbc0ef1196$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9778ffcbc0ef1196$export$c476bbe5da59992d);
const $9778ffcbc0ef1196$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9778ffcbc0ef1196$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9778ffcbc0ef1196$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9778ffcbc0ef1196$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9778ffcbc0ef1196$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9778ffcbc0ef1196$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("clqWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2847e492d5dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");


var $fVXMO = parcelRequire("fVXMO");

var $3tjuM = parcelRequire("3tjuM");

var $iK2U9 = parcelRequire("iK2U9");

var $9t1Ml = parcelRequire("9t1Ml");

var $aLrpD = parcelRequire("aLrpD");

var $a96y2 = parcelRequire("a96y2");

var $DPlg5 = parcelRequire("DPlg5");

var $i9y06 = parcelRequire("i9y06");

var $cTO8p = parcelRequire("cTO8p");
function $7cd2847e492d5dd4$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65:
            return 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b;
        case 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b:
            return 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $7cd2847e492d5dd4$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $5Q9wj.default), onSort: providedOnSort = (0, $5Q9wj.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $5Q9wj.default), onRankEnd: providedOnRankEnd = (0, $5Q9wj.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eUqFw.useState)(false);
    const tableBodyRef = (0, $eUqFw.useRef)(null);
    const onSort = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eUqFw.useEffect)(()=>{
        (0, $fVXMO.validateSortKey)(sortKey, head);
        (0, $fVXMO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) : $7cd2847e492d5dd4$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $fVXMO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3) : (0, $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $DPlg5.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTO8p.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9y06.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a96y2.default), {
        isLoading: isLoading,
        spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $7cd2847e492d5dd4$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7BSAY")));
const $7cd2847e492d5dd4$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t1Ml.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLrpD.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7cd2847e492d5dd4$export$2e2bcd8739ae039 = $7cd2847e492d5dd4$var$DynamicTable;

});
const $9ad1be2eb14b8d3d$export$1dee026a19752d6b = 'ASC';
const $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65 = 'DESC';
const $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f = 'small';
const $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3 = 'large';
const $9ad1be2eb14b8d3d$export$3843c586a90b9cbf = 0.22;

parcelRegister("3tjuM", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $1430aaf59e7cbeab$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $1430aaf59e7cbeab$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $1430aaf59e7cbeab$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $1430aaf59e7cbeab$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g2Ovh = parcelRequire("g2Ovh");
function $1430aaf59e7cbeab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1430aaf59e7cbeab$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $1430aaf59e7cbeab$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $1430aaf59e7cbeab$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $1430aaf59e7cbeab$var$bodyBorder = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`
});
const $1430aaf59e7cbeab$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $g2Ovh.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $g2Ovh.row).focusOutline
        },
        css: [
            $1430aaf59e7cbeab$var$tableStyles,
            isFixedSize && $1430aaf59e7cbeab$var$fixedSizeTableStyles,
            hasDataRow && $1430aaf59e7cbeab$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $1430aaf59e7cbeab$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $1430aaf59e7cbeab$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("caption", {
        css: $1430aaf59e7cbeab$var$captionStyles
    }, children);
const $1430aaf59e7cbeab$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $1430aaf59e7cbeab$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1430aaf59e7cbeab$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("g2Ovh", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $47d84a50d7c96182$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $47d84a50d7c96182$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $47d84a50d7c96182$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $47d84a50d7c96182$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $47d84a50d7c96182$export$38d703b73e2cf64d);

const $47d84a50d7c96182$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $47d84a50d7c96182$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`
};
const $47d84a50d7c96182$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};

});


parcelRegister("iK2U9", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1c04c67c6d2e01dc$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1c04c67c6d2e01dc$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $1c04c67c6d2e01dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c04c67c6d2e01dc$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $1c04c67c6d2e01dc$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1c04c67c6d2e01dc$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $1c04c67c6d2e01dc$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9t1Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc1fe407cca2cd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2c84N = parcelRequire("2c84N");

var $a8MUu = parcelRequire("a8MUu");
class $bdc1fe407cca2cd9$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8MUu.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $bdc1fe407cca2cd9$var$Body = (0, $2c84N.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc1fe407cca2cd9$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bdc1fe407cca2cd9$export$2e2bcd8739ae039 = $bdc1fe407cca2cd9$var$Body;

});
parcelRegister("2c84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1514dd575e5332c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fVXMO = parcelRequire("fVXMO");
const $1514dd575e5332c4$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $1514dd575e5332c4$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $1514dd575e5332c4$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $1514dd575e5332c4$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $1514dd575e5332c4$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fVXMO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $1514dd575e5332c4$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fVXMO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("a8MUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2038a3700f41e476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4RemJ = parcelRequire("4RemJ");

var $iqL3E = parcelRequire("iqL3E");
const $2038a3700f41e476$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqL3E.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RemJ.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2038a3700f41e476$export$2e2bcd8739ae039 = $2038a3700f41e476$var$Row;

});
parcelRegister("4RemJ", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5915d36ce36ccacb$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $39mp0 = parcelRequire("39mp0");
const $5915d36ce36ccacb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("39mp0", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $ad2974e69f235483$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $ad2974e69f235483$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $ad2974e69f235483$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $ad2974e69f235483$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $ad2974e69f235483$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
function $ad2974e69f235483$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2974e69f235483$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $ad2974e69f235483$export$708a733455f59a29 = /*#__PURE__*/ (0, $byn9U.css)({
    width: `var(${$ad2974e69f235483$var$CSS_VAR_WIDTH})`
});
const $ad2974e69f235483$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $ad2974e69f235483$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $ad2974e69f235483$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$ad2974e69f235483$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $ad2974e69f235483$export$f7913df521f684e2 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iqL3E", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $6b389a48d047c2ef$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3tjuM = parcelRequire("3tjuM");
const $6b389a48d047c2ef$var$rowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $6b389a48d047c2ef$var$rowBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $6b389a48d047c2ef$var$rowStyles,
            isHighlighted ? $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles : $6b389a48d047c2ef$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("aLrpD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $73b0e671a4d4f805$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $73b0e671a4d4f805$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("a96y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $feff75185b46f730$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $a53tD = parcelRequire("a53tD");
class $feff75185b46f730$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("a53tD", function(module, exports) {

$parcel$export(module.exports, "Container", () => $aa6b103a00044c0b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $aa6b103a00044c0b$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $aa6b103a00044c0b$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $aa6b103a00044c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa6b103a00044c0b$export$c335a80381ec61f5 = '--contents-opacity';
const $aa6b103a00044c0b$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $aa6b103a00044c0b$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $aa6b103a00044c0b$var$contentsContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: `var(${$aa6b103a00044c0b$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $aa6b103a00044c0b$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$aa6b103a00044c0b$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $aa6b103a00044c0b$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $aa6b103a00044c0b$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $aa6b103a00044c0b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("DPlg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0b56c99dd019f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $sM67g = parcelRequire("sM67g");
class $6c0b56c99dd019f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("sM67g", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e14096c71a70d04d$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e14096c71a70d04d$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e14096c71a70d04d$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $e14096c71a70d04d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e14096c71a70d04d$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e14096c71a70d04d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e14096c71a70d04d$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e14096c71a70d04d$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e14096c71a70d04d$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e14096c71a70d04d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("i9y06", function(module, exports) {

$parcel$export(module.exports, "default", () => $59228fe552548a0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $59228fe552548a0a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $5Mzgj = parcelRequire("5Mzgj");

var $2C9cn = parcelRequire("2C9cn");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
const $52d6d0a6ee26c024$var$navigatorIconWrapperStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.075'
});
function $52d6d0a6ee26c024$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($5Mzgj))) : (0, (/*@__PURE__*/$parcel$interopDefault($2C9cn)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $52d6d0a6ee26c024$var$navigatorIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination));
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = $52d6d0a6ee26c024$var$Pagination;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("5Mzgj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $435cc9c581f97870$var$_react = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $435cc9c581f97870$var$_chevronLeft = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("a4cVy")));

var $435cc9c581f97870$var$_chevronLeftLarge = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("dXKde")));
function $435cc9c581f97870$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $435cc9c581f97870$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $435cc9c581f97870$var$_react.default.createElement($435cc9c581f97870$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $435cc9c581f97870$var$_chevronLeftLarge.default
    }, props));
$435cc9c581f97870$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $435cc9c581f97870$var$_default = module.exports.default = $435cc9c581f97870$var$ChevronLeftIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});


parcelRegister("2C9cn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e764405146a3983$var$_react = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1e764405146a3983$var$_chevronRight = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("fCmfi")));

var $1e764405146a3983$var$_chevronRightLarge = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("dwj4T")));
function $1e764405146a3983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e764405146a3983$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $1e764405146a3983$var$_react.default.createElement($1e764405146a3983$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $1e764405146a3983$var$_chevronRightLarge.default
    }, props));
$1e764405146a3983$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $1e764405146a3983$var$_default = module.exports.default = $1e764405146a3983$var$ChevronRightIcon;

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});



parcelRegister("cTO8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1cf364925ee2f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVXMO = parcelRequire("fVXMO");

var $iLooJ = parcelRequire("iLooJ");

var $6Ztqc = parcelRequire("6Ztqc");

var $jRqbA = parcelRequire("jRqbA");
class $7e1cf364925ee2f7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $6Ztqc.default) : (0, $jRqbA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1cf364925ee2f7$export$2e2bcd8739ae039 = $7e1cf364925ee2f7$var$TableHead;

});
parcelRegister("iLooJ", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e23e257a0c447ed4$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e23e257a0c447ed4$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");



var $g2Ovh = parcelRequire("g2Ovh");

var $39mp0 = parcelRequire("39mp0");
function $e23e257a0c447ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e23e257a0c447ed4$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e23e257a0c447ed4$var$headStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $e23e257a0c447ed4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("thead", {
        css: [
            $e23e257a0c447ed4$var$headStyles,
            isRanking && $e23e257a0c447ed4$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e23e257a0c447ed4$var$headCellBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$headCellBaseStylesModernized = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$onClickStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e23e257a0c447ed4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $g2Ovh.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$ascendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$descendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        [$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR]: (0, $g2Ovh.head).textColor
    };
    const isASC = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles),
            (0, $XHGTv.fg)('design_system_team_dynamic_table_typography') ? $e23e257a0c447ed4$var$headCellBaseStylesModernized : $e23e257a0c447ed4$var$headCellBaseStyles,
            onClick && $e23e257a0c447ed4$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            isSortable && $e23e257a0c447ed4$var$baseStyles,
            isASC && $e23e257a0c447ed4$var$ascendingStyles,
            isDESC && $e23e257a0c447ed4$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("6Ztqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0043750917848b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hwoBY = parcelRequire("hwoBY");

var $fVXMO = parcelRequire("fVXMO");

var $jRqbA = parcelRequire("jRqbA");
class $0043750917848b87$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fVXMO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRqbA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $0043750917848b87$var$RankableTableHeadCell = (0, $hwoBY.default)($0043750917848b87$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0043750917848b87$export$2e2bcd8739ae039 = $0043750917848b87$var$RankableTableHeadCell;

});
parcelRegister("hwoBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f810d119edc97937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f810d119edc97937$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jRqbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $635bc03d85c6882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iLooJ = parcelRequire("iLooJ");
const $635bc03d85c6882e$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635bc03d85c6882e$export$2e2bcd8739ae039 = $635bc03d85c6882e$var$TableHeadCell;

});



parcelRegister("7BSAY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("aVYwg")
]).then(()=>parcelRequire('jlg4D'));

});



parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});


parcelRegister("5LQic", function(module, exports) {

$parcel$export(module.exports, "default", () => $a936112ef67b388e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a936112ef67b388e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    date: {
        "id": "software-burnup-report.grid.date",
        "defaultMessage": "Date"
    },
    event: {
        "id": "software-burnup-report.grid.event",
        "defaultMessage": "Event"
    },
    issue: {
        "id": "software-burnup-report.grid.issue",
        "defaultMessage": "Issue"
    },
    completed: {
        "id": "software-burnup-report.grid.completed",
        "defaultMessage": "Completed"
    },
    scope: {
        "id": "software-burnup-report.grid.scope",
        "defaultMessage": "Scope"
    },
    estimateUpdated: {
        "id": "software-burnup-report.grid.estimate-updated",
        "defaultMessage": "Estimate updated"
    },
    issueCompleted: {
        "id": "software-burnup-report.grid.issue-completed",
        "defaultMessage": "Issue completed"
    },
    issueReopened: {
        "id": "software-burnup-report.grid.issue-reopened",
        "defaultMessage": "Issue re-opened"
    },
    issueRemoved: {
        "id": "software-burnup-report.grid.issue-removed",
        "defaultMessage": "Removed from sprint"
    },
    issueAdded: {
        "id": "software-burnup-report.grid.issue-added",
        "defaultMessage": "Added to sprint"
    },
    sprintStarted: {
        "id": "software-burnup-report.grid.sprint-started",
        "defaultMessage": "Sprint started"
    },
    sprintCompleted: {
        "id": "software-burnup-report.grid.sprint-completed",
        "defaultMessage": "Sprint completed"
    },
    issueRemovedFromSprint: {
        "id": "software-burnup-report.grid.issue-removed-from-sprint",
        "defaultMessage": "(Issue was removed from sprint)"
    },
    scopeArrowLabel: {
        "id": "software-burnup-report.grid.scope-arrow-label",
        "defaultMessage": "To"
    }
});

});


parcelRegister("13lzg", function(module, exports) {

$parcel$export(module.exports, "getTrackEventContextAttributes", () => $1e6ecbaec438648e$export$4bc70768d9bf7727);
$parcel$export(module.exports, "convertChartsDataSecondsToHours", () => $1e6ecbaec438648e$export$839a4ea6a9897035);

var $6DhaC = parcelRequire("6DhaC");
const $1e6ecbaec438648e$export$4bc70768d9bf7727 = (state, filters)=>({
        estimationStatistic: state.estimation,
        sprintFilterRank: (0, $6DhaC.getSprintFilterRank)(filters && filters.sprints, state.sprint && state.sprint.id),
        totalSprints: filters && filters.sprints.length
    });
const $1e6ecbaec438648e$export$839a4ea6a9897035 = (chart)=>{
    const secondsInHour = 3600;
    let { sprintStartEvent: sprintStartEvent, sprintEndEvent: sprintEndEvent } = chart;
    const { scopeChangeEvents: scopeChangeEvents } = chart;
    const convertIssueListItemToHours = (issue)=>({
            ...issue,
            estimate: issue.estimate / secondsInHour
        });
    const convertScopeChangeEventToHour = (event)=>({
            ...event,
            scope: event.scope / secondsInHour,
            completion: event.completion / secondsInHour,
            estimate: event.estimate / secondsInHour,
            prevScope: event.prevScope / secondsInHour,
            prevCompletion: event.prevCompletion / secondsInHour,
            prevEstimate: event.prevEstimate / secondsInHour
        });
    if (sprintStartEvent) sprintStartEvent = {
        ...sprintStartEvent,
        scopeEstimate: sprintStartEvent.scopeEstimate / secondsInHour,
        issueList: sprintStartEvent.issueList.map(convertIssueListItemToHours)
    };
    if (sprintEndEvent) sprintEndEvent = {
        ...sprintEndEvent,
        scope: sprintEndEvent.scope / secondsInHour,
        completion: sprintEndEvent.completion / secondsInHour,
        issueList: sprintEndEvent.issueList.map(convertIssueListItemToHours)
    };
    return {
        ...chart,
        sprintStartEvent: sprintStartEvent,
        sprintEndEvent: sprintEndEvent,
        scopeChangeEvents: scopeChangeEvents.map(convertScopeChangeEventToHour)
    };
};

});




parcelRegister("lldcY", function(module, exports) {

$parcel$export(module.exports, "createReportPageBootstrap", () => $d67e138b0ee59756$export$62233a4527423be3);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $fee69 = parcelRequire("fee69");

var $d6f6c = parcelRequire("d6f6c");

var $fFiKW = parcelRequire("fFiKW");

var $fO5rB = parcelRequire("fO5rB");

var $5p2pw = parcelRequire("5p2pw");

var $bhwgQ = parcelRequire("bhwgQ");

var $7BhMl = parcelRequire("7BhMl");

var $6M8Uw = parcelRequire("6M8Uw");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $edolg = parcelRequire("edolg");
class $d67e138b0ee59756$export$883262dc952d8f59 extends (0, $eUqFw.Component) {
    getUrlParams() {
        const { match: match } = this.props;
        const { boardId: boardId, projectKey: projectKey } = match.params;
        return {
            boardId: Number(boardId),
            projectKey: projectKey
        };
    }
    renderContents() {
        const { App: App } = this.props;
        const { boardId: boardId, projectKey: projectKey } = this.getUrlParams();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $edolg.ProjectAppContainer), {
                projectKey: projectKey || ''
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
                subProduct: "software"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(App, {
                baseUrl: tenantContext.baseUrl,
                projectKey: projectKey || '',
                boardId: boardId
            })));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BhMl.LicenseCheck), {
            type: "software"
        }, ({ result: result })=>result ? this.renderContents() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5p2pw.AsyncNoSoftwareLicense), null)));
    }
}
const $d67e138b0ee59756$export$62233a4527423be3 = (page, App)=>// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; } & { App: ComponentType<AppProps>; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
    (0, $lB25E.withRouter)((props)=>{
        const projectInfo = (0, $fFiKW.useProjectAnalyticsAttributes)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "report-page-bootstrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
            id: `spa-app-bootstrap.next-gen.reports.${page}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
            actionSubject: "report",
            action: "viewed",
            actionSubjectId: page,
            attributes: {
                ...projectInfo
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d67e138b0ee59756$export$883262dc952d8f59, {
            ...props,
            App: App
        })));
    });

});
parcelRegister("fFiKW", function(module, exports) {

$parcel$export(module.exports, "useProjectSimplified", () => $23f818101ec73ec4$export$9f0c70b531288073);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $23f818101ec73ec4$export$b6a91b2d78273787);

var $bNe1g = parcelRequire("bNe1g");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $23f818101ec73ec4$export$f87be37f8e8be65 = ()=>{
    const [projectKey] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey == null) throw new Error('Project key missing');
    return (0, $6vrw7.toProjectKey)(projectKey);
};
const $23f818101ec73ec4$export$16d1475ed6c26568 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    return data === null ? null : (0, $6vrw7.toProjectId)(`${data.projectId}`);
};
const $23f818101ec73ec4$export$4d975d76445a6650 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    if (data === null) return null;
    const { isProjectAdmin: isProjectAdmin } = data;
    return isProjectAdmin === undefined ? null : isProjectAdmin;
};
const $23f818101ec73ec4$export$9f0c70b531288073 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    return data === null ? null : data.simplified;
};
const $23f818101ec73ec4$export$b6a91b2d78273787 = ()=>{
    const projectId = $23f818101ec73ec4$export$16d1475ed6c26568();
    const isProjectAdmin = $23f818101ec73ec4$export$4d975d76445a6650();
    const isProjectSimplified = $23f818101ec73ec4$export$9f0c70b531288073();
    if (projectId === null || isProjectAdmin === null || isProjectSimplified === null) return null;
    return {
        isSimplified: isProjectSimplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("5p2pw", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $de0deb0ce0efa641$export$52d8964299339cae);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $de0deb0ce0efa641$var$LazyNoSoftwareLicense = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4qojl")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $de0deb0ce0efa641$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de0deb0ce0efa641$var$LazyNoSoftwareLicense, null));

});
parcelRegister("4qojl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gd5QC").then(()=>parcelRequire('4kT9n'));

});


parcelRegister("7BhMl", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $623739831bab1cba$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $623739831bab1cba$export$944be0b3bf2a6feb);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");
const $623739831bab1cba$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $623739831bab1cba$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$623739831bab1cba$var$appPermissionMapper[type]]);
const $623739831bab1cba$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $623739831bab1cba$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("edolg", function(module, exports) {

$parcel$export(module.exports, "ProjectAppContainer", () => $1822e422b99b1735$export$2925ae38aba4f7e6);

var $eUqFw = parcelRequire("eUqFw");

var $dpXKE = parcelRequire("dpXKE");

var $bNe1g = parcelRequire("bNe1g");
const $1822e422b99b1735$export$2925ae38aba4f7e6 = ({ children: children, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            projectKey: projectKey,
            projectName: projectData ? projectData.projectName : ''
        }, children));

});




//# sourceMappingURL=async-next-gen-reports-burnup.3f46e327.js.map
